import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: any;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
};

export type AcceptInviteInput = {
  id: Scalars['String'];
  password: Scalars['String'];
};

export type AddDonorsToDaycareInput = {
  appointmentId: Scalars['String'];
  donorIds: Array<Scalars['String']>;
};

export type AdditionalDonationInfoInput = {
  dislikes?: InputMaybe<Array<Scalars['String']>>;
  donationPosition?: InputMaybe<Scalars['String']>;
  donationPositionFreeText?: InputMaybe<Scalars['String']>;
  donorMovement: Scalars['String'];
  emotionalSupport?: InputMaybe<Array<Scalars['String']>>;
  flowRate: FlowRate;
  holdersPosition: Array<Scalars['String']>;
  likes?: InputMaybe<Array<Scalars['String']>>;
  numberOfCollectionUnitsUsed: CollectionUnitsUsed;
  shortPokerId?: InputMaybe<Scalars['String']>;
  shortPrimaryHolderId?: InputMaybe<Scalars['String']>;
  shortSecondaryHolderId?: InputMaybe<Scalars['String']>;
  totalCollectedMls?: InputMaybe<Scalars['Float']>;
  treatPreferences?: InputMaybe<Array<Scalars['String']>>;
  typeOfMovement?: InputMaybe<Scalars['String']>;
  vascularStructure?: InputMaybe<VascularStructure>;
  veinUsed: VeinUsed;
};

export type AdditionalDonationInfoOutput = {
  __typename?: 'AdditionalDonationInfoOutput';
  dislikes?: Maybe<Array<Scalars['String']>>;
  donationPosition?: Maybe<Scalars['String']>;
  donorMovement: Scalars['String'];
  emotionalSupport?: Maybe<Array<Scalars['String']>>;
  flowRate: FlowRate;
  holdersPosition?: Maybe<Array<Scalars['String']>>;
  id: Scalars['String'];
  likes?: Maybe<Array<Scalars['String']>>;
  numberOfCollectionUnitsUsed: CollectionUnitsUsed;
  poker?: Maybe<HolderOutput>;
  primaryHolder?: Maybe<HolderOutput>;
  secondaryHolder?: Maybe<HolderOutput>;
  totalCollectedMls?: Maybe<Scalars['Float']>;
  treatPreferences?: Maybe<Array<Scalars['String']>>;
  typeOfMovement?: Maybe<Scalars['String']>;
  vascularStructure?: Maybe<VascularStructure>;
  veinUsed: VeinUsed;
};

export type AdditionalDonationInfoReportOutput = {
  __typename?: 'AdditionalDonationInfoReportOutput';
  id: Scalars['String'];
  numberOfCollectionUnitsUsed: CollectionUnitsUsed;
  poker?: Maybe<HolderOutput>;
  primaryHolder?: Maybe<HolderOutput>;
  totalCollectedMls?: Maybe<Scalars['Float']>;
};

export type AdditionalInfoInput = {
  dislikes?: InputMaybe<Array<Scalars['String']>>;
  donationPosition?: InputMaybe<Scalars['String']>;
  donationPositionFreeText?: InputMaybe<Scalars['String']>;
  donorMovement: Scalars['String'];
  emotionalSupport?: InputMaybe<Array<Scalars['String']>>;
  flowRate: FlowRate;
  holdersPosition: Array<Scalars['String']>;
  likes?: InputMaybe<Array<Scalars['String']>>;
  numberOfCollectionUnitsUsed: CollectionUnitsUsed;
  pokerId?: InputMaybe<Scalars['String']>;
  primaryHolderId?: InputMaybe<Scalars['String']>;
  secondaryHolderId?: InputMaybe<Scalars['String']>;
  totalCollectedMls?: InputMaybe<Scalars['Float']>;
  treatPreferences?: InputMaybe<Array<Scalars['String']>>;
  typeOfMovement?: InputMaybe<Scalars['String']>;
  vascularStructure?: InputMaybe<VascularStructure>;
  veinUsed: VeinUsed;
};

export type AllIneligibleParticipantsOutput = {
  __typename?: 'AllIneligibleParticipantsOutput';
  ineligible: Array<IneligibleParticipantOutput>;
};

export enum AnimalGender {
  Female = 'Female',
  Male = 'Male'
}

export enum AnimalSpecies {
  Cat = 'Cat',
  Dog = 'Dog'
}

export enum Anticoagulant {
  Asd = 'ASD',
  Cpd = 'CPD',
  Cpda = 'CPDA',
  Cpda_1 = 'CPDA_1',
  CpdSagm = 'CPD_SAGM'
}

export type AppSettingsOutput = {
  __typename?: 'AppSettingsOutput';
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  settingsJson: Scalars['JSON'];
  settingsTab: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type AppointmentDatesInfoOutput = {
  __typename?: 'AppointmentDatesInfoOutput';
  end: Scalars['DateTime'];
  id: Scalars['String'];
  start: Scalars['DateTime'];
};

export type AppointmentDonor = {
  __typename?: 'AppointmentDonor';
  acceptSimparicaTrio: Scalars['Boolean'];
  age: Scalars['Float'];
  approvedDonationML: Scalars['Float'];
  attendDaycareDays?: Maybe<Array<Scalars['String']>>;
  becameReservedDonorDate?: Maybe<Scalars['DateTime']>;
  bloodType?: Maybe<BloodType>;
  breed?: Maybe<Scalars['String']>;
  canRegularlyAttendDaycare?: Maybe<Scalars['Boolean']>;
  color?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  dateOfBirth: Scalars['DateTime'];
  distemperDate?: Maybe<Scalars['DateTime']>;
  distinguishableMarks?: Maybe<Scalars['String']>;
  donationFrequency: Scalars['Float'];
  donationMLApprovedAmount?: Maybe<Scalars['Float']>;
  firstCertificatePrinted: Scalars['Boolean'];
  gender: AnimalGender;
  hasHeartMurmur?: Maybe<Scalars['Boolean']>;
  hasMicrochip?: Maybe<Scalars['Boolean']>;
  hasTransfusion?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  isDaycare?: Maybe<Scalars['Boolean']>;
  lastDonationDate?: Maybe<Scalars['DateTime']>;
  lastLabworkDate?: Maybe<Scalars['DateTime']>;
  lastLabworkFile?: Maybe<Array<FileOutput>>;
  location: Scalars['String'];
  medicationCourse?: Maybe<Scalars['String']>;
  microchipNumber?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  neutered: Scalars['Boolean'];
  nextDonationDate?: Maybe<Scalars['DateTime']>;
  pictures?: Maybe<Array<DonorPictureOutput>>;
  primaryVeterinarian: Scalars['String'];
  rabiesDate?: Maybe<Scalars['DateTime']>;
  reserveNotes?: Maybe<Array<ReserveDonorNoteOutput>>;
  retiredDate?: Maybe<Scalars['DateTime']>;
  retiredReason?: Maybe<RetiredReasons>;
  retiredReasonComment?: Maybe<Scalars['String']>;
  secondCertificatePrinted: Scalars['Boolean'];
  shortId: Scalars['Float'];
  species: AnimalSpecies;
  status: DonorStatus;
  takeMedications?: Maybe<Scalars['Boolean']>;
  type: DonorType;
  user?: Maybe<AppointmentUser>;
  weight: Scalars['Float'];
};

export type AppointmentGroupOutput = {
  __typename?: 'AppointmentGroupOutput';
  id: Scalars['String'];
  title: Scalars['String'];
  user?: Maybe<AppointmentUser>;
};

export type AppointmentOutput = {
  __typename?: 'AppointmentOutput';
  createdAt: Scalars['DateTime'];
  daycareInfo?: Maybe<Array<DaycareAppointmentResponseOutput>>;
  donor?: Maybe<AppointmentDonor>;
  end: Scalars['DateTime'];
  group?: Maybe<AppointmentGroupOutput>;
  id: Scalars['String'];
  isDaycare?: Maybe<Scalars['Boolean']>;
  isPrivate?: Maybe<Scalars['Boolean']>;
  location: Scalars['String'];
  notes?: Maybe<Scalars['String']>;
  start: Scalars['DateTime'];
  team?: Maybe<AppointmentTeamOutput>;
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  users: Array<AppointmentUser>;
};

export type AppointmentTeamOutput = {
  __typename?: 'AppointmentTeamOutput';
  id: Scalars['String'];
  title: Scalars['String'];
};

export enum AppointmentType {
  Daycare = 'Daycare',
  Grouped = 'Grouped',
  Individual = 'Individual'
}

export type AppointmentUser = {
  __typename?: 'AppointmentUser';
  assignedLocations?: Maybe<Array<LocationOutput>>;
  assignedOffice?: Maybe<OfficeOutput>;
  assignedRegions?: Maybe<Array<RegionOutput>>;
  birthday?: Maybe<Scalars['DateTime']>;
  city?: Maybe<Scalars['String']>;
  contactPreferences?: Maybe<Scalars['String']>;
  contacts?: Maybe<Array<ContactOutput>>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  deletionIntentionAt?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  id: Scalars['String'];
  isArchived: Scalars['Boolean'];
  lastName: Scalars['String'];
  locationPreferences?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  productRegionPreference?: Maybe<RegionOutput>;
  shortId: Scalars['Float'];
  state?: Maybe<Scalars['String']>;
  streetAddress?: Maybe<Scalars['String']>;
  type?: Maybe<OwnerType>;
  zipCode?: Maybe<Scalars['String']>;
};

export type AppointmentsFilterInput = {
  donorIds?: InputMaybe<Array<Scalars['String']>>;
  locations?: InputMaybe<Array<Scalars['String']>>;
  type?: InputMaybe<AppointmentType>;
  userIds?: InputMaybe<Array<Scalars['String']>>;
};

export type ArchiveUserInput = {
  userId: Scalars['String'];
};

export type BillingOutput = {
  __typename?: 'BillingOutput';
  city: Scalars['String'];
  company: Scalars['String'];
  country: Scalars['String'];
  email: Scalars['String'];
  firstAddress: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phone: Scalars['String'];
  postcode: Scalars['String'];
  secondAddress?: Maybe<Scalars['String']>;
  state: Scalars['String'];
};

export enum BloodType {
  Dea1Negative = 'Dea1Negative',
  Dea1Positive = 'Dea1Positive',
  Unknown = 'Unknown'
}

export type BloodUnitIdentifiersOutput = {
  __typename?: 'BloodUnitIdentifiersOutput';
  product?: Maybe<ProductOutput>;
  unitId?: Maybe<Scalars['Float']>;
};

export type BreedOutput = {
  __typename?: 'BreedOutput';
  id: Scalars['String'];
  name: Scalars['String'];
  species: AnimalSpecies;
};

export enum CapillaryRefillTime {
  BetweenOneAndTwo = 'BetweenOneAndTwo',
  LessThanTwo = 'LessThanTwo',
  MoreThanTwo = 'MoreThanTwo',
  NotApplicable = 'NotApplicable'
}

export type Category = {
  __typename?: 'Category';
  id: Scalars['Float'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type ChurnRateHistoryOutput = {
  __typename?: 'ChurnRateHistoryOutput';
  /** Periods in ascending chronological order */
  periods: Array<ChurnRatePeriodOutput>;
};

export type ChurnRatePeriodOutput = {
  __typename?: 'ChurnRatePeriodOutput';
  /** Active donors at start of period */
  activeAtStart: Scalars['Int'];
  /** Churn rate percentage (can be negative for net growth) */
  churnRate: Scalars['Float'];
  /** Donors who dropped out in this period */
  dropoutCount: Scalars['Int'];
  /** New enrollments in this period */
  enrollmentCount: Scalars['Int'];
  /** Human-readable period label (e.g. "Feb 2026") */
  label: Scalars['String'];
  /** ISO end date of this period */
  periodEnd: Scalars['String'];
  /** ISO start date of this period */
  periodStart: Scalars['String'];
};

export enum CollectionSet {
  NotApplicable = 'NotApplicable',
  Quad = 'Quad',
  Single = 'Single'
}

export enum CollectionUnitsUsed {
  One = 'One',
  Three = 'Three',
  Two = 'Two',
  Zero = 'Zero'
}

export type ContactInput = {
  city?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  streetAddress?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export type ContactOutput = {
  __typename?: 'ContactOutput';
  city?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  lastName?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  streetAddress?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};

export enum ContactType {
  Email = 'Email',
  Flag = 'Flag',
  InPerson = 'InPerson',
  Other = 'Other',
  Phone = 'Phone',
  Text = 'Text',
  Voicemail = 'Voicemail'
}

export type CreateAdditionalDonationInfoInput = {
  dislikes?: InputMaybe<Array<Scalars['String']>>;
  donationId: Scalars['String'];
  donationPosition?: InputMaybe<Scalars['String']>;
  donationPositionFreeText?: InputMaybe<Scalars['String']>;
  donorMovement: Scalars['String'];
  emotionalSupport?: InputMaybe<Array<Scalars['String']>>;
  flowRate: FlowRate;
  holdersPosition: Array<Scalars['String']>;
  likes?: InputMaybe<Array<Scalars['String']>>;
  numberOfCollectionUnitsUsed: CollectionUnitsUsed;
  pokerId?: InputMaybe<Scalars['String']>;
  primaryHolderId?: InputMaybe<Scalars['String']>;
  secondaryHolderId?: InputMaybe<Scalars['String']>;
  totalCollectedMls?: InputMaybe<Scalars['Float']>;
  treatPreferences?: InputMaybe<Array<Scalars['String']>>;
  typeOfMovement?: InputMaybe<Scalars['String']>;
  vascularStructure?: InputMaybe<VascularStructure>;
  veinUsed: VeinUsed;
};

export type CreateAppointmentWithDonorInput = {
  dates: Array<IntervalInput>;
  donorId: Scalars['String'];
  isDaycare?: InputMaybe<Scalars['Boolean']>;
  isPrivate?: InputMaybe<Scalars['Boolean']>;
  location: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  userIds: Array<Scalars['String']>;
};

export type CreateAppointmentWithGroupInput = {
  dates: Array<IntervalInput>;
  groupId: Scalars['String'];
  isDaycare?: InputMaybe<Scalars['Boolean']>;
  isPrivate?: InputMaybe<Scalars['Boolean']>;
  location: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  teamId?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  userIds: Array<Scalars['String']>;
};

export type CreateContactInput = {
  city?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  streetAddress?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export type CreateDaycareAppointmentWithDonorsInput = {
  dates: Array<IntervalInput>;
  donorIds: Array<Scalars['String']>;
  isDaycare?: InputMaybe<Scalars['Boolean']>;
  isPrivate?: InputMaybe<Scalars['Boolean']>;
  location: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  userIds: Array<Scalars['String']>;
};

export type CreateDonationInput = {
  actual?: InputMaybe<Scalars['Float']>;
  approvedDonationsMl: Scalars['Float'];
  capillaryRefillTime: CapillaryRefillTime;
  collectionSet: CollectionSet;
  comment?: InputMaybe<Scalars['String']>;
  donationDate?: InputMaybe<Scalars['DateTime']>;
  donorId: Scalars['String'];
  examinationNotes?: InputMaybe<Scalars['String']>;
  failedReason?: InputMaybe<DonationFailedReason>;
  ineligible?: InputMaybe<Scalars['Boolean']>;
  ineligibleReason?: InputMaybe<IneligibleReason>;
  ineligibleReasonDetails?: InputMaybe<Scalars['String']>;
  jugularVein: JugularVein;
  maxLimit: Scalars['Float'];
  mucousMembrane: Mm;
  packedCellVolume: Scalars['Float'];
  preferences?: InputMaybe<Scalars['String']>;
  pulse: Scalars['Float'];
  respiration: Scalars['Float'];
  shouldDonate: Scalars['Boolean'];
  temperature: Scalars['Float'];
  totalSolids: Scalars['Float'];
  unit?: InputMaybe<DonationUnit>;
  weatherTemperature: Scalars['Float'];
  weatherTypes: Array<WeatherType>;
  weight: Scalars['Float'];
  working?: InputMaybe<Scalars['Boolean']>;
};

export type CreateDonationWithAdditionalInfoInput = {
  additionalInfo: AdditionalInfoInput;
  vitals: CreateDonationInput;
};

export type CreateDonationsWithAdditionalInfoInput = {
  donations: Array<DonationWithAdditionalInfoInput>;
};

export type CreateDonorContactInput = {
  contactType: ContactType;
  donorId: Scalars['String'];
  /** ISO date string for follow-up */
  followUpDate?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
};

export type CreateDonorForUserInput = {
  donorData: CreateDonorInput;
  userId: Scalars['String'];
};

export type CreateDonorInput = {
  acceptSimparicaTrio?: InputMaybe<Scalars['Boolean']>;
  attendDaycareDays?: InputMaybe<Array<Scalars['String']>>;
  bloodType?: InputMaybe<BloodType>;
  breed?: InputMaybe<Scalars['String']>;
  canRegularlyAttendDaycare?: InputMaybe<Scalars['Boolean']>;
  color?: InputMaybe<Scalars['String']>;
  comment?: InputMaybe<Scalars['String']>;
  dateOfBirth: Scalars['DateTime'];
  distemperDate?: InputMaybe<Scalars['DateTime']>;
  distinguishableMarks?: InputMaybe<Scalars['String']>;
  gender: AnimalGender;
  hasHeartMurmur?: InputMaybe<Scalars['Boolean']>;
  hasMicrochip?: InputMaybe<Scalars['Boolean']>;
  hasTransfusion?: InputMaybe<Scalars['Boolean']>;
  location: Scalars['String'];
  medicationCourse?: InputMaybe<Scalars['String']>;
  microchipNumber?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  neutered: Scalars['Boolean'];
  primaryVeterinarian: Scalars['String'];
  rabiesDate?: InputMaybe<Scalars['DateTime']>;
  retiredDate?: InputMaybe<Scalars['DateTime']>;
  retiredReason?: InputMaybe<RetiredReasons>;
  retiredReasonComment?: InputMaybe<Scalars['String']>;
  species: AnimalSpecies;
  status?: InputMaybe<DonorStatus>;
  takeMedications?: InputMaybe<Scalars['Boolean']>;
  teamId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<DonorType>;
  weight: Scalars['Float'];
};

export type CreateDonorNoteInput = {
  donorId: Scalars['String'];
  text: Scalars['String'];
};

export type CreateDonors = {
  donorsData: Array<CreateDonorInput>;
};

export type CreateDonorsForUserInput = {
  donorsData: Array<CreateDonorInput>;
  userId: Scalars['String'];
};

export type CreateDvmExamInput = {
  donorId: Scalars['String'];
  examinationDate: Scalars['DateTime'];
  notes?: InputMaybe<Scalars['String']>;
  performedById: Scalars['String'];
};

export type CreateEmptyAppointmentInput = {
  dates: Array<IntervalInput>;
  isDaycare?: InputMaybe<Scalars['Boolean']>;
  isPrivate?: InputMaybe<Scalars['Boolean']>;
  location: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  userIds: Array<Scalars['String']>;
};

export type CreateGroupInput = {
  team?: InputMaybe<CreateTeamInput>;
  title: Scalars['String'];
  userId: Scalars['String'];
};

export type CreateLabworkInput = {
  collectionDate: Scalars['DateTime'];
  donorId: Scalars['String'];
};

export type CreateLocationInput = {
  name: Scalars['String'];
  regionId?: InputMaybe<Scalars['String']>;
  type: LocationType;
};

export type CreateOfficeInput = {
  idexxAccountNumber?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  regionId: Scalars['String'];
  zoetisAccountNumber?: InputMaybe<Scalars['String']>;
};

export type CreateProductInput = {
  anticoagulant?: InputMaybe<Anticoagulant>;
  discardedData?: InputMaybe<DiscardedProductDataInput>;
  donationId: Scalars['String'];
  isMantelAssigned?: InputMaybe<Scalars['Boolean']>;
  regionPreferenceId?: InputMaybe<Scalars['String']>;
  respin?: InputMaybe<Scalars['Boolean']>;
  storageRequirements: Array<Scalars['String']>;
  value: Scalars['Float'];
  woocommerceCategoryId: Scalars['Float'];
  woocommerceProductId: Scalars['Float'];
};

export type CreateProductsInput = {
  products: Array<CreateProductInput>;
};

export type CreateRegionInput = {
  idexxAccountNumber?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  zoetisAccountNumber?: InputMaybe<Scalars['String']>;
};

export type CreateTeamInput = {
  groupId?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};

export type CurrentUserAppointmentsFilterInput = {
  locations?: InputMaybe<Array<Scalars['String']>>;
};

export type CurrentUserDonorListFilterInput = {
  isDaycare?: InputMaybe<Scalars['Boolean']>;
  locations?: InputMaybe<Array<Scalars['String']>>;
  name?: InputMaybe<Scalars['String']>;
  searchingQuery?: InputMaybe<Scalars['String']>;
};

export type CurrentUserDonorListInput = {
  filter?: InputMaybe<CurrentUserDonorListFilterInput>;
  skip?: Scalars['Float'];
  sort?: InputMaybe<Array<SortUserDonorListInput>>;
  take?: Scalars['Float'];
};

export type CursorPaginationMetaData = {
  __typename?: 'CursorPaginationMetaData';
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<Scalars['String']>;
  total: Scalars['Float'];
};

export type CustomerOutput = {
  __typename?: 'CustomerOutput';
  billing: BillingOutput;
  email?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  id: Scalars['String'];
  lastName: Scalars['String'];
  shipping: ShippingOutput;
  username: Scalars['String'];
};

export type DailyRegistrationOutput = {
  __typename?: 'DailyRegistrationOutput';
  /** Number of donors registered on this day */
  count: Scalars['Int'];
  /** Date in YYYY-MM-DD format */
  date: Scalars['String'];
  /** ISO day of week (1=Monday, 7=Sunday) */
  isoWeekday: Scalars['Int'];
};

export type DataAuditPipelineDonorRow = {
  __typename?: 'DataAuditPipelineDonorRow';
  /** Donor registration date */
  createdAt: Scalars['DateTime'];
  /** Donor ID */
  donorId: Scalars['String'];
  /** Donor location text */
  donorLocation?: Maybe<Scalars['String']>;
  /** Donor name */
  donorName: Scalars['String'];
  /** Donor status */
  donorStatus: Scalars['String'];
  /** Owner full name */
  ownerFullName?: Maybe<Scalars['String']>;
  /** Region name */
  regionName?: Maybe<Scalars['String']>;
};

export type DataAuditPipelineDonorsOutput = {
  __typename?: 'DataAuditPipelineDonorsOutput';
  /** Donor count */
  donorCount: Scalars['Int'];
  /** Individual donor rows */
  rows: Array<DataAuditPipelineDonorRow>;
  /** Statuses queried */
  statuses: Array<Scalars['String']>;
};

export type DataAuditRecruitedDonorRow = {
  __typename?: 'DataAuditRecruitedDonorRow';
  /** Donor registration date */
  createdAt: Scalars['DateTime'];
  /** Donor ID */
  donorId: Scalars['String'];
  /** Donor location text */
  donorLocation?: Maybe<Scalars['String']>;
  /** Donor name */
  donorName: Scalars['String'];
  /** Donor status */
  donorStatus?: Maybe<Scalars['String']>;
  /** Owner full name */
  ownerFullName?: Maybe<Scalars['String']>;
  /** Region name */
  regionName?: Maybe<Scalars['String']>;
};

export type DataAuditRecruitedDonorsOutput = {
  __typename?: 'DataAuditRecruitedDonorsOutput';
  /** Recruited donor count */
  donorCount: Scalars['Int'];
  /** Period end */
  periodEnd: Scalars['DateTime'];
  /** Period start */
  periodStart: Scalars['DateTime'];
  /** Individual donor rows */
  rows: Array<DataAuditRecruitedDonorRow>;
};

export type DataAuditUnitDonorRow = {
  __typename?: 'DataAuditUnitDonorRow';
  /** Donor ID */
  donorId: Scalars['String'];
  /** Donor location text */
  donorLocation?: Maybe<Scalars['String']>;
  /** Donor name */
  donorName: Scalars['String'];
  /** Donor status */
  donorStatus?: Maybe<Scalars['String']>;
  /** Owner full name */
  ownerFullName?: Maybe<Scalars['String']>;
  /** Region name */
  regionName?: Maybe<Scalars['String']>;
  /** Unit count for this donor in period */
  units: Scalars['Int'];
};

export type DataAuditUnitDonorsOutput = {
  __typename?: 'DataAuditUnitDonorsOutput';
  /** Period end */
  periodEnd: Scalars['DateTime'];
  /** Period start */
  periodStart: Scalars['DateTime'];
  /** Donor rows with unit counts */
  rows: Array<DataAuditUnitDonorRow>;
  /** Total unit count */
  unitCount: Scalars['Int'];
};

export type DataAuditUnitRow = {
  __typename?: 'DataAuditUnitRow';
  /** WooCommerce category ID */
  categoryId: Scalars['Int'];
  /** Donation date */
  donationDate?: Maybe<Scalars['DateTime']>;
  /** Donation ID */
  donationId: Scalars['String'];
  /** Donor ID */
  donorId: Scalars['String'];
  /** Donor location text */
  donorLocation?: Maybe<Scalars['String']>;
  /** Donor name */
  donorName: Scalars['String'];
  /** Donor short ID */
  donorShortId: Scalars['Int'];
  /** Donor status */
  donorStatus?: Maybe<Scalars['String']>;
  /** Owner full name */
  ownerFullName?: Maybe<Scalars['String']>;
  /** Owner short ID */
  ownerShortId?: Maybe<Scalars['Int']>;
  /** Product created date */
  productCreatedAt: Scalars['DateTime'];
  /** Product ID */
  productId: Scalars['String'];
  /** Product short ID */
  productShortId: Scalars['Int'];
  /** Product status */
  productStatus: Scalars['String'];
  /** Region name */
  regionName?: Maybe<Scalars['String']>;
  /** Unit type label (pRBC or FFP) */
  unitType: Scalars['String'];
  /** WooCommerce product ID */
  woocommerceProductId: Scalars['Int'];
};

export type DataAuditUnitsOutput = {
  __typename?: 'DataAuditUnitsOutput';
  /** Distinct donor count */
  donorCount: Scalars['Int'];
  /** Period end (null for all-time) */
  periodEnd?: Maybe<Scalars['DateTime']>;
  /** Period start (null for all-time) */
  periodStart?: Maybe<Scalars['DateTime']>;
  /** Individual product rows */
  rows: Array<DataAuditUnitRow>;
  /** Total unit count */
  unitCount: Scalars['Int'];
};

export type DateRangeInput = {
  /** End of the date range */
  end: Scalars['DateTime'];
  /** Start of the date range */
  start: Scalars['DateTime'];
};

export type DaycareAppointmentDetailOutput = {
  __typename?: 'DaycareAppointmentDetailOutput';
  appointment: AppointmentOutput;
  interactions: Array<DaycareAppointmentResponseOutput>;
  meta: DaycareAppointmentMetaOutput;
  requests: Array<DaycareAppointmentRequestOutput>;
};

export type DaycareAppointmentMetaOutput = {
  __typename?: 'DaycareAppointmentMetaOutput';
  maxDonorsCapacity: Scalars['Int'];
  registeredDonors: Scalars['Int'];
};

export type DaycareAppointmentRequestOutput = {
  __typename?: 'DaycareAppointmentRequestOutput';
  donor: DonorOutput;
  id: Scalars['String'];
  note?: Maybe<Scalars['String']>;
  user: OwnerOutput;
};

export type DaycareAppointmentResponseOutput = {
  __typename?: 'DaycareAppointmentResponseOutput';
  id: Scalars['String'];
  note?: Maybe<Scalars['String']>;
  owner: OwnerOutput;
  ownerResponse: Scalars['Boolean'];
  registeredDonors: Array<DonorOutput>;
};

export enum DaycareRegistrationStatus {
  Registered = 'Registered',
  RegisteredWithNo = 'RegisteredWithNo',
  Requested = 'Requested',
  Unregister = 'Unregister'
}

export type DaycareUnenrollDonorInput = {
  daycareId: Scalars['String'];
  donorId: Scalars['String'];
};

export type DeleteDonorInput = {
  id: Scalars['String'];
};

export type DeleteDonorNoteInput = {
  id: Scalars['String'];
};

export type DeleteLocationInput = {
  id: Scalars['String'];
};

export type DeleteOfficeInput = {
  id: Scalars['String'];
};

export type DeleteProductInput = {
  id: Scalars['String'];
};

export type DeleteRegionInput = {
  id: Scalars['String'];
};

export type DetachLabworkFileInput = {
  fileId: Scalars['String'];
  id: Scalars['String'];
};

export type DetachUserAttachmentInput = {
  fileId: Scalars['String'];
  id: Scalars['String'];
};

export type DiscardReasonCount = {
  __typename?: 'DiscardReasonCount';
  count: Scalars['Int'];
  reason: Scalars['String'];
};

export type DiscardReasonCountOutput = {
  __typename?: 'DiscardReasonCountOutput';
  /** Number of products discarded for this reason */
  count: Scalars['Int'];
  /** Discard reason */
  reason: ReasonDiscardProduct;
};

export type DiscardedProductDataInput = {
  notes?: InputMaybe<Scalars['String']>;
  processingType: ProcessingProductType;
  processorId: Scalars['String'];
  reason: ReasonDiscardProduct;
};

export type DiscardedProductDataOutput = {
  __typename?: 'DiscardedProductDataOutput';
  notes?: Maybe<Scalars['String']>;
  processingType: ProcessingProductType;
  processor?: Maybe<ProductProcessorOutput>;
  reason: ReasonDiscardProduct;
};

export type DiscardedProductDataReportOutput = {
  __typename?: 'DiscardedProductDataReportOutput';
  notes?: Maybe<Scalars['String']>;
  processingType: ProcessingProductType;
  processor?: Maybe<ProductProcessorOutput>;
  reason: ReasonDiscardProduct;
};

export type DiscardedUnitEntry = {
  __typename?: 'DiscardedUnitEntry';
  createdAt: Scalars['String'];
  discardNotes?: Maybe<Scalars['String']>;
  discardReason: Scalars['String'];
  donationDate?: Maybe<Scalars['String']>;
  donorName: Scalars['String'];
  location?: Maybe<Scalars['String']>;
  ownerName?: Maybe<Scalars['String']>;
  productShortId: Scalars['Int'];
  regionName?: Maybe<Scalars['String']>;
  woocommerceCategoryId: Scalars['Int'];
  woocommerceProductId: Scalars['Int'];
};

export type DonationDonor = {
  __typename?: 'DonationDonor';
  acceptSimparicaTrio: Scalars['Boolean'];
  age: Scalars['Float'];
  approvedDonationML: Scalars['Float'];
  attendDaycareDays?: Maybe<Array<Scalars['String']>>;
  becameReservedDonorDate?: Maybe<Scalars['DateTime']>;
  bloodType?: Maybe<BloodType>;
  breed?: Maybe<Scalars['String']>;
  canRegularlyAttendDaycare?: Maybe<Scalars['Boolean']>;
  color?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  dateOfBirth: Scalars['DateTime'];
  distemperDate?: Maybe<Scalars['DateTime']>;
  distinguishableMarks?: Maybe<Scalars['String']>;
  donationFrequency: Scalars['Float'];
  donationMLApprovedAmount?: Maybe<Scalars['Float']>;
  firstCertificatePrinted: Scalars['Boolean'];
  gender: AnimalGender;
  hasHeartMurmur?: Maybe<Scalars['Boolean']>;
  hasMicrochip?: Maybe<Scalars['Boolean']>;
  hasTransfusion?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  isDaycare?: Maybe<Scalars['Boolean']>;
  lastDonationDate?: Maybe<Scalars['DateTime']>;
  lastLabworkDate?: Maybe<Scalars['DateTime']>;
  lastLabworkFile?: Maybe<Array<FileOutput>>;
  location: Scalars['String'];
  medicationCourse?: Maybe<Scalars['String']>;
  microchipNumber?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  neutered: Scalars['Boolean'];
  nextDonationDate?: Maybe<Scalars['DateTime']>;
  pictures?: Maybe<Array<DonorPictureOutput>>;
  primaryVeterinarian: Scalars['String'];
  rabiesDate?: Maybe<Scalars['DateTime']>;
  reserveNotes?: Maybe<Array<ReserveDonorNoteOutput>>;
  retiredDate?: Maybe<Scalars['DateTime']>;
  retiredReason?: Maybe<RetiredReasons>;
  retiredReasonComment?: Maybe<Scalars['String']>;
  secondCertificatePrinted: Scalars['Boolean'];
  shortId: Scalars['Float'];
  species: AnimalSpecies;
  status: DonorStatus;
  takeMedications?: Maybe<Scalars['Boolean']>;
  team?: Maybe<TeamOutput>;
  type: DonorType;
  user?: Maybe<HolderOutput>;
  weight: Scalars['Float'];
};

export type DonationDonorReportOutput = {
  __typename?: 'DonationDonorReportOutput';
  acceptSimparicaTrio: Scalars['Boolean'];
  age: Scalars['Float'];
  approvedDonationML: Scalars['Float'];
  becameReservedDonorDate?: Maybe<Scalars['DateTime']>;
  bloodType?: Maybe<BloodType>;
  breed?: Maybe<Scalars['String']>;
  canRegularlyAttendDaycare?: Maybe<Scalars['Boolean']>;
  color?: Maybe<Scalars['String']>;
  distemperDate?: Maybe<Scalars['DateTime']>;
  donationFrequency: Scalars['Float'];
  donationMLApprovedAmount?: Maybe<Scalars['Float']>;
  donorStatusUpdatedAt: Scalars['DateTime'];
  dvmExamDue?: Maybe<Scalars['DateTime']>;
  dvmExamPerformedBy?: Maybe<Scalars['String']>;
  gender: AnimalGender;
  id: Scalars['String'];
  isDaycare: Scalars['Boolean'];
  labWorkDue?: Maybe<Scalars['DateTime']>;
  location: Scalars['String'];
  microchipNumber?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  neutered: Scalars['Boolean'];
  nextDonationDate?: Maybe<Scalars['DateTime']>;
  notes: Array<DonorNoteOutput>;
  primaryVeterinarian: Scalars['String'];
  rabiesDate?: Maybe<Scalars['DateTime']>;
  region?: Maybe<Scalars['String']>;
  retiredDate?: Maybe<Scalars['DateTime']>;
  retiredReason?: Maybe<RetiredReasons>;
  retiredReasonComment?: Maybe<Scalars['String']>;
  shortId: Scalars['Float'];
  species: AnimalSpecies;
  status: DonorStatus;
  totalCollected?: Maybe<Scalars['Float']>;
  type: DonorType;
  user?: Maybe<DonationOwnerReportOutput>;
  weight: Scalars['Float'];
};

export enum DonationFailedReason {
  Medical = 'Medical',
  Phlebotomy = 'Phlebotomy',
  Restraint = 'Restraint'
}

export type DonationListFilterInput = {
  bloodTypes?: InputMaybe<Array<BloodType>>;
  discarded?: InputMaybe<Scalars['Boolean']>;
  failed?: InputMaybe<Scalars['Boolean']>;
  fromDate?: InputMaybe<Scalars['DateTime']>;
  ineligible?: InputMaybe<Scalars['Boolean']>;
  locationQuery?: InputMaybe<Scalars['String']>;
  locations?: InputMaybe<Array<Scalars['String']>>;
  productCategories?: InputMaybe<Array<Scalars['Float']>>;
  searchQuery?: InputMaybe<Scalars['String']>;
  toDate?: InputMaybe<Scalars['DateTime']>;
};

export type DonationListOutput = {
  __typename?: 'DonationListOutput';
  data: Array<DonationOutput>;
  meta: MetaData;
};

export enum DonationListSort {
  DonorName = 'DonorName',
  LastDonationDate = 'LastDonationDate',
  OwnerLastName = 'OwnerLastName'
}

export type DonationOutput = {
  __typename?: 'DonationOutput';
  actual?: Maybe<Scalars['Float']>;
  additionalInfo?: Maybe<AdditionalDonationInfoOutput>;
  approvedDonationsMl: Scalars['Float'];
  capillaryRefillTime: CapillaryRefillTime;
  collectionSet: CollectionSet;
  comment?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  donationDate: Scalars['DateTime'];
  donor: DonationDonor;
  examinationNotes?: Maybe<Scalars['String']>;
  failedReason?: Maybe<DonationFailedReason>;
  id: Scalars['String'];
  ineligible: Scalars['Boolean'];
  ineligibleReason?: Maybe<IneligibleReason>;
  ineligibleReasonDetails?: Maybe<Scalars['String']>;
  jugularVein: JugularVein;
  maxLimit: Scalars['Float'];
  mucousMembrane: Mm;
  packedCellVolume: Scalars['Float'];
  preferences?: Maybe<Scalars['String']>;
  products?: Maybe<Array<DonationProductOutput>>;
  pulse: Scalars['Float'];
  respiration: Scalars['Float'];
  shortId: Scalars['Float'];
  shouldDonate?: Maybe<Scalars['Boolean']>;
  temperature: Scalars['Float'];
  totalSolids: Scalars['Float'];
  unit?: Maybe<DonationUnit>;
  weatherTemperature: Scalars['Float'];
  weatherTypes: Array<WeatherType>;
  weight: Scalars['Float'];
};

export type DonationOwnerReportOutput = {
  __typename?: 'DonationOwnerReportOutput';
  birthday?: Maybe<Scalars['DateTime']>;
  city?: Maybe<Scalars['String']>;
  contactPreferences?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  id: Scalars['String'];
  isArchived: Scalars['Boolean'];
  lastName: Scalars['String'];
  locationPreferences?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  regionPreferences?: Maybe<Scalars['String']>;
  shortId: Scalars['Float'];
  state?: Maybe<Scalars['String']>;
  streetAddress?: Maybe<Scalars['String']>;
  type?: Maybe<OwnerType>;
  zipCode?: Maybe<Scalars['String']>;
};

export type DonationProductOutput = {
  __typename?: 'DonationProductOutput';
  anticoagulant?: Maybe<Anticoagulant>;
  bloodIdentifiers?: Maybe<Array<BloodUnitIdentifiersOutput>>;
  createdAt: Scalars['DateTime'];
  discardedProduct?: Maybe<DiscardedProductDataOutput>;
  expirationDate: Scalars['DateTime'];
  id: Scalars['String'];
  isMantelAssigned?: Maybe<Scalars['Boolean']>;
  publishable: Scalars['Boolean'];
  published: Scalars['Boolean'];
  regionPreference?: Maybe<RegionOutput>;
  respin?: Maybe<Scalars['Boolean']>;
  shortId: Scalars['Float'];
  status: ProductStatus;
  storageRequirements: Array<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  value: Scalars['Float'];
  woocommerceCategoryId: Scalars['Float'];
  woocommerceOrderId?: Maybe<Scalars['Float']>;
  woocommerceProductId: Scalars['Float'];
};

export type DonationProductRecordOutput = {
  __typename?: 'DonationProductRecordOutput';
  /** Discard reason if discarded */
  discardReason?: Maybe<Scalars['String']>;
  /** WooCommerce order ID if sold */
  orderId?: Maybe<Scalars['Int']>;
  /** WooCommerce product ID */
  productId: Scalars['Int'];
  /** Product status (Collected, Processed, Sold, Discarded, etc.) */
  status: Scalars['String'];
  /** Product type: pRBC, FFP, FP, Whole Blood, etc. */
  type: Scalars['String'];
};

export type DonationRecordOutput = {
  __typename?: 'DonationRecordOutput';
  /** Actual FFP from double donor produced */
  actualFFPDouble: Scalars['Int'];
  /** Actual FFP from single donor produced */
  actualFFPSingle: Scalars['Int'];
  /** Actual collected mL */
  actualML?: Maybe<Scalars['Int']>;
  /** Actual pRBC units produced */
  actualPRBC: Scalars['Int'];
  /** Approved collection amount in mL */
  approvedML: Scalars['Int'];
  /** Collection set type */
  collectionSet?: Maybe<Scalars['String']>;
  date: Scalars['DateTime'];
  /** Donation unit (0, 1, or 2 units) */
  donationUnit?: Maybe<Scalars['String']>;
  donorId: Scalars['String'];
  donorName: Scalars['String'];
  /** Examination notes */
  examinationNotes?: Maybe<Scalars['String']>;
  /** Expected FFP from double donor */
  expectedFFPDouble: Scalars['Int'];
  /** Expected FFP from single donor */
  expectedFFPSingle: Scalars['Int'];
  /** Expected pRBC units */
  expectedPRBC: Scalars['Int'];
  /** Discard reasons for failed/partial donations (e.g. Clots, LowVolume) */
  failureReasons: Array<Scalars['String']>;
  id: Scalars['String'];
  /** Ineligible reason if applicable */
  ineligibleReason?: Maybe<Scalars['String']>;
  locationName: Scalars['String'];
  phlebotomistName: Scalars['String'];
  /** Individual products produced from this donation */
  products: Array<DonationProductRecordOutput>;
  regionName: Scalars['String'];
  /** Auto-increment short ID */
  shortId: Scalars['Int'];
  /** Status: 'Complete', 'DBL→SGL', 'Ineligible', 'Partial', 'Failed', 'Pending' */
  status: Scalars['String'];
  /** 'Single' or 'Double' */
  type: Scalars['String'];
  /** Vein side used */
  veinSide?: Maybe<Scalars['String']>;
};

export type DonationReportOutput = {
  __typename?: 'DonationReportOutput';
  actual?: Maybe<Scalars['Float']>;
  additionalInfo?: Maybe<AdditionalDonationInfoReportOutput>;
  approvedDonationsMl: Scalars['Float'];
  capillaryRefillTime: CapillaryRefillTime;
  comment?: Maybe<Scalars['String']>;
  donationDate: Scalars['DateTime'];
  donationNumber: Scalars['Float'];
  donor?: Maybe<DonationDonorReportOutput>;
  failedReason?: Maybe<DonationFailedReason>;
  id: Scalars['String'];
  ineligibleReason?: Maybe<IneligibleReason>;
  jugularVein: JugularVein;
  mucousMembrane: Mm;
  packedCellVolume: Scalars['Float'];
  products?: Maybe<Array<ProductReportOutput>>;
  pulse: Scalars['Float'];
  respiration: Scalars['Float'];
  shortId: Scalars['Float'];
  temperature: Scalars['Float'];
  totalSolids: Scalars['Float'];
  unit?: Maybe<DonationUnit>;
  weight: Scalars['Float'];
  working: Scalars['Boolean'];
};

export enum DonationUnit {
  Unit0 = 'Unit0',
  Unit1 = 'Unit1',
  Unit2 = 'Unit2'
}

export enum DonationUnitType {
  Dbl = 'DBL',
  Sgl = 'SGL'
}

export type DonationWithAdditionalInfoInput = {
  additional: AdditionalDonationInfoInput;
  vitals: VitalsDonationInfoInput;
};

export type DonationsAnalyticsInput = {
  filter?: InputMaybe<DonationListFilterInput>;
  skip?: Scalars['Float'];
  sort?: InputMaybe<Array<SortDonationListInput>>;
  take?: Scalars['Float'];
};

export type DonorAnalyticsOutput = {
  __typename?: 'DonorAnalyticsOutput';
  statusBreakdown: Array<DonorStatusCount>;
  totalDoubleDonors: Scalars['Int'];
  totalExperiencedDonors: Scalars['Int'];
  totalNewDonors: Scalars['Int'];
  totalSingleDonors: Scalars['Int'];
};

export type DonorAnalyticsQueryInput = {
  filter?: InputMaybe<DonorListFilterInput>;
};

export type DonorContactOutput = {
  __typename?: 'DonorContactOutput';
  contactType: ContactType;
  createdAt: Scalars['String'];
  donorId: Scalars['String'];
  followUpDate?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  notes?: Maybe<Scalars['String']>;
  user: DonorContactUserOutput;
};

export type DonorContactUserOutput = {
  __typename?: 'DonorContactUserOutput';
  firstName: Scalars['String'];
  id: Scalars['String'];
  lastName: Scalars['String'];
};

export type DonorDonationHistoryOutput = {
  __typename?: 'DonorDonationHistoryOutput';
  donations: Array<DonorDonationHistoryRecordOutput>;
  /** Total number of donations */
  total: Scalars['Int'];
};

export type DonorDonationHistoryRecordOutput = {
  __typename?: 'DonorDonationHistoryRecordOutput';
  approvedML: Scalars['Int'];
  date: Scalars['DateTime'];
  donorName: Scalars['String'];
  id: Scalars['String'];
  locationName: Scalars['String'];
  regionName: Scalars['String'];
  shortId: Scalars['Int'];
  /** Complete | Partial | Failed | DBL→SGL | Pending | Ineligible */
  status: Scalars['String'];
  /** 'Single' or 'Double' */
  type: Scalars['String'];
};

export type DonorLastDonationIntervalInput = {
  from: Scalars['Float'];
  to: Scalars['Float'];
};

export type DonorListFilterInput = {
  bloodType?: InputMaybe<Array<BloodType>>;
  createdAtFrom?: InputMaybe<Scalars['DateTime']>;
  createdAtTo?: InputMaybe<Scalars['DateTime']>;
  groupId?: InputMaybe<Scalars['String']>;
  isDaycare?: InputMaybe<Scalars['Boolean']>;
  lastDonationInterval?: InputMaybe<DonorLastDonationIntervalInput>;
  locations?: InputMaybe<Array<Scalars['String']>>;
  maxApprovedDonationML?: InputMaybe<Scalars['Float']>;
  minApprovedDonationML?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
  searchingQuery?: InputMaybe<Scalars['String']>;
  statuses?: InputMaybe<Array<DonorStatus>>;
  teamId?: InputMaybe<Scalars['String']>;
  types?: InputMaybe<Array<DonorType>>;
};

export enum DonorListSort {
  LastName = 'LastName',
  Name = 'Name',
  ReservedDate = 'ReservedDate',
  Team = 'Team'
}

export type DonorNoteFileOutput = {
  __typename?: 'DonorNoteFileOutput';
  createdAt: Scalars['DateTime'];
  file: FileOutput;
  id: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type DonorNoteOutput = {
  __typename?: 'DonorNoteOutput';
  createdAt: Scalars['DateTime'];
  files: Array<DonorNoteFileOutput>;
  id: Scalars['String'];
  isPinned: Scalars['Boolean'];
  text: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  user: UserOutput;
};

export type DonorOutput = {
  __typename?: 'DonorOutput';
  acceptSimparicaTrio: Scalars['Boolean'];
  age: Scalars['Float'];
  approvedDonationML: Scalars['Float'];
  attendDaycareDays?: Maybe<Array<Scalars['String']>>;
  becameReservedDonorDate?: Maybe<Scalars['DateTime']>;
  bloodType?: Maybe<BloodType>;
  breed?: Maybe<Scalars['String']>;
  canRegularlyAttendDaycare?: Maybe<Scalars['Boolean']>;
  color?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  dateOfBirth: Scalars['DateTime'];
  distemperDate?: Maybe<Scalars['DateTime']>;
  distinguishableMarks?: Maybe<Scalars['String']>;
  donationFrequency: Scalars['Float'];
  donationMLApprovedAmount?: Maybe<Scalars['Float']>;
  firstCertificatePrinted: Scalars['Boolean'];
  gender: AnimalGender;
  hasHeartMurmur?: Maybe<Scalars['Boolean']>;
  hasMicrochip?: Maybe<Scalars['Boolean']>;
  hasTransfusion?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  isDaycare?: Maybe<Scalars['Boolean']>;
  lastDonationDate?: Maybe<Scalars['DateTime']>;
  lastLabworkDate?: Maybe<Scalars['DateTime']>;
  lastLabworkFile?: Maybe<Array<FileOutput>>;
  location: Scalars['String'];
  medicationCourse?: Maybe<Scalars['String']>;
  microchipNumber?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  neutered: Scalars['Boolean'];
  nextDonationDate?: Maybe<Scalars['DateTime']>;
  pictures?: Maybe<Array<DonorPictureOutput>>;
  primaryVeterinarian: Scalars['String'];
  rabiesDate?: Maybe<Scalars['DateTime']>;
  reserveNotes?: Maybe<Array<ReserveDonorNoteOutput>>;
  retiredDate?: Maybe<Scalars['DateTime']>;
  retiredReason?: Maybe<RetiredReasons>;
  retiredReasonComment?: Maybe<Scalars['String']>;
  secondCertificatePrinted: Scalars['Boolean'];
  shortId: Scalars['Float'];
  species: AnimalSpecies;
  status: DonorStatus;
  takeMedications?: Maybe<Scalars['Boolean']>;
  team?: Maybe<TeamOutput>;
  type: DonorType;
  user?: Maybe<OwnerOutput>;
  weight: Scalars['Float'];
};

export type DonorOwnerReportOutput = {
  __typename?: 'DonorOwnerReportOutput';
  birthday?: Maybe<Scalars['DateTime']>;
  city?: Maybe<Scalars['String']>;
  contactPreferences?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  id: Scalars['String'];
  isArchived: Scalars['Boolean'];
  lastName: Scalars['String'];
  locationPreferences?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  regionPreferences?: Maybe<Scalars['String']>;
  shortId: Scalars['Float'];
  state?: Maybe<Scalars['String']>;
  streetAddress?: Maybe<Scalars['String']>;
  type?: Maybe<OwnerType>;
  zipCode?: Maybe<Scalars['String']>;
};

export type DonorPictureOutput = {
  __typename?: 'DonorPictureOutput';
  donor: DonorOutput;
  file: FileOutput;
  id: Scalars['String'];
  isPrimary: Scalars['Boolean'];
};

export type DonorPipelineStatsOutput = {
  __typename?: 'DonorPipelineStatsOutput';
  /** Current count of donors with active statuses */
  activeDonorCount: Scalars['Int'];
  /** Current count of donors with approved statuses */
  approvedDonorCount: Scalars['Int'];
  /** Daily registration breakdown for the last 7 days */
  lastWeekDaily: Array<DailyRegistrationOutput>;
  /** Current count of donors with pending statuses */
  pendingDonorCount: Scalars['Int'];
  /** New donor registrations for each time period */
  registrationsByPeriod: Array<PeriodRegistrationOutput>;
};

export type DonorReportOutput = {
  __typename?: 'DonorReportOutput';
  acceptSimparicaTrio: Scalars['Boolean'];
  age: Scalars['Float'];
  approvedDonationML: Scalars['Float'];
  becameReservedDonorDate?: Maybe<Scalars['DateTime']>;
  bloodType?: Maybe<BloodType>;
  breed?: Maybe<Scalars['String']>;
  canRegularlyAttendDaycare?: Maybe<Scalars['Boolean']>;
  color?: Maybe<Scalars['String']>;
  distemperDate?: Maybe<Scalars['DateTime']>;
  donationFrequency: Scalars['Float'];
  donationMLApprovedAmount?: Maybe<Scalars['Float']>;
  donorStatusUpdatedAt: Scalars['DateTime'];
  dvmExamDue?: Maybe<Scalars['DateTime']>;
  dvmExamPerformedBy?: Maybe<Scalars['String']>;
  gender: AnimalGender;
  id: Scalars['String'];
  isDaycare: Scalars['Boolean'];
  labWorkDue?: Maybe<Scalars['DateTime']>;
  location: Scalars['String'];
  microchipNumber?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  neutered: Scalars['Boolean'];
  nextDonationDate?: Maybe<Scalars['DateTime']>;
  notes: Array<DonorNoteOutput>;
  primaryVeterinarian: Scalars['String'];
  rabiesDate?: Maybe<Scalars['DateTime']>;
  region?: Maybe<Scalars['String']>;
  retiredDate?: Maybe<Scalars['DateTime']>;
  retiredReason?: Maybe<RetiredReasons>;
  retiredReasonComment?: Maybe<Scalars['String']>;
  shortId: Scalars['Float'];
  species: AnimalSpecies;
  status: DonorStatus;
  totalCollected?: Maybe<Scalars['Float']>;
  type: DonorType;
  user?: Maybe<DonorOwnerReportOutput>;
  weight: Scalars['Float'];
};

export type DonorStatsOutput = {
  __typename?: 'DonorStatsOutput';
  ffpUnitsCreated: Scalars['Int'];
  prbcCreated: Scalars['Int'];
  totalDonations: Scalars['Int'];
  totalMlsDonated: Scalars['Float'];
};

export enum DonorStatus {
  Active = 'Active',
  Affiliate = 'Affiliate',
  AnnualLabworkDue = 'AnnualLabworkDue',
  Approved = 'Approved',
  Archived = 'Archived',
  LabworkPending = 'LabworkPending',
  NotAccepted = 'NotAccepted',
  Pending = 'Pending',
  Registered = 'Registered',
  Requested = 'Requested',
  Retired = 'Retired',
  Trp = 'Trp'
}

export type DonorStatusCount = {
  __typename?: 'DonorStatusCount';
  count: Scalars['Int'];
  status: DonorStatus;
};

export type DonorStatusOutput = {
  __typename?: 'DonorStatusOutput';
  donorId: Scalars['ID'];
  id: Scalars['ID'];
  newStatus: Scalars['String'];
  previousStatus?: Maybe<Scalars['String']>;
};

export enum DonorType {
  Grouped = 'Grouped',
  Individual = 'Individual'
}

export type DonorsAnalyticsInput = {
  filter?: InputMaybe<DonorListFilterInput>;
  skip?: Scalars['Float'];
  sort?: InputMaybe<Array<SortDonorListInput>>;
  take?: Scalars['Float'];
};

export type DonorsListForTeamInput = {
  filter?: InputMaybe<DonorListFilterInput>;
  skip?: Scalars['Float'];
  sort?: InputMaybe<Array<SortDonorListInput>>;
  take?: Scalars['Float'];
  teamId: Scalars['String'];
  userId: Scalars['String'];
};

export type DonorsListInput = {
  filter?: InputMaybe<DonorListFilterInput>;
  skip?: Scalars['Float'];
  sort?: InputMaybe<Array<SortDonorListInput>>;
  take?: Scalars['Float'];
};

export type DonorsListOutput = {
  __typename?: 'DonorsListOutput';
  data: Array<DonorOutput>;
  meta: MetaData;
};

export type DonorsStatusListOutput = {
  __typename?: 'DonorsStatusListOutput';
  data: Array<DonorStatusOutput>;
  meta: MetaData;
};

export type DropoutHistoryOutput = {
  __typename?: 'DropoutHistoryOutput';
  /** Periods in ascending chronological order */
  periods: Array<DropoutHistoryPeriodOutput>;
};

export type DropoutHistoryPeriodOutput = {
  __typename?: 'DropoutHistoryPeriodOutput';
  /** Active donors at start of period */
  activeAtStart: Scalars['Int'];
  /** Donors who dropped out in this period */
  dropoutCount: Scalars['Int'];
  /** Dropout rate (dropouts / activeAtStart * 100) */
  dropoutRate: Scalars['Float'];
  /** Human-readable period label */
  label: Scalars['String'];
  /** ISO end date of this period */
  periodEnd: Scalars['String'];
  /** ISO start date of this period */
  periodStart: Scalars['String'];
};

export type DvmExamInput = {
  filter?: InputMaybe<DvmExamListFilterInput>;
  skip?: Scalars['Float'];
  sort?: InputMaybe<Array<SortDvmExamListInput>>;
  take?: Scalars['Float'];
};

export type DvmExamListFilterInput = {
  donorId?: InputMaybe<Scalars['String']>;
  donorStatuses?: InputMaybe<Array<DonorStatus>>;
  /** Return only the latest exam per donor */
  latestPerDonor?: InputMaybe<Scalars['Boolean']>;
  locationIds?: InputMaybe<Array<Scalars['String']>>;
  /** Next exam due (examinationDate + 1 year) is on or after */
  nextExamDueFrom?: InputMaybe<Scalars['DateTime']>;
  /** Next exam due (examinationDate + 1 year) is on or before */
  nextExamDueTo?: InputMaybe<Scalars['DateTime']>;
  performedById?: InputMaybe<Scalars['String']>;
  /** Match any of these vets (merged duplicate-name accounts) */
  performedByIds?: InputMaybe<Array<Scalars['String']>>;
  regionIds?: InputMaybe<Array<Scalars['String']>>;
  searchingQuery?: InputMaybe<Scalars['String']>;
};

export type DvmExamListOutput = {
  __typename?: 'DvmExamListOutput';
  data: Array<DvmExamOutput>;
  meta: MetaData;
};

export enum DvmExamListSort {
  DonorId = 'DonorId',
  ExaminationDate = 'ExaminationDate',
  LastName = 'LastName',
  Location = 'Location',
  NextExamDue = 'NextExamDue',
  PetName = 'PetName',
  Region = 'Region',
  Veterinarian = 'Veterinarian'
}

export type DvmExamOutput = {
  __typename?: 'DvmExamOutput';
  donor: DonorOutput;
  /** Location (daycare) attributed via ops-dashboard logic */
  donorLocation?: Maybe<Scalars['String']>;
  /** Region attributed via ops-dashboard location logic */
  donorRegion?: Maybe<Scalars['String']>;
  examinationDate: Scalars['DateTime'];
  id: Scalars['String'];
  /** examinationDate + 1 year; set on list queries */
  nextExamDue?: Maybe<Scalars['DateTime']>;
  notes?: Maybe<Scalars['String']>;
  performedBy: UserOutput;
};

export type EmailConfirmationInput = {
  code: Scalars['String'];
};

export type EnrollDonorInput = {
  donorId: Scalars['String'];
  id: Scalars['String'];
};

export type FeeLineOutput = {
  __typename?: 'FeeLineOutput';
  amount: Scalars['String'];
  id: Scalars['Float'];
  name: Scalars['String'];
  taxClass: Scalars['String'];
  taxStatus: TaxStatus;
  total: Scalars['String'];
  totalTax: Scalars['String'];
};

export type FileOutput = {
  __typename?: 'FileOutput';
  filename: Scalars['String'];
  id: Scalars['String'];
};

export type FindGroupInput = {
  id: Scalars['String'];
};

export type FindTeamInput = {
  id: Scalars['String'];
};

export enum FlowRate {
  Fast = 'Fast',
  IntermittentStopping = 'IntermittentStopping',
  Medium = 'Medium',
  NotApplicable = 'NotApplicable',
  OccasionalFlutter = 'OccasionalFlutter',
  PersistentFlutter = 'PersistentFlutter',
  Slow = 'Slow'
}

export type ForgotPasswordInput = {
  email: Scalars['String'];
};

export type GetAdditionalDonationInfoInput = {
  id: Scalars['String'];
};

export type GetAllDonorsStatusesInput = {
  skip?: Scalars['Float'];
  take?: Scalars['Float'];
};

export type GetAppSettingsInput = {
  settingsTab: Scalars['String'];
};

export type GetAppointmentInput = {
  id: Scalars['String'];
};

export type GetAppointmentsForCurrentUserInput = {
  end: Scalars['DateTime'];
  filter?: InputMaybe<CurrentUserAppointmentsFilterInput>;
  start: Scalars['DateTime'];
};

export type GetAppointmentsInput = {
  end: Scalars['DateTime'];
  filter?: InputMaybe<AppointmentsFilterInput>;
  start: Scalars['DateTime'];
};

export type GetChurnRateHistoryInput = {
  /** Statuses considered active */
  activeDonorStatuses?: InputMaybe<Array<DonorStatus>>;
  /** The current (most recent) period end date — used as anchor */
  anchorRange: DateRangeInput;
  /** Number of historical bars to return (default 12, max 12) */
  bars?: InputMaybe<Scalars['Int']>;
  /** Filter by location IDs */
  locationIds?: InputMaybe<Array<Scalars['String']>>;
  /** Filter by office IDs */
  officeIds?: InputMaybe<Array<Scalars['String']>>;
  /** Period granularity: week | month | quarter | weekCal | monthCal | quarterCal */
  periodType: Scalars['String'];
  /** Filter by region IDs */
  regionIds?: InputMaybe<Array<Scalars['String']>>;
};

export type GetCustomerInput = {
  id: Scalars['String'];
};

export type GetDataAuditDonorsInput = {
  /** Filter by donor statuses. Used for pipeline snapshot queries. */
  donorStatuses?: InputMaybe<Array<Scalars['String']>>;
  /** Period date range to filter donors by createdAt. Null for snapshot queries. */
  periodRange?: InputMaybe<DateRangeInput>;
  /** Filter by region IDs (empty/null = all regions) */
  regionIds?: InputMaybe<Array<Scalars['String']>>;
};

export type GetDataAuditUnitsInput = {
  /** Filter by location IDs (donor location) */
  locationIds?: InputMaybe<Array<Scalars['String']>>;
  /** Period date range to filter products by donation date. Null for all-time. */
  periodRange?: InputMaybe<DateRangeInput>;
  /** Filter by region IDs (empty/null = all regions) */
  regionIds?: InputMaybe<Array<Scalars['String']>>;
  /** WooCommerce category ID to filter products (31=pRBC, 33=FFP). Default: 31 */
  woocommerceCategoryId?: InputMaybe<Scalars['Int']>;
};

export type GetDonationInput = {
  id: Scalars['String'];
};

export type GetDonationReportsInput = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Float']>;
};

export type GetDonationsListInput = {
  filter?: InputMaybe<DonationListFilterInput>;
  skip?: Scalars['Float'];
  sort?: InputMaybe<Array<SortDonationListInput>>;
  take?: InputMaybe<Scalars['Float']>;
};

export type GetDonorDonationHistoryInput = {
  /** Donor UUID */
  donorId: Scalars['String'];
};

export type GetDonorDvmExamsInput = {
  donorId: Scalars['String'];
};

export type GetDonorInput = {
  id: Scalars['String'];
};

export type GetDonorPicturesInput = {
  id: Scalars['String'];
};

export type GetDonorPipelineStatsInput = {
  /** List of donor statuses considered "active" for active donor count */
  activeDonorStatuses?: InputMaybe<Array<DonorStatus>>;
  /** List of donor statuses considered "approved" for approved donor count */
  approvedDonorStatuses?: InputMaybe<Array<DonorStatus>>;
  /** Filter by location IDs (donor location) (optional) */
  locationIds?: InputMaybe<Array<Scalars['String']>>;
  /** Filter by office IDs (optional) */
  officeIds?: InputMaybe<Array<Scalars['String']>>;
  /** List of donor statuses considered "pending" for pending donor count */
  pendingDonorStatuses?: InputMaybe<Array<DonorStatus>>;
  /** Filter by region IDs (optional - returns all regions if empty) */
  regionIds?: InputMaybe<Array<Scalars['String']>>;
};

export type GetDonorStatsInput = {
  donorId: Scalars['String'];
};

export type GetDonorsByIdsInput = {
  ids: Array<Scalars['String']>;
};

export type GetDonorsReportInput = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Float']>;
};

export type GetDvmExamInput = {
  id: Scalars['String'];
};

export type GetIneligibleParticipantsReportsInput = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Float']>;
};

export type GetInvitationListInput = {
  filter?: InputMaybe<InvitationsListFilterInput>;
  skip?: Scalars['Float'];
  sort?: InputMaybe<Array<SortInvitationListInput>>;
  take?: Scalars['Float'];
};

export type GetLabworkAttachmentsListInput = {
  labworkId: Scalars['String'];
};

export type GetLabworkInput = {
  id: Scalars['String'];
};

export type GetLeaderboardHistoryInput = {
  /** Number of weeks to return (default: 52) */
  weeks?: InputMaybe<Scalars['Int']>;
};

export type GetLivesSavedByDonorInput = {
  donorId: Scalars['String'];
};

export type GetLocationsInput = {
  filter?: InputMaybe<LocationsFilterInput>;
  skip?: Scalars['Float'];
  take?: Scalars['Float'];
};

export type GetMetricsHistoryInput = {
  /** Statuses considered active */
  activeDonorStatuses?: InputMaybe<Array<DonorStatus>>;
  /** The current (most recent) period end date — used as anchor */
  anchorRange: DateRangeInput;
  /** Number of historical bars to return (default 12, max 12) */
  bars?: InputMaybe<Scalars['Int']>;
  /** Expected days between donations (used for show rate history) */
  donorDonationFrequency?: InputMaybe<Scalars['Int']>;
  /** Days after registration before a new donor is eligible to donate (default: 40, used for show rate history) */
  donorEligibilityDays?: InputMaybe<Scalars['Int']>;
  /** ISO date (YYYY-MM-DD) — periods whose start is before this date are excluded from results (donor_status_change_history cutoff) */
  historyDataCutoff?: InputMaybe<Scalars['String']>;
  /** Filter by location IDs */
  locationIds?: InputMaybe<Array<Scalars['String']>>;
  /** Filter by office IDs */
  officeIds?: InputMaybe<Array<Scalars['String']>>;
  /** Period granularity: week | month | quarter | weekCal | monthCal | quarterCal */
  periodType: Scalars['String'];
  /** Filter by region IDs */
  regionIds?: InputMaybe<Array<Scalars['String']>>;
  /** Min donations to be considered repeat donor (used for retention & ratio history) */
  repeatDonationsThreshold?: InputMaybe<Scalars['Int']>;
};

export type GetMicrochipPriceOutput = {
  __typename?: 'GetMicrochipPriceOutput';
  price: Scalars['Float'];
};

export type GetNightlyCountForTodayInput = {
  officeId: Scalars['String'];
};

export type GetNightlyCountsListInput = {
  /** ISO date (YYYY-MM-DD) */
  endDate?: InputMaybe<Scalars['String']>;
  officeId?: InputMaybe<Scalars['String']>;
  skip?: Scalars['Int'];
  /** ISO date (YYYY-MM-DD) */
  startDate?: InputMaybe<Scalars['String']>;
  take?: Scalars['Int'];
};

export type GetNotificationListInput = {
  filter?: InputMaybe<NotificationListFilterInput>;
  skip?: Scalars['Float'];
  take?: Scalars['Float'];
};

export type GetOpsOverviewStatsInput = {
  /** Period end */
  end: Scalars['DateTime'];
  /** Previous period end */
  prevEnd?: InputMaybe<Scalars['DateTime']>;
  /** Previous period start */
  prevStart?: InputMaybe<Scalars['DateTime']>;
  regionIds?: InputMaybe<Array<Scalars['String']>>;
  /** Period start */
  start: Scalars['DateTime'];
  /** WooCommerce product IDs for FFP DBL */
  wcFfpDblProductIds?: InputMaybe<Array<Scalars['Int']>>;
  /** WooCommerce product IDs for FFP SGL */
  wcFfpSglProductIds?: InputMaybe<Array<Scalars['Int']>>;
  /** Filter orders to these WooCommerce ship location names */
  wcLocationNames?: InputMaybe<Array<Scalars['String']>>;
  /** WooCommerce product IDs for pRBC */
  wcPrbcProductIds?: InputMaybe<Array<Scalars['Int']>>;
};

export type GetOrderInput = {
  id: Scalars['Float'];
};

export type GetOrdersListInput = {
  filter?: InputMaybe<OrdersListFilterInput>;
  skip?: Scalars['Float'];
  sort?: InputMaybe<OrdersListSortInput>;
  take?: Scalars['Float'];
};

export type GetOwnerListInput = {
  filter?: InputMaybe<OwnersListFilterInput>;
  skip?: Scalars['Float'];
  sort?: InputMaybe<Array<SortUserListInput>>;
  take?: Scalars['Float'];
};

export type GetOwnersReportsInput = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Float']>;
};

export type GetPermissionsInput = {
  filter?: InputMaybe<PermissionsFilterInput>;
};

export type GetPhlebotomistStatsInput = {
  /** Date range start (inclusive) */
  dateFrom: Scalars['DateTime'];
  /** Date range end (inclusive) */
  dateTo: Scalars['DateTime'];
  /** Filter by location IDs (donor location) (optional) */
  locationIds?: InputMaybe<Array<Scalars['String']>>;
  /** Filter by office IDs (phlebotomist assigned office) (optional) */
  officeIds?: InputMaybe<Array<Scalars['String']>>;
  /** Filter by specific phlebotomist ID (optional - returns all if not specified) */
  phlebotomistId?: InputMaybe<Scalars['String']>;
  /** Filter by region IDs (optional - returns all regions if empty) */
  regionIds?: InputMaybe<Array<Scalars['String']>>;
};

export type GetPhlebotomistTrendStatsInput = {
  /** Date range start (inclusive) */
  dateFrom: Scalars['DateTime'];
  /** Date range end (inclusive) */
  dateTo: Scalars['DateTime'];
  /** Interval size for grouping data (day, week, month, quarter, year) */
  intervalSize: TrendIntervalSize;
  /** Filter by specific phlebotomist ID (optional - aggregates all if not specified) */
  phlebotomistId?: InputMaybe<Scalars['String']>;
  /** Filter by region IDs (optional - returns all regions if empty) */
  regionIds?: InputMaybe<Array<Scalars['String']>>;
};

export type GetPrbcDonationDonorsInput = {
  /** Statuses considered active */
  activeDonorStatuses?: InputMaybe<Array<DonorStatus>>;
  /** Filter by SGL/DBL classification. When omitted, returns all donors. */
  donationUnitType?: InputMaybe<DonationUnitType>;
  /** Filter to lapsed donors whose last donation was more than N days ago. */
  lapsedDays?: InputMaybe<Scalars['Int']>;
  /** Filter by location IDs (donor location) */
  locationIds?: InputMaybe<Array<Scalars['String']>>;
  /** Filter by office IDs */
  officeIds?: InputMaybe<Array<Scalars['String']>>;
  /** Period date range to filter pRBC donations. When null, returns all matching donors with all-time units. */
  periodRange?: InputMaybe<DateRangeInput>;
  /** Filter by region IDs */
  regionIds?: InputMaybe<Array<Scalars['String']>>;
  /** Filter donors by registration date (createdAt). Used for "New Registrations" views. */
  registrationRange?: InputMaybe<DateRangeInput>;
  /** When true, restrict to donors who have an Active transition in status history or a donation. */
  requireActiveHistory?: InputMaybe<Scalars['Boolean']>;
  /** When true, restrict to donors who have an Approved transition recorded in donor_status_change_history. */
  requireApprovedHistory?: InputMaybe<Scalars['Boolean']>;
  /** When true, restrict to donors who have an Archived transition recorded in donor_status_change_history. */
  requireArchivedHistory?: InputMaybe<Scalars['Boolean']>;
  /** When true, restrict to donors who have a Retired transition recorded in donor_status_change_history. */
  requireRetiredHistory?: InputMaybe<Scalars['Boolean']>;
  /** Filter to retired (Unresponsive) donors — lower bound of days-ago range (inclusive) */
  retiredDaysFrom?: InputMaybe<Scalars['Int']>;
  /** Filter to retired (Unresponsive) donors — upper bound of days-ago range (exclusive). Null = no upper bound. */
  retiredDaysTo?: InputMaybe<Scalars['Int']>;
  /** Filter to donors retiring due to age within N days. 30 = 30-59 days, 60 = 60-89 days, 90 = 90-120 days. */
  retiringInDays?: InputMaybe<Scalars['Int']>;
  /** mL threshold for SGL/DBL classification (default: 420). Donors with approvedDonationML >= this are DBL. */
  sglThresholdMl?: InputMaybe<Scalars['Int']>;
};

export type GetPreviousDonationInput = {
  donorId: Scalars['String'];
};

export type GetProductInput = {
  id: Scalars['Float'];
};

export type GetProductReportsInput = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Float']>;
  mantelOnly?: InputMaybe<Scalars['Boolean']>;
};

export type GetProductUnitCountsInput = {
  /** WooCommerce product IDs considered FFP DBL (multiplier = 2). E.g. [503, 504] */
  ffpDblProductIds?: InputMaybe<Array<Scalars['Int']>>;
  /** WooCommerce product IDs considered FFP SGL (multiplier = 1). E.g. [502, 8179] */
  ffpSglProductIds?: InputMaybe<Array<Scalars['Int']>>;
  /** Filter by location IDs (donor location) */
  locationIds?: InputMaybe<Array<Scalars['String']>>;
  /** Filter by office IDs */
  officeIds?: InputMaybe<Array<Scalars['String']>>;
  /** Period date range to filter products by createdAt */
  periodRange: DateRangeInput;
  /** Filter by region IDs (empty/null = all regions) */
  regionIds?: InputMaybe<Array<Scalars['String']>>;
  /** WooCommerce category ID to filter by (31 = pRBC, 33 = FFP) */
  woocommerceCategoryId: Scalars['Int'];
};

export type GetProductsCountInput = {
  bloodType?: InputMaybe<Array<BloodType>>;
  statuses?: InputMaybe<Array<ProductStatus>>;
  woocommerceCategory?: InputMaybe<Array<Scalars['Float']>>;
};

export type GetPublicLocationsInput = {
  filter?: InputMaybe<LocationsFilterInput>;
  skip?: Scalars['Float'];
  take?: Scalars['Float'];
};

export type GetRecruiterDashboardMetricsInput = {
  /** Statuses considered active */
  activeDonorStatuses?: InputMaybe<Array<DonorStatus>>;
  /** Previous period date range (same duration, shifted back) for growth comparison */
  comparedPeriodRange?: InputMaybe<DateRangeInput>;
  /** Expected days between donations for show rate calculation */
  donorDonationFrequency?: InputMaybe<Scalars['Int']>;
  /** Days after registration before a new donor is eligible to donate (default: 40) */
  donorEligibilityDays?: InputMaybe<Scalars['Int']>;
  /** Day breakpoints for lapsed donor counts (e.g. [30, 60, 90]) */
  lapsedDonorBreakpoints?: InputMaybe<Array<Scalars['Int']>>;
  /** Days after last donation a donor is still presumed active (unless status explicitly changed) */
  lastDonationActiveTimeoutDays?: InputMaybe<Scalars['Int']>;
  /** Filter by location IDs (donor location) */
  locationIds?: InputMaybe<Array<Scalars['String']>>;
  /** Filter by office IDs */
  officeIds?: InputMaybe<Array<Scalars['String']>>;
  /** Current filter date range (period start/end) */
  periodRange: DateRangeInput;
  /** Current calendar quarter date range */
  quarterRange: DateRangeInput;
  /** Filter by region IDs */
  regionIds?: InputMaybe<Array<Scalars['String']>>;
  /** Min donations to be considered repeat donor */
  repeatDonationsThreshold?: InputMaybe<Scalars['Int']>;
  /** Day breakpoints for retired donor (Unresponsive) counts (e.g. [30, 60, 90]) */
  retiredDonorBreakpoints?: InputMaybe<Array<Scalars['Int']>>;
  /** mL threshold for SGL vs DBL classification. Donors with donationMLApprovedAmount < this value are SGL, >= are DBL. Defaults to 420. */
  sglThresholdMl?: InputMaybe<Scalars['Int']>;
};

export type GetRecruiterDonorsInput = {
  /** Period end (donor createdAt <=) */
  end: Scalars['DateTime'];
  /** The recruiter (RegionalUser) user ID */
  recruiterId: Scalars['String'];
  /** mL threshold for SGL/DBL classification (default: 420). Donors with approvedDonationML >= this are DBL. */
  sglThresholdMl?: InputMaybe<Scalars['Int']>;
  /** Period start (donor createdAt >=) */
  start: Scalars['DateTime'];
};

export type GetRecruiterLeaderboardInput = {
  /** End of the date range */
  end: Scalars['DateTime'];
  /** Optional: limit to specific region IDs */
  regionIds?: InputMaybe<Array<Scalars['String']>>;
  /** Start of the date range */
  start: Scalars['DateTime'];
};

export type GetRecruiterLocationStatsInput = {
  /** Donor statuses considered "active". Defaults to [Active, Approved, AnnualLabworkDue] */
  activeDonorStatuses?: InputMaybe<Array<DonorStatus>>;
  /** Only return locations with a donation within this many days. If omitted, returns all assigned locations. */
  activeLocationThresholdDays?: InputMaybe<Scalars['Int']>;
  /** Period start (ISO-8601). Used for recruited count and donation stats. */
  dateFrom?: InputMaybe<Scalars['String']>;
  /** Period end (ISO-8601). Used for recruited count and donation stats. */
  dateTo?: InputMaybe<Scalars['String']>;
  /** Days after last donation a donor is still presumed active (unless status explicitly changed) */
  lastDonationActiveTimeoutDays?: InputMaybe<Scalars['Int']>;
  /** The recruiter (RegionalUser) user ID. If omitted, returns all assigned locations. */
  recruiterId?: InputMaybe<Scalars['String']>;
  /** Optional single region ID filter (deprecated, use regionIds) */
  regionId?: InputMaybe<Scalars['String']>;
  /** Optional region IDs filter */
  regionIds?: InputMaybe<Array<Scalars['String']>>;
  /** mL threshold for SGL vs DBL classification. Donors with donationMLApprovedAmount < this value are SGL, >= are DBL. Defaults to 420. */
  sglThresholdMl?: InputMaybe<Scalars['Int']>;
  /** Rolling window in days for the Units/Event metric (alltimeUnits, alltimeEventCount). 0 or null = all time. */
  unitsPerEventDays?: InputMaybe<Scalars['Int']>;
};

export type GetRecruiterStatsInput = {
  /** A location is "active" if at least one donation was made there within this many days */
  activeLocationThresholdDays: Scalars['Int'];
  /** Current period end */
  end: Scalars['DateTime'];
  /** Previous period end */
  prevEnd: Scalars['DateTime'];
  /** Previous period start */
  prevStart: Scalars['DateTime'];
  regionIds?: InputMaybe<Array<Scalars['String']>>;
  /** Current period start */
  start: Scalars['DateTime'];
};

export type GetRegionRecruitStatsInput = {
  /** A location is "active" if at least one donation was made there within this many days */
  activeLocationThresholdDays: Scalars['Int'];
  /** Current period end */
  end: Scalars['DateTime'];
  /** Previous period end */
  prevEnd: Scalars['DateTime'];
  /** Previous period start */
  prevStart: Scalars['DateTime'];
  regionIds?: InputMaybe<Array<Scalars['String']>>;
  /** Current period start */
  start: Scalars['DateTime'];
};

export type GetRegistrationDonorsInput = {
  /** Filter by location IDs */
  locationIds?: InputMaybe<Array<Scalars['String']>>;
  /** Filter by office IDs */
  officeIds?: InputMaybe<Array<Scalars['String']>>;
  /** Date range to filter donors by createdAt */
  periodRange: DateRangeInput;
  /** Filter by region IDs (empty/null = all regions) */
  regionIds?: InputMaybe<Array<Scalars['String']>>;
  /** mL threshold for SGL/DBL classification (default: 420). Donors with approvedDonationML >= this are DBL. */
  sglThresholdMl?: InputMaybe<Scalars['Int']>;
};

export type GetRequestInput = {
  id: Scalars['String'];
};

export type GetSpecificDonorDonationsListInput = {
  filter?: InputMaybe<SpecificDonorDonationListFilter>;
  skip?: Scalars['Float'];
  sort?: InputMaybe<Array<SortDonationListInput>>;
  take?: InputMaybe<Scalars['Float']>;
};

export type GetUserAttachmentsListInput = {
  userId: Scalars['String'];
};

export type GetUserInput = {
  id: Scalars['String'];
};

export type GetUserListInput = {
  filter?: InputMaybe<UsersListFilterInput>;
  skip?: Scalars['Float'];
  sort?: InputMaybe<Array<SortUserListInput>>;
  take?: Scalars['Float'];
};

export type GetWoocommerceProductCategoriesInput = {
  exclude?: InputMaybe<Array<Scalars['Float']>>;
  include?: InputMaybe<Array<Scalars['Float']>>;
  order?: InputMaybe<Scalars['String']>;
  orderby?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Float']>;
  per_page?: InputMaybe<Scalars['Float']>;
};

export type GetWoocommerceProductsInput = {
  category?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
  order?: InputMaybe<Scalars['String']>;
  orderby?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Float']>;
  per_page?: InputMaybe<Scalars['Float']>;
};

export type GetWoocommerceTopSellersInput = {
  period?: InputMaybe<TopSellersPeriod>;
};

export type GroupListFilterInput = {
  searchingQuery?: InputMaybe<Scalars['String']>;
  userIds?: InputMaybe<Array<Scalars['String']>>;
};

export type GroupListInput = {
  filter?: InputMaybe<GroupListFilterInput>;
  skip?: Scalars['Float'];
  sort?: InputMaybe<Array<SortGroupListInput>>;
  take?: Scalars['Float'];
};

export type GroupListItemOutput = {
  __typename?: 'GroupListItemOutput';
  donorCount?: Maybe<Scalars['Float']>;
  id: Scalars['String'];
  teamCount: Scalars['Float'];
  teams?: Maybe<Array<GroupTeamOutput>>;
  title: Scalars['String'];
  user?: Maybe<GroupListItemUserOutput>;
};

export type GroupListItemUserOutput = {
  __typename?: 'GroupListItemUserOutput';
  firstName: Scalars['String'];
  id: Scalars['String'];
  lastName: Scalars['String'];
};

export type GroupListOutput = {
  __typename?: 'GroupListOutput';
  data: Array<GroupListItemOutput>;
  meta: MetaData;
};

export enum GroupListSort {
  Donors = 'Donors',
  Owner = 'Owner',
  Teams = 'Teams',
  Title = 'Title'
}

export type GroupOutput = {
  __typename?: 'GroupOutput';
  id: Scalars['String'];
  teams: Array<TeamOutput>;
  title: Scalars['String'];
  user?: Maybe<OwnerOutput>;
};

export type GroupTeamOutput = {
  __typename?: 'GroupTeamOutput';
  id: Scalars['String'];
  title: Scalars['String'];
};

export type HolderOutput = {
  __typename?: 'HolderOutput';
  assignedLocations?: Maybe<Array<LocationOutput>>;
  assignedOffice?: Maybe<OfficeOutput>;
  assignedRegions?: Maybe<Array<RegionOutput>>;
  birthday?: Maybe<Scalars['DateTime']>;
  city?: Maybe<Scalars['String']>;
  contactPreferences?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  deletionIntentionAt?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  id: Scalars['String'];
  isArchived: Scalars['Boolean'];
  lastName: Scalars['String'];
  locationPreferences?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  productRegionPreference?: Maybe<RegionOutput>;
  shortId: Scalars['Float'];
  state?: Maybe<Scalars['String']>;
  streetAddress?: Maybe<Scalars['String']>;
  type?: Maybe<OwnerType>;
  zipCode?: Maybe<Scalars['String']>;
};

export type IneligibleParticipantOutput = {
  __typename?: 'IneligibleParticipantOutput';
  createdAt: Scalars['DateTime'];
  donorData: Scalars['String'];
  id: Scalars['String'];
  ownerData: Scalars['String'];
};

export enum IneligibleReason {
  Medical = 'Medical',
  Other = 'Other',
  Temperament = 'Temperament'
}

export type IntervalInput = {
  end: Scalars['DateTime'];
  start: Scalars['DateTime'];
};

export enum InvitationListSort {
  CreatedAt = 'CreatedAt',
  FirstName = 'FirstName',
  LastName = 'LastName',
  LocationPreferences = 'LocationPreferences'
}

export type InvitationOutput = {
  __typename?: 'InvitationOutput';
  additionalContact?: Maybe<ContactOutput>;
  birthday?: Maybe<Scalars['DateTime']>;
  city?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  donor?: Maybe<DonorOutput>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  id: Scalars['String'];
  lastName: Scalars['String'];
  locationPreferences?: Maybe<Scalars['String']>;
  phoneNumber: Scalars['String'];
  role: Scalars['String'];
  state?: Maybe<Scalars['String']>;
  streetAddress?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};

export type InvitationsListFilterInput = {
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  searchingQuery?: InputMaybe<Scalars['String']>;
};

export type InviteOwnerInput = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phoneNumber: Scalars['String'];
};

export type InviteOwnerWithDonorInput = {
  donor: CreateDonorInput;
  owner: InviteOwnerInput;
};

export type InviteUserInput = {
  additionalContact?: InputMaybe<CreateContactInput>;
  birthday?: InputMaybe<Scalars['DateTime']>;
  city?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  locationPreferences?: InputMaybe<Scalars['String']>;
  phoneNumber: Scalars['String'];
  role: InviteUserRole;
  state?: InputMaybe<Scalars['String']>;
  streetAddress?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export enum InviteUserRole {
  Admin = 'Admin',
  CanineHandler = 'CanineHandler',
  Dvm = 'DVM',
  MedicalDirector = 'MedicalDirector',
  Operations = 'Operations',
  Owner = 'Owner',
  Phlebotomist = 'Phlebotomist',
  RegionalUser = 'RegionalUser',
  TeamLead = 'TeamLead'
}

export enum JugularVein {
  Left = 'Left',
  NotApplicable = 'NotApplicable',
  Right = 'Right'
}

export type LabworkAttachmentOutput = {
  __typename?: 'LabworkAttachmentOutput';
  createdAt: Scalars['DateTime'];
  file: FileOutput;
  id: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type LabworkListFilterInput = {
  donorId?: InputMaybe<Scalars['String']>;
  locationName?: InputMaybe<Array<Scalars['String']>>;
  searchingQuery?: InputMaybe<Scalars['String']>;
  statuses?: InputMaybe<Array<LabworkStatus>>;
};

export type LabworkListInput = {
  filter?: InputMaybe<LabworkListFilterInput>;
  skip?: Scalars['Float'];
  sort?: InputMaybe<Array<SortLabworkListInput>>;
  take?: Scalars['Float'];
};

export type LabworkListOutput = {
  __typename?: 'LabworkListOutput';
  data: Array<LabworkOutput>;
  meta: MetaData;
};

export enum LabworkListSort {
  CollectionDate = 'CollectionDate',
  LastName = 'LastName',
  PetName = 'PetName'
}

export type LabworkOutput = {
  __typename?: 'LabworkOutput';
  collectionDate: Scalars['DateTime'];
  donor: DonorOutput;
  id: Scalars['String'];
  status: LabworkStatus;
};

export enum LabworkStatus {
  AnnualDue = 'AnnualDue',
  AwaitingDvmApproval = 'AwaitingDvmApproval',
  Cleared = 'Cleared',
  Collected = 'Collected',
  FailedCbc = 'FailedCBC',
  FailedChem = 'FailedChem',
  FailedHealthConcern = 'FailedHealthConcern',
  FailedInfectious = 'FailedInfectious',
  FailedTemperament = 'FailedTemperament',
  PendingResult = 'PendingResult',
  ReCheck = 'ReCheck',
  Sent = 'Sent'
}

export type LeaderboardHistoryOutput = {
  __typename?: 'LeaderboardHistoryOutput';
  weeks: Array<LeaderboardHistoryWeek>;
};

export type LeaderboardHistoryWeek = {
  __typename?: 'LeaderboardHistoryWeek';
  /** Recruited donor count for the winner */
  recruitedCount: Scalars['Int'];
  /** Sunday date of that week (ISO date string) */
  weekEndDate: Scalars['String'];
  /** ISO week number (1-53) */
  weekNumber: Scalars['Int'];
  /** 1st place recruiter full name */
  winnerName?: Maybe<Scalars['String']>;
  /** 1st place recruiter region name */
  winnerRegion?: Maybe<Scalars['String']>;
  /** 1st place recruiter user ID */
  winnerUserId?: Maybe<Scalars['String']>;
  /** Year of the week */
  year: Scalars['Int'];
};

export type LivesSavedOutput = {
  __typename?: 'LivesSavedOutput';
  lives: Scalars['Int'];
};

export type LocationOutput = {
  __typename?: 'LocationOutput';
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  name: Scalars['String'];
  region?: Maybe<RegionOutput>;
  type: LocationType;
  updatedAt: Scalars['DateTime'];
};

export enum LocationType {
  ForDaycareOwners = 'ForDaycareOwners',
  ForExternalUsers = 'ForExternalUsers',
  ForInternalUsers = 'ForInternalUsers'
}

export type LocationsFilterInput = {
  assignedOnly?: InputMaybe<Scalars['Boolean']>;
  regionIds?: InputMaybe<Array<Scalars['String']>>;
  searchingQuery?: InputMaybe<Scalars['String']>;
  types?: InputMaybe<Array<LocationType>>;
};

export type LoginInput = {
  durable?: InputMaybe<Scalars['Boolean']>;
  email: Scalars['String'];
  password: Scalars['String'];
};

export type LoginOutput = {
  __typename?: 'LoginOutput';
  accessToken: Scalars['String'];
  refreshToken: Scalars['String'];
};

export enum Mm {
  Blue = 'Blue',
  DarkPink = 'DarkPink',
  Grey = 'Grey',
  LightPink = 'LightPink',
  NotApplicable = 'NotApplicable',
  Pigmented = 'Pigmented',
  Pink = 'Pink',
  Tacky = 'Tacky',
  White = 'White',
  Yellow = 'Yellow'
}

export type MakePicturePrimaryInput = {
  pictureId: Scalars['String'];
};

export type MakeProductAvailableInput = {
  id: Scalars['String'];
};

export type ManageDonorsInTeamInput = {
  donorIds: Array<Scalars['String']>;
  teamId: Scalars['String'];
};

export type MetaData = {
  __typename?: 'MetaData';
  total: Scalars['Float'];
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptInvite: UserOutput;
  addDonorsToDaycare: Scalars['Boolean'];
  addNote: DonorNoteOutput;
  addNoteToReserveDonor: ReserveDonorNoteOutput;
  approveDaycareAppointmentRequest: Scalars['Boolean'];
  archiveDonorsNoLabworkSinceReg: Scalars['Boolean'];
  archivePendingDonors: Scalars['Boolean'];
  archiveUser: Scalars['Boolean'];
  cancelDaycareAppointmentRequest: Scalars['Boolean'];
  cancelDeletingCurrentOwner: Scalars['Boolean'];
  cleanExpiredDatabaseData: Scalars['Boolean'];
  confirmEmail: Scalars['Boolean'];
  createAdditionalDonationInfo: AdditionalDonationInfoOutput;
  createAppointments: Array<AppointmentOutput>;
  createAppointmentsWithDonor: Array<AppointmentOutput>;
  createAppointmentsWithGroup: Array<AppointmentOutput>;
  createContact: ContactOutput;
  createDaycareAppointmentsWithDonors: Scalars['Boolean'];
  createDonation: DonationOutput;
  createDonationWithAdditionalInfo: DonationOutput;
  createDonationsWithAdditionalInfo: Scalars['Boolean'];
  createDonor: DonorOutput;
  /** Create a donor contact log entry */
  createDonorContact: DonorContactOutput;
  createDonorForUser: DonorOutput;
  createDonors: Scalars['Boolean'];
  createDonorsForUser: Scalars['Boolean'];
  createDvmExam: DvmExamOutput;
  createGroup: GroupOutput;
  createLabwork: LabworkOutput;
  createLocation: Array<LocationOutput>;
  createOffice: Array<OfficeOutput>;
  createProduct: ProductOutput;
  createProducts: Array<ProductOutput>;
  createRegion: Array<RegionOutput>;
  createTeam: TeamOutput;
  deleteDonation: Scalars['Boolean'];
  deleteDonor: Scalars['Boolean'];
  /** Delete a donor contact log entry */
  deleteDonorContact: Scalars['Boolean'];
  deleteInvitation: Scalars['Boolean'];
  deleteLocation: Scalars['Boolean'];
  deleteNightlyCount: Scalars['Boolean'];
  deleteNote: Scalars['Boolean'];
  deleteNotification: Scalars['Boolean'];
  deleteOffice: Scalars['Boolean'];
  deleteProduct: Scalars['Boolean'];
  deleteRegion: Scalars['Boolean'];
  deleteReserveDonorNote: Scalars['Boolean'];
  detachLabworkFile: Scalars['Boolean'];
  detachUserFile: Scalars['Boolean'];
  disproveDaycareAppointmentRequest: Scalars['Boolean'];
  enrollDonorToAppointment: Scalars['Boolean'];
  enrollMyDonorToAppointment: Scalars['Boolean'];
  eraseDeletedUsers: Scalars['Boolean'];
  eraseUsersWithUnconfirmedEmails: Scalars['Boolean'];
  forgotPassword: Scalars['Boolean'];
  inviteOwnerWithDonor: Scalars['Boolean'];
  inviteUser: Scalars['Boolean'];
  login: LoginOutput;
  logout: Scalars['Boolean'];
  makeDonorPicturePrimary: Scalars['Boolean'];
  makeNotificationsRead: Scalars['Boolean'];
  makeProductAvailable: ProductOutput;
  manageDonorsInTeam: Scalars['Boolean'];
  processRequest: Scalars['Boolean'];
  refreshToken: LoginOutput;
  registerOnDaycareAppointment: Scalars['Boolean'];
  removeAdditionalDonationInfo: Scalars['Boolean'];
  removeAppointment: Scalars['Boolean'];
  removeContact: Scalars['Boolean'];
  removeCurrentOwner: Scalars['Boolean'];
  removeDonation: Scalars['Boolean'];
  removeDvmExam: Scalars['Boolean'];
  removeGroup: Scalars['Boolean'];
  removeLabwork: Scalars['Boolean'];
  removeMyAppointment: Scalars['Boolean'];
  removeOwner: Scalars['Boolean'];
  removeRequest: Scalars['Boolean'];
  removeTeam: Scalars['Boolean'];
  removeUser: Scalars['Boolean'];
  resendEmailConfirmationCode: Scalars['Boolean'];
  resendNightlyCount: Scalars['Boolean'];
  resetPassword: Scalars['Boolean'];
  resetPrimaryDonorPictures: Scalars['Boolean'];
  retireActiveDonorsWithNoDonations: Scalars['Boolean'];
  retireDonorsDueToAge: Scalars['Boolean'];
  retireDonorsInAnnualLabworkDueWithNoDonations: Scalars['Boolean'];
  saveAppSettings: AppSettingsOutput;
  saveNightlyCount: NightlyCountOutput;
  sendEmail: Scalars['Boolean'];
  sendLabworkExpirationEmail: Scalars['Boolean'];
  sendTaskSchedulesForInternalUsers: Scalars['Boolean'];
  shareLabworkResults: Scalars['Boolean'];
  signUp: UserOutput;
  signUpWithDonors: Scalars['Boolean'];
  unArchiveUser: Scalars['Boolean'];
  unenrollDonorFromDaycare: Scalars['Boolean'];
  unenrollMyDonorFromAppointment: Scalars['Boolean'];
  untieWoocommerceOrderFromProduct: ProductOutput;
  updateAdditionalDonationInfo: AdditionalDonationInfoOutput;
  updateAppointment: AppointmentOutput;
  updateContact: ContactOutput;
  updateContacts: Array<ContactOutput>;
  updateCurrentOwnerEmail: UserOutput;
  updateCurrentOwnerInfo: UserOutput;
  updateDonation: DonationOutput;
  updateDonationComment: DonationOutput;
  updateDonationDonor: DonationOutput;
  updateDonor: DonorOutput;
  updateDonorStatus: Scalars['Boolean'];
  updateDonorStatusWithDueLabwork: Scalars['Boolean'];
  updateDonorsOwner?: Maybe<DonorOutput>;
  updateDvmExam: DvmExamOutput;
  updateGroup: GroupOutput;
  updateGroupOwner?: Maybe<GroupOutput>;
  updateLabwork: LabworkOutput;
  updateLabworkStatus: LabworkOutput;
  updateLocation: Array<LocationOutput>;
  updateNote: DonorNoteOutput;
  updateNotificationConfigList: Array<NotificationConfigOutput>;
  updateOffice: Array<OfficeOutput>;
  updateOwnerEmail: UserOutput;
  updateOwnerInfo: UserOutput;
  updatePermissions: Array<PermissionsOutput>;
  /** This endpoint alowes to update manually update the main product fields, except status. In case if user attaches woocommerceOrderId, product status changes to "Sold" */
  updateProduct: ProductOutput;
  updateProductStatus: ProductOutput;
  updateRegion: Array<RegionOutput>;
  updateReserveDonorNote: ReserveDonorNoteOutput;
  updateTeam: TeamOutput;
  updateUserEmail: UserOutput;
  updateUserInfo: UserOutput;
  updateUserRole: UserOutput;
  updateVitalsParameterList: Array<VitalsParameterOutput>;
  /** Upsert a Flag contact entry — creates if none exists, updates if one does */
  upsertDonorContactFlag: DonorContactOutput;
};


export type MutationAcceptInviteArgs = {
  input: AcceptInviteInput;
};


export type MutationAddDonorsToDaycareArgs = {
  input: AddDonorsToDaycareInput;
};


export type MutationAddNoteArgs = {
  input: CreateDonorNoteInput;
};


export type MutationAddNoteToReserveDonorArgs = {
  input: CreateDonorNoteInput;
};


export type MutationApproveDaycareAppointmentRequestArgs = {
  requestId: Scalars['String'];
};


export type MutationArchiveUserArgs = {
  input: ArchiveUserInput;
};


export type MutationCancelDaycareAppointmentRequestArgs = {
  requestId: Scalars['String'];
};


export type MutationConfirmEmailArgs = {
  input: EmailConfirmationInput;
};


export type MutationCreateAdditionalDonationInfoArgs = {
  input: CreateAdditionalDonationInfoInput;
};


export type MutationCreateAppointmentsArgs = {
  input: CreateEmptyAppointmentInput;
};


export type MutationCreateAppointmentsWithDonorArgs = {
  input: CreateAppointmentWithDonorInput;
};


export type MutationCreateAppointmentsWithGroupArgs = {
  input: CreateAppointmentWithGroupInput;
};


export type MutationCreateContactArgs = {
  input: CreateContactInput;
};


export type MutationCreateDaycareAppointmentsWithDonorsArgs = {
  input: CreateDaycareAppointmentWithDonorsInput;
};


export type MutationCreateDonationArgs = {
  input: CreateDonationInput;
};


export type MutationCreateDonationWithAdditionalInfoArgs = {
  input: CreateDonationWithAdditionalInfoInput;
};


export type MutationCreateDonationsWithAdditionalInfoArgs = {
  input: CreateDonationsWithAdditionalInfoInput;
};


export type MutationCreateDonorArgs = {
  input: CreateDonorInput;
};


export type MutationCreateDonorContactArgs = {
  input: CreateDonorContactInput;
};


export type MutationCreateDonorForUserArgs = {
  input: CreateDonorForUserInput;
};


export type MutationCreateDonorsArgs = {
  input: CreateDonors;
};


export type MutationCreateDonorsForUserArgs = {
  input: CreateDonorsForUserInput;
};


export type MutationCreateDvmExamArgs = {
  input: CreateDvmExamInput;
};


export type MutationCreateGroupArgs = {
  input: CreateGroupInput;
};


export type MutationCreateLabworkArgs = {
  input: CreateLabworkInput;
};


export type MutationCreateLocationArgs = {
  input: CreateLocationInput;
};


export type MutationCreateOfficeArgs = {
  input: CreateOfficeInput;
};


export type MutationCreateProductArgs = {
  input: CreateProductInput;
};


export type MutationCreateProductsArgs = {
  input: CreateProductsInput;
};


export type MutationCreateRegionArgs = {
  input: CreateRegionInput;
};


export type MutationCreateTeamArgs = {
  input: CreateTeamInput;
};


export type MutationDeleteDonationArgs = {
  donationId: Scalars['String'];
};


export type MutationDeleteDonorArgs = {
  input: DeleteDonorInput;
};


export type MutationDeleteDonorContactArgs = {
  id: Scalars['String'];
};


export type MutationDeleteInvitationArgs = {
  id: Scalars['String'];
};


export type MutationDeleteLocationArgs = {
  input: DeleteLocationInput;
};


export type MutationDeleteNightlyCountArgs = {
  input: NightlyCountIdInput;
};


export type MutationDeleteNoteArgs = {
  input: DeleteDonorNoteInput;
};


export type MutationDeleteNotificationArgs = {
  input: RemoveNotificationInput;
};


export type MutationDeleteOfficeArgs = {
  input: DeleteOfficeInput;
};


export type MutationDeleteProductArgs = {
  input: DeleteProductInput;
};


export type MutationDeleteRegionArgs = {
  input: DeleteRegionInput;
};


export type MutationDeleteReserveDonorNoteArgs = {
  input: DeleteDonorNoteInput;
};


export type MutationDetachLabworkFileArgs = {
  input: DetachLabworkFileInput;
};


export type MutationDetachUserFileArgs = {
  input: DetachUserAttachmentInput;
};


export type MutationDisproveDaycareAppointmentRequestArgs = {
  requestId: Scalars['String'];
};


export type MutationEnrollDonorToAppointmentArgs = {
  input: EnrollDonorInput;
};


export type MutationEnrollMyDonorToAppointmentArgs = {
  input: EnrollDonorInput;
};


export type MutationForgotPasswordArgs = {
  input: ForgotPasswordInput;
};


export type MutationInviteOwnerWithDonorArgs = {
  input: InviteOwnerWithDonorInput;
};


export type MutationInviteUserArgs = {
  input: InviteUserInput;
};


export type MutationLoginArgs = {
  input: LoginInput;
};


export type MutationMakeDonorPicturePrimaryArgs = {
  input: MakePicturePrimaryInput;
};


export type MutationMakeProductAvailableArgs = {
  input: MakeProductAvailableInput;
};


export type MutationManageDonorsInTeamArgs = {
  input: ManageDonorsInTeamInput;
};


export type MutationProcessRequestArgs = {
  input: UpdateRequestInput;
};


export type MutationRegisterOnDaycareAppointmentArgs = {
  input: RegisterOnDaycareAppointmentInput;
};


export type MutationRemoveAdditionalDonationInfoArgs = {
  input: RemoveAdditionalDonationInfoInput;
};


export type MutationRemoveAppointmentArgs = {
  input: RemoveAppointmentInput;
};


export type MutationRemoveContactArgs = {
  input: RemoveContactInput;
};


export type MutationRemoveDonationArgs = {
  input: RemoveDonationInput;
};


export type MutationRemoveDvmExamArgs = {
  input: RemoveDvmExamInput;
};


export type MutationRemoveGroupArgs = {
  input: RemoveGroupInput;
};


export type MutationRemoveLabworkArgs = {
  input: RemoveLabworkInput;
};


export type MutationRemoveMyAppointmentArgs = {
  input: RemoveAppointmentInput;
};


export type MutationRemoveOwnerArgs = {
  input: RemoveUserInput;
};


export type MutationRemoveRequestArgs = {
  input: RemoveRequestInput;
};


export type MutationRemoveTeamArgs = {
  input: RemoveTeamInput;
};


export type MutationRemoveUserArgs = {
  input: RemoveUserInput;
};


export type MutationResendEmailConfirmationCodeArgs = {
  input: ResendEmailConfirmationCodeInput;
};


export type MutationResendNightlyCountArgs = {
  input: NightlyCountIdInput;
};


export type MutationResetPasswordArgs = {
  input: ResetPasswordInput;
};


export type MutationResetPrimaryDonorPicturesArgs = {
  input: ResetPrimaryPicturesInput;
};


export type MutationSaveAppSettingsArgs = {
  input: SaveAppSettingsInput;
};


export type MutationSaveNightlyCountArgs = {
  input: SaveNightlyCountInput;
};


export type MutationSendEmailArgs = {
  input: SendEmailInput;
};


export type MutationSendLabworkExpirationEmailArgs = {
  input: SendLabworkExpirationEmailInput;
};


export type MutationShareLabworkResultsArgs = {
  input: ShareLabworkResultsWithOwnerInput;
};


export type MutationSignUpArgs = {
  input: SignUpInput;
};


export type MutationSignUpWithDonorsArgs = {
  input: SignUpWithDonorsInput;
};


export type MutationUnArchiveUserArgs = {
  input: ArchiveUserInput;
};


export type MutationUnenrollDonorFromDaycareArgs = {
  input: DaycareUnenrollDonorInput;
};


export type MutationUnenrollMyDonorFromAppointmentArgs = {
  input: UnenrollDonorInput;
};


export type MutationUntieWoocommerceOrderFromProductArgs = {
  input: UntieWoocommerceOrderInput;
};


export type MutationUpdateAdditionalDonationInfoArgs = {
  input: UpdateAdditionalDonationInfoInput;
};


export type MutationUpdateAppointmentArgs = {
  updateAppointmentInput: UpdateAppointmentInput;
};


export type MutationUpdateContactArgs = {
  input: UpdateContactInput;
};


export type MutationUpdateContactsArgs = {
  input: UpdateContactsInput;
};


export type MutationUpdateCurrentOwnerEmailArgs = {
  input: UpdateUserEmailInput;
};


export type MutationUpdateCurrentOwnerInfoArgs = {
  input: UpdateOwnerInput;
};


export type MutationUpdateDonationArgs = {
  input: UpdateDonationInput;
};


export type MutationUpdateDonationCommentArgs = {
  input: UpdateDonationCommentInput;
};


export type MutationUpdateDonationDonorArgs = {
  input: UpdateDonationDonorInput;
};


export type MutationUpdateDonorArgs = {
  input: UpdateDonorInput;
};


export type MutationUpdateDonorStatusArgs = {
  input: UpdateDonorStatusInput;
};


export type MutationUpdateDonorsOwnerArgs = {
  input: UpdateDonorsOwnerInput;
};


export type MutationUpdateDvmExamArgs = {
  input: UpdateDvmExamInput;
};


export type MutationUpdateGroupArgs = {
  input: UpdateGroupInput;
};


export type MutationUpdateGroupOwnerArgs = {
  input: UpdateGroupOwnerInput;
};


export type MutationUpdateLabworkArgs = {
  input: UpdateLabworkInput;
};


export type MutationUpdateLabworkStatusArgs = {
  input: UpdateLabworkStatusInput;
};


export type MutationUpdateLocationArgs = {
  input: UpdateLocationInput;
};


export type MutationUpdateNoteArgs = {
  input: UpdateDonorNoteInput;
};


export type MutationUpdateNotificationConfigListArgs = {
  input: UpdateNotificationConfigListInput;
};


export type MutationUpdateOfficeArgs = {
  input: UpdateOfficeInput;
};


export type MutationUpdateOwnerEmailArgs = {
  input: UpdateUserEmailInput;
};


export type MutationUpdateOwnerInfoArgs = {
  input: UpdateOwnerInput;
};


export type MutationUpdatePermissionsArgs = {
  input: PermissionsInput;
};


export type MutationUpdateProductArgs = {
  input: UpdateProductInput;
};


export type MutationUpdateProductStatusArgs = {
  input: UpdateProductStatusInput;
};


export type MutationUpdateRegionArgs = {
  input: UpdateRegionInput;
};


export type MutationUpdateReserveDonorNoteArgs = {
  input: UpdateDonorNoteInput;
};


export type MutationUpdateTeamArgs = {
  input: UpdateTeamInput;
};


export type MutationUpdateUserEmailArgs = {
  input: UpdateUserEmailInput;
};


export type MutationUpdateUserInfoArgs = {
  input: UpdateUserInputPartial;
};


export type MutationUpdateUserRoleArgs = {
  input: UpdateUserRoleInput;
};


export type MutationUpdateVitalsParameterListArgs = {
  input: UpdateVitalsParametersListInput;
};


export type MutationUpsertDonorContactFlagArgs = {
  donorId: Scalars['String'];
  flagValue: Scalars['String'];
};

export type NightlyCountAllowedOfficeOutput = {
  __typename?: 'NightlyCountAllowedOfficeOutput';
  id: Scalars['String'];
  name: Scalars['String'];
  regionName: Scalars['String'];
};

export type NightlyCountIdInput = {
  id: Scalars['String'];
};

export type NightlyCountItemOutput = {
  __typename?: 'NightlyCountItemOutput';
  count: Scalars['Int'];
  id: Scalars['String'];
  productBloodType?: Maybe<NightlyCountProductBloodType>;
  productClass: NightlyCountProductClass;
  productKey: Scalars['String'];
  productTitle: Scalars['String'];
  woocommerceProductId: Scalars['Int'];
};

export type NightlyCountListOutput = {
  __typename?: 'NightlyCountListOutput';
  data: Array<NightlyCountOutput>;
  meta: MetaData;
};

export type NightlyCountOfficeOutput = {
  __typename?: 'NightlyCountOfficeOutput';
  id: Scalars['String'];
  name: Scalars['String'];
  regionName?: Maybe<Scalars['String']>;
};

export type NightlyCountOutput = {
  __typename?: 'NightlyCountOutput';
  /** YYYY-MM-DD */
  countDate: Scalars['String'];
  createdAt: Scalars['DateTime'];
  createdByUser?: Maybe<NightlyCountUserOutput>;
  createdByUserId: Scalars['String'];
  id: Scalars['String'];
  items: Array<NightlyCountItemOutput>;
  lastEditedAt?: Maybe<Scalars['DateTime']>;
  lastEditedByUser?: Maybe<NightlyCountUserOutput>;
  lastEditedByUserId?: Maybe<Scalars['String']>;
  office?: Maybe<NightlyCountOfficeOutput>;
  officeId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export enum NightlyCountProductBloodType {
  Negative = 'Negative',
  Positive = 'Positive'
}

export enum NightlyCountProductClass {
  Accessory = 'Accessory',
  Ffp = 'FFP',
  Prbc = 'PRBC',
  Whole = 'Whole'
}

export type NightlyCountUserOutput = {
  __typename?: 'NightlyCountUserOutput';
  email: Scalars['String'];
  firstName: Scalars['String'];
  id: Scalars['String'];
  lastName: Scalars['String'];
};

export enum Notification {
  AppointmentsCancellation = 'AppointmentsCancellation',
  AppointmentsReminders = 'AppointmentsReminders',
  DailyInventoryDigest = 'DailyInventoryDigest',
  DaycareAppointmentRequestCreation = 'DaycareAppointmentRequestCreation',
  DaycareAppointmentRequestRejected = 'DaycareAppointmentRequestRejected',
  DaycareAppointmentUnenrolled = 'DaycareAppointmentUnenrolled',
  DonorCreation = 'DonorCreation',
  DonorUnenrolled = 'DonorUnenrolled',
  HoldbackPoolBelowReservation = 'HoldbackPoolBelowReservation',
  InventoryCriticalThreshold = 'InventoryCriticalThreshold',
  InventoryWarningThreshold = 'InventoryWarningThreshold',
  MakingAppointments = 'MakingAppointments',
  NewWooCommerceOrder = 'NewWooCommerceOrder',
  OwnerCreation = 'OwnerCreation',
  PendingReservationConfirmation = 'PendingReservationConfirmation',
  RecurringReservationReady = 'RecurringReservationReady',
  RemindersToTakePartAgain = 'RemindersToTakePartAgain',
  RequestCreation = 'RequestCreation',
  ReservationExpiringIn48Hours = 'ReservationExpiringIn48Hours',
  UserDeleting = 'UserDeleting',
  WasRegisteredOnDaycare = 'WasRegisteredOnDaycare'
}

export type NotificationAddedSubscriptionInput = {
  userId: Scalars['String'];
};

export type NotificationConfigOutput = {
  __typename?: 'NotificationConfigOutput';
  name: Notification;
  value: Scalars['Boolean'];
};

export type NotificationListFilterInput = {
  isRead?: InputMaybe<Scalars['Boolean']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type NotificationListOutput = {
  __typename?: 'NotificationListOutput';
  data: Array<NotificationOutput>;
  meta: MetaData;
};

export type NotificationOutput = {
  __typename?: 'NotificationOutput';
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  isRead: Scalars['Boolean'];
  payload: NotificationPayloadOutput;
  type: NotificationType;
  user: NotificationUserOutput;
};

export type NotificationPayloadOutput = {
  __typename?: 'NotificationPayloadOutput';
  appointment?: Maybe<AppointmentOutput>;
  appointmentId?: Maybe<Scalars['String']>;
  request?: Maybe<PartialRequestOutput>;
};

export enum NotificationType {
  AppointmentCanceled = 'AppointmentCanceled',
  AppointmentCreated = 'AppointmentCreated',
  AppointmentForGroupCreated = 'AppointmentForGroupCreated',
  DonorEnrolled = 'DonorEnrolled',
  DonorUnenrolled = 'DonorUnenrolled',
  RequestCreated = 'RequestCreated'
}

export type NotificationUserOutput = {
  __typename?: 'NotificationUserOutput';
  assignedLocations?: Maybe<Array<LocationOutput>>;
  assignedOffice?: Maybe<OfficeOutput>;
  assignedRegions?: Maybe<Array<RegionOutput>>;
  birthday?: Maybe<Scalars['DateTime']>;
  city?: Maybe<Scalars['String']>;
  contactPreferences?: Maybe<Scalars['String']>;
  contacts?: Maybe<Array<ContactOutput>>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  deletionIntentionAt?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  id: Scalars['String'];
  isArchived: Scalars['Boolean'];
  lastName: Scalars['String'];
  locationPreferences?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  productRegionPreference?: Maybe<RegionOutput>;
  role: RoleWithoutPermissionsOutput;
  shortId: Scalars['Float'];
  state?: Maybe<Scalars['String']>;
  streetAddress?: Maybe<Scalars['String']>;
  type?: Maybe<OwnerType>;
  zipCode?: Maybe<Scalars['String']>;
};

export type NotificationWebSocketOutput = {
  __typename?: 'NotificationWebSocketOutput';
  id: Scalars['String'];
  isRead: Scalars['Boolean'];
  type: NotificationType;
};

export type OfficeOutput = {
  __typename?: 'OfficeOutput';
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  idexxAccountNumber?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  region: RegionOutput;
  updatedAt: Scalars['DateTime'];
  zoetisAccountNumber?: Maybe<Scalars['String']>;
};

export type OpsOverviewDbSummaryOutput = {
  __typename?: 'OpsOverviewDbSummaryOutput';
  /** Earliest product created date in the system */
  earliestProductDate?: Maybe<Scalars['String']>;
  /** Earliest product sold date (updatedAt) in the system */
  earliestSoldDate?: Maybe<Scalars['String']>;
  ffpDiscarded: Scalars['Int'];
  ffpProduced: Scalars['Int'];
  inventoryTurnover: Scalars['Float'];
  monthlyUnitsShipped: Scalars['Int'];
  prbcDiscarded: Scalars['Int'];
  prbcProduced: Scalars['Int'];
  prevFfpTurnover: Scalars['Float'];
  prevFfpWastageRate: Scalars['Float'];
  prevInventoryTurnover: Scalars['Float'];
  prevMonthlyUnitsShipped: Scalars['Int'];
  prevPrbcTurnover: Scalars['Float'];
  prevPrbcWastageRate: Scalars['Float'];
  prevUnitsShippedBreakdown: ProductClassBreakdown;
  prevWastageRate: Scalars['Float'];
  reservationFillRate: Scalars['Float'];
  /** Top discard reasons with counts (current period) */
  topDiscardReasons: Array<DiscardReasonCount>;
  /** Total units discarded in period */
  totalDiscarded: Scalars['Int'];
  /** Total units produced in period */
  totalProduced: Scalars['Int'];
  turnoverBreakdown: ProductClassRateBreakdown;
  unitsShippedBreakdown: ProductClassBreakdown;
  wastageBreakdown: ProductClassRateBreakdown;
  wastageRate: Scalars['Float'];
};

export type OpsOverviewStatsOutput = {
  __typename?: 'OpsOverviewStatsOutput';
  /** Individual discarded product entries for drilldown */
  discardedUnitEntries: Array<DiscardedUnitEntry>;
  /** Inventory turnover ratio (units out / units in) */
  inventoryTurnover: Scalars['Float'];
  /** Total units shipped in the period */
  monthlyUnitsShipped: Scalars['Int'];
  /** Previous period FFP turnover ratio */
  prevFfpTurnover: Scalars['Float'];
  /** Previous period FFP wastage rate */
  prevFfpWastageRate: Scalars['Float'];
  /** Previous period inventory turnover ratio */
  prevInventoryTurnover: Scalars['Float'];
  /** Total units shipped in the previous period (for trend) */
  prevMonthlyUnitsShipped: Scalars['Int'];
  /** Previous period pRBC turnover ratio */
  prevPrbcTurnover: Scalars['Float'];
  /** Previous period pRBC wastage rate */
  prevPrbcWastageRate: Scalars['Float'];
  /** Previous period units shipped breakdown by product class */
  prevUnitsShippedBreakdown: ProductClassBreakdown;
  /** Previous period wastage rate */
  prevWastageRate: Scalars['Float'];
  /** WooCommerce orders count in the previous period */
  prevWooCommerceSalesCount: Scalars['Int'];
  /** WooCommerce sales total in the previous period */
  prevWooCommerceSalesTotal: Scalars['Float'];
  /** Previous period FFP total units sold */
  prevWooFfpCount: Scalars['Int'];
  /** Previous period pRBC units sold */
  prevWooPrbcCount: Scalars['Int'];
  /** Total WooCommerce line item units in the previous period */
  prevWooTotalUnits: Scalars['Int'];
  /** Recurring reservation fill rate as a percentage (fulfilled / template) */
  reservationFillRate: Scalars['Float'];
  /** Individual shipped product entries for drilldown */
  shippedUnitEntries: Array<ShippedUnitEntry>;
  /** Inventory turnover breakdown by product class */
  turnoverBreakdown: ProductClassRateBreakdown;
  /** Turnover breakdown entries for drilldown */
  turnoverEntries: Array<TurnoverEntry>;
  /** Units shipped breakdown by product class */
  unitsShippedBreakdown: ProductClassBreakdown;
  /** Wastage rate breakdown by product class */
  wastageBreakdown: ProductClassRateBreakdown;
  /** Wastage / discard rate as a percentage */
  wastageRate: Scalars['Float'];
  /** WooCommerce orders count in the period */
  wooCommerceSalesCount: Scalars['Int'];
  /** WooCommerce sales total in the period */
  wooCommerceSalesTotal: Scalars['Float'];
  /** Total FFP DBL units sold */
  wooFfpDblCount: Scalars['Int'];
  /** Total FFP SGL units sold */
  wooFfpSglCount: Scalars['Int'];
  /** Per-location product class breakdown */
  wooLocationBreakdown: Array<WooLocationSalesBreakdown>;
  /** WooCommerce order entries for drilldown */
  wooOrders: Array<WooOrderEntry>;
  /** Total other units sold */
  wooOtherCount: Scalars['Int'];
  /** Total pRBC units sold */
  wooPrbcCount: Scalars['Int'];
  /** Total WooCommerce line item units in the period */
  wooTotalUnits: Scalars['Int'];
};

export type OpsOverviewSummaryOutput = {
  __typename?: 'OpsOverviewSummaryOutput';
  inventoryTurnover: Scalars['Float'];
  monthlyUnitsShipped: Scalars['Int'];
  prevFfpTurnover: Scalars['Float'];
  prevFfpWastageRate: Scalars['Float'];
  prevInventoryTurnover: Scalars['Float'];
  prevMonthlyUnitsShipped: Scalars['Int'];
  prevPrbcTurnover: Scalars['Float'];
  prevPrbcWastageRate: Scalars['Float'];
  prevUnitsShippedBreakdown: ProductClassBreakdown;
  prevWastageRate: Scalars['Float'];
  prevWooCommerceSalesCount: Scalars['Int'];
  prevWooCommerceSalesTotal: Scalars['Float'];
  prevWooFfpCount: Scalars['Int'];
  prevWooPrbcCount: Scalars['Int'];
  reservationFillRate: Scalars['Float'];
  turnoverBreakdown: ProductClassRateBreakdown;
  unitsShippedBreakdown: ProductClassBreakdown;
  wastageBreakdown: ProductClassRateBreakdown;
  wastageRate: Scalars['Float'];
  wooCommerceSalesCount: Scalars['Int'];
  wooCommerceSalesTotal: Scalars['Float'];
  wooFfpDblCount: Scalars['Int'];
  wooFfpSglCount: Scalars['Int'];
  wooOtherCount: Scalars['Int'];
  wooPrbcCount: Scalars['Int'];
};

export type OpsOverviewWooSummaryOutput = {
  __typename?: 'OpsOverviewWooSummaryOutput';
  prevWooCommerceSalesCount: Scalars['Int'];
  prevWooCommerceSalesTotal: Scalars['Float'];
  prevWooFfpCount: Scalars['Int'];
  prevWooPrbcCount: Scalars['Int'];
  wooCommerceSalesCount: Scalars['Int'];
  wooCommerceSalesTotal: Scalars['Float'];
  wooFfpDblCount: Scalars['Int'];
  wooFfpSglCount: Scalars['Int'];
  wooOtherCount: Scalars['Int'];
  wooPrbcCount: Scalars['Int'];
};

export enum Order {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type OrderItemOutput = {
  __typename?: 'OrderItemOutput';
  id: Scalars['Float'];
  name: Scalars['String'];
  price: Scalars['Float'];
  quantity: Scalars['Float'];
  sku?: Maybe<Scalars['String']>;
};

export type OrderListOutput = {
  __typename?: 'OrderListOutput';
  data: Array<OrderOutput>;
  meta: MetaData;
};

export type OrderOutput = {
  __typename?: 'OrderOutput';
  billing: BillingOutput;
  customerId: Scalars['String'];
  date: Scalars['String'];
  feeLines: Array<FeeLineOutput>;
  id: Scalars['String'];
  items: Array<OrderItemOutput>;
  number: Scalars['Float'];
  paymentMethod: Scalars['String'];
  shipping: ShippingOutput;
  shippingLines: Array<ShippingLineOutput>;
  status: Scalars['String'];
  total: Scalars['String'];
  trackingCode?: Maybe<Scalars['String']>;
};

export enum OrderStatusFilter {
  Any = 'Any',
  AutoDraft = 'AutoDraft',
  Cancelled = 'Cancelled',
  CheckoutDraft = 'CheckoutDraft',
  Completed = 'Completed',
  Completed2 = 'Completed2',
  Delayed = 'Delayed',
  Failed = 'Failed',
  New = 'New',
  OnHold = 'OnHold',
  Pending = 'Pending',
  Processing = 'Processing',
  Refunded = 'Refunded',
  Shipped = 'Shipped',
  Trash = 'Trash'
}

export type OrdersListFilterInput = {
  number?: InputMaybe<Scalars['Float']>;
  status?: InputMaybe<Array<OrderStatusFilter>>;
};

export enum OrdersListSort {
  Date = 'Date'
}

export type OrdersListSortInput = {
  fieldName: OrdersListSort;
  order: Order;
};

export type OwnerDonorReportOutput = {
  __typename?: 'OwnerDonorReportOutput';
  location?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  status: DonorStatus;
};

export type OwnerOutput = {
  __typename?: 'OwnerOutput';
  assignedLocations?: Maybe<Array<LocationOutput>>;
  assignedOffice?: Maybe<OfficeOutput>;
  assignedRegions?: Maybe<Array<RegionOutput>>;
  birthday?: Maybe<Scalars['DateTime']>;
  city?: Maybe<Scalars['String']>;
  contactPreferences?: Maybe<Scalars['String']>;
  contacts?: Maybe<Array<ContactOutput>>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  deletionIntentionAt?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  hasMultipleDonors?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  isArchived: Scalars['Boolean'];
  lastName: Scalars['String'];
  locationPreferences?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  productRegionPreference?: Maybe<RegionOutput>;
  role: RoleWithoutPermissionsOutput;
  shortId: Scalars['Float'];
  state?: Maybe<Scalars['String']>;
  streetAddress?: Maybe<Scalars['String']>;
  type?: Maybe<OwnerType>;
  zipCode?: Maybe<Scalars['String']>;
};

export type OwnerReportOutput = {
  __typename?: 'OwnerReportOutput';
  birthday?: Maybe<Scalars['DateTime']>;
  city?: Maybe<Scalars['String']>;
  contactPreferences?: Maybe<Scalars['String']>;
  donors?: Maybe<Array<OwnerDonorReportOutput>>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  id: Scalars['String'];
  isArchived: Scalars['Boolean'];
  lastName: Scalars['String'];
  locationPreferences?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  regionPreferences?: Maybe<Scalars['String']>;
  regions: Array<Scalars['String']>;
  shortId: Scalars['Float'];
  state?: Maybe<Scalars['String']>;
  streetAddress?: Maybe<Scalars['String']>;
  type?: Maybe<OwnerType>;
  zipCode?: Maybe<Scalars['String']>;
};

export enum OwnerType {
  Group = 'Group',
  Individual = 'Individual'
}

export type OwnersListFilterInput = {
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  locationPreferences?: InputMaybe<Array<Scalars['String']>>;
  ownerTypes?: InputMaybe<Array<OwnerType>>;
  searchingQuery?: InputMaybe<Scalars['String']>;
  username?: InputMaybe<Scalars['String']>;
};

export type PaginatedDonationReportOutput = {
  __typename?: 'PaginatedDonationReportOutput';
  data: Array<DonationReportOutput>;
  meta: CursorPaginationMetaData;
};

export type PaginatedDonorReportOutput = {
  __typename?: 'PaginatedDonorReportOutput';
  data: Array<DonorReportOutput>;
  meta: CursorPaginationMetaData;
};

export type PaginatedIneligibleParticipantsOutput = {
  __typename?: 'PaginatedIneligibleParticipantsOutput';
  data: Array<IneligibleParticipantOutput>;
  meta: CursorPaginationMetaData;
};

export type PaginatedInvitationListOutput = {
  __typename?: 'PaginatedInvitationListOutput';
  data: Array<InvitationOutput>;
  meta: MetaData;
};

export type PaginatedLocationsOutput = {
  __typename?: 'PaginatedLocationsOutput';
  data: Array<LocationOutput>;
  meta: MetaData;
};

export type PaginatedOwnerReportOutput = {
  __typename?: 'PaginatedOwnerReportOutput';
  data: Array<OwnerReportOutput>;
  meta: CursorPaginationMetaData;
};

export type PaginatedProductReportOutput = {
  __typename?: 'PaginatedProductReportOutput';
  data: Array<ProductReportOutput>;
  meta: CursorPaginationMetaData;
};

export type PaginatedUserListOutput = {
  __typename?: 'PaginatedUserListOutput';
  data: Array<UserOutput>;
  meta: MetaData;
};

export type PartialDonorOutput = {
  __typename?: 'PartialDonorOutput';
  acceptSimparicaTrio?: Maybe<Scalars['Boolean']>;
  age?: Maybe<Scalars['Float']>;
  approvedDonationML?: Maybe<Scalars['Float']>;
  attendDaycareDays?: Maybe<Array<Scalars['String']>>;
  becameReservedDonorDate?: Maybe<Scalars['DateTime']>;
  bloodType?: Maybe<BloodType>;
  breed?: Maybe<Scalars['String']>;
  canRegularlyAttendDaycare?: Maybe<Scalars['Boolean']>;
  color?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  distemperDate?: Maybe<Scalars['DateTime']>;
  distinguishableMarks?: Maybe<Scalars['String']>;
  donationFrequency?: Maybe<Scalars['Float']>;
  donationMLApprovedAmount?: Maybe<Scalars['Float']>;
  firstCertificatePrinted?: Maybe<Scalars['Boolean']>;
  gender?: Maybe<AnimalGender>;
  hasHeartMurmur?: Maybe<Scalars['Boolean']>;
  hasMicrochip?: Maybe<Scalars['Boolean']>;
  hasTransfusion?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  isDaycare?: Maybe<Scalars['Boolean']>;
  lastDonationDate?: Maybe<Scalars['DateTime']>;
  lastLabworkDate?: Maybe<Scalars['DateTime']>;
  lastLabworkFile?: Maybe<Array<FileOutput>>;
  location?: Maybe<Scalars['String']>;
  medicationCourse?: Maybe<Scalars['String']>;
  microchipNumber?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  neutered?: Maybe<Scalars['Boolean']>;
  nextDonationDate?: Maybe<Scalars['DateTime']>;
  pictures?: Maybe<Array<DonorPictureOutput>>;
  primaryVeterinarian?: Maybe<Scalars['String']>;
  rabiesDate?: Maybe<Scalars['DateTime']>;
  reserveNotes?: Maybe<Array<ReserveDonorNoteOutput>>;
  retiredDate?: Maybe<Scalars['DateTime']>;
  retiredReason?: Maybe<RetiredReasons>;
  retiredReasonComment?: Maybe<Scalars['String']>;
  secondCertificatePrinted?: Maybe<Scalars['Boolean']>;
  shortId?: Maybe<Scalars['Float']>;
  species?: Maybe<AnimalSpecies>;
  status?: Maybe<DonorStatus>;
  takeMedications?: Maybe<Scalars['Boolean']>;
  team?: Maybe<TeamOutput>;
  type?: Maybe<DonorType>;
  user?: Maybe<OwnerOutput>;
  weight?: Maybe<Scalars['Float']>;
};

export type PartialRequestOutput = {
  __typename?: 'PartialRequestOutput';
  donor: PartialDonorOutput;
  id: Scalars['String'];
  number: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type PeriodRegistrationOutput = {
  __typename?: 'PeriodRegistrationOutput';
  /** Number of new donors registered */
  count: Scalars['Int'];
  /** End of the period */
  endDate: Scalars['DateTime'];
  /** Time period identifier */
  period: Scalars['String'];
  /** Start of the period */
  startDate: Scalars['DateTime'];
};

export type PermissionInput = {
  id: Scalars['String'];
  value: Scalars['Boolean'];
};

export enum PermissionsEnum {
  AddCommentsToTheDonationAtTheDonorProfile = 'addCommentsToTheDonationAtTheDonorProfile',
  AddDonorToAppointment = 'addDonorToAppointment',
  AddNewDonation = 'addNewDonation',
  AddProducts = 'addProducts',
  AddUsers = 'addUsers',
  ApproveDisapproveRequests = 'approveDisapproveRequests',
  ApproveDonationMl = 'approveDonationML',
  ArchiveDonors = 'archiveDonors',
  ArchiveOwners = 'archiveOwners',
  ChangeDonorStatus = 'changeDonorStatus',
  ChangeUserRole = 'changeUserRole',
  CreateLabels = 'createLabels',
  CreateTimeSlotOrAppointment = 'createTimeSlotOrAppointment',
  CreteLocation = 'creteLocation',
  DeleteAppointments = 'deleteAppointments',
  DeleteDonation = 'deleteDonation',
  DeleteDonorsPictures = 'deleteDonorsPictures',
  DeleteLabworkData = 'deleteLabworkData',
  DeleteLocation = 'deleteLocation',
  DeleteProduct = 'deleteProduct',
  DeleteUsers = 'deleteUsers',
  DetachLabworkFile = 'detachLabworkFile',
  DonationFrequency = 'donationFrequency',
  MakeProductsAvailable = 'makeProductsAvailable',
  ManagePermissions = 'managePermissions',
  PrintTasksSchedule = 'printTasksSchedule',
  ReceiveEmailWithTaskScheduleEveryFriday = 'receiveEmailWithTaskScheduleEveryFriday',
  ReceiveNotifications = 'receiveNotifications',
  ShareLabworkResults = 'shareLabworkResults',
  UpdateDonationData = 'updateDonationData',
  UpdateDonorsData = 'updateDonorsData',
  UpdateLabworkData = 'updateLabworkData',
  UpdateLabworkStatus = 'updateLabworkStatus',
  UpdateLocation = 'updateLocation',
  UpdateOwnProfile = 'updateOwnProfile',
  UpdateOwnersData = 'updateOwnersData',
  UpdateOwnersEmail = 'updateOwnersEmail',
  UpdateProduct = 'updateProduct',
  UpdateProductLocationPreference = 'updateProductLocationPreference',
  UpdateProductStatus = 'updateProductStatus',
  UpdateProductStatusManually = 'updateProductStatusManually',
  UpdateTheTrainingReserveDonors = 'updateTheTrainingReserveDonors',
  UpdateUserEmail = 'updateUserEmail',
  UpdateUserInfo = 'updateUserInfo',
  UpdateVitalsChartParameters = 'updateVitalsChartParameters',
  UploadDonorsPictures = 'uploadDonorsPictures',
  ViewAppointments = 'viewAppointments',
  ViewDonationDataCollectionPage = 'viewDonationDataCollectionPage',
  ViewDonorsPictures = 'viewDonorsPictures',
  ViewLabworkResults = 'viewLabworkResults',
  ViewListOfOrders = 'viewListOfOrders',
  ViewProductList = 'viewProductList',
  ViewReports = 'viewReports',
  ViewRequestsForApproval = 'viewRequestsForApproval',
  ViewSpecificDonationDataAtDonorProfile = 'viewSpecificDonationDataAtDonorProfile',
  ViewTasksSchedule = 'viewTasksSchedule',
  ViewTasksScheduleOfSpecificUser = 'viewTasksScheduleOfSpecificUser',
  ViewTheHistoryOfAppointments = 'viewTheHistoryOfAppointments',
  ViewTheListOfDonors = 'viewTheListOfDonors',
  ViewTheListOfOwners = 'viewTheListOfOwners',
  ViewTheListOfTrainingReserveDonors = 'viewTheListOfTrainingReserveDonors',
  ViewUsersList = 'viewUsersList',
  ViewVitalsChart = 'viewVitalsChart'
}

export type PermissionsFilterInput = {
  roles?: InputMaybe<Array<UserRole>>;
};

export type PermissionsInput = {
  values: Array<PermissionInput>;
};

export type PermissionsOutput = {
  __typename?: 'PermissionsOutput';
  id: Scalars['String'];
  permission: PermissionsEnum;
  role: RoleOutput;
  value: Scalars['Boolean'];
};

export type PetBreedListFilterInput = {
  searchingQuery?: InputMaybe<Scalars['String']>;
  species?: InputMaybe<AnimalSpecies>;
};

export type PetBreedsListInput = {
  filter?: InputMaybe<PetBreedListFilterInput>;
  skip?: Scalars['Float'];
  take?: Scalars['Float'];
};

export type PetBreedsListOutput = {
  __typename?: 'PetBreedsListOutput';
  data: Array<BreedOutput>;
  meta: MetaData;
};

export type PhlebotomistStatsOutput = {
  __typename?: 'PhlebotomistStatsOutput';
  /** Actual FFP from double donors */
  actualFFPDouble: Scalars['Int'];
  /** Actual FFP from single donors */
  actualFFPSingle: Scalars['Int'];
  /** Actual pRBC units produced (combined) */
  actualPRBC: Scalars['Int'];
  /** Actual pRBC from double donors */
  actualPRBCDouble: Scalars['Int'];
  /** Actual pRBC from single donors */
  actualPRBCSingle: Scalars['Int'];
  /** Total actual products produced */
  actualTotal: Scalars['Int'];
  /** Assigned office ID for team grouping */
  assignedOfficeId?: Maybe<Scalars['String']>;
  /** Assigned office name for team grouping */
  assignedOfficeName?: Maybe<Scalars['String']>;
  /** Total attempted donations (all draws in date range) */
  attemptedDonations: Scalars['Int'];
  /** Discard reasons from completely failed donations (0 units yielded) */
  completelyFailedDiscards: Array<DiscardReasonCountOutput>;
  /** Number of completely failed donations (0 units yielded) with discarded products */
  completelyFailedDonations: Scalars['Int'];
  /** Double donors who only yielded single products (DBL→SGL) */
  dblDonorsSglYield: Scalars['Int'];
  /** Double donors success rate */
  dblDonorsSuccessRate: Scalars['Float'];
  /** This phlebotomist's share of office donations: (successfulDonations / totalOfficeSuccessful) * 100 */
  donationSharePercent: Scalars['Float'];
  /** Count of double donors (approvedDonationsMl >= 420) */
  doubleDonors: Scalars['Int'];
  /** Expected FFP from double donors */
  expectedFFPDouble: Scalars['Int'];
  /** Expected FFP from single donors */
  expectedFFPSingle: Scalars['Int'];
  /** Expected pRBC units (combined) */
  expectedPRBC: Scalars['Int'];
  /** Expected pRBC from double donors */
  expectedPRBCDouble: Scalars['Int'];
  /** Expected pRBC from single donors */
  expectedPRBCSingle: Scalars['Int'];
  /** Total expected products (pRBC + FFP) */
  expectedTotal: Scalars['Int'];
  /** Location/office preference (string) - DEPRECATED: use assignedOfficeId */
  locationPreference?: Maybe<Scalars['String']>;
  /** Equal share percentage: 100 / teamCount */
  officeSharePercent: Scalars['Float'];
  /** Overall success rate: actualTotal / expectedTotal * 100 */
  overallSuccessRate: Scalars['Float'];
  /** Discard reasons from partially failed donations (1+ units yielded but not all expected) */
  partiallyFailedDiscards: Array<DiscardReasonCountOutput>;
  /** Number of partially failed donations (1+ units yielded but not all expected) with discarded products */
  partiallyFailedDonations: Scalars['Int'];
  /** Number of donations not yet processed (no products and no discards) */
  pendingDonations: Scalars['Int'];
  /** Phlebotomist email */
  phlebotomistEmail?: Maybe<Scalars['String']>;
  /** Phlebotomist user ID */
  phlebotomistId: Scalars['String'];
  /** Phlebotomist full name */
  phlebotomistName: Scalars['String'];
  /** pRBC success rate: actualPRBC / expectedPRBC * 100 */
  prbcSuccessRate: Scalars['Float'];
  /** Recent donation records for the table */
  recentDonations: Array<DonationRecordOutput>;
  /** Region ID */
  regionId?: Maybe<Scalars['String']>;
  /** Region name */
  regionName?: Maybe<Scalars['String']>;
  /** Single donors success rate */
  sglDonorsSuccessRate: Scalars['Float'];
  /** Count of single donors (approvedDonationsMl < 420) */
  singleDonors: Scalars['Int'];
  /** Successful donations (ineligible = false) */
  successfulDonations: Scalars['Int'];
  /** Double donors with successful products */
  successfulDoubleDonors: Scalars['Int'];
  /** Single donors with successful products */
  successfulSingleDonors: Scalars['Int'];
  /** Number of Phlebotomist/TeamLead users at same office/location (for goal calculations) */
  teamCount: Scalars['Int'];
  /** Total successful donations for all phlebotomists at the same office in date range */
  totalOfficeSuccessful: Scalars['Int'];
};

/** Trend data point for phlebotomist stats */
export type PhlebotomistTrendStatsOutput = {
  __typename?: 'PhlebotomistTrendStatsOutput';
  /** Actual FFP from double donors */
  actualFFPDouble: Scalars['Int'];
  /** Actual FFP from single donors */
  actualFFPSingle: Scalars['Int'];
  /** Actual pRBC units */
  actualPRBC: Scalars['Int'];
  /** Total actual products */
  actualTotal: Scalars['Int'];
  /** Total attempted donations in this period */
  attemptedDonations: Scalars['Int'];
  /** Double donors success rate (successfulDouble / totalDouble * 100) */
  dblDonorsSuccessRate: Scalars['Float'];
  /** Number of double donors */
  doubleDonors: Scalars['Int'];
  /** Expected FFP from double donors */
  expectedFFPDouble: Scalars['Int'];
  /** Expected FFP from single donors */
  expectedFFPSingle: Scalars['Int'];
  /** Expected pRBC units */
  expectedPRBC: Scalars['Int'];
  /** Total expected products */
  expectedTotal: Scalars['Int'];
  /** Overall unit success rate (actualTotal / expectedTotal * 100) */
  overallSuccessRate: Scalars['Float'];
  /** Period label (e.g., "01/15", "Jan 2025", "Q1 2025") */
  period: Scalars['String'];
  /** End date of this period */
  periodEnd: Scalars['DateTime'];
  /** Start date of this period */
  periodStart: Scalars['DateTime'];
  /** pRBC success rate (actualPRBC / expectedPRBC * 100) */
  prbcSuccessRate: Scalars['Float'];
  /** Single donors success rate (successfulSingle / totalSingle * 100) */
  sglDonorsSuccessRate: Scalars['Float'];
  /** Number of single donors */
  singleDonors: Scalars['Int'];
  /** Successful donations (yielded at least some product) */
  successfulDonations: Scalars['Int'];
  /** Successful double donors (Complete status) */
  successfulDoubleDonors: Scalars['Int'];
  /** Successful single donors (Complete status) */
  successfulSingleDonors: Scalars['Int'];
};

export type PrbcDonationDonorOutput = {
  __typename?: 'PrbcDonationDonorOutput';
  /** Date the donor first transitioned to Active status */
  activeDate?: Maybe<Scalars['DateTime']>;
  /** Date the donor first transitioned to Approved status */
  approvedDate?: Maybe<Scalars['DateTime']>;
  /** Donor approved donation volume in mL */
  approvedDonationML?: Maybe<Scalars['Int']>;
  /** Date the donor first transitioned to Archived status */
  archivedDate?: Maybe<Scalars['DateTime']>;
  /** Blood type display: P (Positive), N (Negative), U (Unknown) */
  bloodTypeDisplay: Scalars['String'];
  /** Donor breed */
  breed?: Maybe<Scalars['String']>;
  /** Donor date of birth */
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  /** Donor UUID */
  donorId: Scalars['String'];
  /** Donor name */
  donorName: Scalars['String'];
  /** Donor short ID for links */
  donorShortId: Scalars['Int'];
  /** Most recent donation date (all time) */
  lastDonationDate?: Maybe<Scalars['DateTime']>;
  /** Donor location */
  location: Scalars['String'];
  /** Owner assigned location names (comma-separated) from user_assigned_locations */
  ownerAssignedLocations?: Maybe<Scalars['String']>;
  /** Owner city */
  ownerCity?: Maybe<Scalars['String']>;
  /** Owner contact preferences */
  ownerContactPreferences?: Maybe<Scalars['String']>;
  /** Owner email address */
  ownerEmail?: Maybe<Scalars['String']>;
  /** Owner full name (firstName + lastName) */
  ownerFullName?: Maybe<Scalars['String']>;
  /** Owner phone number */
  ownerPhone?: Maybe<Scalars['String']>;
  /** Owner short ID for links */
  ownerShortId?: Maybe<Scalars['Int']>;
  /** Owner state */
  ownerState?: Maybe<Scalars['String']>;
  /** pRBC units within the period (SGL=1, DBL=2) */
  periodUnits: Scalars['Int'];
  /** Region name resolved from donor location via LocationEntity */
  region?: Maybe<Scalars['String']>;
  /** Donor registration date (createdAt) */
  registeredAt?: Maybe<Scalars['DateTime']>;
  /** Date the donor transitioned to Retired status (from status change history) */
  retiredDate?: Maybe<Scalars['DateTime']>;
  /** Reason the donor was retired (e.g. Age, Unresponsive) */
  retiredReason?: Maybe<Scalars['String']>;
  /** SGL or DBL based on most recent donation approvedML */
  sglDbl: Scalars['String'];
  /** Current donor status */
  status: Scalars['String'];
  /** Total eligible donation count (all time) */
  totalDonations: Scalars['Int'];
  /** Donor weight in lbs */
  weight?: Maybe<Scalars['Float']>;
};

export type PrbcDonationDonorsListOutput = {
  __typename?: 'PrbcDonationDonorsListOutput';
  donors: Array<PrbcDonationDonorOutput>;
  /** Total number of matching donors */
  total: Scalars['Int'];
};

export enum ProcessingProductType {
  Nextday = 'Nextday',
  Sameday = 'Sameday'
}

export type ProductAdditionlaDonationInfoReportOutput = {
  __typename?: 'ProductAdditionlaDonationInfoReportOutput';
  id: Scalars['String'];
  poker?: Maybe<ProductDonationHolderReportOutput>;
  primaryHolder?: Maybe<ProductDonationHolderReportOutput>;
};

export type ProductClassBreakdown = {
  __typename?: 'ProductClassBreakdown';
  ffpDbl: Scalars['Int'];
  ffpSgl: Scalars['Int'];
  ffpTotal: Scalars['Int'];
  prbcDbl: Scalars['Int'];
  prbcSgl: Scalars['Int'];
  prbcTotal: Scalars['Int'];
};

export type ProductClassRateBreakdown = {
  __typename?: 'ProductClassRateBreakdown';
  ffpDblRate: Scalars['Float'];
  ffpRate: Scalars['Float'];
  ffpSglRate: Scalars['Float'];
  prbcDblRate: Scalars['Float'];
  prbcRate: Scalars['Float'];
  prbcSglRate: Scalars['Float'];
};

export type ProductDonationHolderReportOutput = {
  __typename?: 'ProductDonationHolderReportOutput';
  firstName: Scalars['String'];
  id: Scalars['String'];
  lastName: Scalars['String'];
};

export type ProductDonationReportOutput = {
  __typename?: 'ProductDonationReportOutput';
  actual?: Maybe<Scalars['Float']>;
  additionalInfo?: Maybe<ProductAdditionlaDonationInfoReportOutput>;
  approvedDonationsMl?: Maybe<Scalars['Float']>;
  donor?: Maybe<ProductDonorReportOutput>;
  id: Scalars['String'];
};

export type ProductDonorOwnerReportOutput = {
  __typename?: 'ProductDonorOwnerReportOutput';
  id: Scalars['String'];
  lastName: Scalars['String'];
};

export type ProductDonorReportOutput = {
  __typename?: 'ProductDonorReportOutput';
  bloodType?: Maybe<BloodType>;
  id: Scalars['String'];
  location: Scalars['String'];
  name: Scalars['String'];
  user?: Maybe<ProductDonorOwnerReportOutput>;
};

export type ProductListFilterInput = {
  bloodType?: InputMaybe<Array<BloodType>>;
  orderId?: InputMaybe<Scalars['String']>;
  regionName?: InputMaybe<Array<Scalars['String']>>;
  searchQuery?: InputMaybe<Scalars['String']>;
  statuses?: InputMaybe<Array<ProductStatus>>;
  woocommerceCategory?: InputMaybe<Array<Scalars['Float']>>;
};

export type ProductListInput = {
  filter?: InputMaybe<ProductListFilterInput>;
  skip?: Scalars['Float'];
  sort?: InputMaybe<Array<ProductListSortInput>>;
  take?: Scalars['Float'];
};

export type ProductListOutput = {
  __typename?: 'ProductListOutput';
  data: Array<ProductOutput>;
  meta: MetaData;
};

export enum ProductListSort {
  DonorName = 'DonorName',
  ExpirationDate = 'ExpirationDate',
  OwnerLastName = 'OwnerLastName',
  ProductRegion = 'ProductRegion',
  Value = 'Value'
}

export type ProductListSortInput = {
  fieldName: ProductListSort;
  order: Order;
};

export type ProductOutput = {
  __typename?: 'ProductOutput';
  anticoagulant?: Maybe<Anticoagulant>;
  bloodIdentifiers?: Maybe<Array<BloodUnitIdentifiersOutput>>;
  createdAt: Scalars['DateTime'];
  discardedProduct?: Maybe<DiscardedProductDataOutput>;
  donation: DonationOutput;
  expirationDate: Scalars['DateTime'];
  id: Scalars['String'];
  isMantelAssigned?: Maybe<Scalars['Boolean']>;
  publishable: Scalars['Boolean'];
  published: Scalars['Boolean'];
  regionPreference?: Maybe<RegionOutput>;
  respin?: Maybe<Scalars['Boolean']>;
  shortId: Scalars['Float'];
  status: ProductStatus;
  storageRequirements: Array<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  value: Scalars['Float'];
  woocommerceCategoryId: Scalars['Float'];
  woocommerceOrderId?: Maybe<Scalars['Float']>;
  woocommerceProductId: Scalars['Float'];
};

export type ProductProcessorOutput = {
  __typename?: 'ProductProcessorOutput';
  firstName: Scalars['String'];
  id: Scalars['String'];
  lastName: Scalars['String'];
};

export type ProductReportOutput = {
  __typename?: 'ProductReportOutput';
  anticoagulant?: Maybe<Anticoagulant>;
  createdAt: Scalars['DateTime'];
  discardedProduct?: Maybe<DiscardedProductDataReportOutput>;
  donation: ProductDonationReportOutput;
  expirationDate: Scalars['DateTime'];
  id: Scalars['String'];
  isMantelAssigned?: Maybe<Scalars['Boolean']>;
  regionPreference?: Maybe<RegionOutput>;
  respin?: Maybe<Scalars['Boolean']>;
  shortId: Scalars['Float'];
  status: ProductStatus;
  storageRequirements: Array<Scalars['String']>;
  value: Scalars['Float'];
  woocommerceCategoryId: Scalars['Float'];
  woocommerceProductId: Scalars['Float'];
};

export enum ProductStatus {
  Available = 'Available',
  Collected = 'Collected',
  Cryoprecipitate = 'Cryoprecipitate',
  Discarded = 'Discarded',
  Pending = 'Pending',
  Processed = 'Processed',
  Sold = 'Sold'
}

export type ProductUnitCountsOutput = {
  __typename?: 'ProductUnitCountsOutput';
  /** Distinct donor count with matching products */
  donorCount: Scalars['Int'];
  /** Total product count matching filters */
  unitCount: Scalars['Int'];
};

export type PublicRegionOutput = {
  __typename?: 'PublicRegionOutput';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type Query = {
  __typename?: 'Query';
  checkUserConnection: Scalars['Boolean'];
  currentUser: UserOutput;
  findAllGroup: GroupListOutput;
  findDonorsForTeam: DonorsListOutput;
  findGroup: GroupOutput;
  findTeam: TeamOutput;
  getAdditionalDonationInfo: AdditionalDonationInfoOutput;
  getAllAppSettings: Array<AppSettingsOutput>;
  getAllDonorStatuses: DonorsStatusListOutput;
  getAllIneligibleParticipants: AllIneligibleParticipantsOutput;
  getAppSettings?: Maybe<AppSettingsOutput>;
  getAppVersion: Scalars['String'];
  getAppointment: AppointmentOutput;
  getAppointments: Array<AppointmentOutput>;
  getAppointmentsDatesForDonor: Array<AppointmentDatesInfoOutput>;
  getAppointmentsDonorsList: Array<DonorOutput>;
  getAppointmentsForCurrentUser: Array<AppointmentOutput>;
  getChartsData: DonationListOutput;
  /** Get historical churn rates for up to 12 consecutive periods (1 year lookback) */
  getChurnRateHistory: ChurnRateHistoryOutput;
  getCurrentUserDonorsList: DonorsListOutput;
  getCustomer: CustomerOutput;
  /** Debug: Get donors by status for pipeline health snapshot (Active/Pending/Approved) */
  getDataAuditPipelineDonors: DataAuditPipelineDonorsOutput;
  /** Debug: Get recruited donors (status != NotAccepted) created in a period */
  getDataAuditRecruitedDonors: DataAuditRecruitedDonorsOutput;
  /** Debug: Get donor-aggregated pRBC unit counts for a period */
  getDataAuditUnitDonors: DataAuditUnitDonorsOutput;
  /** Debug: Get raw product rows for pRBC units collected in a period */
  getDataAuditUnits: DataAuditUnitsOutput;
  getDaycareAppointmentInfo: DaycareAppointmentDetailOutput;
  getDaycareAppointmentInfoForCurrentUser: UserDaycareAppointmentInfoOutput;
  getDonation: DonationOutput;
  getDonationReports: PaginatedDonationReportOutput;
  getDonationsList: DonationListOutput;
  getDonationsListForAnalytics: DonationListOutput;
  getDonor: DonorOutput;
  /** Pre-aggregated donor counts — replaces paginated list fetches for analytics dashboards */
  getDonorAnalytics: DonorAnalyticsOutput;
  /** Get bulk donor contact flag states — returns JSON map of donorId → { contacted, latestNote }. Also runs cleanup of stale flags. */
  getDonorContactFlags: Scalars['String'];
  /** Get all contact log entries for a donor */
  getDonorContacts: Array<DonorContactOutput>;
  /** Get all-time donation history for a specific donor */
  getDonorDonationHistory: DonorDonationHistoryOutput;
  getDonorDvmExams: Array<DvmExamOutput>;
  getDonorLivesSaved: LivesSavedOutput;
  getDonorNotes: Array<DonorNoteOutput>;
  getDonorPictures: Array<DonorPictureOutput>;
  /** Get donor pipeline statistics including active donor count and registrations by time period */
  getDonorPipelineStats: DonorPipelineStatsOutput;
  getDonorStats: DonorStatsOutput;
  getDonorsList: DonorsListOutput;
  getDonorsListByIds: Array<DonorOutput>;
  getDonorsListForAnalytics: DonorsListOutput;
  getDonorsReport: PaginatedDonorReportOutput;
  /** Get historical dropout rates for up to 12 consecutive periods */
  getDropoutHistory: DropoutHistoryOutput;
  getDvmExam: DvmExamOutput;
  getDvmExamList: DvmExamListOutput;
  getIneligibleParticipantsReports: PaginatedIneligibleParticipantsOutput;
  getInvitationsList: PaginatedInvitationListOutput;
  getLabwork: LabworkOutput;
  getLabworkAttachments: Array<LabworkAttachmentOutput>;
  getLabworkList: LabworkListOutput;
  /** Get weekly leaderboard history — 1st place recruiter per week for N weeks */
  getLeaderboardHistory: LeaderboardHistoryOutput;
  getLocationWithAvailableDaycare: Array<LocationOutput>;
  getLocations: PaginatedLocationsOutput;
  getMicrochipPrice: GetMicrochipPriceOutput;
  getMyPermissions: Array<PermissionsOutput>;
  getNightlyCountForToday?: Maybe<NightlyCountOutput>;
  getNightlyCountOfficesForCurrentUser: Array<NightlyCountAllowedOfficeOutput>;
  getNightlyCountsList: NightlyCountListOutput;
  getNotificationConfigList: Array<NotificationConfigOutput>;
  getNotificationsList: NotificationListOutput;
  getOffices: Array<OfficeOutput>;
  /** Ops dashboard: product rows for location units by donation date */
  getOpsLocationUnits: DataAuditUnitsOutput;
  /** DB-only overview metrics: units shipped, wastage, turnover (fast) */
  getOpsOverviewDbSummary: OpsOverviewDbSummaryOutput;
  /** Get ops overview stats: inventory, wastage, turnover, reservation fill rate, sales (STUB) */
  getOpsOverviewStats: OpsOverviewStatsOutput;
  /** Lean summary for overview cards — parallelized, no drilldown data */
  getOpsOverviewSummary: OpsOverviewSummaryOutput;
  /** WooCommerce-only overview metrics (external API, cached) */
  getOpsOverviewWooSummary: OpsOverviewWooSummaryOutput;
  getOrder: OrderOutput;
  getOrdersList: OrderListOutput;
  getOwner: OwnerOutput;
  getOwnerReports: PaginatedOwnerReportOutput;
  getOwnersList: PaginatedUserListOutput;
  getPermissions: Array<PermissionsOutput>;
  getPetBreedsList: PetBreedsListOutput;
  /** Get aggregated statistics for phlebotomists/collection team members */
  getPhlebotomistStats: Array<PhlebotomistStatsOutput>;
  /** Get trend statistics aggregated by time interval */
  getPhlebotomistTrendStats: Array<PhlebotomistTrendStatsOutput>;
  /** Get donors whose donations produced pRBC products within a period, matching spatial filters */
  getPrbcDonationDonors: PrbcDonationDonorsListOutput;
  getPreviousDonation: DonationOutput;
  getPrivateDaycareAppointmentForCurrentUser: Array<AppointmentOutput>;
  getProduct: ProductOutput;
  getProductReports: PaginatedProductReportOutput;
  /** Get aggregate product unit count and donor count for a period, filtered by category */
  getProductUnitCounts: ProductUnitCountsOutput;
  getProducts: ProductListOutput;
  getProductsCount: Scalars['Float'];
  getPublicLocations: PaginatedLocationsOutput;
  getPublicRegions: Array<PublicRegionOutput>;
  /** Get historical first-time vs repeat ratio for up to 12 consecutive periods */
  getRatioHistory: RatioHistoryOutput;
  /** Get recruiter dashboard metrics: retention score, dropout rate, churn rates, and trends */
  getRecruiterDashboardMetrics: RecruiterDashboardMetricsOutput;
  /** Get newly recruited donors for a specific recruiter (donors created in period, attributed to recruiter region) */
  getRecruiterDonors: PrbcDonationDonorsListOutput;
  /** Get leaderboard of recruiters ranked by new donor count in a date range */
  getRecruiterLeaderboard: RecruiterLeaderboardOutput;
  /** Get per-location stats for a specific recruiter: active donor count and latest donation date */
  getRecruiterLocationStats: RecruiterLocationStatsOutput;
  /** Get recruiter stats: recruited donor count, active location count, with previous period comparison */
  getRecruiterStats: RecruiterStatsOutput;
  /** Get region-level recruit stats: recruited donor count and active/total location counts per region */
  getRegionRecruitStats: RegionRecruitStatsOutput;
  getRegions: Array<RegionOutput>;
  /** Get donors registered in a period, excluding NotAccepted. For new registrations tables. */
  getRegistrationDonors: PrbcDonationDonorsListOutput;
  getRequest: RequestOutput;
  getRequestList: RequestListOutput;
  /** Get historical retention scores for up to 12 consecutive periods */
  getRetentionHistory: RetentionHistoryOutput;
  /** Debug query: fetch all items from a SharePoint list by its ID (up to 15 000) */
  getSharepointListItems: SharepointListItemsOutput;
  /** Get historical show rates for up to 12 consecutive periods */
  getShowRateHistory: ShowRateHistoryOutput;
  getSpecificDonorDonationsList: DonationListOutput;
  getUser: UserOutput;
  getUserAttachments: Array<UserAttachmentOutput>;
  getUserContacts: Array<ContactOutput>;
  getUserDonorsList: DonorsListOutput;
  getUsersList: PaginatedUserListOutput;
  getVitalsParameterList: Array<VitalsParameterOutput>;
  getWoocommerceCategories: Array<WoocommerceProductCategoryOutput>;
  getWoocommerceProducts: WoocommerceProductListOutput;
  getWoocommerceTopSellers: Array<WoocommerceTopSellerOutput>;
  hasDonorRelateddataSources: Scalars['Boolean'];
};


export type QueryFindAllGroupArgs = {
  input: GroupListInput;
};


export type QueryFindDonorsForTeamArgs = {
  input: DonorsListForTeamInput;
};


export type QueryFindGroupArgs = {
  input: FindGroupInput;
};


export type QueryFindTeamArgs = {
  input: FindTeamInput;
};


export type QueryGetAdditionalDonationInfoArgs = {
  input: GetAdditionalDonationInfoInput;
};


export type QueryGetAllDonorStatusesArgs = {
  pagination?: InputMaybe<GetAllDonorsStatusesInput>;
};


export type QueryGetAppSettingsArgs = {
  input: GetAppSettingsInput;
};


export type QueryGetAppointmentArgs = {
  input: GetAppointmentInput;
};


export type QueryGetAppointmentsArgs = {
  input: GetAppointmentsInput;
};


export type QueryGetAppointmentsDatesForDonorArgs = {
  donorId: Scalars['String'];
};


export type QueryGetAppointmentsForCurrentUserArgs = {
  input: GetAppointmentsForCurrentUserInput;
};


export type QueryGetChartsDataArgs = {
  input: GetSpecificDonorDonationsListInput;
};


export type QueryGetChurnRateHistoryArgs = {
  input: GetChurnRateHistoryInput;
};


export type QueryGetCurrentUserDonorsListArgs = {
  input: CurrentUserDonorListInput;
};


export type QueryGetCustomerArgs = {
  input: GetCustomerInput;
};


export type QueryGetDataAuditPipelineDonorsArgs = {
  input: GetDataAuditDonorsInput;
};


export type QueryGetDataAuditRecruitedDonorsArgs = {
  input: GetDataAuditDonorsInput;
};


export type QueryGetDataAuditUnitDonorsArgs = {
  input: GetDataAuditUnitsInput;
};


export type QueryGetDataAuditUnitsArgs = {
  input: GetDataAuditUnitsInput;
};


export type QueryGetDaycareAppointmentInfoArgs = {
  input: Scalars['String'];
};


export type QueryGetDaycareAppointmentInfoForCurrentUserArgs = {
  appointmentId: Scalars['String'];
};


export type QueryGetDonationArgs = {
  input: GetDonationInput;
};


export type QueryGetDonationReportsArgs = {
  input: GetDonationReportsInput;
};


export type QueryGetDonationsListArgs = {
  input: GetDonationsListInput;
};


export type QueryGetDonationsListForAnalyticsArgs = {
  input: DonationsAnalyticsInput;
};


export type QueryGetDonorArgs = {
  input: GetDonorInput;
};


export type QueryGetDonorAnalyticsArgs = {
  input: DonorAnalyticsQueryInput;
};


export type QueryGetDonorContactFlagsArgs = {
  donorIds: Array<Scalars['String']>;
};


export type QueryGetDonorContactsArgs = {
  donorId: Scalars['String'];
};


export type QueryGetDonorDonationHistoryArgs = {
  input: GetDonorDonationHistoryInput;
};


export type QueryGetDonorDvmExamsArgs = {
  input: GetDonorDvmExamsInput;
};


export type QueryGetDonorLivesSavedArgs = {
  input: GetLivesSavedByDonorInput;
};


export type QueryGetDonorNotesArgs = {
  donorId: Scalars['String'];
};


export type QueryGetDonorPicturesArgs = {
  input: GetDonorPicturesInput;
};


export type QueryGetDonorPipelineStatsArgs = {
  input: GetDonorPipelineStatsInput;
};


export type QueryGetDonorStatsArgs = {
  input: GetDonorStatsInput;
};


export type QueryGetDonorsListArgs = {
  input: DonorsListInput;
};


export type QueryGetDonorsListByIdsArgs = {
  input: GetDonorsByIdsInput;
};


export type QueryGetDonorsListForAnalyticsArgs = {
  input: DonorsAnalyticsInput;
};


export type QueryGetDonorsReportArgs = {
  input: GetDonorsReportInput;
};


export type QueryGetDropoutHistoryArgs = {
  input: GetMetricsHistoryInput;
};


export type QueryGetDvmExamArgs = {
  input: GetDvmExamInput;
};


export type QueryGetDvmExamListArgs = {
  input: DvmExamInput;
};


export type QueryGetIneligibleParticipantsReportsArgs = {
  input: GetIneligibleParticipantsReportsInput;
};


export type QueryGetInvitationsListArgs = {
  input: GetInvitationListInput;
};


export type QueryGetLabworkArgs = {
  input: GetLabworkInput;
};


export type QueryGetLabworkAttachmentsArgs = {
  input: GetLabworkAttachmentsListInput;
};


export type QueryGetLabworkListArgs = {
  input: LabworkListInput;
};


export type QueryGetLeaderboardHistoryArgs = {
  input: GetLeaderboardHistoryInput;
};


export type QueryGetLocationsArgs = {
  input: GetLocationsInput;
};


export type QueryGetNightlyCountForTodayArgs = {
  input: GetNightlyCountForTodayInput;
};


export type QueryGetNightlyCountsListArgs = {
  input: GetNightlyCountsListInput;
};


export type QueryGetNotificationsListArgs = {
  input: GetNotificationListInput;
};


export type QueryGetOpsLocationUnitsArgs = {
  input: GetDataAuditUnitsInput;
};


export type QueryGetOpsOverviewDbSummaryArgs = {
  input: GetOpsOverviewStatsInput;
};


export type QueryGetOpsOverviewStatsArgs = {
  input: GetOpsOverviewStatsInput;
};


export type QueryGetOpsOverviewSummaryArgs = {
  input: GetOpsOverviewStatsInput;
};


export type QueryGetOpsOverviewWooSummaryArgs = {
  input: GetOpsOverviewStatsInput;
};


export type QueryGetOrderArgs = {
  input: GetOrderInput;
};


export type QueryGetOrdersListArgs = {
  input: GetOrdersListInput;
};


export type QueryGetOwnerArgs = {
  input: GetUserInput;
};


export type QueryGetOwnerReportsArgs = {
  input: GetOwnersReportsInput;
};


export type QueryGetOwnersListArgs = {
  input: GetOwnerListInput;
};


export type QueryGetPermissionsArgs = {
  input: GetPermissionsInput;
};


export type QueryGetPetBreedsListArgs = {
  input: PetBreedsListInput;
};


export type QueryGetPhlebotomistStatsArgs = {
  input: GetPhlebotomistStatsInput;
};


export type QueryGetPhlebotomistTrendStatsArgs = {
  input: GetPhlebotomistTrendStatsInput;
};


export type QueryGetPrbcDonationDonorsArgs = {
  input: GetPrbcDonationDonorsInput;
};


export type QueryGetPreviousDonationArgs = {
  input: GetPreviousDonationInput;
};


export type QueryGetPrivateDaycareAppointmentForCurrentUserArgs = {
  input: GetAppointmentsForCurrentUserInput;
};


export type QueryGetProductArgs = {
  input: GetProductInput;
};


export type QueryGetProductReportsArgs = {
  input: GetProductReportsInput;
};


export type QueryGetProductUnitCountsArgs = {
  input: GetProductUnitCountsInput;
};


export type QueryGetProductsArgs = {
  input: ProductListInput;
};


export type QueryGetProductsCountArgs = {
  input: GetProductsCountInput;
};


export type QueryGetPublicLocationsArgs = {
  input: GetPublicLocationsInput;
};


export type QueryGetRatioHistoryArgs = {
  input: GetMetricsHistoryInput;
};


export type QueryGetRecruiterDashboardMetricsArgs = {
  input: GetRecruiterDashboardMetricsInput;
};


export type QueryGetRecruiterDonorsArgs = {
  input: GetRecruiterDonorsInput;
};


export type QueryGetRecruiterLeaderboardArgs = {
  input: GetRecruiterLeaderboardInput;
};


export type QueryGetRecruiterLocationStatsArgs = {
  input: GetRecruiterLocationStatsInput;
};


export type QueryGetRecruiterStatsArgs = {
  input: GetRecruiterStatsInput;
};


export type QueryGetRegionRecruitStatsArgs = {
  input: GetRegionRecruitStatsInput;
};


export type QueryGetRegistrationDonorsArgs = {
  input: GetRegistrationDonorsInput;
};


export type QueryGetRequestArgs = {
  input: GetRequestInput;
};


export type QueryGetRequestListArgs = {
  input: RequestsListInput;
};


export type QueryGetRetentionHistoryArgs = {
  input: GetMetricsHistoryInput;
};


export type QueryGetSharepointListItemsArgs = {
  listId: Scalars['String'];
};


export type QueryGetShowRateHistoryArgs = {
  input: GetMetricsHistoryInput;
};


export type QueryGetSpecificDonorDonationsListArgs = {
  input: GetSpecificDonorDonationsListInput;
};


export type QueryGetUserArgs = {
  input: GetUserInput;
};


export type QueryGetUserAttachmentsArgs = {
  input: GetUserAttachmentsListInput;
};


export type QueryGetUserDonorsListArgs = {
  input: UserDonorListInput;
};


export type QueryGetUsersListArgs = {
  input: GetUserListInput;
};


export type QueryGetWoocommerceCategoriesArgs = {
  input: GetWoocommerceProductCategoriesInput;
};


export type QueryGetWoocommerceProductsArgs = {
  input: GetWoocommerceProductsInput;
};


export type QueryGetWoocommerceTopSellersArgs = {
  input: GetWoocommerceTopSellersInput;
};


export type QueryHasDonorRelateddataSourcesArgs = {
  input: DeleteDonorInput;
};

export type RatioHistoryOutput = {
  __typename?: 'RatioHistoryOutput';
  /** Periods in ascending chronological order */
  periods: Array<RatioHistoryPeriodOutput>;
};

export type RatioHistoryPeriodOutput = {
  __typename?: 'RatioHistoryPeriodOutput';
  /** Total active donors */
  activeDonorCount: Scalars['Int'];
  /** First-time donor count */
  firstTimeDonorCount: Scalars['Int'];
  /** Ratio of first-time to repeat donors (first-time / (first-time + repeat) * 100) */
  firstTimePct: Scalars['Float'];
  /** Human-readable period label */
  label: Scalars['String'];
  /** ISO end date of this period */
  periodEnd: Scalars['String'];
  /** ISO start date of this period */
  periodStart: Scalars['String'];
  /** Repeat donor count */
  repeatDonorCount: Scalars['Int'];
};

export enum ReasonDiscardProduct {
  BrokenBag = 'BrokenBag',
  Clots = 'Clots',
  DonorHealthIssue = 'DonorHealthIssue',
  Expired = 'Expired',
  Hemolyzed = 'Hemolyzed',
  Lipemic = 'Lipemic',
  LowVolume = 'LowVolume',
  Other = 'Other',
  RedCellContamination = 'RedCellContamination',
  SealIssue = 'SealIssue',
  Timeout = 'Timeout'
}

export type RecruiterDashboardMetricsOutput = {
  __typename?: 'RecruiterDashboardMetricsOutput';
  /** Current active donor count (filtered) */
  activeDonorCount: Scalars['Int'];
  /** Estimated active donor count at the end of the compared (previous) period */
  comparedPeriodActiveDonorCount?: Maybe<Scalars['Int']>;
  /** Total donations given in the period by active donors */
  donorsWhoDonated: Scalars['Int'];
  /** Active donors whose last donation was double unit (>= 420 mL approved) */
  doubleDonorCount: Scalars['Int'];
  /** Expected number of donations in the period */
  expectedDonations: Scalars['Int'];
  /** Active donors with < threshold donations (first-time donors) */
  firstTimeDonorCount: Scalars['Int'];
  /** Estimated active donor count at the end of the selected period (uses status history + donation timeout) */
  historicalActiveDonorCount?: Maybe<Scalars['Int']>;
  /** Lapsed donor counts per breakpoint — donors whose last donation was more than N days ago (parallel to input breakpoints) */
  lapsedDonorCounts: Array<Scalars['Int']>;
  /** Active donors at start of selected period */
  periodActiveAtStart: Scalars['Int'];
  /** Dropouts in the selected period */
  periodDropoutCount: Scalars['Int'];
  /** New enrollments in the selected period */
  periodNewEnrollmentCount: Scalars['Int'];
  /** Active donors at start of quarter */
  quarterlyActiveAtStart: Scalars['Int'];
  /** Donors who dropped out this quarter */
  quarterlyDropoutCount: Scalars['Int'];
  /** New enrollments in the current quarter */
  quarterlyNewEnrollmentCount: Scalars['Int'];
  /** Donors with >= threshold donations (repeat donors) */
  repeatDonorCount: Scalars['Int'];
  /** Retired (Unresponsive) donor counts per breakpoint range — donors whose most recent transition to Retired status falls within each range from today */
  retiredDonorCounts: Array<Scalars['Int']>;
  /** Donor show rate percentage (donationsGiven / expectedDonations * 100) */
  showRate: Scalars['Float'];
  /** Active donors whose last donation was single unit (< 420 mL approved) */
  singleDonorCount: Scalars['Int'];
};

export type RecruiterLeaderboardEntry = {
  __typename?: 'RecruiterLeaderboardEntry';
  /** First name */
  firstName: Scalars['String'];
  /** Last name */
  lastName: Scalars['String'];
  /** Number of new donors recruited in the region during the period */
  newDonorCount: Scalars['Int'];
  /** Primary assigned region ID */
  regionId?: Maybe<Scalars['String']>;
  /** User ID of the recruiter */
  userId: Scalars['String'];
};

export type RecruiterLeaderboardOutput = {
  __typename?: 'RecruiterLeaderboardOutput';
  entries: Array<RecruiterLeaderboardEntry>;
};

export type RecruiterLocationStatsEntry = {
  __typename?: 'RecruiterLocationStatsEntry';
  /** Count of active donors at this location as of 90 days ago (for growth trend) */
  activeDonors90DaysAgo?: Maybe<Scalars['Int']>;
  /** All-time number of distinct donation event dates at this location */
  alltimeEventCount?: Maybe<Scalars['Int']>;
  /** All-time total pRBC units at this location */
  alltimeUnits?: Maybe<Scalars['Int']>;
  /** Number of attempted (non-ineligible) donations at this location during the period */
  attemptedDonations?: Maybe<Scalars['Int']>;
  /** Average days from Active to Retired status transition */
  avgDaysActiveToRetired?: Maybe<Scalars['Float']>;
  /** Average days from donor creation (Applied) to Active status */
  avgDaysAppliedToActive?: Maybe<Scalars['Float']>;
  /** Average days from Pending to Approved status transition */
  avgDaysPendingToApproved?: Maybe<Scalars['Float']>;
  /** Average days from Pending to Archived status transition */
  avgDaysPendingToArchived?: Maybe<Scalars['Float']>;
  /** Days since the last donor registration at this location */
  daysSinceLastRegistration?: Maybe<Scalars['Float']>;
  /** Number of active donors whose most recent donation was double-unit (>=420ml) */
  dblDonorCount?: Maybe<Scalars['Int']>;
  /** Number of distinct donation event dates at this location during the period (excludes ineligible) */
  donationEventCount?: Maybe<Scalars['Int']>;
  /** Date of the earliest donation at this location (for units/year calculation) */
  firstDonationDate?: Maybe<Scalars['DateTime']>;
  /** Number of donors during the period whose total donation count is 1 (first-time) */
  firstTimeDonationCount?: Maybe<Scalars['Int']>;
  /** pRBC units from last calendar month */
  lastMonthUnits?: Maybe<Scalars['Int']>;
  /** Registration date of the most recently registered donor at this location */
  lastNewDonorDate?: Maybe<Scalars['DateTime']>;
  /** Name of the most recently registered donor at this location */
  lastNewDonorName?: Maybe<Scalars['String']>;
  /** Date/time of the most recent donation at this location */
  latestDonation?: Maybe<Scalars['DateTime']>;
  locationId: Scalars['String'];
  locationName: Scalars['String'];
  /** Average days pending donors at this location have been in Pending status */
  pendingAvgDays?: Maybe<Scalars['Float']>;
  /** Number of donors with Pending status at this location */
  pendingDonorCount?: Maybe<Scalars['Int']>;
  /** Number of attempted (non-ineligible) donations at this location during the prior period */
  prevAttemptedDonations?: Maybe<Scalars['Int']>;
  /** Number of distinct donation event dates at this location during the prior period (excludes ineligible) */
  prevDonationEventCount?: Maybe<Scalars['Int']>;
  /** pRBC units from the calendar month before last */
  prevMonthUnits?: Maybe<Scalars['Int']>;
  /** Total product units from the previous period (same span shifted back) for MoM comparison */
  prevPeriodUnits?: Maybe<Scalars['Int']>;
  /** Number of donors recruited (created) at this location during the prior period */
  prevRecruitedCount?: Maybe<Scalars['Int']>;
  /** Number of successful donations at this location during the prior period */
  prevSuccessfulDonations?: Maybe<Scalars['Int']>;
  /** Number of donors recruited (created) at this location during the period */
  recruitedCount?: Maybe<Scalars['Int']>;
  regionName?: Maybe<Scalars['String']>;
  /** Number of donors with Retired status at this location during the period */
  retiredDonorCount?: Maybe<Scalars['Int']>;
  /** Donors whose 9th birthday is 30-59 days from now (retiring due to age) */
  retiringIn30Count?: Maybe<Scalars['Int']>;
  /** Donors whose 9th birthday is 60-89 days from now (retiring due to age) */
  retiringIn60Count?: Maybe<Scalars['Int']>;
  /** Donors whose 9th birthday is 90-120 days from now (retiring due to age) */
  retiringIn90Count?: Maybe<Scalars['Int']>;
  /** Number of active donors whose most recent donation was single-unit (<420ml) */
  sglDonorCount?: Maybe<Scalars['Int']>;
  /** Percentage of active donors whose most recent donation approvedDonationsMl < 420 (SGL) */
  sglPercent?: Maybe<Scalars['Float']>;
  /** JSON array of stalled (Pending) donors: [{name, daysPending}], ordered by days desc */
  stalledDonorsJson?: Maybe<Scalars['String']>;
  /** Number of successful donations at this location during the period */
  successfulDonations?: Maybe<Scalars['Int']>;
  /** Number of active donors at this location within the period */
  totalActiveDonors: Scalars['Int'];
  /** Total donor pool at this location from PAWS CRM (SharePoint) */
  totalDonorPool?: Maybe<Scalars['Int']>;
  /** Total product units from donations at this location during the period */
  totalUnits?: Maybe<Scalars['Int']>;
  /** Total product units from all donations at this location (all time) */
  totalUnitsSinceInception?: Maybe<Scalars['Int']>;
  /** Number of distinct donors who contributed at least one unit during the period */
  unitDonorCount?: Maybe<Scalars['Int']>;
};

export type RecruiterLocationStatsOutput = {
  __typename?: 'RecruiterLocationStatsOutput';
  entries: Array<RecruiterLocationStatsEntry>;
  /** Total number of locations matching region/recruiter filters (ignoring active threshold) */
  totalLocationCount: Scalars['Int'];
};

export type RecruiterStatsEntry = {
  __typename?: 'RecruiterStatsEntry';
  /** Assigned locations with at least one donation within the threshold window */
  activeLocationCount: Scalars['Int'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  /** Active locations in the previous period */
  prevActiveLocationCount: Scalars['Int'];
  /** New donors recruited in the previous period */
  prevRecruitedDonorCount: Scalars['Int'];
  /** New donors recruited in the current period */
  recruitedDonorCount: Scalars['Int'];
  regionId?: Maybe<Scalars['String']>;
  regionName?: Maybe<Scalars['String']>;
  /** Total assigned locations for this recruiter */
  totalAssignedLocationCount: Scalars['Int'];
  userId: Scalars['String'];
};

export type RecruiterStatsOutput = {
  __typename?: 'RecruiterStatsOutput';
  entries: Array<RecruiterStatsEntry>;
  /** Number of locations with no recruiter assigned */
  unassignedLocationCount: Scalars['Int'];
  /** List of locations with no recruiter assigned */
  unassignedLocations: Array<UnassignedLocationEntry>;
};

export type RegionOutput = {
  __typename?: 'RegionOutput';
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  idexxAccountNumber?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  zoetisAccountNumber?: Maybe<Scalars['String']>;
};

export type RegionRecruitStatsEntry = {
  __typename?: 'RegionRecruitStatsEntry';
  /** Locations in this region with at least one donation within the threshold window */
  activeLocationCount: Scalars['Int'];
  /** New donors recruited in this region during the previous period (for trend comparison) */
  prevRecruitedDonorCount: Scalars['Int'];
  /** New donors recruited in this region during the period */
  recruitedDonorCount: Scalars['Int'];
  regionId: Scalars['String'];
  regionName: Scalars['String'];
  /** Total locations in this region */
  totalLocationCount: Scalars['Int'];
};

export type RegionRecruitStatsOutput = {
  __typename?: 'RegionRecruitStatsOutput';
  entries: Array<RegionRecruitStatsEntry>;
};

export type RegisterOnDaycareAppointmentInput = {
  appointmentId: Scalars['String'];
  donorIds?: Array<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  ownerResponse: Scalars['Boolean'];
};

export type RemoveAdditionalDonationInfoInput = {
  id: Scalars['String'];
};

export type RemoveAppointmentInput = {
  id: Scalars['String'];
};

export type RemoveContactInput = {
  id: Scalars['String'];
};

export type RemoveDonationInput = {
  id: Scalars['String'];
};

export type RemoveDvmExamInput = {
  id: Scalars['String'];
};

export type RemoveGroupInput = {
  id: Scalars['String'];
};

export type RemoveLabworkInput = {
  id: Scalars['String'];
};

export type RemoveNotificationInput = {
  id: Scalars['String'];
};

export type RemoveRequestInput = {
  id: Scalars['String'];
};

export type RemoveTeamInput = {
  id: Scalars['String'];
};

export type RemoveUserInput = {
  id: Scalars['String'];
};

export type RequestListFilterInput = {
  number?: InputMaybe<Scalars['Float']>;
  ownerName?: InputMaybe<Scalars['String']>;
};

export type RequestListOutput = {
  __typename?: 'RequestListOutput';
  data: Array<RequestOutput>;
  meta: MetaData;
};

export enum RequestListSort {
  Date = 'Date',
  Owner = 'Owner'
}

export type RequestOutput = {
  __typename?: 'RequestOutput';
  donor: DonorOutput;
  id: Scalars['String'];
  number: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export enum RequestStatus {
  Approve = 'Approve',
  Reject = 'Reject'
}

export type RequestsListInput = {
  filter?: InputMaybe<RequestListFilterInput>;
  skip?: Scalars['Float'];
  sort?: InputMaybe<Array<SortRequestListInput>>;
  take?: Scalars['Float'];
};

export type ResendEmailConfirmationCodeInput = {
  email: Scalars['String'];
};

export type ReserveDonorNoteOutput = {
  __typename?: 'ReserveDonorNoteOutput';
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  text: Scalars['String'];
};

export type ResetPasswordInput = {
  code: Scalars['String'];
  password: Scalars['String'];
};

export type ResetPrimaryPicturesInput = {
  donorId: Scalars['String'];
};

export type RetentionHistoryOutput = {
  __typename?: 'RetentionHistoryOutput';
  /** Periods in ascending chronological order */
  periods: Array<RetentionHistoryPeriodOutput>;
};

export type RetentionHistoryPeriodOutput = {
  __typename?: 'RetentionHistoryPeriodOutput';
  /** Total active donors in this period */
  activeDonorCount: Scalars['Int'];
  /** Human-readable period label */
  label: Scalars['String'];
  /** ISO end date of this period */
  periodEnd: Scalars['String'];
  /** ISO start date of this period */
  periodStart: Scalars['String'];
  /** Repeat donors in this period */
  repeatDonorCount: Scalars['Int'];
  /** Retention score (repeat / active * 100) */
  retentionScore: Scalars['Float'];
};

export enum RetiredReasons {
  Age = 'Age',
  Health = 'Health',
  Moving = 'Moving',
  Other = 'Other',
  Owner = 'Owner',
  Request = 'Request',
  Temperament = 'Temperament',
  Unresponsive = 'Unresponsive'
}

export type RoleOutput = {
  __typename?: 'RoleOutput';
  id: Scalars['String'];
  value: UserRole;
};

export type RoleWithoutPermissionsOutput = {
  __typename?: 'RoleWithoutPermissionsOutput';
  id: Scalars['String'];
  value: UserRole;
};

export type SaveAppSettingsInput = {
  settingsJson: Scalars['JSON'];
  settingsTab: Scalars['String'];
};

export type SaveNightlyCountInput = {
  items: Array<SaveNightlyCountItemInput>;
  officeId: Scalars['String'];
};

export type SaveNightlyCountItemInput = {
  count: Scalars['Int'];
  productBloodType?: InputMaybe<NightlyCountProductBloodType>;
  productClass: NightlyCountProductClass;
  productKey: Scalars['String'];
  productTitle: Scalars['String'];
  woocommerceProductId: Scalars['Int'];
};

export type SendEmailInput = {
  html?: InputMaybe<Scalars['String']>;
  subject: Scalars['String'];
  text?: InputMaybe<Scalars['String']>;
  to: Array<Scalars['String']>;
};

export type SendLabworkExpirationEmailInput = {
  cronJobId: Scalars['String'];
  donorLink?: InputMaybe<Scalars['String']>;
  templateName: Scalars['String'];
  to: Array<Scalars['String']>;
};

export type ShareLabworkResultsWithOwnerInput = {
  fileId: Scalars['String'];
  labworkId: Scalars['String'];
};

export type SharepointListItemsOutput = {
  __typename?: 'SharepointListItemsOutput';
  displayName: Scalars['String'];
  items: Array<Scalars['JSON']>;
  listId: Scalars['String'];
  /** False when SharePoint integration is disabled (missing Azure credentials or site id). Distinguishes "Graph unavailable" from "list is empty". */
  sharepointEnabled: Scalars['Boolean'];
  /** Total number of items in the SharePoint list */
  totalCount: Scalars['Int'];
  totalFetched: Scalars['Int'];
};

export type ShippedUnitEntry = {
  __typename?: 'ShippedUnitEntry';
  createdAt: Scalars['String'];
  donationDate?: Maybe<Scalars['String']>;
  donorName: Scalars['String'];
  location?: Maybe<Scalars['String']>;
  ownerName?: Maybe<Scalars['String']>;
  productShortId: Scalars['Int'];
  productStatus: Scalars['String'];
  regionName?: Maybe<Scalars['String']>;
  updatedAt: Scalars['String'];
  woocommerceCategoryId: Scalars['Int'];
  woocommerceOrderId?: Maybe<Scalars['Int']>;
  woocommerceProductId: Scalars['Int'];
};

export type ShippingLineOutput = {
  __typename?: 'ShippingLineOutput';
  id: Scalars['Float'];
  instanceId: Scalars['String'];
  methodId: Scalars['String'];
  methodTitle: Scalars['String'];
  total: Scalars['String'];
  totalTax: Scalars['String'];
};

export type ShippingOutput = {
  __typename?: 'ShippingOutput';
  city: Scalars['String'];
  company: Scalars['String'];
  country: Scalars['String'];
  firstAddress: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phone: Scalars['String'];
  postcode: Scalars['String'];
  secondAddress?: Maybe<Scalars['String']>;
  state: Scalars['String'];
};

export type ShowRateHistoryOutput = {
  __typename?: 'ShowRateHistoryOutput';
  /** Periods in ascending chronological order */
  periods: Array<ShowRateHistoryPeriodOutput>;
};

export type ShowRateHistoryPeriodOutput = {
  __typename?: 'ShowRateHistoryPeriodOutput';
  /** Total donations given in this period */
  donorsWhoDonated: Scalars['Int'];
  /** Expected donations in this period */
  expectedDonations: Scalars['Int'];
  /** Human-readable period label */
  label: Scalars['String'];
  /** ISO end date of this period */
  periodEnd: Scalars['String'];
  /** ISO start date of this period */
  periodStart: Scalars['String'];
  /** Show rate (donationsGiven / expectedDonations * 100) */
  showRate: Scalars['Float'];
};

export type SignUpInput = {
  contactPreferences?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  password: Scalars['String'];
};

export type SignUpWithDonorsInput = {
  donors: Array<CreateDonorInput>;
  user: SignUpWithoutPassword;
};

export type SignUpWithoutPassword = {
  contactPreferences?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  locationPreferences?: InputMaybe<Scalars['String']>;
  phoneNumber: Scalars['String'];
};

export type SortDonationListInput = {
  fieldName: DonationListSort;
  order: Order;
};

export type SortDonorListInput = {
  fieldName: DonorListSort;
  order: Order;
};

export type SortDvmExamListInput = {
  fieldName: DvmExamListSort;
  order: Order;
};

export type SortGroupListInput = {
  fieldName: GroupListSort;
  order: Order;
};

export type SortInvitationListInput = {
  fieldName: InvitationListSort;
  order: Order;
};

export type SortLabworkListInput = {
  fieldName: LabworkListSort;
  order: Order;
};

export type SortRequestListInput = {
  fieldName: RequestListSort;
  order: Order;
};

export type SortUserDonorListInput = {
  fieldName: UserDonorListSort;
  order: Order;
};

export type SortUserListInput = {
  fieldName: UserListSort;
  order: Order;
};

export type SpecificDonorDonationListFilter = {
  bloodTypes?: InputMaybe<Array<BloodType>>;
  donorId: Scalars['String'];
  fromDate?: InputMaybe<Scalars['DateTime']>;
  locationQuery?: InputMaybe<Scalars['String']>;
  locations?: InputMaybe<Array<Scalars['String']>>;
  searchQuery?: InputMaybe<Scalars['String']>;
  toDate?: InputMaybe<Scalars['DateTime']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  notificationAdded: NotificationWebSocketOutput;
};


export type SubscriptionNotificationAddedArgs = {
  input: NotificationAddedSubscriptionInput;
};

export enum TaxStatus {
  None = 'None',
  Taxable = 'Taxable'
}

export type TeamOutput = {
  __typename?: 'TeamOutput';
  donors?: Maybe<Array<DonorOutput>>;
  group?: Maybe<GroupOutput>;
  id: Scalars['String'];
  title: Scalars['String'];
};

export enum TopSellersPeriod {
  LastMonth = 'LastMonth',
  Month = 'Month',
  Week = 'Week',
  Year = 'Year'
}

/** Interval size for trend data aggregation */
export enum TrendIntervalSize {
  Day = 'DAY',
  Month = 'MONTH',
  Quarter = 'QUARTER',
  Week = 'WEEK',
  Year = 'YEAR'
}

export type TurnoverEntry = {
  __typename?: 'TurnoverEntry';
  inQty: Scalars['Int'];
  outQty: Scalars['Int'];
  regionName?: Maybe<Scalars['String']>;
  turnoverPct: Scalars['Float'];
  unitType: Scalars['String'];
};

export type UnassignedLocationEntry = {
  __typename?: 'UnassignedLocationEntry';
  id: Scalars['String'];
  name: Scalars['String'];
  regionName?: Maybe<Scalars['String']>;
};

export type UnenrollDonorInput = {
  donorId: Scalars['String'];
  id: Scalars['String'];
};

export type UntieWoocommerceOrderInput = {
  productId: Scalars['String'];
};

export type UpdateAdditionalDonationInfoInput = {
  dislikes?: InputMaybe<Array<Scalars['String']>>;
  donationId?: InputMaybe<Scalars['String']>;
  donationPosition?: InputMaybe<Scalars['String']>;
  donationPositionFreeText?: InputMaybe<Scalars['String']>;
  donorMovement?: InputMaybe<Scalars['String']>;
  emotionalSupport?: InputMaybe<Array<Scalars['String']>>;
  flowRate?: InputMaybe<FlowRate>;
  holdersPosition?: InputMaybe<Array<Scalars['String']>>;
  id: Scalars['String'];
  likes?: InputMaybe<Array<Scalars['String']>>;
  numberOfCollectionUnitsUsed?: InputMaybe<CollectionUnitsUsed>;
  pokerId?: InputMaybe<Scalars['String']>;
  primaryHolderId?: InputMaybe<Scalars['String']>;
  secondaryHolderId?: InputMaybe<Scalars['String']>;
  totalCollectedMls?: InputMaybe<Scalars['Float']>;
  treatPreferences?: InputMaybe<Array<Scalars['String']>>;
  typeOfMovement?: InputMaybe<Scalars['String']>;
  vascularStructure?: InputMaybe<VascularStructure>;
  veinUsed?: InputMaybe<VeinUsed>;
};

export type UpdateAppointmentInput = {
  appointmentId: Scalars['String'];
  dates?: InputMaybe<Array<IntervalInput>>;
  donorId?: InputMaybe<Scalars['String']>;
  groupId?: InputMaybe<Scalars['String']>;
  isPrivate?: InputMaybe<Scalars['Boolean']>;
  location?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  teamId?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  type: AppointmentType;
  userIds?: InputMaybe<Array<Scalars['String']>>;
};

export type UpdateContactInput = {
  city?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  lastName?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  streetAddress?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export type UpdateContactsInput = {
  contacts: Array<UpdateContactInput>;
};

export type UpdateDonationCommentInput = {
  comment?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
};

export type UpdateDonationDonorInput = {
  donorId: Scalars['String'];
  id: Scalars['String'];
};

export type UpdateDonationInput = {
  actual?: InputMaybe<Scalars['Float']>;
  approvedDonationsMl?: InputMaybe<Scalars['Float']>;
  capillaryRefillTime?: InputMaybe<CapillaryRefillTime>;
  collectionSet?: InputMaybe<CollectionSet>;
  comment?: InputMaybe<Scalars['String']>;
  donationDate?: InputMaybe<Scalars['DateTime']>;
  examinationNotes?: InputMaybe<Scalars['String']>;
  failedReason?: InputMaybe<DonationFailedReason>;
  id: Scalars['String'];
  ineligible?: InputMaybe<Scalars['Boolean']>;
  ineligibleReason?: InputMaybe<IneligibleReason>;
  ineligibleReasonDetails?: InputMaybe<Scalars['String']>;
  jugularVein?: InputMaybe<JugularVein>;
  maxLimit?: InputMaybe<Scalars['Float']>;
  mucousMembrane?: InputMaybe<Mm>;
  packedCellVolume?: InputMaybe<Scalars['Float']>;
  preferences?: InputMaybe<Scalars['String']>;
  pulse?: InputMaybe<Scalars['Float']>;
  respiration?: InputMaybe<Scalars['Float']>;
  shouldDonate?: InputMaybe<Scalars['Boolean']>;
  temperature?: InputMaybe<Scalars['Float']>;
  totalSolids?: InputMaybe<Scalars['Float']>;
  unit?: InputMaybe<DonationUnit>;
  weatherTemperature?: InputMaybe<Scalars['Float']>;
  weatherTypes?: InputMaybe<Array<WeatherType>>;
  weight?: InputMaybe<Scalars['Float']>;
  working?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateDonorInput = {
  acceptSimparicaTrio?: InputMaybe<Scalars['Boolean']>;
  approvedDonationML?: InputMaybe<Scalars['Float']>;
  attendDaycareDays?: InputMaybe<Array<Scalars['String']>>;
  bloodType?: InputMaybe<BloodType>;
  breed?: InputMaybe<Scalars['String']>;
  canRegularlyAttendDaycare?: InputMaybe<Scalars['Boolean']>;
  color?: InputMaybe<Scalars['String']>;
  comment?: InputMaybe<Scalars['String']>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']>;
  distemperDate?: InputMaybe<Scalars['DateTime']>;
  distinguishableMarks?: InputMaybe<Scalars['String']>;
  donationFrequency?: InputMaybe<Scalars['Float']>;
  donationMLApprovedAmount?: InputMaybe<Scalars['Float']>;
  firstCertificatePrinted?: InputMaybe<Scalars['Boolean']>;
  gender?: InputMaybe<AnimalGender>;
  hasHeartMurmur?: InputMaybe<Scalars['Boolean']>;
  hasMicrochip?: InputMaybe<Scalars['Boolean']>;
  hasTransfusion?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
  isDaycare?: InputMaybe<Scalars['Boolean']>;
  location?: InputMaybe<Scalars['String']>;
  medicationCourse?: InputMaybe<Scalars['String']>;
  microchipNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  neutered?: InputMaybe<Scalars['Boolean']>;
  primaryVeterinarian?: InputMaybe<Scalars['String']>;
  rabiesDate?: InputMaybe<Scalars['DateTime']>;
  retiredDate?: InputMaybe<Scalars['DateTime']>;
  retiredReason?: InputMaybe<RetiredReasons>;
  retiredReasonComment?: InputMaybe<Scalars['String']>;
  secondCertificatePrinted?: InputMaybe<Scalars['Boolean']>;
  species?: InputMaybe<AnimalSpecies>;
  status?: InputMaybe<DonorStatus>;
  takeMedications?: InputMaybe<Scalars['Boolean']>;
  teamId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<DonorType>;
  weight?: InputMaybe<Scalars['Float']>;
};

export type UpdateDonorNoteInput = {
  id: Scalars['String'];
  isPinned?: InputMaybe<Scalars['Boolean']>;
  text?: InputMaybe<Scalars['String']>;
};

export type UpdateDonorStatusInput = {
  id: Scalars['String'];
  status: DonorStatus;
};

export type UpdateDonorsOwnerInput = {
  id: Scalars['String'];
  ownerId?: InputMaybe<Scalars['String']>;
};

export type UpdateDvmExamInput = {
  examinationDate?: InputMaybe<Scalars['DateTime']>;
  id: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  performedById?: InputMaybe<Scalars['String']>;
};

export type UpdateGroupInput = {
  id: Scalars['String'];
  title?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type UpdateGroupOwnerInput = {
  id: Scalars['String'];
  ownerId: Scalars['String'];
};

export type UpdateLabworkInput = {
  collectionDate?: InputMaybe<Scalars['DateTime']>;
  donorId?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
};

export type UpdateLabworkStatusInput = {
  id: Scalars['String'];
  status: LabworkStatus;
};

export type UpdateLocationInput = {
  id: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  regionId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<LocationType>;
};

export type UpdateNotificationConfigInput = {
  name: Notification;
  value: Scalars['Boolean'];
};

export type UpdateNotificationConfigListInput = {
  notifications: Array<UpdateNotificationConfigInput>;
};

export type UpdateOfficeInput = {
  id: Scalars['String'];
  idexxAccountNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  regionId?: InputMaybe<Scalars['String']>;
  zoetisAccountNumber?: InputMaybe<Scalars['String']>;
};

export type UpdateOwnerInput = {
  additionalContact?: InputMaybe<ContactInput>;
  assignedLocationIds?: InputMaybe<Array<Scalars['String']>>;
  assignedOfficeId?: InputMaybe<Scalars['String']>;
  assignedRegionIds?: InputMaybe<Array<Scalars['String']>>;
  birthday?: InputMaybe<Scalars['DateTime']>;
  city?: InputMaybe<Scalars['String']>;
  contactPreferences?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  lastName?: InputMaybe<Scalars['String']>;
  locationPreferences?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  productRegionPreferenceId?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  streetAddress?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export type UpdateProductInput = {
  id: Scalars['String'];
  status?: InputMaybe<ProductStatus>;
  value?: InputMaybe<Scalars['Float']>;
  woocommerceOrderId?: InputMaybe<Scalars['Float']>;
};

export type UpdateProductStatusInput = {
  id: Scalars['String'];
  status: ProductStatus;
};

export type UpdateRegionInput = {
  id: Scalars['String'];
  idexxAccountNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  zoetisAccountNumber?: InputMaybe<Scalars['String']>;
};

export type UpdateRequestInput = {
  id: Scalars['String'];
  reason?: InputMaybe<Scalars['String']>;
  status: RequestStatus;
};

export type UpdateTeamInput = {
  donorIds?: InputMaybe<Array<Scalars['String']>>;
  id: Scalars['String'];
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateUserEmailInput = {
  email: Scalars['String'];
  id: Scalars['String'];
};

export type UpdateUserInputPartial = {
  additionalContact?: InputMaybe<ContactInput>;
  assignedLocationIds?: InputMaybe<Array<Scalars['String']>>;
  assignedOfficeId?: InputMaybe<Scalars['String']>;
  assignedRegionIds?: InputMaybe<Array<Scalars['String']>>;
  city?: InputMaybe<Scalars['String']>;
  contactPreferences?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  lastName?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  productRegionPreferenceId?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  streetAddress?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export type UpdateUserRoleInput = {
  id: Scalars['String'];
  role: UserRole;
};

export type UpdateVitalsParameterInput = {
  criticalValues?: InputMaybe<Array<Scalars['String']>>;
  id: Scalars['String'];
  max?: InputMaybe<Scalars['Float']>;
  min?: InputMaybe<Scalars['Float']>;
  percentageDifference?: InputMaybe<Scalars['Float']>;
  type?: InputMaybe<VitalsParametersType>;
};

export type UpdateVitalsParametersListInput = {
  vitalsParameters: Array<UpdateVitalsParameterInput>;
};

export type UserAttachmentOutput = {
  __typename?: 'UserAttachmentOutput';
  createdAt: Scalars['DateTime'];
  file: FileOutput;
  id: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type UserDaycareAppointmentInfoOutput = {
  __typename?: 'UserDaycareAppointmentInfoOutput';
  daycareId?: Maybe<Scalars['String']>;
  registeredDonors: Array<DonorOutput>;
  requests: Array<DaycareAppointmentRequestOutput>;
  status: DaycareRegistrationStatus;
};

export type UserDonorListInput = {
  filter?: InputMaybe<DonorListFilterInput>;
  skip?: Scalars['Float'];
  sort?: InputMaybe<Array<SortDonorListInput>>;
  take?: Scalars['Float'];
  userId: Scalars['String'];
};

export enum UserDonorListSort {
  Gender = 'Gender',
  Name = 'Name'
}

export enum UserListSort {
  Email = 'Email',
  FirstName = 'FirstName',
  LastName = 'LastName',
  LocationPreferences = 'LocationPreferences'
}

export type UserOutput = {
  __typename?: 'UserOutput';
  assignedLocations?: Maybe<Array<LocationOutput>>;
  assignedOffice?: Maybe<OfficeOutput>;
  assignedRegions?: Maybe<Array<RegionOutput>>;
  birthday?: Maybe<Scalars['DateTime']>;
  city?: Maybe<Scalars['String']>;
  contactPreferences?: Maybe<Scalars['String']>;
  contacts?: Maybe<Array<ContactOutput>>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  deletionIntentionAt?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  id: Scalars['String'];
  isArchived: Scalars['Boolean'];
  lastName: Scalars['String'];
  locationPreferences?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  productRegionPreference?: Maybe<RegionOutput>;
  role: RoleOutput;
  shortId: Scalars['Float'];
  state?: Maybe<Scalars['String']>;
  streetAddress?: Maybe<Scalars['String']>;
  type?: Maybe<OwnerType>;
  zipCode?: Maybe<Scalars['String']>;
};

export enum UserRole {
  Admin = 'Admin',
  CanineHandler = 'CanineHandler',
  CollectionTeam = 'CollectionTeam',
  Dvm = 'DVM',
  DogHandler = 'DogHandler',
  InventoryTeam = 'InventoryTeam',
  MedicalDirector = 'MedicalDirector',
  Operations = 'Operations',
  Owner = 'Owner',
  Phlebotomist = 'Phlebotomist',
  RegionalUser = 'RegionalUser',
  TeamLead = 'TeamLead'
}

export type UsersListFilterInput = {
  ids?: InputMaybe<Array<Scalars['String']>>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  ownerTypes?: InputMaybe<Array<OwnerType>>;
  productRegionPreferenceId?: InputMaybe<Scalars['String']>;
  roles?: InputMaybe<Array<UserRole>>;
  searchingQuery?: InputMaybe<Scalars['String']>;
  username?: InputMaybe<Scalars['String']>;
};

export enum VascularStructure {
  Deep = 'Deep',
  Lateral = 'Lateral',
  Medial = 'Medial',
  Superficial = 'Superficial'
}

export enum VeinUsed {
  Both = 'Both',
  LeftJugular = 'LeftJugular',
  NotApplicable = 'NotApplicable',
  RightJugular = 'RightJugular'
}

export type VitalsDonationInfoInput = {
  actual?: InputMaybe<Scalars['Float']>;
  approvedDonationsMl: Scalars['Float'];
  capillaryRefillTime: CapillaryRefillTime;
  collectionSet: CollectionSet;
  comment?: InputMaybe<Scalars['String']>;
  donationDate?: InputMaybe<Scalars['DateTime']>;
  examinationNotes?: InputMaybe<Scalars['String']>;
  expected?: InputMaybe<Scalars['Float']>;
  failedReason?: InputMaybe<DonationFailedReason>;
  jugularVein: JugularVein;
  maxLimit: Scalars['Float'];
  mucousMembrane: Mm;
  packedCellVolume: Scalars['Float'];
  preferences?: InputMaybe<Scalars['String']>;
  pulse: Scalars['Float'];
  respiration: Scalars['Float'];
  shortDonorId: Scalars['String'];
  shouldDonate: Scalars['Boolean'];
  temperature: Scalars['Float'];
  totalSolids: Scalars['Float'];
  unit?: InputMaybe<DonationUnit>;
  weatherTemperature: Scalars['Float'];
  weatherTypes: Array<WeatherType>;
  weight: Scalars['Float'];
  working: Scalars['Boolean'];
};

export type VitalsParameterOutput = {
  __typename?: 'VitalsParameterOutput';
  criticalValues?: Maybe<Array<Scalars['String']>>;
  id: Scalars['String'];
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  percentageDifference?: Maybe<Scalars['Float']>;
  type: VitalsParametersType;
};

export enum VitalsParametersType {
  CapillaryRefillTimeValue = 'CapillaryRefillTimeValue',
  MucousMembrane = 'MucousMembrane',
  PackedCellVolume = 'PackedCellVolume',
  Pulse = 'Pulse',
  Respiration = 'Respiration',
  TemperatureToCheck = 'TemperatureToCheck',
  TemperatureToStop = 'TemperatureToStop',
  TotalSolids = 'TotalSolids',
  Weight = 'Weight'
}

export enum WeatherType {
  Clear = 'Clear',
  Cloudy = 'Cloudy',
  Drizzle = 'Drizzle',
  NotApplicable = 'NotApplicable',
  Overcast = 'Overcast',
  PartiallyCloudy = 'PartiallyCloudy',
  Rain = 'Rain',
  Snow = 'Snow',
  Stormy = 'Stormy',
  Sunny = 'Sunny'
}

export type WooLocationSalesBreakdown = {
  __typename?: 'WooLocationSalesBreakdown';
  ffpDblCount: Scalars['Int'];
  ffpSglCount: Scalars['Int'];
  locationName: Scalars['String'];
  otherCount: Scalars['Int'];
  prbcCount: Scalars['Int'];
  revenue: Scalars['Float'];
};

export type WooOrderEntry = {
  __typename?: 'WooOrderEntry';
  company?: Maybe<Scalars['String']>;
  customerName: Scalars['String'];
  dateCreated: Scalars['String'];
  lineItems: Array<WooOrderLineItem>;
  orderId: Scalars['Int'];
  orderNumber: Scalars['Int'];
  shipLocationName?: Maybe<Scalars['String']>;
  shippingClassSlug?: Maybe<Scalars['String']>;
  splitType?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  total: Scalars['Float'];
};

export type WooOrderLineItem = {
  __typename?: 'WooOrderLineItem';
  id: Scalars['Int'];
  meta: Array<WooOrderLineItemMeta>;
  name: Scalars['String'];
  price: Scalars['Float'];
  productId: Scalars['Int'];
  quantity: Scalars['Int'];
  sku: Scalars['String'];
};

export type WooOrderLineItemMeta = {
  __typename?: 'WooOrderLineItemMeta';
  key: Scalars['String'];
  value: Scalars['String'];
};

export type WoocommerceProductCategoryOutput = {
  __typename?: 'WoocommerceProductCategoryOutput';
  count: Scalars['Float'];
  id: Scalars['Float'];
  name: Scalars['String'];
  parent: Scalars['Float'];
  slug: Scalars['String'];
};

export type WoocommerceProductListOutput = {
  __typename?: 'WoocommerceProductListOutput';
  data: Array<WoocommerceProductOutput>;
  meta: MetaData;
};

export type WoocommerceProductOutput = {
  __typename?: 'WoocommerceProductOutput';
  categories: Array<Category>;
  date_created: Scalars['String'];
  date_modified: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['Float'];
  name: Scalars['String'];
  price: Scalars['String'];
  slug: Scalars['String'];
  status: Scalars['String'];
  stock_quantity?: Maybe<Scalars['Float']>;
  stock_status: Scalars['String'];
  type: Scalars['String'];
};

export type WoocommerceTopSellerOutput = {
  __typename?: 'WoocommerceTopSellerOutput';
  name: Scalars['String'];
  product_id: Scalars['Float'];
  quantity: Scalars['Float'];
};

export type UpdateAllPermissionsMutationVariables = Exact<{
  input: PermissionsInput;
}>;


export type UpdateAllPermissionsMutation = { __typename?: 'Mutation', updatePermissions: Array<{ __typename?: 'PermissionsOutput', id: string, value: boolean, permission: PermissionsEnum }> };

export type InviteUserMutationVariables = Exact<{
  input: InviteUserInput;
}>;


export type InviteUserMutation = { __typename?: 'Mutation', inviteUser: boolean };

export type AcceptInviteMutationVariables = Exact<{
  input: AcceptInviteInput;
}>;


export type AcceptInviteMutation = { __typename?: 'Mutation', acceptInvite: { __typename?: 'UserOutput', email: string } };

export type RemoveUserMutationVariables = Exact<{
  input: RemoveUserInput;
}>;


export type RemoveUserMutation = { __typename?: 'Mutation', removeUser: boolean };

export type RemoveOwnerMutationVariables = Exact<{
  input: RemoveUserInput;
}>;


export type RemoveOwnerMutation = { __typename?: 'Mutation', removeOwner: boolean };

export type UpdateUserInfoMutationVariables = Exact<{
  input: UpdateUserInputPartial;
}>;


export type UpdateUserInfoMutation = { __typename?: 'Mutation', updateUserInfo: { __typename?: 'UserOutput', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number, type?: OwnerType | null, isArchived: boolean, deletionIntentionAt?: any | null, contactPreferences?: string | null, deletedAt?: any | null, contacts?: Array<{ __typename?: 'ContactOutput', streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, email?: string | null, firstName?: string | null, id: string, lastName?: string | null, phoneNumber?: string | null }> | null, role: { __typename?: 'RoleOutput', id: string, value: UserRole }, assignedLocations?: Array<{ __typename?: 'LocationOutput', id: string, createdAt: any, updatedAt: any, name: string, type: LocationType, region?: { __typename?: 'RegionOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null } | null }> | null, assignedRegions?: Array<{ __typename?: 'RegionOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null }> | null, productRegionPreference?: { __typename?: 'RegionOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null } | null, assignedOffice?: { __typename?: 'OfficeOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null, region: { __typename?: 'RegionOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null } } | null } };

export type UpdateUserEmailMutationVariables = Exact<{
  input: UpdateUserEmailInput;
}>;


export type UpdateUserEmailMutation = { __typename?: 'Mutation', updateUserEmail: { __typename?: 'UserOutput', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number, type?: OwnerType | null, isArchived: boolean, deletionIntentionAt?: any | null, contactPreferences?: string | null, deletedAt?: any | null, contacts?: Array<{ __typename?: 'ContactOutput', streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, email?: string | null, firstName?: string | null, id: string, lastName?: string | null, phoneNumber?: string | null }> | null, role: { __typename?: 'RoleOutput', id: string, value: UserRole }, assignedLocations?: Array<{ __typename?: 'LocationOutput', id: string, createdAt: any, updatedAt: any, name: string, type: LocationType, region?: { __typename?: 'RegionOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null } | null }> | null, assignedRegions?: Array<{ __typename?: 'RegionOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null }> | null, productRegionPreference?: { __typename?: 'RegionOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null } | null, assignedOffice?: { __typename?: 'OfficeOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null, region: { __typename?: 'RegionOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null } } | null } };

export type UpdateUserRoleMutationVariables = Exact<{
  input: UpdateUserRoleInput;
}>;


export type UpdateUserRoleMutation = { __typename?: 'Mutation', updateUserRole: { __typename?: 'UserOutput', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number, type?: OwnerType | null, isArchived: boolean, deletionIntentionAt?: any | null, contactPreferences?: string | null, deletedAt?: any | null, contacts?: Array<{ __typename?: 'ContactOutput', streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, email?: string | null, firstName?: string | null, id: string, lastName?: string | null, phoneNumber?: string | null }> | null, role: { __typename?: 'RoleOutput', id: string, value: UserRole }, assignedLocations?: Array<{ __typename?: 'LocationOutput', id: string, createdAt: any, updatedAt: any, name: string, type: LocationType, region?: { __typename?: 'RegionOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null } | null }> | null, assignedRegions?: Array<{ __typename?: 'RegionOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null }> | null, productRegionPreference?: { __typename?: 'RegionOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null } | null, assignedOffice?: { __typename?: 'OfficeOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null, region: { __typename?: 'RegionOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null } } | null } };

export type GetPermissionsQueryVariables = Exact<{
  input: GetPermissionsInput;
}>;


export type GetPermissionsQuery = { __typename?: 'Query', getPermissions: Array<{ __typename?: 'PermissionsOutput', id: string, value: boolean, permission: PermissionsEnum, role: { __typename?: 'RoleOutput', id: string, value: UserRole } }> };

export type GetUserQueryVariables = Exact<{
  input: GetUserInput;
}>;


export type GetUserQuery = { __typename?: 'Query', getUser: { __typename?: 'UserOutput', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number, type?: OwnerType | null, isArchived: boolean, deletionIntentionAt?: any | null, contactPreferences?: string | null, deletedAt?: any | null, contacts?: Array<{ __typename?: 'ContactOutput', streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, email?: string | null, firstName?: string | null, id: string, lastName?: string | null, phoneNumber?: string | null }> | null, role: { __typename?: 'RoleOutput', id: string, value: UserRole }, assignedLocations?: Array<{ __typename?: 'LocationOutput', id: string, createdAt: any, updatedAt: any, name: string, type: LocationType, region?: { __typename?: 'RegionOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null } | null }> | null, assignedRegions?: Array<{ __typename?: 'RegionOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null }> | null, productRegionPreference?: { __typename?: 'RegionOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null } | null, assignedOffice?: { __typename?: 'OfficeOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null, region: { __typename?: 'RegionOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null } } | null } };

export type AppointmentFragment = { __typename?: 'AppointmentOutput', id: string, createdAt: any, updatedAt: any, title: string, start: any, end: any, location: string, notes?: string | null, isDaycare?: boolean | null, isPrivate?: boolean | null };

export type AppointmentUserFragment = { __typename?: 'AppointmentUser', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number };

export type AppointmentGroupFragment = { __typename?: 'AppointmentGroupOutput', id: string, title: string };

export type AppointmentTeamFragment = { __typename?: 'AppointmentTeamOutput', id: string, title: string };

export type AppointmentDonorFragment = { __typename?: 'AppointmentDonor', id: string, age: number, gender: AnimalGender, hasTransfusion?: boolean | null, name: string, neutered: boolean, primaryVeterinarian: string, species: AnimalSpecies, takeMedications?: boolean | null, weight: number, bloodType?: BloodType | null, status: DonorStatus, type: DonorType, location: string, distinguishableMarks?: string | null, microchipNumber?: string | null, medicationCourse?: string | null, comment?: string | null, breed?: string | null, color?: string | null, createdAt: any, shortId: number, firstCertificatePrinted: boolean, secondCertificatePrinted: boolean };

export type CreateAppointmentsMutationVariables = Exact<{
  input: CreateEmptyAppointmentInput;
}>;


export type CreateAppointmentsMutation = { __typename?: 'Mutation', createAppointments: Array<{ __typename?: 'AppointmentOutput', id: string, createdAt: any, updatedAt: any, title: string, start: any, end: any, location: string, notes?: string | null, isDaycare?: boolean | null, isPrivate?: boolean | null, users: Array<{ __typename?: 'AppointmentUser', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number, contacts?: Array<{ __typename?: 'ContactOutput', streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, email?: string | null, firstName?: string | null, id: string, lastName?: string | null, phoneNumber?: string | null }> | null }>, donor?: { __typename?: 'AppointmentDonor', id: string, age: number, gender: AnimalGender, hasTransfusion?: boolean | null, name: string, neutered: boolean, primaryVeterinarian: string, species: AnimalSpecies, takeMedications?: boolean | null, weight: number, bloodType?: BloodType | null, status: DonorStatus, type: DonorType, location: string, distinguishableMarks?: string | null, microchipNumber?: string | null, medicationCourse?: string | null, comment?: string | null, breed?: string | null, color?: string | null, createdAt: any, shortId: number, firstCertificatePrinted: boolean, secondCertificatePrinted: boolean, user?: { __typename?: 'AppointmentUser', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number, contacts?: Array<{ __typename?: 'ContactOutput', streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, email?: string | null, firstName?: string | null, id: string, lastName?: string | null, phoneNumber?: string | null }> | null } | null } | null, group?: { __typename?: 'AppointmentGroupOutput', id: string, title: string, user?: { __typename?: 'AppointmentUser', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number, contacts?: Array<{ __typename?: 'ContactOutput', streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, email?: string | null, firstName?: string | null, id: string, lastName?: string | null, phoneNumber?: string | null }> | null } | null } | null, team?: { __typename?: 'AppointmentTeamOutput', id: string, title: string } | null }> };

export type CreateAppointmentsWithDonorMutationVariables = Exact<{
  input: CreateAppointmentWithDonorInput;
}>;


export type CreateAppointmentsWithDonorMutation = { __typename?: 'Mutation', createAppointmentsWithDonor: Array<{ __typename?: 'AppointmentOutput', id: string, createdAt: any, updatedAt: any, title: string, start: any, end: any, location: string, notes?: string | null, isDaycare?: boolean | null, isPrivate?: boolean | null, users: Array<{ __typename?: 'AppointmentUser', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number, contacts?: Array<{ __typename?: 'ContactOutput', streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, email?: string | null, firstName?: string | null, id: string, lastName?: string | null, phoneNumber?: string | null }> | null }>, donor?: { __typename?: 'AppointmentDonor', id: string, age: number, gender: AnimalGender, hasTransfusion?: boolean | null, name: string, neutered: boolean, primaryVeterinarian: string, species: AnimalSpecies, takeMedications?: boolean | null, weight: number, bloodType?: BloodType | null, status: DonorStatus, type: DonorType, location: string, distinguishableMarks?: string | null, microchipNumber?: string | null, medicationCourse?: string | null, comment?: string | null, breed?: string | null, color?: string | null, createdAt: any, shortId: number, firstCertificatePrinted: boolean, secondCertificatePrinted: boolean, user?: { __typename?: 'AppointmentUser', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number, contacts?: Array<{ __typename?: 'ContactOutput', streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, email?: string | null, firstName?: string | null, id: string, lastName?: string | null, phoneNumber?: string | null }> | null } | null } | null, group?: { __typename?: 'AppointmentGroupOutput', id: string, title: string, user?: { __typename?: 'AppointmentUser', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number, contacts?: Array<{ __typename?: 'ContactOutput', streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, email?: string | null, firstName?: string | null, id: string, lastName?: string | null, phoneNumber?: string | null }> | null } | null } | null, team?: { __typename?: 'AppointmentTeamOutput', id: string, title: string } | null }> };

export type CreateAppointmentsWithGroupMutationVariables = Exact<{
  input: CreateAppointmentWithGroupInput;
}>;


export type CreateAppointmentsWithGroupMutation = { __typename?: 'Mutation', createAppointmentsWithGroup: Array<{ __typename?: 'AppointmentOutput', id: string, createdAt: any, updatedAt: any, title: string, start: any, end: any, location: string, notes?: string | null, isDaycare?: boolean | null, isPrivate?: boolean | null, users: Array<{ __typename?: 'AppointmentUser', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number, contacts?: Array<{ __typename?: 'ContactOutput', streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, email?: string | null, firstName?: string | null, id: string, lastName?: string | null, phoneNumber?: string | null }> | null }>, donor?: { __typename?: 'AppointmentDonor', id: string, age: number, gender: AnimalGender, hasTransfusion?: boolean | null, name: string, neutered: boolean, primaryVeterinarian: string, species: AnimalSpecies, takeMedications?: boolean | null, weight: number, bloodType?: BloodType | null, status: DonorStatus, type: DonorType, location: string, distinguishableMarks?: string | null, microchipNumber?: string | null, medicationCourse?: string | null, comment?: string | null, breed?: string | null, color?: string | null, createdAt: any, shortId: number, firstCertificatePrinted: boolean, secondCertificatePrinted: boolean, user?: { __typename?: 'AppointmentUser', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number, contacts?: Array<{ __typename?: 'ContactOutput', streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, email?: string | null, firstName?: string | null, id: string, lastName?: string | null, phoneNumber?: string | null }> | null } | null } | null, group?: { __typename?: 'AppointmentGroupOutput', id: string, title: string, user?: { __typename?: 'AppointmentUser', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number, contacts?: Array<{ __typename?: 'ContactOutput', streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, email?: string | null, firstName?: string | null, id: string, lastName?: string | null, phoneNumber?: string | null }> | null } | null } | null, team?: { __typename?: 'AppointmentTeamOutput', id: string, title: string } | null }> };

export type EnrollDonorToAppointmentMutationVariables = Exact<{
  input: EnrollDonorInput;
}>;


export type EnrollDonorToAppointmentMutation = { __typename?: 'Mutation', enrollDonorToAppointment: boolean };

export type UnenrollMyDonorFromAppointmentMutationVariables = Exact<{
  input: UnenrollDonorInput;
}>;


export type UnenrollMyDonorFromAppointmentMutation = { __typename?: 'Mutation', unenrollMyDonorFromAppointment: boolean };

export type EnrollMyDonorToAppointmentMutationVariables = Exact<{
  input: EnrollDonorInput;
}>;


export type EnrollMyDonorToAppointmentMutation = { __typename?: 'Mutation', enrollMyDonorToAppointment: boolean };

export type RemoveAppointmentMutationVariables = Exact<{
  input: RemoveAppointmentInput;
}>;


export type RemoveAppointmentMutation = { __typename?: 'Mutation', removeAppointment: boolean };

export type UpdateAppointmentMutationVariables = Exact<{
  input: UpdateAppointmentInput;
}>;


export type UpdateAppointmentMutation = { __typename?: 'Mutation', updateAppointment: { __typename?: 'AppointmentOutput', id: string, createdAt: any, updatedAt: any, title: string, start: any, end: any, location: string, notes?: string | null, isDaycare?: boolean | null, isPrivate?: boolean | null, users: Array<{ __typename?: 'AppointmentUser', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number, contacts?: Array<{ __typename?: 'ContactOutput', streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, email?: string | null, firstName?: string | null, id: string, lastName?: string | null, phoneNumber?: string | null }> | null }>, donor?: { __typename?: 'AppointmentDonor', id: string, age: number, gender: AnimalGender, hasTransfusion?: boolean | null, name: string, neutered: boolean, primaryVeterinarian: string, species: AnimalSpecies, takeMedications?: boolean | null, weight: number, bloodType?: BloodType | null, status: DonorStatus, type: DonorType, location: string, distinguishableMarks?: string | null, microchipNumber?: string | null, medicationCourse?: string | null, comment?: string | null, breed?: string | null, color?: string | null, createdAt: any, shortId: number, firstCertificatePrinted: boolean, secondCertificatePrinted: boolean, user?: { __typename?: 'AppointmentUser', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number, contacts?: Array<{ __typename?: 'ContactOutput', streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, email?: string | null, firstName?: string | null, id: string, lastName?: string | null, phoneNumber?: string | null }> | null } | null } | null, group?: { __typename?: 'AppointmentGroupOutput', id: string, title: string, user?: { __typename?: 'AppointmentUser', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number, contacts?: Array<{ __typename?: 'ContactOutput', streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, email?: string | null, firstName?: string | null, id: string, lastName?: string | null, phoneNumber?: string | null }> | null } | null } | null, team?: { __typename?: 'AppointmentTeamOutput', id: string, title: string } | null } };

export type RegisterOnDaycareAppointmentMutationVariables = Exact<{
  input: RegisterOnDaycareAppointmentInput;
}>;


export type RegisterOnDaycareAppointmentMutation = { __typename?: 'Mutation', registerOnDaycareAppointment: boolean };

export type ApproveDaycareAppointmentRequestMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type ApproveDaycareAppointmentRequestMutation = { __typename?: 'Mutation', approveDaycareAppointmentRequest: boolean };

export type DisproveDaycareAppointmentRequestMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DisproveDaycareAppointmentRequestMutation = { __typename?: 'Mutation', disproveDaycareAppointmentRequest: boolean };

export type CancelDaycareAppointmentRequestMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type CancelDaycareAppointmentRequestMutation = { __typename?: 'Mutation', cancelDaycareAppointmentRequest: boolean };

export type CreateDaycareAppointmentsWithDonorsMutationVariables = Exact<{
  input: CreateDaycareAppointmentWithDonorsInput;
}>;


export type CreateDaycareAppointmentsWithDonorsMutation = { __typename?: 'Mutation', createDaycareAppointmentsWithDonors: boolean };

export type UnenrollDonorFromDaycareMutationVariables = Exact<{
  input: DaycareUnenrollDonorInput;
}>;


export type UnenrollDonorFromDaycareMutation = { __typename?: 'Mutation', unenrollDonorFromDaycare: boolean };

export type AddDonorsToDaycareMutationVariables = Exact<{
  input: AddDonorsToDaycareInput;
}>;


export type AddDonorsToDaycareMutation = { __typename?: 'Mutation', addDonorsToDaycare: boolean };

export type GetAppointmentsQueryVariables = Exact<{
  input: GetAppointmentsInput;
}>;


export type GetAppointmentsQuery = { __typename?: 'Query', getAppointments: Array<{ __typename?: 'AppointmentOutput', id: string, createdAt: any, updatedAt: any, title: string, start: any, end: any, location: string, notes?: string | null, isDaycare?: boolean | null, isPrivate?: boolean | null, users: Array<{ __typename?: 'AppointmentUser', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number, contacts?: Array<{ __typename?: 'ContactOutput', streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, email?: string | null, firstName?: string | null, id: string, lastName?: string | null, phoneNumber?: string | null }> | null }>, donor?: { __typename?: 'AppointmentDonor', id: string, age: number, gender: AnimalGender, hasTransfusion?: boolean | null, name: string, neutered: boolean, primaryVeterinarian: string, species: AnimalSpecies, takeMedications?: boolean | null, weight: number, bloodType?: BloodType | null, status: DonorStatus, type: DonorType, location: string, distinguishableMarks?: string | null, microchipNumber?: string | null, medicationCourse?: string | null, comment?: string | null, breed?: string | null, color?: string | null, createdAt: any, shortId: number, firstCertificatePrinted: boolean, secondCertificatePrinted: boolean, user?: { __typename?: 'AppointmentUser', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number, contacts?: Array<{ __typename?: 'ContactOutput', streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, email?: string | null, firstName?: string | null, id: string, lastName?: string | null, phoneNumber?: string | null }> | null } | null } | null, group?: { __typename?: 'AppointmentGroupOutput', id: string, title: string, user?: { __typename?: 'AppointmentUser', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number, contacts?: Array<{ __typename?: 'ContactOutput', streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, email?: string | null, firstName?: string | null, id: string, lastName?: string | null, phoneNumber?: string | null }> | null } | null } | null, team?: { __typename?: 'AppointmentTeamOutput', id: string, title: string } | null }> };

export type GetAppointmentQueryVariables = Exact<{
  input: GetAppointmentInput;
}>;


export type GetAppointmentQuery = { __typename?: 'Query', getAppointment: { __typename?: 'AppointmentOutput', id: string, createdAt: any, updatedAt: any, title: string, start: any, end: any, location: string, notes?: string | null, isDaycare?: boolean | null, isPrivate?: boolean | null, users: Array<{ __typename?: 'AppointmentUser', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number, contacts?: Array<{ __typename?: 'ContactOutput', streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, email?: string | null, firstName?: string | null, id: string, lastName?: string | null, phoneNumber?: string | null }> | null }>, donor?: { __typename?: 'AppointmentDonor', id: string, age: number, gender: AnimalGender, hasTransfusion?: boolean | null, name: string, neutered: boolean, primaryVeterinarian: string, species: AnimalSpecies, takeMedications?: boolean | null, weight: number, bloodType?: BloodType | null, status: DonorStatus, type: DonorType, location: string, distinguishableMarks?: string | null, microchipNumber?: string | null, medicationCourse?: string | null, comment?: string | null, breed?: string | null, color?: string | null, createdAt: any, shortId: number, firstCertificatePrinted: boolean, secondCertificatePrinted: boolean, user?: { __typename?: 'AppointmentUser', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number, contacts?: Array<{ __typename?: 'ContactOutput', streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, email?: string | null, firstName?: string | null, id: string, lastName?: string | null, phoneNumber?: string | null }> | null } | null } | null, group?: { __typename?: 'AppointmentGroupOutput', id: string, title: string, user?: { __typename?: 'AppointmentUser', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number, contacts?: Array<{ __typename?: 'ContactOutput', streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, email?: string | null, firstName?: string | null, id: string, lastName?: string | null, phoneNumber?: string | null }> | null } | null } | null, team?: { __typename?: 'AppointmentTeamOutput', id: string, title: string } | null } };

export type GetAppointmentsForCurrentUserQueryVariables = Exact<{
  input: GetAppointmentsForCurrentUserInput;
}>;


export type GetAppointmentsForCurrentUserQuery = { __typename?: 'Query', getAppointmentsForCurrentUser: Array<{ __typename?: 'AppointmentOutput', id: string, createdAt: any, updatedAt: any, title: string, start: any, end: any, location: string, notes?: string | null, isDaycare?: boolean | null, isPrivate?: boolean | null, users: Array<{ __typename?: 'AppointmentUser', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number, contacts?: Array<{ __typename?: 'ContactOutput', streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, email?: string | null, firstName?: string | null, id: string, lastName?: string | null, phoneNumber?: string | null }> | null }>, donor?: { __typename?: 'AppointmentDonor', id: string, age: number, gender: AnimalGender, hasTransfusion?: boolean | null, name: string, neutered: boolean, primaryVeterinarian: string, species: AnimalSpecies, takeMedications?: boolean | null, weight: number, bloodType?: BloodType | null, status: DonorStatus, type: DonorType, location: string, distinguishableMarks?: string | null, microchipNumber?: string | null, medicationCourse?: string | null, comment?: string | null, breed?: string | null, color?: string | null, createdAt: any, shortId: number, firstCertificatePrinted: boolean, secondCertificatePrinted: boolean, user?: { __typename?: 'AppointmentUser', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number, contacts?: Array<{ __typename?: 'ContactOutput', streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, email?: string | null, firstName?: string | null, id: string, lastName?: string | null, phoneNumber?: string | null }> | null } | null } | null, group?: { __typename?: 'AppointmentGroupOutput', id: string, title: string, user?: { __typename?: 'AppointmentUser', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number, contacts?: Array<{ __typename?: 'ContactOutput', streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, email?: string | null, firstName?: string | null, id: string, lastName?: string | null, phoneNumber?: string | null }> | null } | null } | null, team?: { __typename?: 'AppointmentTeamOutput', id: string, title: string } | null }> };

export type GetPrivateDaycareAppointmentForCurrentUserQueryVariables = Exact<{
  input: GetAppointmentsForCurrentUserInput;
}>;


export type GetPrivateDaycareAppointmentForCurrentUserQuery = { __typename?: 'Query', getPrivateDaycareAppointmentForCurrentUser: Array<{ __typename?: 'AppointmentOutput', id: string, createdAt: any, updatedAt: any, title: string, start: any, end: any, location: string, notes?: string | null, isDaycare?: boolean | null, isPrivate?: boolean | null, users: Array<{ __typename?: 'AppointmentUser', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number, contacts?: Array<{ __typename?: 'ContactOutput', streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, email?: string | null, firstName?: string | null, id: string, lastName?: string | null, phoneNumber?: string | null }> | null }>, donor?: { __typename?: 'AppointmentDonor', id: string, age: number, gender: AnimalGender, hasTransfusion?: boolean | null, name: string, neutered: boolean, primaryVeterinarian: string, species: AnimalSpecies, takeMedications?: boolean | null, weight: number, bloodType?: BloodType | null, status: DonorStatus, type: DonorType, location: string, distinguishableMarks?: string | null, microchipNumber?: string | null, medicationCourse?: string | null, comment?: string | null, breed?: string | null, color?: string | null, createdAt: any, shortId: number, firstCertificatePrinted: boolean, secondCertificatePrinted: boolean, user?: { __typename?: 'AppointmentUser', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number, contacts?: Array<{ __typename?: 'ContactOutput', streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, email?: string | null, firstName?: string | null, id: string, lastName?: string | null, phoneNumber?: string | null }> | null } | null } | null, group?: { __typename?: 'AppointmentGroupOutput', id: string, title: string, user?: { __typename?: 'AppointmentUser', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number, contacts?: Array<{ __typename?: 'ContactOutput', streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, email?: string | null, firstName?: string | null, id: string, lastName?: string | null, phoneNumber?: string | null }> | null } | null } | null, team?: { __typename?: 'AppointmentTeamOutput', id: string, title: string } | null }> };

export type GetDaycareAppointmentInfoQueryVariables = Exact<{
  input: Scalars['String'];
}>;


export type GetDaycareAppointmentInfoQuery = { __typename?: 'Query', getDaycareAppointmentInfo: { __typename?: 'DaycareAppointmentDetailOutput', interactions: Array<{ __typename?: 'DaycareAppointmentResponseOutput', id: string, note?: string | null, ownerResponse: boolean, owner: { __typename?: 'OwnerOutput', email: string, id: string, firstName: string, lastName: string, hasMultipleDonors?: boolean | null, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number, type?: OwnerType | null, isArchived: boolean, contactPreferences?: string | null, createdAt: any, deletedAt?: any | null }, registeredDonors: Array<{ __typename?: 'DonorOutput', id: string, age: number, gender: AnimalGender, hasTransfusion?: boolean | null, name: string, neutered: boolean, primaryVeterinarian: string, species: AnimalSpecies, takeMedications?: boolean | null, weight: number, approvedDonationML: number, donationMLApprovedAmount?: number | null, bloodType?: BloodType | null, status: DonorStatus, type: DonorType, location: string, distinguishableMarks?: string | null, microchipNumber?: string | null, medicationCourse?: string | null, comment?: string | null, breed?: string | null, color?: string | null, createdAt: any, shortId: number, firstCertificatePrinted: boolean, secondCertificatePrinted: boolean, becameReservedDonorDate?: any | null, retiredDate?: any | null, distemperDate?: any | null, rabiesDate?: any | null, lastDonationDate?: any | null, nextDonationDate?: any | null, lastLabworkDate?: any | null, hasMicrochip?: boolean | null, acceptSimparicaTrio: boolean, isDaycare?: boolean | null, donationFrequency: number, canRegularlyAttendDaycare?: boolean | null, attendDaycareDays?: Array<string> | null, retiredReason?: RetiredReasons | null, retiredReasonComment?: string | null, dateOfBirth: any }> }>, meta: { __typename?: 'DaycareAppointmentMetaOutput', maxDonorsCapacity: number, registeredDonors: number }, requests: Array<{ __typename?: 'DaycareAppointmentRequestOutput', id: string, note?: string | null, user: { __typename?: 'OwnerOutput', email: string, id: string, firstName: string, lastName: string, hasMultipleDonors?: boolean | null, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number, type?: OwnerType | null, isArchived: boolean, contactPreferences?: string | null, createdAt: any, deletedAt?: any | null }, donor: { __typename?: 'DonorOutput', id: string, age: number, gender: AnimalGender, hasTransfusion?: boolean | null, name: string, neutered: boolean, primaryVeterinarian: string, species: AnimalSpecies, takeMedications?: boolean | null, weight: number, approvedDonationML: number, donationMLApprovedAmount?: number | null, bloodType?: BloodType | null, status: DonorStatus, type: DonorType, location: string, distinguishableMarks?: string | null, microchipNumber?: string | null, medicationCourse?: string | null, comment?: string | null, breed?: string | null, color?: string | null, createdAt: any, shortId: number, firstCertificatePrinted: boolean, secondCertificatePrinted: boolean, becameReservedDonorDate?: any | null, retiredDate?: any | null, distemperDate?: any | null, rabiesDate?: any | null, lastDonationDate?: any | null, nextDonationDate?: any | null, lastLabworkDate?: any | null, hasMicrochip?: boolean | null, acceptSimparicaTrio: boolean, isDaycare?: boolean | null, donationFrequency: number, canRegularlyAttendDaycare?: boolean | null, attendDaycareDays?: Array<string> | null, retiredReason?: RetiredReasons | null, retiredReasonComment?: string | null, dateOfBirth: any } }> } };

export type GetDaycareAppointmentInfoForCurrentUserQueryVariables = Exact<{
  appointmentId: Scalars['String'];
}>;


export type GetDaycareAppointmentInfoForCurrentUserQuery = { __typename?: 'Query', getDaycareAppointmentInfoForCurrentUser: { __typename?: 'UserDaycareAppointmentInfoOutput', status: DaycareRegistrationStatus, daycareId?: string | null, registeredDonors: Array<{ __typename?: 'DonorOutput', id: string, age: number, gender: AnimalGender, hasTransfusion?: boolean | null, name: string, neutered: boolean, primaryVeterinarian: string, species: AnimalSpecies, takeMedications?: boolean | null, weight: number, approvedDonationML: number, donationMLApprovedAmount?: number | null, bloodType?: BloodType | null, status: DonorStatus, type: DonorType, location: string, distinguishableMarks?: string | null, microchipNumber?: string | null, medicationCourse?: string | null, comment?: string | null, breed?: string | null, color?: string | null, createdAt: any, shortId: number, firstCertificatePrinted: boolean, secondCertificatePrinted: boolean, becameReservedDonorDate?: any | null, retiredDate?: any | null, distemperDate?: any | null, rabiesDate?: any | null, lastDonationDate?: any | null, nextDonationDate?: any | null, lastLabworkDate?: any | null, hasMicrochip?: boolean | null, acceptSimparicaTrio: boolean, isDaycare?: boolean | null, donationFrequency: number, canRegularlyAttendDaycare?: boolean | null, attendDaycareDays?: Array<string> | null, retiredReason?: RetiredReasons | null, retiredReasonComment?: string | null, dateOfBirth: any }>, requests: Array<{ __typename?: 'DaycareAppointmentRequestOutput', id: string, donor: { __typename?: 'DonorOutput', id: string, age: number, gender: AnimalGender, hasTransfusion?: boolean | null, name: string, neutered: boolean, primaryVeterinarian: string, species: AnimalSpecies, takeMedications?: boolean | null, weight: number, approvedDonationML: number, donationMLApprovedAmount?: number | null, bloodType?: BloodType | null, status: DonorStatus, type: DonorType, location: string, distinguishableMarks?: string | null, microchipNumber?: string | null, medicationCourse?: string | null, comment?: string | null, breed?: string | null, color?: string | null, createdAt: any, shortId: number, firstCertificatePrinted: boolean, secondCertificatePrinted: boolean, becameReservedDonorDate?: any | null, retiredDate?: any | null, distemperDate?: any | null, rabiesDate?: any | null, lastDonationDate?: any | null, nextDonationDate?: any | null, lastLabworkDate?: any | null, hasMicrochip?: boolean | null, acceptSimparicaTrio: boolean, isDaycare?: boolean | null, donationFrequency: number, canRegularlyAttendDaycare?: boolean | null, attendDaycareDays?: Array<string> | null, retiredReason?: RetiredReasons | null, retiredReasonComment?: string | null, dateOfBirth: any } }> } };

export type LoginMutationVariables = Exact<{
  input: LoginInput;
}>;


export type LoginMutation = { __typename?: 'Mutation', login: { __typename?: 'LoginOutput', accessToken: string, refreshToken: string } };

export type RefreshTokenMutationVariables = Exact<{ [key: string]: never; }>;


export type RefreshTokenMutation = { __typename?: 'Mutation', refreshToken: { __typename?: 'LoginOutput', accessToken: string, refreshToken: string } };

export type LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutation = { __typename?: 'Mutation', logout: boolean };

export type ResendEmailConfirmationCodeMutationVariables = Exact<{
  input: ResendEmailConfirmationCodeInput;
}>;


export type ResendEmailConfirmationCodeMutation = { __typename?: 'Mutation', resendEmailConfirmationCode: boolean };

export type GetAppVersionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAppVersionQuery = { __typename?: 'Query', getAppVersion: string };

export type GetDataAuditUnitsQueryVariables = Exact<{
  input: GetDataAuditUnitsInput;
}>;


export type GetDataAuditUnitsQuery = { __typename?: 'Query', getDataAuditUnits: { __typename?: 'DataAuditUnitsOutput', periodStart?: any | null, periodEnd?: any | null, unitCount: number, donorCount: number, rows: Array<{ __typename?: 'DataAuditUnitRow', productId: string, productShortId: number, unitType: string, categoryId: number, woocommerceProductId: number, productStatus: string, productCreatedAt: any, donationId: string, donorId: string, donorShortId: number, donorName: string, ownerFullName?: string | null, donorLocation?: string | null, regionName?: string | null, donorStatus?: string | null }> } };

export type GetDataAuditUnitDonorsQueryVariables = Exact<{
  input: GetDataAuditUnitsInput;
}>;


export type GetDataAuditUnitDonorsQuery = { __typename?: 'Query', getDataAuditUnitDonors: { __typename?: 'DataAuditUnitDonorsOutput', periodStart: any, periodEnd: any, unitCount: number, rows: Array<{ __typename?: 'DataAuditUnitDonorRow', donorId: string, donorName: string, ownerFullName?: string | null, donorLocation?: string | null, regionName?: string | null, donorStatus?: string | null, units: number }> } };

export type GetDataAuditRecruitedDonorsQueryVariables = Exact<{
  input: GetDataAuditDonorsInput;
}>;


export type GetDataAuditRecruitedDonorsQuery = { __typename?: 'Query', getDataAuditRecruitedDonors: { __typename?: 'DataAuditRecruitedDonorsOutput', periodStart: any, periodEnd: any, donorCount: number, rows: Array<{ __typename?: 'DataAuditRecruitedDonorRow', donorId: string, donorName: string, createdAt: any, ownerFullName?: string | null, donorLocation?: string | null, regionName?: string | null, donorStatus?: string | null }> } };

export type GetOpsLocationUnitsQueryVariables = Exact<{
  input: GetDataAuditUnitsInput;
}>;


export type GetOpsLocationUnitsQuery = { __typename?: 'Query', getOpsLocationUnits: { __typename?: 'DataAuditUnitsOutput', periodStart?: any | null, periodEnd?: any | null, unitCount: number, donorCount: number, rows: Array<{ __typename?: 'DataAuditUnitRow', productId: string, productShortId: number, unitType: string, categoryId: number, woocommerceProductId: number, productStatus: string, productCreatedAt: any, donationId: string, donorId: string, donorShortId: number, donorName: string, ownerFullName?: string | null, ownerShortId?: number | null, donorLocation?: string | null, regionName?: string | null, donorStatus?: string | null, donationDate?: any | null }> } };

export type GetProductUnitCountsQueryVariables = Exact<{
  input: GetProductUnitCountsInput;
}>;


export type GetProductUnitCountsQuery = { __typename?: 'Query', getProductUnitCounts: { __typename?: 'ProductUnitCountsOutput', unitCount: number, donorCount: number } };

export type GetDataAuditPipelineDonorsQueryVariables = Exact<{
  input: GetDataAuditDonorsInput;
}>;


export type GetDataAuditPipelineDonorsQuery = { __typename?: 'Query', getDataAuditPipelineDonors: { __typename?: 'DataAuditPipelineDonorsOutput', donorCount: number, statuses: Array<string>, rows: Array<{ __typename?: 'DataAuditPipelineDonorRow', donorId: string, donorName: string, createdAt: any, ownerFullName?: string | null, donorLocation?: string | null, regionName?: string | null, donorStatus: string }> } };

export type GetRegistrationDonorsQueryVariables = Exact<{
  input: GetRegistrationDonorsInput;
}>;


export type GetRegistrationDonorsQuery = { __typename?: 'Query', getRegistrationDonors: { __typename?: 'PrbcDonationDonorsListOutput', total: number, donors: Array<{ __typename?: 'PrbcDonationDonorOutput', donorId: string, donorShortId: number, donorName: string, ownerFullName?: string | null, ownerShortId?: number | null, bloodTypeDisplay: string, status: string, lastDonationDate?: any | null, sglDbl: string, totalDonations: number, periodUnits: number, location: string, registeredAt?: any | null, approvedDonationML?: number | null, weight?: number | null, ownerPhone?: string | null, ownerEmail?: string | null, ownerCity?: string | null, ownerState?: string | null, ownerContactPreferences?: string | null, ownerAssignedLocations?: string | null, breed?: string | null, dateOfBirth?: any | null, region?: string | null, activeDate?: any | null }> } };

export type GetLeaderboardHistoryQueryVariables = Exact<{
  input: GetLeaderboardHistoryInput;
}>;


export type GetLeaderboardHistoryQuery = { __typename?: 'Query', getLeaderboardHistory: { __typename?: 'LeaderboardHistoryOutput', weeks: Array<{ __typename?: 'LeaderboardHistoryWeek', weekNumber: number, year: number, weekEndDate: string, winnerName?: string | null, winnerRegion?: string | null, winnerUserId?: string | null, recruitedCount: number }> } };

export type HolderFragment = { __typename?: 'HolderOutput', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number };

export type DonationProductFragment = { __typename?: 'DonationProductOutput', anticoagulant?: Anticoagulant | null, createdAt: any, id: string, shortId: number, status: ProductStatus, storageRequirements: Array<string>, updatedAt: any, value: number, woocommerceProductId: number, woocommerceCategoryId: number, expirationDate: any, bloodIdentifiers?: Array<{ __typename?: 'BloodUnitIdentifiersOutput', unitId?: number | null, product?: { __typename?: 'ProductOutput', id: string, shortId: number } | null }> | null };

export type DonationDonorFragment = { __typename?: 'DonationDonor', id: string, age: number, gender: AnimalGender, hasTransfusion?: boolean | null, name: string, neutered: boolean, primaryVeterinarian: string, species: AnimalSpecies, takeMedications?: boolean | null, weight: number, bloodType?: BloodType | null, status: DonorStatus, type: DonorType, location: string, distinguishableMarks?: string | null, microchipNumber?: string | null, medicationCourse?: string | null, comment?: string | null, breed?: string | null, color?: string | null, createdAt: any, shortId: number, firstCertificatePrinted: boolean, secondCertificatePrinted: boolean, lastDonationDate?: any | null, lastLabworkDate?: any | null, nextDonationDate?: any | null };

export type AdditionalDonationInfoFragment = { __typename?: 'AdditionalDonationInfoOutput', id: string, numberOfCollectionUnitsUsed: CollectionUnitsUsed, veinUsed: VeinUsed, vascularStructure?: VascularStructure | null, flowRate: FlowRate, donationPosition?: string | null, holdersPosition?: Array<string> | null, donorMovement: string, typeOfMovement?: string | null, emotionalSupport?: Array<string> | null, dislikes?: Array<string> | null, likes?: Array<string> | null, treatPreferences?: Array<string> | null, totalCollectedMls?: number | null, primaryHolder?: { __typename?: 'HolderOutput', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number } | null, secondaryHolder?: { __typename?: 'HolderOutput', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number } | null, poker?: { __typename?: 'HolderOutput', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number } | null };

export type DonationFragment = { __typename?: 'DonationOutput', id: string, collectionSet: CollectionSet, capillaryRefillTime: CapillaryRefillTime, approvedDonationsMl: number, jugularVein: JugularVein, maxLimit: number, mucousMembrane: Mm, packedCellVolume: number, pulse: number, respiration: number, shouldDonate?: boolean | null, temperature: number, totalSolids: number, unit?: DonationUnit | null, failedReason?: DonationFailedReason | null, actual?: number | null, weatherTemperature: number, weatherTypes: Array<WeatherType>, weight: number, examinationNotes?: string | null, preferences?: string | null, createdAt: any, comment?: string | null, shortId: number, donationDate: any, ineligible: boolean, ineligibleReason?: IneligibleReason | null, ineligibleReasonDetails?: string | null, products?: Array<{ __typename?: 'DonationProductOutput', anticoagulant?: Anticoagulant | null, createdAt: any, id: string, shortId: number, status: ProductStatus, storageRequirements: Array<string>, updatedAt: any, value: number, woocommerceProductId: number, woocommerceCategoryId: number, expirationDate: any, discardedProduct?: { __typename?: 'DiscardedProductDataOutput', processingType: ProcessingProductType, reason: ReasonDiscardProduct, notes?: string | null } | null, bloodIdentifiers?: Array<{ __typename?: 'BloodUnitIdentifiersOutput', unitId?: number | null, product?: { __typename?: 'ProductOutput', id: string, shortId: number } | null }> | null }> | null, donor: { __typename?: 'DonationDonor', id: string, age: number, gender: AnimalGender, hasTransfusion?: boolean | null, name: string, neutered: boolean, primaryVeterinarian: string, species: AnimalSpecies, takeMedications?: boolean | null, weight: number, bloodType?: BloodType | null, status: DonorStatus, type: DonorType, location: string, distinguishableMarks?: string | null, microchipNumber?: string | null, medicationCourse?: string | null, comment?: string | null, breed?: string | null, color?: string | null, createdAt: any, shortId: number, firstCertificatePrinted: boolean, secondCertificatePrinted: boolean, lastDonationDate?: any | null, lastLabworkDate?: any | null, nextDonationDate?: any | null, team?: { __typename?: 'TeamOutput', id: string, title: string } | null, user?: { __typename?: 'HolderOutput', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number } | null, pictures?: Array<{ __typename?: 'DonorPictureOutput', id: string, isPrimary: boolean, file: { __typename?: 'FileOutput', id: string, filename: string } }> | null }, additionalInfo?: { __typename?: 'AdditionalDonationInfoOutput', id: string, numberOfCollectionUnitsUsed: CollectionUnitsUsed, veinUsed: VeinUsed, vascularStructure?: VascularStructure | null, flowRate: FlowRate, donationPosition?: string | null, holdersPosition?: Array<string> | null, donorMovement: string, typeOfMovement?: string | null, emotionalSupport?: Array<string> | null, dislikes?: Array<string> | null, likes?: Array<string> | null, treatPreferences?: Array<string> | null, totalCollectedMls?: number | null, primaryHolder?: { __typename?: 'HolderOutput', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number } | null, secondaryHolder?: { __typename?: 'HolderOutput', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number } | null, poker?: { __typename?: 'HolderOutput', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number } | null } | null };

export type CreateDonationMutationVariables = Exact<{
  input: CreateDonationInput;
}>;


export type CreateDonationMutation = { __typename?: 'Mutation', createDonation: { __typename?: 'DonationOutput', id: string, collectionSet: CollectionSet, capillaryRefillTime: CapillaryRefillTime, approvedDonationsMl: number, jugularVein: JugularVein, maxLimit: number, mucousMembrane: Mm, packedCellVolume: number, pulse: number, respiration: number, shouldDonate?: boolean | null, temperature: number, totalSolids: number, unit?: DonationUnit | null, failedReason?: DonationFailedReason | null, actual?: number | null, weatherTemperature: number, weatherTypes: Array<WeatherType>, weight: number, examinationNotes?: string | null, preferences?: string | null, createdAt: any, comment?: string | null, shortId: number, donationDate: any, ineligible: boolean, ineligibleReason?: IneligibleReason | null, ineligibleReasonDetails?: string | null, products?: Array<{ __typename?: 'DonationProductOutput', anticoagulant?: Anticoagulant | null, createdAt: any, id: string, shortId: number, status: ProductStatus, storageRequirements: Array<string>, updatedAt: any, value: number, woocommerceProductId: number, woocommerceCategoryId: number, expirationDate: any, discardedProduct?: { __typename?: 'DiscardedProductDataOutput', processingType: ProcessingProductType, reason: ReasonDiscardProduct, notes?: string | null } | null, bloodIdentifiers?: Array<{ __typename?: 'BloodUnitIdentifiersOutput', unitId?: number | null, product?: { __typename?: 'ProductOutput', id: string, shortId: number } | null }> | null }> | null, donor: { __typename?: 'DonationDonor', id: string, age: number, gender: AnimalGender, hasTransfusion?: boolean | null, name: string, neutered: boolean, primaryVeterinarian: string, species: AnimalSpecies, takeMedications?: boolean | null, weight: number, bloodType?: BloodType | null, status: DonorStatus, type: DonorType, location: string, distinguishableMarks?: string | null, microchipNumber?: string | null, medicationCourse?: string | null, comment?: string | null, breed?: string | null, color?: string | null, createdAt: any, shortId: number, firstCertificatePrinted: boolean, secondCertificatePrinted: boolean, lastDonationDate?: any | null, lastLabworkDate?: any | null, nextDonationDate?: any | null, team?: { __typename?: 'TeamOutput', id: string, title: string } | null, user?: { __typename?: 'HolderOutput', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number } | null, pictures?: Array<{ __typename?: 'DonorPictureOutput', id: string, isPrimary: boolean, file: { __typename?: 'FileOutput', id: string, filename: string } }> | null }, additionalInfo?: { __typename?: 'AdditionalDonationInfoOutput', id: string, numberOfCollectionUnitsUsed: CollectionUnitsUsed, veinUsed: VeinUsed, vascularStructure?: VascularStructure | null, flowRate: FlowRate, donationPosition?: string | null, holdersPosition?: Array<string> | null, donorMovement: string, typeOfMovement?: string | null, emotionalSupport?: Array<string> | null, dislikes?: Array<string> | null, likes?: Array<string> | null, treatPreferences?: Array<string> | null, totalCollectedMls?: number | null, primaryHolder?: { __typename?: 'HolderOutput', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number } | null, secondaryHolder?: { __typename?: 'HolderOutput', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number } | null, poker?: { __typename?: 'HolderOutput', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number } | null } | null } };

export type UpdateDonationMutationVariables = Exact<{
  input: UpdateDonationInput;
}>;


export type UpdateDonationMutation = { __typename?: 'Mutation', updateDonation: { __typename?: 'DonationOutput', id: string, collectionSet: CollectionSet, capillaryRefillTime: CapillaryRefillTime, approvedDonationsMl: number, jugularVein: JugularVein, maxLimit: number, mucousMembrane: Mm, packedCellVolume: number, pulse: number, respiration: number, shouldDonate?: boolean | null, temperature: number, totalSolids: number, unit?: DonationUnit | null, failedReason?: DonationFailedReason | null, actual?: number | null, weatherTemperature: number, weatherTypes: Array<WeatherType>, weight: number, examinationNotes?: string | null, preferences?: string | null, createdAt: any, comment?: string | null, shortId: number, donationDate: any, ineligible: boolean, ineligibleReason?: IneligibleReason | null, ineligibleReasonDetails?: string | null, products?: Array<{ __typename?: 'DonationProductOutput', anticoagulant?: Anticoagulant | null, createdAt: any, id: string, shortId: number, status: ProductStatus, storageRequirements: Array<string>, updatedAt: any, value: number, woocommerceProductId: number, woocommerceCategoryId: number, expirationDate: any, discardedProduct?: { __typename?: 'DiscardedProductDataOutput', processingType: ProcessingProductType, reason: ReasonDiscardProduct, notes?: string | null } | null, bloodIdentifiers?: Array<{ __typename?: 'BloodUnitIdentifiersOutput', unitId?: number | null, product?: { __typename?: 'ProductOutput', id: string, shortId: number } | null }> | null }> | null, donor: { __typename?: 'DonationDonor', id: string, age: number, gender: AnimalGender, hasTransfusion?: boolean | null, name: string, neutered: boolean, primaryVeterinarian: string, species: AnimalSpecies, takeMedications?: boolean | null, weight: number, bloodType?: BloodType | null, status: DonorStatus, type: DonorType, location: string, distinguishableMarks?: string | null, microchipNumber?: string | null, medicationCourse?: string | null, comment?: string | null, breed?: string | null, color?: string | null, createdAt: any, shortId: number, firstCertificatePrinted: boolean, secondCertificatePrinted: boolean, lastDonationDate?: any | null, lastLabworkDate?: any | null, nextDonationDate?: any | null, team?: { __typename?: 'TeamOutput', id: string, title: string } | null, user?: { __typename?: 'HolderOutput', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number } | null, pictures?: Array<{ __typename?: 'DonorPictureOutput', id: string, isPrimary: boolean, file: { __typename?: 'FileOutput', id: string, filename: string } }> | null }, additionalInfo?: { __typename?: 'AdditionalDonationInfoOutput', id: string, numberOfCollectionUnitsUsed: CollectionUnitsUsed, veinUsed: VeinUsed, vascularStructure?: VascularStructure | null, flowRate: FlowRate, donationPosition?: string | null, holdersPosition?: Array<string> | null, donorMovement: string, typeOfMovement?: string | null, emotionalSupport?: Array<string> | null, dislikes?: Array<string> | null, likes?: Array<string> | null, treatPreferences?: Array<string> | null, totalCollectedMls?: number | null, primaryHolder?: { __typename?: 'HolderOutput', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number } | null, secondaryHolder?: { __typename?: 'HolderOutput', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number } | null, poker?: { __typename?: 'HolderOutput', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number } | null } | null } };

export type UpdateDonationCommentMutationVariables = Exact<{
  input: UpdateDonationCommentInput;
}>;


export type UpdateDonationCommentMutation = { __typename?: 'Mutation', updateDonationComment: { __typename?: 'DonationOutput', id: string, collectionSet: CollectionSet, capillaryRefillTime: CapillaryRefillTime, approvedDonationsMl: number, jugularVein: JugularVein, maxLimit: number, mucousMembrane: Mm, packedCellVolume: number, pulse: number, respiration: number, shouldDonate?: boolean | null, temperature: number, totalSolids: number, unit?: DonationUnit | null, failedReason?: DonationFailedReason | null, actual?: number | null, weatherTemperature: number, weatherTypes: Array<WeatherType>, weight: number, examinationNotes?: string | null, preferences?: string | null, createdAt: any, comment?: string | null, shortId: number, donationDate: any, ineligible: boolean, ineligibleReason?: IneligibleReason | null, ineligibleReasonDetails?: string | null, products?: Array<{ __typename?: 'DonationProductOutput', anticoagulant?: Anticoagulant | null, createdAt: any, id: string, shortId: number, status: ProductStatus, storageRequirements: Array<string>, updatedAt: any, value: number, woocommerceProductId: number, woocommerceCategoryId: number, expirationDate: any, discardedProduct?: { __typename?: 'DiscardedProductDataOutput', processingType: ProcessingProductType, reason: ReasonDiscardProduct, notes?: string | null } | null, bloodIdentifiers?: Array<{ __typename?: 'BloodUnitIdentifiersOutput', unitId?: number | null, product?: { __typename?: 'ProductOutput', id: string, shortId: number } | null }> | null }> | null, donor: { __typename?: 'DonationDonor', id: string, age: number, gender: AnimalGender, hasTransfusion?: boolean | null, name: string, neutered: boolean, primaryVeterinarian: string, species: AnimalSpecies, takeMedications?: boolean | null, weight: number, bloodType?: BloodType | null, status: DonorStatus, type: DonorType, location: string, distinguishableMarks?: string | null, microchipNumber?: string | null, medicationCourse?: string | null, comment?: string | null, breed?: string | null, color?: string | null, createdAt: any, shortId: number, firstCertificatePrinted: boolean, secondCertificatePrinted: boolean, lastDonationDate?: any | null, lastLabworkDate?: any | null, nextDonationDate?: any | null, team?: { __typename?: 'TeamOutput', id: string, title: string } | null, user?: { __typename?: 'HolderOutput', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number } | null, pictures?: Array<{ __typename?: 'DonorPictureOutput', id: string, isPrimary: boolean, file: { __typename?: 'FileOutput', id: string, filename: string } }> | null }, additionalInfo?: { __typename?: 'AdditionalDonationInfoOutput', id: string, numberOfCollectionUnitsUsed: CollectionUnitsUsed, veinUsed: VeinUsed, vascularStructure?: VascularStructure | null, flowRate: FlowRate, donationPosition?: string | null, holdersPosition?: Array<string> | null, donorMovement: string, typeOfMovement?: string | null, emotionalSupport?: Array<string> | null, dislikes?: Array<string> | null, likes?: Array<string> | null, treatPreferences?: Array<string> | null, totalCollectedMls?: number | null, primaryHolder?: { __typename?: 'HolderOutput', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number } | null, secondaryHolder?: { __typename?: 'HolderOutput', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number } | null, poker?: { __typename?: 'HolderOutput', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number } | null } | null } };

export type UpdateDonationDonorMutationVariables = Exact<{
  input: UpdateDonationDonorInput;
}>;


export type UpdateDonationDonorMutation = { __typename?: 'Mutation', updateDonationDonor: { __typename?: 'DonationOutput', id: string, collectionSet: CollectionSet, capillaryRefillTime: CapillaryRefillTime, approvedDonationsMl: number, jugularVein: JugularVein, maxLimit: number, mucousMembrane: Mm, packedCellVolume: number, pulse: number, respiration: number, shouldDonate?: boolean | null, temperature: number, totalSolids: number, unit?: DonationUnit | null, failedReason?: DonationFailedReason | null, actual?: number | null, weatherTemperature: number, weatherTypes: Array<WeatherType>, weight: number, examinationNotes?: string | null, preferences?: string | null, createdAt: any, comment?: string | null, shortId: number, donationDate: any, ineligible: boolean, ineligibleReason?: IneligibleReason | null, ineligibleReasonDetails?: string | null, products?: Array<{ __typename?: 'DonationProductOutput', anticoagulant?: Anticoagulant | null, createdAt: any, id: string, shortId: number, status: ProductStatus, storageRequirements: Array<string>, updatedAt: any, value: number, woocommerceProductId: number, woocommerceCategoryId: number, expirationDate: any, discardedProduct?: { __typename?: 'DiscardedProductDataOutput', processingType: ProcessingProductType, reason: ReasonDiscardProduct, notes?: string | null } | null, bloodIdentifiers?: Array<{ __typename?: 'BloodUnitIdentifiersOutput', unitId?: number | null, product?: { __typename?: 'ProductOutput', id: string, shortId: number } | null }> | null }> | null, donor: { __typename?: 'DonationDonor', id: string, age: number, gender: AnimalGender, hasTransfusion?: boolean | null, name: string, neutered: boolean, primaryVeterinarian: string, species: AnimalSpecies, takeMedications?: boolean | null, weight: number, bloodType?: BloodType | null, status: DonorStatus, type: DonorType, location: string, distinguishableMarks?: string | null, microchipNumber?: string | null, medicationCourse?: string | null, comment?: string | null, breed?: string | null, color?: string | null, createdAt: any, shortId: number, firstCertificatePrinted: boolean, secondCertificatePrinted: boolean, lastDonationDate?: any | null, lastLabworkDate?: any | null, nextDonationDate?: any | null, team?: { __typename?: 'TeamOutput', id: string, title: string } | null, user?: { __typename?: 'HolderOutput', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number } | null, pictures?: Array<{ __typename?: 'DonorPictureOutput', id: string, isPrimary: boolean, file: { __typename?: 'FileOutput', id: string, filename: string } }> | null }, additionalInfo?: { __typename?: 'AdditionalDonationInfoOutput', id: string, numberOfCollectionUnitsUsed: CollectionUnitsUsed, veinUsed: VeinUsed, vascularStructure?: VascularStructure | null, flowRate: FlowRate, donationPosition?: string | null, holdersPosition?: Array<string> | null, donorMovement: string, typeOfMovement?: string | null, emotionalSupport?: Array<string> | null, dislikes?: Array<string> | null, likes?: Array<string> | null, treatPreferences?: Array<string> | null, totalCollectedMls?: number | null, primaryHolder?: { __typename?: 'HolderOutput', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number } | null, secondaryHolder?: { __typename?: 'HolderOutput', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number } | null, poker?: { __typename?: 'HolderOutput', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number } | null } | null } };

export type CreateAdditionalDonationInfoMutationVariables = Exact<{
  input: CreateAdditionalDonationInfoInput;
}>;


export type CreateAdditionalDonationInfoMutation = { __typename?: 'Mutation', createAdditionalDonationInfo: { __typename?: 'AdditionalDonationInfoOutput', id: string, numberOfCollectionUnitsUsed: CollectionUnitsUsed, veinUsed: VeinUsed, vascularStructure?: VascularStructure | null, flowRate: FlowRate, donationPosition?: string | null, holdersPosition?: Array<string> | null, donorMovement: string, typeOfMovement?: string | null, emotionalSupport?: Array<string> | null, dislikes?: Array<string> | null, likes?: Array<string> | null, treatPreferences?: Array<string> | null, totalCollectedMls?: number | null, primaryHolder?: { __typename?: 'HolderOutput', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number } | null, secondaryHolder?: { __typename?: 'HolderOutput', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number } | null, poker?: { __typename?: 'HolderOutput', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number } | null } };

export type UpdateAdditionalDonationInfoMutationVariables = Exact<{
  input: UpdateAdditionalDonationInfoInput;
}>;


export type UpdateAdditionalDonationInfoMutation = { __typename?: 'Mutation', updateAdditionalDonationInfo: { __typename?: 'AdditionalDonationInfoOutput', id: string, numberOfCollectionUnitsUsed: CollectionUnitsUsed, veinUsed: VeinUsed, vascularStructure?: VascularStructure | null, flowRate: FlowRate, donationPosition?: string | null, holdersPosition?: Array<string> | null, donorMovement: string, typeOfMovement?: string | null, emotionalSupport?: Array<string> | null, dislikes?: Array<string> | null, likes?: Array<string> | null, treatPreferences?: Array<string> | null, totalCollectedMls?: number | null, primaryHolder?: { __typename?: 'HolderOutput', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number } | null, secondaryHolder?: { __typename?: 'HolderOutput', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number } | null, poker?: { __typename?: 'HolderOutput', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number } | null } };

export type CreateDonationWithAdditionalInfoMutationVariables = Exact<{
  input: CreateDonationWithAdditionalInfoInput;
}>;


export type CreateDonationWithAdditionalInfoMutation = { __typename?: 'Mutation', createDonationWithAdditionalInfo: { __typename?: 'DonationOutput', id: string, collectionSet: CollectionSet, capillaryRefillTime: CapillaryRefillTime, approvedDonationsMl: number, jugularVein: JugularVein, maxLimit: number, mucousMembrane: Mm, packedCellVolume: number, pulse: number, respiration: number, shouldDonate?: boolean | null, temperature: number, totalSolids: number, unit?: DonationUnit | null, failedReason?: DonationFailedReason | null, actual?: number | null, weatherTemperature: number, weatherTypes: Array<WeatherType>, weight: number, examinationNotes?: string | null, preferences?: string | null, createdAt: any, comment?: string | null, shortId: number, donationDate: any, ineligible: boolean, ineligibleReason?: IneligibleReason | null, ineligibleReasonDetails?: string | null, products?: Array<{ __typename?: 'DonationProductOutput', anticoagulant?: Anticoagulant | null, createdAt: any, id: string, shortId: number, status: ProductStatus, storageRequirements: Array<string>, updatedAt: any, value: number, woocommerceProductId: number, woocommerceCategoryId: number, expirationDate: any, discardedProduct?: { __typename?: 'DiscardedProductDataOutput', processingType: ProcessingProductType, reason: ReasonDiscardProduct, notes?: string | null } | null, bloodIdentifiers?: Array<{ __typename?: 'BloodUnitIdentifiersOutput', unitId?: number | null, product?: { __typename?: 'ProductOutput', id: string, shortId: number } | null }> | null }> | null, donor: { __typename?: 'DonationDonor', id: string, age: number, gender: AnimalGender, hasTransfusion?: boolean | null, name: string, neutered: boolean, primaryVeterinarian: string, species: AnimalSpecies, takeMedications?: boolean | null, weight: number, bloodType?: BloodType | null, status: DonorStatus, type: DonorType, location: string, distinguishableMarks?: string | null, microchipNumber?: string | null, medicationCourse?: string | null, comment?: string | null, breed?: string | null, color?: string | null, createdAt: any, shortId: number, firstCertificatePrinted: boolean, secondCertificatePrinted: boolean, lastDonationDate?: any | null, lastLabworkDate?: any | null, nextDonationDate?: any | null, team?: { __typename?: 'TeamOutput', id: string, title: string } | null, user?: { __typename?: 'HolderOutput', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number } | null, pictures?: Array<{ __typename?: 'DonorPictureOutput', id: string, isPrimary: boolean, file: { __typename?: 'FileOutput', id: string, filename: string } }> | null }, additionalInfo?: { __typename?: 'AdditionalDonationInfoOutput', id: string, numberOfCollectionUnitsUsed: CollectionUnitsUsed, veinUsed: VeinUsed, vascularStructure?: VascularStructure | null, flowRate: FlowRate, donationPosition?: string | null, holdersPosition?: Array<string> | null, donorMovement: string, typeOfMovement?: string | null, emotionalSupport?: Array<string> | null, dislikes?: Array<string> | null, likes?: Array<string> | null, treatPreferences?: Array<string> | null, totalCollectedMls?: number | null, primaryHolder?: { __typename?: 'HolderOutput', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number } | null, secondaryHolder?: { __typename?: 'HolderOutput', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number } | null, poker?: { __typename?: 'HolderOutput', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number } | null } | null } };

export type CreateDonationsWithAdditionalInfoMutationVariables = Exact<{
  input: CreateDonationsWithAdditionalInfoInput;
}>;


export type CreateDonationsWithAdditionalInfoMutation = { __typename?: 'Mutation', createDonationsWithAdditionalInfo: boolean };

export type DeleteDonationMutationVariables = Exact<{
  donationId: Scalars['String'];
}>;


export type DeleteDonationMutation = { __typename?: 'Mutation', deleteDonation: boolean };

export type GetPreviousDonationQueryVariables = Exact<{
  input: GetPreviousDonationInput;
}>;


export type GetPreviousDonationQuery = { __typename?: 'Query', getPreviousDonation: { __typename?: 'DonationOutput', id: string, collectionSet: CollectionSet, capillaryRefillTime: CapillaryRefillTime, approvedDonationsMl: number, jugularVein: JugularVein, maxLimit: number, mucousMembrane: Mm, packedCellVolume: number, pulse: number, respiration: number, shouldDonate?: boolean | null, temperature: number, totalSolids: number, unit?: DonationUnit | null, failedReason?: DonationFailedReason | null, actual?: number | null, weatherTemperature: number, weatherTypes: Array<WeatherType>, weight: number, examinationNotes?: string | null, preferences?: string | null, createdAt: any, comment?: string | null, shortId: number, donationDate: any, ineligible: boolean, ineligibleReason?: IneligibleReason | null, ineligibleReasonDetails?: string | null, products?: Array<{ __typename?: 'DonationProductOutput', anticoagulant?: Anticoagulant | null, createdAt: any, id: string, shortId: number, status: ProductStatus, storageRequirements: Array<string>, updatedAt: any, value: number, woocommerceProductId: number, woocommerceCategoryId: number, expirationDate: any, discardedProduct?: { __typename?: 'DiscardedProductDataOutput', processingType: ProcessingProductType, reason: ReasonDiscardProduct, notes?: string | null } | null, bloodIdentifiers?: Array<{ __typename?: 'BloodUnitIdentifiersOutput', unitId?: number | null, product?: { __typename?: 'ProductOutput', id: string, shortId: number } | null }> | null }> | null, donor: { __typename?: 'DonationDonor', id: string, age: number, gender: AnimalGender, hasTransfusion?: boolean | null, name: string, neutered: boolean, primaryVeterinarian: string, species: AnimalSpecies, takeMedications?: boolean | null, weight: number, bloodType?: BloodType | null, status: DonorStatus, type: DonorType, location: string, distinguishableMarks?: string | null, microchipNumber?: string | null, medicationCourse?: string | null, comment?: string | null, breed?: string | null, color?: string | null, createdAt: any, shortId: number, firstCertificatePrinted: boolean, secondCertificatePrinted: boolean, lastDonationDate?: any | null, lastLabworkDate?: any | null, nextDonationDate?: any | null, team?: { __typename?: 'TeamOutput', id: string, title: string } | null, user?: { __typename?: 'HolderOutput', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number } | null, pictures?: Array<{ __typename?: 'DonorPictureOutput', id: string, isPrimary: boolean, file: { __typename?: 'FileOutput', id: string, filename: string } }> | null }, additionalInfo?: { __typename?: 'AdditionalDonationInfoOutput', id: string, numberOfCollectionUnitsUsed: CollectionUnitsUsed, veinUsed: VeinUsed, vascularStructure?: VascularStructure | null, flowRate: FlowRate, donationPosition?: string | null, holdersPosition?: Array<string> | null, donorMovement: string, typeOfMovement?: string | null, emotionalSupport?: Array<string> | null, dislikes?: Array<string> | null, likes?: Array<string> | null, treatPreferences?: Array<string> | null, totalCollectedMls?: number | null, primaryHolder?: { __typename?: 'HolderOutput', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number } | null, secondaryHolder?: { __typename?: 'HolderOutput', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number } | null, poker?: { __typename?: 'HolderOutput', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number } | null } | null } };

export type GetDonationQueryVariables = Exact<{
  input: GetDonationInput;
}>;


export type GetDonationQuery = { __typename?: 'Query', getDonation: { __typename?: 'DonationOutput', id: string, collectionSet: CollectionSet, capillaryRefillTime: CapillaryRefillTime, approvedDonationsMl: number, jugularVein: JugularVein, maxLimit: number, mucousMembrane: Mm, packedCellVolume: number, pulse: number, respiration: number, shouldDonate?: boolean | null, temperature: number, totalSolids: number, unit?: DonationUnit | null, failedReason?: DonationFailedReason | null, actual?: number | null, weatherTemperature: number, weatherTypes: Array<WeatherType>, weight: number, examinationNotes?: string | null, preferences?: string | null, createdAt: any, comment?: string | null, shortId: number, donationDate: any, ineligible: boolean, ineligibleReason?: IneligibleReason | null, ineligibleReasonDetails?: string | null, products?: Array<{ __typename?: 'DonationProductOutput', anticoagulant?: Anticoagulant | null, createdAt: any, id: string, shortId: number, status: ProductStatus, storageRequirements: Array<string>, updatedAt: any, value: number, woocommerceProductId: number, woocommerceCategoryId: number, expirationDate: any, discardedProduct?: { __typename?: 'DiscardedProductDataOutput', processingType: ProcessingProductType, reason: ReasonDiscardProduct, notes?: string | null } | null, bloodIdentifiers?: Array<{ __typename?: 'BloodUnitIdentifiersOutput', unitId?: number | null, product?: { __typename?: 'ProductOutput', id: string, shortId: number } | null }> | null }> | null, donor: { __typename?: 'DonationDonor', id: string, age: number, gender: AnimalGender, hasTransfusion?: boolean | null, name: string, neutered: boolean, primaryVeterinarian: string, species: AnimalSpecies, takeMedications?: boolean | null, weight: number, bloodType?: BloodType | null, status: DonorStatus, type: DonorType, location: string, distinguishableMarks?: string | null, microchipNumber?: string | null, medicationCourse?: string | null, comment?: string | null, breed?: string | null, color?: string | null, createdAt: any, shortId: number, firstCertificatePrinted: boolean, secondCertificatePrinted: boolean, lastDonationDate?: any | null, lastLabworkDate?: any | null, nextDonationDate?: any | null, team?: { __typename?: 'TeamOutput', id: string, title: string } | null, user?: { __typename?: 'HolderOutput', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number } | null, pictures?: Array<{ __typename?: 'DonorPictureOutput', id: string, isPrimary: boolean, file: { __typename?: 'FileOutput', id: string, filename: string } }> | null }, additionalInfo?: { __typename?: 'AdditionalDonationInfoOutput', id: string, numberOfCollectionUnitsUsed: CollectionUnitsUsed, veinUsed: VeinUsed, vascularStructure?: VascularStructure | null, flowRate: FlowRate, donationPosition?: string | null, holdersPosition?: Array<string> | null, donorMovement: string, typeOfMovement?: string | null, emotionalSupport?: Array<string> | null, dislikes?: Array<string> | null, likes?: Array<string> | null, treatPreferences?: Array<string> | null, totalCollectedMls?: number | null, primaryHolder?: { __typename?: 'HolderOutput', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number } | null, secondaryHolder?: { __typename?: 'HolderOutput', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number } | null, poker?: { __typename?: 'HolderOutput', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number } | null } | null } };

export type GetDonationListQueryVariables = Exact<{
  input: GetDonationsListInput;
}>;


export type GetDonationListQuery = { __typename?: 'Query', getDonationsList: { __typename?: 'DonationListOutput', data: Array<{ __typename?: 'DonationOutput', id: string, collectionSet: CollectionSet, capillaryRefillTime: CapillaryRefillTime, approvedDonationsMl: number, jugularVein: JugularVein, maxLimit: number, mucousMembrane: Mm, packedCellVolume: number, pulse: number, respiration: number, shouldDonate?: boolean | null, temperature: number, totalSolids: number, unit?: DonationUnit | null, failedReason?: DonationFailedReason | null, actual?: number | null, weatherTemperature: number, weatherTypes: Array<WeatherType>, weight: number, examinationNotes?: string | null, preferences?: string | null, createdAt: any, comment?: string | null, shortId: number, donationDate: any, ineligible: boolean, ineligibleReason?: IneligibleReason | null, ineligibleReasonDetails?: string | null, products?: Array<{ __typename?: 'DonationProductOutput', anticoagulant?: Anticoagulant | null, createdAt: any, id: string, shortId: number, status: ProductStatus, storageRequirements: Array<string>, updatedAt: any, value: number, woocommerceProductId: number, woocommerceCategoryId: number, expirationDate: any, discardedProduct?: { __typename?: 'DiscardedProductDataOutput', processingType: ProcessingProductType, reason: ReasonDiscardProduct, notes?: string | null } | null, bloodIdentifiers?: Array<{ __typename?: 'BloodUnitIdentifiersOutput', unitId?: number | null, product?: { __typename?: 'ProductOutput', id: string, shortId: number } | null }> | null }> | null, donor: { __typename?: 'DonationDonor', id: string, age: number, gender: AnimalGender, hasTransfusion?: boolean | null, name: string, neutered: boolean, primaryVeterinarian: string, species: AnimalSpecies, takeMedications?: boolean | null, weight: number, bloodType?: BloodType | null, status: DonorStatus, type: DonorType, location: string, distinguishableMarks?: string | null, microchipNumber?: string | null, medicationCourse?: string | null, comment?: string | null, breed?: string | null, color?: string | null, createdAt: any, shortId: number, firstCertificatePrinted: boolean, secondCertificatePrinted: boolean, lastDonationDate?: any | null, lastLabworkDate?: any | null, nextDonationDate?: any | null, team?: { __typename?: 'TeamOutput', id: string, title: string } | null, user?: { __typename?: 'HolderOutput', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number } | null, pictures?: Array<{ __typename?: 'DonorPictureOutput', id: string, isPrimary: boolean, file: { __typename?: 'FileOutput', id: string, filename: string } }> | null }, additionalInfo?: { __typename?: 'AdditionalDonationInfoOutput', id: string, numberOfCollectionUnitsUsed: CollectionUnitsUsed, veinUsed: VeinUsed, vascularStructure?: VascularStructure | null, flowRate: FlowRate, donationPosition?: string | null, holdersPosition?: Array<string> | null, donorMovement: string, typeOfMovement?: string | null, emotionalSupport?: Array<string> | null, dislikes?: Array<string> | null, likes?: Array<string> | null, treatPreferences?: Array<string> | null, totalCollectedMls?: number | null, primaryHolder?: { __typename?: 'HolderOutput', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number } | null, secondaryHolder?: { __typename?: 'HolderOutput', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number } | null, poker?: { __typename?: 'HolderOutput', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number } | null } | null }>, meta: { __typename?: 'MetaData', total: number } } };

export type GetSpecificDonorDonationsListQueryVariables = Exact<{
  input: GetSpecificDonorDonationsListInput;
}>;


export type GetSpecificDonorDonationsListQuery = { __typename?: 'Query', getSpecificDonorDonationsList: { __typename?: 'DonationListOutput', data: Array<{ __typename?: 'DonationOutput', id: string, collectionSet: CollectionSet, capillaryRefillTime: CapillaryRefillTime, approvedDonationsMl: number, jugularVein: JugularVein, maxLimit: number, mucousMembrane: Mm, packedCellVolume: number, pulse: number, respiration: number, shouldDonate?: boolean | null, temperature: number, totalSolids: number, unit?: DonationUnit | null, failedReason?: DonationFailedReason | null, actual?: number | null, weatherTemperature: number, weatherTypes: Array<WeatherType>, weight: number, examinationNotes?: string | null, preferences?: string | null, createdAt: any, comment?: string | null, shortId: number, donationDate: any, ineligible: boolean, ineligibleReason?: IneligibleReason | null, ineligibleReasonDetails?: string | null, products?: Array<{ __typename?: 'DonationProductOutput', anticoagulant?: Anticoagulant | null, createdAt: any, id: string, shortId: number, status: ProductStatus, storageRequirements: Array<string>, updatedAt: any, value: number, woocommerceProductId: number, woocommerceCategoryId: number, expirationDate: any, discardedProduct?: { __typename?: 'DiscardedProductDataOutput', processingType: ProcessingProductType, reason: ReasonDiscardProduct, notes?: string | null } | null, bloodIdentifiers?: Array<{ __typename?: 'BloodUnitIdentifiersOutput', unitId?: number | null, product?: { __typename?: 'ProductOutput', id: string, shortId: number } | null }> | null }> | null, donor: { __typename?: 'DonationDonor', id: string, age: number, gender: AnimalGender, hasTransfusion?: boolean | null, name: string, neutered: boolean, primaryVeterinarian: string, species: AnimalSpecies, takeMedications?: boolean | null, weight: number, bloodType?: BloodType | null, status: DonorStatus, type: DonorType, location: string, distinguishableMarks?: string | null, microchipNumber?: string | null, medicationCourse?: string | null, comment?: string | null, breed?: string | null, color?: string | null, createdAt: any, shortId: number, firstCertificatePrinted: boolean, secondCertificatePrinted: boolean, lastDonationDate?: any | null, lastLabworkDate?: any | null, nextDonationDate?: any | null, team?: { __typename?: 'TeamOutput', id: string, title: string } | null, user?: { __typename?: 'HolderOutput', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number } | null, pictures?: Array<{ __typename?: 'DonorPictureOutput', id: string, isPrimary: boolean, file: { __typename?: 'FileOutput', id: string, filename: string } }> | null }, additionalInfo?: { __typename?: 'AdditionalDonationInfoOutput', id: string, numberOfCollectionUnitsUsed: CollectionUnitsUsed, veinUsed: VeinUsed, vascularStructure?: VascularStructure | null, flowRate: FlowRate, donationPosition?: string | null, holdersPosition?: Array<string> | null, donorMovement: string, typeOfMovement?: string | null, emotionalSupport?: Array<string> | null, dislikes?: Array<string> | null, likes?: Array<string> | null, treatPreferences?: Array<string> | null, totalCollectedMls?: number | null, primaryHolder?: { __typename?: 'HolderOutput', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number } | null, secondaryHolder?: { __typename?: 'HolderOutput', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number } | null, poker?: { __typename?: 'HolderOutput', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number } | null } | null }>, meta: { __typename?: 'MetaData', total: number } } };

export type GetDonationsListForAnalyticsQueryVariables = Exact<{
  input: DonationsAnalyticsInput;
}>;


export type GetDonationsListForAnalyticsQuery = { __typename?: 'Query', getDonationsListForAnalytics: { __typename?: 'DonationListOutput', data: Array<{ __typename?: 'DonationOutput', id: string, collectionSet: CollectionSet, capillaryRefillTime: CapillaryRefillTime, approvedDonationsMl: number, jugularVein: JugularVein, maxLimit: number, mucousMembrane: Mm, packedCellVolume: number, pulse: number, respiration: number, shouldDonate?: boolean | null, temperature: number, totalSolids: number, unit?: DonationUnit | null, failedReason?: DonationFailedReason | null, actual?: number | null, weatherTemperature: number, weatherTypes: Array<WeatherType>, weight: number, examinationNotes?: string | null, preferences?: string | null, createdAt: any, comment?: string | null, shortId: number, donationDate: any, ineligible: boolean, ineligibleReason?: IneligibleReason | null, ineligibleReasonDetails?: string | null, products?: Array<{ __typename?: 'DonationProductOutput', anticoagulant?: Anticoagulant | null, createdAt: any, id: string, shortId: number, status: ProductStatus, storageRequirements: Array<string>, updatedAt: any, value: number, woocommerceProductId: number, woocommerceCategoryId: number, expirationDate: any, discardedProduct?: { __typename?: 'DiscardedProductDataOutput', processingType: ProcessingProductType, reason: ReasonDiscardProduct, notes?: string | null } | null, bloodIdentifiers?: Array<{ __typename?: 'BloodUnitIdentifiersOutput', unitId?: number | null, product?: { __typename?: 'ProductOutput', id: string, shortId: number } | null }> | null }> | null, donor: { __typename?: 'DonationDonor', id: string, age: number, gender: AnimalGender, hasTransfusion?: boolean | null, name: string, neutered: boolean, primaryVeterinarian: string, species: AnimalSpecies, takeMedications?: boolean | null, weight: number, bloodType?: BloodType | null, status: DonorStatus, type: DonorType, location: string, distinguishableMarks?: string | null, microchipNumber?: string | null, medicationCourse?: string | null, comment?: string | null, breed?: string | null, color?: string | null, createdAt: any, shortId: number, firstCertificatePrinted: boolean, secondCertificatePrinted: boolean, lastDonationDate?: any | null, lastLabworkDate?: any | null, nextDonationDate?: any | null, team?: { __typename?: 'TeamOutput', id: string, title: string } | null, user?: { __typename?: 'HolderOutput', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number } | null, pictures?: Array<{ __typename?: 'DonorPictureOutput', id: string, isPrimary: boolean, file: { __typename?: 'FileOutput', id: string, filename: string } }> | null }, additionalInfo?: { __typename?: 'AdditionalDonationInfoOutput', id: string, numberOfCollectionUnitsUsed: CollectionUnitsUsed, veinUsed: VeinUsed, vascularStructure?: VascularStructure | null, flowRate: FlowRate, donationPosition?: string | null, holdersPosition?: Array<string> | null, donorMovement: string, typeOfMovement?: string | null, emotionalSupport?: Array<string> | null, dislikes?: Array<string> | null, likes?: Array<string> | null, treatPreferences?: Array<string> | null, totalCollectedMls?: number | null, primaryHolder?: { __typename?: 'HolderOutput', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number } | null, secondaryHolder?: { __typename?: 'HolderOutput', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number } | null, poker?: { __typename?: 'HolderOutput', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number } | null } | null }>, meta: { __typename?: 'MetaData', total: number } } };

export type GetPhlebotomistStatsQueryVariables = Exact<{
  input: GetPhlebotomistStatsInput;
}>;


export type GetPhlebotomistStatsQuery = { __typename?: 'Query', getPhlebotomistStats: Array<{ __typename?: 'PhlebotomistStatsOutput', phlebotomistId: string, phlebotomistName: string, phlebotomistEmail?: string | null, regionId?: string | null, regionName?: string | null, locationPreference?: string | null, assignedOfficeId?: string | null, assignedOfficeName?: string | null, attemptedDonations: number, successfulDonations: number, pendingDonations: number, singleDonors: number, doubleDonors: number, successfulSingleDonors: number, successfulDoubleDonors: number, expectedTotal: number, expectedPRBC: number, expectedPRBCSingle: number, expectedPRBCDouble: number, expectedFFPSingle: number, expectedFFPDouble: number, actualTotal: number, actualPRBC: number, actualPRBCSingle: number, actualPRBCDouble: number, actualFFPSingle: number, actualFFPDouble: number, dblDonorsSglYield: number, overallSuccessRate: number, prbcSuccessRate: number, sglDonorsSuccessRate: number, dblDonorsSuccessRate: number, teamCount: number, totalOfficeSuccessful: number, donationSharePercent: number, officeSharePercent: number, completelyFailedDonations: number, partiallyFailedDonations: number, completelyFailedDiscards: Array<{ __typename?: 'DiscardReasonCountOutput', reason: ReasonDiscardProduct, count: number }>, partiallyFailedDiscards: Array<{ __typename?: 'DiscardReasonCountOutput', reason: ReasonDiscardProduct, count: number }>, recentDonations: Array<{ __typename?: 'DonationRecordOutput', id: string, shortId: number, date: any, donorName: string, donorId: string, type: string, approvedML: number, actualML?: number | null, collectionSet?: string | null, veinSide?: string | null, donationUnit?: string | null, examinationNotes?: string | null, ineligibleReason?: string | null, expectedPRBC: number, expectedFFPSingle: number, expectedFFPDouble: number, actualPRBC: number, actualFFPSingle: number, actualFFPDouble: number, status: string, phlebotomistName: string, locationName: string, regionName: string, failureReasons: Array<string>, products: Array<{ __typename?: 'DonationProductRecordOutput', type: string, productId: number, status: string, orderId?: number | null, discardReason?: string | null }> }> }> };

export type GetPhlebotomistTrendStatsQueryVariables = Exact<{
  input: GetPhlebotomistTrendStatsInput;
}>;


export type GetPhlebotomistTrendStatsQuery = { __typename?: 'Query', getPhlebotomistTrendStats: Array<{ __typename?: 'PhlebotomistTrendStatsOutput', period: string, periodStart: any, periodEnd: any, attemptedDonations: number, successfulDonations: number, singleDonors: number, doubleDonors: number, successfulSingleDonors: number, successfulDoubleDonors: number, expectedTotal: number, expectedPRBC: number, expectedFFPSingle: number, expectedFFPDouble: number, actualTotal: number, actualPRBC: number, actualFFPSingle: number, actualFFPDouble: number, overallSuccessRate: number, prbcSuccessRate: number, sglDonorsSuccessRate: number, dblDonorsSuccessRate: number }> };

export type DonorFragment = { __typename?: 'DonorOutput', id: string, age: number, gender: AnimalGender, hasTransfusion?: boolean | null, name: string, neutered: boolean, primaryVeterinarian: string, species: AnimalSpecies, takeMedications?: boolean | null, weight: number, approvedDonationML: number, donationMLApprovedAmount?: number | null, bloodType?: BloodType | null, status: DonorStatus, type: DonorType, location: string, distinguishableMarks?: string | null, microchipNumber?: string | null, medicationCourse?: string | null, comment?: string | null, breed?: string | null, color?: string | null, createdAt: any, shortId: number, firstCertificatePrinted: boolean, secondCertificatePrinted: boolean, becameReservedDonorDate?: any | null, retiredDate?: any | null, distemperDate?: any | null, rabiesDate?: any | null, lastDonationDate?: any | null, nextDonationDate?: any | null, lastLabworkDate?: any | null, hasMicrochip?: boolean | null, acceptSimparicaTrio: boolean, isDaycare?: boolean | null, donationFrequency: number, canRegularlyAttendDaycare?: boolean | null, attendDaycareDays?: Array<string> | null, retiredReason?: RetiredReasons | null, retiredReasonComment?: string | null, dateOfBirth: any };

export type PartialDonorFragment = { __typename?: 'PartialDonorOutput', id?: string | null, age?: number | null, gender?: AnimalGender | null, hasTransfusion?: boolean | null, name?: string | null, neutered?: boolean | null, primaryVeterinarian?: string | null, species?: AnimalSpecies | null, takeMedications?: boolean | null, weight?: number | null, approvedDonationML?: number | null, donationMLApprovedAmount?: number | null, bloodType?: BloodType | null, status?: DonorStatus | null, type?: DonorType | null, location?: string | null, distinguishableMarks?: string | null, microchipNumber?: string | null, medicationCourse?: string | null, comment?: string | null, breed?: string | null, color?: string | null, createdAt?: any | null, shortId?: number | null, firstCertificatePrinted?: boolean | null, secondCertificatePrinted?: boolean | null, becameReservedDonorDate?: any | null, retiredDate?: any | null, distemperDate?: any | null, rabiesDate?: any | null, lastDonationDate?: any | null, nextDonationDate?: any | null, lastLabworkDate?: any | null, hasMicrochip?: boolean | null, acceptSimparicaTrio?: boolean | null, isDaycare?: boolean | null, donationFrequency?: number | null, canRegularlyAttendDaycare?: boolean | null, attendDaycareDays?: Array<string> | null, retiredReason?: RetiredReasons | null, retiredReasonComment?: string | null, dateOfBirth?: any | null };

export type TeamFragment = { __typename?: 'TeamOutput', id: string, title: string };

export type GroupTeamFragment = { __typename?: 'GroupTeamOutput', id: string, title: string };

export type GroupFragment = { __typename?: 'GroupOutput', id: string, title: string };

export type GroupListItemFragment = { __typename?: 'GroupListItemOutput', teamCount: number, donorCount?: number | null, title: string, id: string, user?: { __typename?: 'GroupListItemUserOutput', firstName: string, lastName: string, id: string } | null };

export type ReserveDonorNoteFragment = { __typename?: 'ReserveDonorNoteOutput', id: string, text: string, createdAt: any };

export type DonorNoteFragment = { __typename?: 'DonorNoteOutput', id: string, text: string, isPinned: boolean, createdAt: any, updatedAt: any, files: Array<{ __typename?: 'DonorNoteFileOutput', id: string, file: { __typename?: 'FileOutput', id: string, filename: string } }>, user: { __typename?: 'UserOutput', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number, type?: OwnerType | null, isArchived: boolean, deletionIntentionAt?: any | null, contactPreferences?: string | null, deletedAt?: any | null, assignedLocations?: Array<{ __typename?: 'LocationOutput', id: string, createdAt: any, updatedAt: any, name: string, type: LocationType, region?: { __typename?: 'RegionOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null } | null }> | null, assignedRegions?: Array<{ __typename?: 'RegionOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null }> | null, productRegionPreference?: { __typename?: 'RegionOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null } | null, assignedOffice?: { __typename?: 'OfficeOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null, region: { __typename?: 'RegionOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null } } | null } };

export type DonorBreedFragment = { __typename?: 'BreedOutput', id: string, species: AnimalSpecies, name: string };

export type LabworkFragment = { __typename?: 'LabworkOutput', id: string, collectionDate: any, status: LabworkStatus };

export type DvmExamFragment = { __typename?: 'DvmExamOutput', id: string, examinationDate: any, notes?: string | null, nextExamDue?: any | null, donorRegion?: string | null, donorLocation?: string | null };

export type PictureFragment = { __typename?: 'DonorPictureOutput', id: string, isPrimary: boolean, file: { __typename?: 'FileOutput', id: string, filename: string } };

export type FileFragment = { __typename?: 'FileOutput', id: string, filename: string };

export type VitalsParameterFragment = { __typename?: 'VitalsParameterOutput', id: string, criticalValues?: Array<string> | null, type: VitalsParametersType, max?: number | null, min?: number | null, percentageDifference?: number | null };

export type LabworkAttachmentFragment = { __typename?: 'LabworkAttachmentOutput', id: string, createdAt: any, updatedAt: any };

export type CreateDonorsForUserMutationVariables = Exact<{
  input: CreateDonorsForUserInput;
}>;


export type CreateDonorsForUserMutation = { __typename?: 'Mutation', createDonorsForUser: boolean };

export type CreateDonorsMutationVariables = Exact<{
  input: CreateDonors;
}>;


export type CreateDonorsMutation = { __typename?: 'Mutation', createDonors: boolean };

export type CreateDonorMutationVariables = Exact<{
  input: CreateDonorInput;
}>;


export type CreateDonorMutation = { __typename?: 'Mutation', createDonor: { __typename?: 'DonorOutput', id: string, age: number, gender: AnimalGender, hasTransfusion?: boolean | null, name: string, neutered: boolean, primaryVeterinarian: string, species: AnimalSpecies, takeMedications?: boolean | null, weight: number, approvedDonationML: number, donationMLApprovedAmount?: number | null, bloodType?: BloodType | null, status: DonorStatus, type: DonorType, location: string, distinguishableMarks?: string | null, microchipNumber?: string | null, medicationCourse?: string | null, comment?: string | null, breed?: string | null, color?: string | null, createdAt: any, shortId: number, firstCertificatePrinted: boolean, secondCertificatePrinted: boolean, becameReservedDonorDate?: any | null, retiredDate?: any | null, distemperDate?: any | null, rabiesDate?: any | null, lastDonationDate?: any | null, nextDonationDate?: any | null, lastLabworkDate?: any | null, hasMicrochip?: boolean | null, acceptSimparicaTrio: boolean, isDaycare?: boolean | null, donationFrequency: number, canRegularlyAttendDaycare?: boolean | null, attendDaycareDays?: Array<string> | null, retiredReason?: RetiredReasons | null, retiredReasonComment?: string | null, dateOfBirth: any, team?: { __typename?: 'TeamOutput', id: string, title: string } | null, user?: { __typename?: 'OwnerOutput', email: string, id: string, firstName: string, lastName: string, hasMultipleDonors?: boolean | null, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number, type?: OwnerType | null, isArchived: boolean, contactPreferences?: string | null, createdAt: any, deletedAt?: any | null, contacts?: Array<{ __typename?: 'ContactOutput', streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, email?: string | null, firstName?: string | null, id: string, lastName?: string | null, phoneNumber?: string | null }> | null } | null, reserveNotes?: Array<{ __typename?: 'ReserveDonorNoteOutput', id: string, text: string, createdAt: any }> | null } };

export type UpdateGroupMutationVariables = Exact<{
  input: UpdateGroupInput;
}>;


export type UpdateGroupMutation = { __typename?: 'Mutation', updateGroup: { __typename?: 'GroupOutput', title: string } };

export type UpdateTeamMutationVariables = Exact<{
  input: UpdateTeamInput;
}>;


export type UpdateTeamMutation = { __typename?: 'Mutation', updateTeam: { __typename?: 'TeamOutput', title: string } };

export type RemoveGroupMutationVariables = Exact<{
  input: RemoveGroupInput;
}>;


export type RemoveGroupMutation = { __typename?: 'Mutation', removeGroup: boolean };

export type CreateTeamMutationVariables = Exact<{
  input: CreateTeamInput;
}>;


export type CreateTeamMutation = { __typename?: 'Mutation', createTeam: { __typename?: 'TeamOutput', id: string } };

export type RemoveTeamMutationVariables = Exact<{
  input: RemoveTeamInput;
}>;


export type RemoveTeamMutation = { __typename?: 'Mutation', removeTeam: boolean };

export type RemoveDonorMutationVariables = Exact<{
  input: DeleteDonorInput;
}>;


export type RemoveDonorMutation = { __typename?: 'Mutation', deleteDonor: boolean };

export type CreateGroupMutationVariables = Exact<{
  input: CreateGroupInput;
}>;


export type CreateGroupMutation = { __typename?: 'Mutation', createGroup: { __typename?: 'GroupOutput', id: string } };

export type InviteOwnerWithDonorMutationVariables = Exact<{
  input: InviteOwnerWithDonorInput;
}>;


export type InviteOwnerWithDonorMutation = { __typename?: 'Mutation', inviteOwnerWithDonor: boolean };

export type CreateDonorForUserMutationVariables = Exact<{
  input: CreateDonorForUserInput;
}>;


export type CreateDonorForUserMutation = { __typename?: 'Mutation', createDonorForUser: { __typename?: 'DonorOutput', id: string, age: number, gender: AnimalGender, hasTransfusion?: boolean | null, name: string, neutered: boolean, primaryVeterinarian: string, species: AnimalSpecies, takeMedications?: boolean | null, weight: number, approvedDonationML: number, donationMLApprovedAmount?: number | null, bloodType?: BloodType | null, status: DonorStatus, type: DonorType, location: string, distinguishableMarks?: string | null, microchipNumber?: string | null, medicationCourse?: string | null, comment?: string | null, breed?: string | null, color?: string | null, createdAt: any, shortId: number, firstCertificatePrinted: boolean, secondCertificatePrinted: boolean, becameReservedDonorDate?: any | null, retiredDate?: any | null, distemperDate?: any | null, rabiesDate?: any | null, lastDonationDate?: any | null, nextDonationDate?: any | null, lastLabworkDate?: any | null, hasMicrochip?: boolean | null, acceptSimparicaTrio: boolean, isDaycare?: boolean | null, donationFrequency: number, canRegularlyAttendDaycare?: boolean | null, attendDaycareDays?: Array<string> | null, retiredReason?: RetiredReasons | null, retiredReasonComment?: string | null, dateOfBirth: any, team?: { __typename?: 'TeamOutput', id: string, title: string } | null, user?: { __typename?: 'OwnerOutput', email: string, id: string, firstName: string, lastName: string, hasMultipleDonors?: boolean | null, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number, type?: OwnerType | null, isArchived: boolean, contactPreferences?: string | null, createdAt: any, deletedAt?: any | null, contacts?: Array<{ __typename?: 'ContactOutput', streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, email?: string | null, firstName?: string | null, id: string, lastName?: string | null, phoneNumber?: string | null }> | null } | null, reserveNotes?: Array<{ __typename?: 'ReserveDonorNoteOutput', id: string, text: string, createdAt: any }> | null } };

export type UpdateDonorMutationVariables = Exact<{
  input: UpdateDonorInput;
}>;


export type UpdateDonorMutation = { __typename?: 'Mutation', updateDonor: { __typename?: 'DonorOutput', id: string, age: number, gender: AnimalGender, hasTransfusion?: boolean | null, name: string, neutered: boolean, primaryVeterinarian: string, species: AnimalSpecies, takeMedications?: boolean | null, weight: number, approvedDonationML: number, donationMLApprovedAmount?: number | null, bloodType?: BloodType | null, status: DonorStatus, type: DonorType, location: string, distinguishableMarks?: string | null, microchipNumber?: string | null, medicationCourse?: string | null, comment?: string | null, breed?: string | null, color?: string | null, createdAt: any, shortId: number, firstCertificatePrinted: boolean, secondCertificatePrinted: boolean, becameReservedDonorDate?: any | null, retiredDate?: any | null, distemperDate?: any | null, rabiesDate?: any | null, lastDonationDate?: any | null, nextDonationDate?: any | null, lastLabworkDate?: any | null, hasMicrochip?: boolean | null, acceptSimparicaTrio: boolean, isDaycare?: boolean | null, donationFrequency: number, canRegularlyAttendDaycare?: boolean | null, attendDaycareDays?: Array<string> | null, retiredReason?: RetiredReasons | null, retiredReasonComment?: string | null, dateOfBirth: any, team?: { __typename?: 'TeamOutput', id: string, title: string } | null, user?: { __typename?: 'OwnerOutput', email: string, id: string, firstName: string, lastName: string, hasMultipleDonors?: boolean | null, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number, type?: OwnerType | null, isArchived: boolean, contactPreferences?: string | null, createdAt: any, deletedAt?: any | null, contacts?: Array<{ __typename?: 'ContactOutput', streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, email?: string | null, firstName?: string | null, id: string, lastName?: string | null, phoneNumber?: string | null }> | null } | null, reserveNotes?: Array<{ __typename?: 'ReserveDonorNoteOutput', id: string, text: string, createdAt: any }> | null } };

export type AddNoteToReserveDonorMutationVariables = Exact<{
  input: CreateDonorNoteInput;
}>;


export type AddNoteToReserveDonorMutation = { __typename?: 'Mutation', addNoteToReserveDonor: { __typename?: 'ReserveDonorNoteOutput', id: string, text: string, createdAt: any } };

export type UpdateReserveDonorNoteMutationVariables = Exact<{
  input: UpdateDonorNoteInput;
}>;


export type UpdateReserveDonorNoteMutation = { __typename?: 'Mutation', updateReserveDonorNote: { __typename?: 'ReserveDonorNoteOutput', id: string, text: string, createdAt: any } };

export type DeleteReserveDonorNoteMutationVariables = Exact<{
  input: DeleteDonorNoteInput;
}>;


export type DeleteReserveDonorNoteMutation = { __typename?: 'Mutation', deleteReserveDonorNote: boolean };

export type UpdateLabworkMutationVariables = Exact<{
  input: UpdateLabworkInput;
}>;


export type UpdateLabworkMutation = { __typename?: 'Mutation', updateLabwork: { __typename?: 'LabworkOutput', id: string, collectionDate: any, status: LabworkStatus, donor: { __typename?: 'DonorOutput', id: string, age: number, gender: AnimalGender, hasTransfusion?: boolean | null, name: string, neutered: boolean, primaryVeterinarian: string, species: AnimalSpecies, takeMedications?: boolean | null, weight: number, approvedDonationML: number, donationMLApprovedAmount?: number | null, bloodType?: BloodType | null, status: DonorStatus, type: DonorType, location: string, distinguishableMarks?: string | null, microchipNumber?: string | null, medicationCourse?: string | null, comment?: string | null, breed?: string | null, color?: string | null, createdAt: any, shortId: number, firstCertificatePrinted: boolean, secondCertificatePrinted: boolean, becameReservedDonorDate?: any | null, retiredDate?: any | null, distemperDate?: any | null, rabiesDate?: any | null, lastDonationDate?: any | null, nextDonationDate?: any | null, lastLabworkDate?: any | null, hasMicrochip?: boolean | null, acceptSimparicaTrio: boolean, isDaycare?: boolean | null, donationFrequency: number, canRegularlyAttendDaycare?: boolean | null, attendDaycareDays?: Array<string> | null, retiredReason?: RetiredReasons | null, retiredReasonComment?: string | null, dateOfBirth: any, user?: { __typename?: 'OwnerOutput', email: string, id: string, firstName: string, lastName: string, hasMultipleDonors?: boolean | null, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number, type?: OwnerType | null, isArchived: boolean, contactPreferences?: string | null, createdAt: any, deletedAt?: any | null } | null } } };

export type UpdateDvmExamMutationVariables = Exact<{
  input: UpdateDvmExamInput;
}>;


export type UpdateDvmExamMutation = { __typename?: 'Mutation', updateDvmExam: { __typename?: 'DvmExamOutput', id: string, examinationDate: any, notes?: string | null, nextExamDue?: any | null, donorRegion?: string | null, donorLocation?: string | null, performedBy: { __typename?: 'UserOutput', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number, type?: OwnerType | null, isArchived: boolean, deletionIntentionAt?: any | null, contactPreferences?: string | null, deletedAt?: any | null, assignedLocations?: Array<{ __typename?: 'LocationOutput', id: string, createdAt: any, updatedAt: any, name: string, type: LocationType, region?: { __typename?: 'RegionOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null } | null }> | null, assignedRegions?: Array<{ __typename?: 'RegionOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null }> | null, productRegionPreference?: { __typename?: 'RegionOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null } | null, assignedOffice?: { __typename?: 'OfficeOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null, region: { __typename?: 'RegionOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null } } | null } } };

export type UpdateLabworkStatusMutationVariables = Exact<{
  input: UpdateLabworkStatusInput;
}>;


export type UpdateLabworkStatusMutation = { __typename?: 'Mutation', updateLabworkStatus: { __typename?: 'LabworkOutput', id: string, collectionDate: any, status: LabworkStatus, donor: { __typename?: 'DonorOutput', id: string, age: number, gender: AnimalGender, hasTransfusion?: boolean | null, name: string, neutered: boolean, primaryVeterinarian: string, species: AnimalSpecies, takeMedications?: boolean | null, weight: number, approvedDonationML: number, donationMLApprovedAmount?: number | null, bloodType?: BloodType | null, status: DonorStatus, type: DonorType, location: string, distinguishableMarks?: string | null, microchipNumber?: string | null, medicationCourse?: string | null, comment?: string | null, breed?: string | null, color?: string | null, createdAt: any, shortId: number, firstCertificatePrinted: boolean, secondCertificatePrinted: boolean, becameReservedDonorDate?: any | null, retiredDate?: any | null, distemperDate?: any | null, rabiesDate?: any | null, lastDonationDate?: any | null, nextDonationDate?: any | null, lastLabworkDate?: any | null, hasMicrochip?: boolean | null, acceptSimparicaTrio: boolean, isDaycare?: boolean | null, donationFrequency: number, canRegularlyAttendDaycare?: boolean | null, attendDaycareDays?: Array<string> | null, retiredReason?: RetiredReasons | null, retiredReasonComment?: string | null, dateOfBirth: any, user?: { __typename?: 'OwnerOutput', email: string, id: string, firstName: string, lastName: string, hasMultipleDonors?: boolean | null, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number, type?: OwnerType | null, isArchived: boolean, contactPreferences?: string | null, createdAt: any, deletedAt?: any | null } | null } } };

export type CreateLabworkMutationVariables = Exact<{
  input: CreateLabworkInput;
}>;


export type CreateLabworkMutation = { __typename?: 'Mutation', createLabwork: { __typename?: 'LabworkOutput', id: string, collectionDate: any, status: LabworkStatus, donor: { __typename?: 'DonorOutput', id: string, age: number, gender: AnimalGender, hasTransfusion?: boolean | null, name: string, neutered: boolean, primaryVeterinarian: string, species: AnimalSpecies, takeMedications?: boolean | null, weight: number, approvedDonationML: number, donationMLApprovedAmount?: number | null, bloodType?: BloodType | null, status: DonorStatus, type: DonorType, location: string, distinguishableMarks?: string | null, microchipNumber?: string | null, medicationCourse?: string | null, comment?: string | null, breed?: string | null, color?: string | null, createdAt: any, shortId: number, firstCertificatePrinted: boolean, secondCertificatePrinted: boolean, becameReservedDonorDate?: any | null, retiredDate?: any | null, distemperDate?: any | null, rabiesDate?: any | null, lastDonationDate?: any | null, nextDonationDate?: any | null, lastLabworkDate?: any | null, hasMicrochip?: boolean | null, acceptSimparicaTrio: boolean, isDaycare?: boolean | null, donationFrequency: number, canRegularlyAttendDaycare?: boolean | null, attendDaycareDays?: Array<string> | null, retiredReason?: RetiredReasons | null, retiredReasonComment?: string | null, dateOfBirth: any, user?: { __typename?: 'OwnerOutput', email: string, id: string, firstName: string, lastName: string, hasMultipleDonors?: boolean | null, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number, type?: OwnerType | null, isArchived: boolean, contactPreferences?: string | null, createdAt: any, deletedAt?: any | null } | null } } };

export type CreateDvmExamMutationVariables = Exact<{
  input: CreateDvmExamInput;
}>;


export type CreateDvmExamMutation = { __typename?: 'Mutation', createDvmExam: { __typename?: 'DvmExamOutput', id: string, examinationDate: any, notes?: string | null, nextExamDue?: any | null, donorRegion?: string | null, donorLocation?: string | null, performedBy: { __typename?: 'UserOutput', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number, type?: OwnerType | null, isArchived: boolean, deletionIntentionAt?: any | null, contactPreferences?: string | null, deletedAt?: any | null, assignedLocations?: Array<{ __typename?: 'LocationOutput', id: string, createdAt: any, updatedAt: any, name: string, type: LocationType, region?: { __typename?: 'RegionOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null } | null }> | null, assignedRegions?: Array<{ __typename?: 'RegionOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null }> | null, productRegionPreference?: { __typename?: 'RegionOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null } | null, assignedOffice?: { __typename?: 'OfficeOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null, region: { __typename?: 'RegionOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null } } | null } } };

export type ShareLabworkResultsMutationVariables = Exact<{
  input: ShareLabworkResultsWithOwnerInput;
}>;


export type ShareLabworkResultsMutation = { __typename?: 'Mutation', shareLabworkResults: boolean };

export type RemoveLabworkMutationVariables = Exact<{
  input: RemoveLabworkInput;
}>;


export type RemoveLabworkMutation = { __typename?: 'Mutation', removeLabwork: boolean };

export type RemoveDvmExamMutationVariables = Exact<{
  input: RemoveDvmExamInput;
}>;


export type RemoveDvmExamMutation = { __typename?: 'Mutation', removeDvmExam: boolean };

export type DetachLabworkFileMutationVariables = Exact<{
  input: DetachLabworkFileInput;
}>;


export type DetachLabworkFileMutation = { __typename?: 'Mutation', detachLabworkFile: boolean };

export type UpdateVitalsParametersListMutationVariables = Exact<{
  input: UpdateVitalsParametersListInput;
}>;


export type UpdateVitalsParametersListMutation = { __typename?: 'Mutation', updateVitalsParameterList: Array<{ __typename?: 'VitalsParameterOutput', id: string, criticalValues?: Array<string> | null, type: VitalsParametersType, max?: number | null, min?: number | null, percentageDifference?: number | null }> };

export type UpdateDonorsOwnerMutationVariables = Exact<{
  input: UpdateDonorsOwnerInput;
}>;


export type UpdateDonorsOwnerMutation = { __typename?: 'Mutation', updateDonorsOwner?: { __typename?: 'DonorOutput', id: string, age: number, gender: AnimalGender, hasTransfusion?: boolean | null, name: string, neutered: boolean, primaryVeterinarian: string, species: AnimalSpecies, takeMedications?: boolean | null, weight: number, approvedDonationML: number, donationMLApprovedAmount?: number | null, bloodType?: BloodType | null, status: DonorStatus, type: DonorType, location: string, distinguishableMarks?: string | null, microchipNumber?: string | null, medicationCourse?: string | null, comment?: string | null, breed?: string | null, color?: string | null, createdAt: any, shortId: number, firstCertificatePrinted: boolean, secondCertificatePrinted: boolean, becameReservedDonorDate?: any | null, retiredDate?: any | null, distemperDate?: any | null, rabiesDate?: any | null, lastDonationDate?: any | null, nextDonationDate?: any | null, lastLabworkDate?: any | null, hasMicrochip?: boolean | null, acceptSimparicaTrio: boolean, isDaycare?: boolean | null, donationFrequency: number, canRegularlyAttendDaycare?: boolean | null, attendDaycareDays?: Array<string> | null, retiredReason?: RetiredReasons | null, retiredReasonComment?: string | null, dateOfBirth: any, team?: { __typename?: 'TeamOutput', id: string, title: string } | null, user?: { __typename?: 'OwnerOutput', email: string, id: string, firstName: string, lastName: string, hasMultipleDonors?: boolean | null, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number, type?: OwnerType | null, isArchived: boolean, contactPreferences?: string | null, createdAt: any, deletedAt?: any | null, contacts?: Array<{ __typename?: 'ContactOutput', streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, email?: string | null, firstName?: string | null, id: string, lastName?: string | null, phoneNumber?: string | null }> | null } | null, reserveNotes?: Array<{ __typename?: 'ReserveDonorNoteOutput', id: string, text: string, createdAt: any }> | null } | null };

export type UpdateGroupOwnerMutationVariables = Exact<{
  input: UpdateGroupOwnerInput;
}>;


export type UpdateGroupOwnerMutation = { __typename?: 'Mutation', updateGroupOwner?: { __typename?: 'GroupOutput', id: string, title: string, teams: Array<{ __typename?: 'TeamOutput', id: string, title: string, donors?: Array<{ __typename?: 'DonorOutput', id: string, age: number, gender: AnimalGender, hasTransfusion?: boolean | null, name: string, neutered: boolean, primaryVeterinarian: string, species: AnimalSpecies, takeMedications?: boolean | null, weight: number, approvedDonationML: number, donationMLApprovedAmount?: number | null, bloodType?: BloodType | null, status: DonorStatus, type: DonorType, location: string, distinguishableMarks?: string | null, microchipNumber?: string | null, medicationCourse?: string | null, comment?: string | null, breed?: string | null, color?: string | null, createdAt: any, shortId: number, firstCertificatePrinted: boolean, secondCertificatePrinted: boolean, becameReservedDonorDate?: any | null, retiredDate?: any | null, distemperDate?: any | null, rabiesDate?: any | null, lastDonationDate?: any | null, nextDonationDate?: any | null, lastLabworkDate?: any | null, hasMicrochip?: boolean | null, acceptSimparicaTrio: boolean, isDaycare?: boolean | null, donationFrequency: number, canRegularlyAttendDaycare?: boolean | null, attendDaycareDays?: Array<string> | null, retiredReason?: RetiredReasons | null, retiredReasonComment?: string | null, dateOfBirth: any }> | null }>, user?: { __typename?: 'OwnerOutput', email: string, id: string, firstName: string, lastName: string, hasMultipleDonors?: boolean | null, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number, type?: OwnerType | null, isArchived: boolean, contactPreferences?: string | null, createdAt: any, deletedAt?: any | null, contacts?: Array<{ __typename?: 'ContactOutput', streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, email?: string | null, firstName?: string | null, id: string, lastName?: string | null, phoneNumber?: string | null }> | null } | null } | null };

export type ManageDonorsInTeamMutationVariables = Exact<{
  input: ManageDonorsInTeamInput;
}>;


export type ManageDonorsInTeamMutation = { __typename?: 'Mutation', manageDonorsInTeam: boolean };

export type AddNoteMutationVariables = Exact<{
  input: CreateDonorNoteInput;
}>;


export type AddNoteMutation = { __typename?: 'Mutation', addNote: { __typename?: 'DonorNoteOutput', id: string, text: string, isPinned: boolean, createdAt: any, updatedAt: any, files: Array<{ __typename?: 'DonorNoteFileOutput', id: string, file: { __typename?: 'FileOutput', id: string, filename: string } }>, user: { __typename?: 'UserOutput', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number, type?: OwnerType | null, isArchived: boolean, deletionIntentionAt?: any | null, contactPreferences?: string | null, deletedAt?: any | null, assignedLocations?: Array<{ __typename?: 'LocationOutput', id: string, createdAt: any, updatedAt: any, name: string, type: LocationType, region?: { __typename?: 'RegionOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null } | null }> | null, assignedRegions?: Array<{ __typename?: 'RegionOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null }> | null, productRegionPreference?: { __typename?: 'RegionOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null } | null, assignedOffice?: { __typename?: 'OfficeOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null, region: { __typename?: 'RegionOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null } } | null } } };

export type UpdateNoteMutationVariables = Exact<{
  input: UpdateDonorNoteInput;
}>;


export type UpdateNoteMutation = { __typename?: 'Mutation', updateNote: { __typename?: 'DonorNoteOutput', id: string, text: string, isPinned: boolean, createdAt: any, updatedAt: any, files: Array<{ __typename?: 'DonorNoteFileOutput', id: string, file: { __typename?: 'FileOutput', id: string, filename: string } }>, user: { __typename?: 'UserOutput', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number, type?: OwnerType | null, isArchived: boolean, deletionIntentionAt?: any | null, contactPreferences?: string | null, deletedAt?: any | null, assignedLocations?: Array<{ __typename?: 'LocationOutput', id: string, createdAt: any, updatedAt: any, name: string, type: LocationType, region?: { __typename?: 'RegionOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null } | null }> | null, assignedRegions?: Array<{ __typename?: 'RegionOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null }> | null, productRegionPreference?: { __typename?: 'RegionOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null } | null, assignedOffice?: { __typename?: 'OfficeOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null, region: { __typename?: 'RegionOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null } } | null } } };

export type DeleteNoteMutationVariables = Exact<{
  input: DeleteDonorNoteInput;
}>;


export type DeleteNoteMutation = { __typename?: 'Mutation', deleteNote: boolean };

export type MakeDonorPicturePrimaryMutationVariables = Exact<{
  input: MakePicturePrimaryInput;
}>;


export type MakeDonorPicturePrimaryMutation = { __typename?: 'Mutation', makeDonorPicturePrimary: boolean };

export type ResetPrimaryDonorPicturesMutationVariables = Exact<{
  input: ResetPrimaryPicturesInput;
}>;


export type ResetPrimaryDonorPicturesMutation = { __typename?: 'Mutation', resetPrimaryDonorPictures: boolean };

export type CreateDonorContactMutationVariables = Exact<{
  input: CreateDonorContactInput;
}>;


export type CreateDonorContactMutation = { __typename?: 'Mutation', createDonorContact: { __typename?: 'DonorContactOutput', id: string, donorId: string, contactType: ContactType, notes?: string | null, followUpDate?: string | null, createdAt: string, user: { __typename?: 'DonorContactUserOutput', id: string, firstName: string, lastName: string } } };

export type DeleteDonorContactMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteDonorContactMutation = { __typename?: 'Mutation', deleteDonorContact: boolean };

export type UpsertDonorContactFlagMutationVariables = Exact<{
  donorId: Scalars['String'];
  flagValue: Scalars['String'];
}>;


export type UpsertDonorContactFlagMutation = { __typename?: 'Mutation', upsertDonorContactFlag: { __typename?: 'DonorContactOutput', id: string, donorId: string, contactType: ContactType, notes?: string | null, createdAt: string } };

export type GetDonorsListQueryVariables = Exact<{
  input: DonorsListInput;
}>;


export type GetDonorsListQuery = { __typename?: 'Query', getDonorsList: { __typename?: 'DonorsListOutput', data: Array<{ __typename?: 'DonorOutput', id: string, age: number, gender: AnimalGender, hasTransfusion?: boolean | null, name: string, neutered: boolean, primaryVeterinarian: string, species: AnimalSpecies, takeMedications?: boolean | null, weight: number, approvedDonationML: number, donationMLApprovedAmount?: number | null, bloodType?: BloodType | null, status: DonorStatus, type: DonorType, location: string, distinguishableMarks?: string | null, microchipNumber?: string | null, medicationCourse?: string | null, comment?: string | null, breed?: string | null, color?: string | null, createdAt: any, shortId: number, firstCertificatePrinted: boolean, secondCertificatePrinted: boolean, becameReservedDonorDate?: any | null, retiredDate?: any | null, distemperDate?: any | null, rabiesDate?: any | null, lastDonationDate?: any | null, nextDonationDate?: any | null, lastLabworkDate?: any | null, hasMicrochip?: boolean | null, acceptSimparicaTrio: boolean, isDaycare?: boolean | null, donationFrequency: number, canRegularlyAttendDaycare?: boolean | null, attendDaycareDays?: Array<string> | null, retiredReason?: RetiredReasons | null, retiredReasonComment?: string | null, dateOfBirth: any, team?: { __typename?: 'TeamOutput', id: string, title: string } | null, user?: { __typename?: 'OwnerOutput', email: string, id: string, firstName: string, lastName: string, hasMultipleDonors?: boolean | null, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number, type?: OwnerType | null, isArchived: boolean, contactPreferences?: string | null, createdAt: any, deletedAt?: any | null, contacts?: Array<{ __typename?: 'ContactOutput', streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, email?: string | null, firstName?: string | null, id: string, lastName?: string | null, phoneNumber?: string | null }> | null } | null, reserveNotes?: Array<{ __typename?: 'ReserveDonorNoteOutput', id: string, text: string, createdAt: any }> | null }>, meta: { __typename?: 'MetaData', total: number } } };

export type GetDvmExamListQueryVariables = Exact<{
  input: DvmExamInput;
}>;


export type GetDvmExamListQuery = { __typename?: 'Query', getDvmExamList: { __typename?: 'DvmExamListOutput', data: Array<{ __typename?: 'DvmExamOutput', id: string, examinationDate: any, notes?: string | null, nextExamDue?: any | null, donorRegion?: string | null, donorLocation?: string | null, performedBy: { __typename?: 'UserOutput', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number, type?: OwnerType | null, isArchived: boolean, deletionIntentionAt?: any | null, contactPreferences?: string | null, deletedAt?: any | null, assignedLocations?: Array<{ __typename?: 'LocationOutput', id: string, createdAt: any, updatedAt: any, name: string, type: LocationType, region?: { __typename?: 'RegionOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null } | null }> | null, assignedRegions?: Array<{ __typename?: 'RegionOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null }> | null, productRegionPreference?: { __typename?: 'RegionOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null } | null, assignedOffice?: { __typename?: 'OfficeOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null, region: { __typename?: 'RegionOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null } } | null }, donor: { __typename?: 'DonorOutput', id: string, age: number, gender: AnimalGender, hasTransfusion?: boolean | null, name: string, neutered: boolean, primaryVeterinarian: string, species: AnimalSpecies, takeMedications?: boolean | null, weight: number, approvedDonationML: number, donationMLApprovedAmount?: number | null, bloodType?: BloodType | null, status: DonorStatus, type: DonorType, location: string, distinguishableMarks?: string | null, microchipNumber?: string | null, medicationCourse?: string | null, comment?: string | null, breed?: string | null, color?: string | null, createdAt: any, shortId: number, firstCertificatePrinted: boolean, secondCertificatePrinted: boolean, becameReservedDonorDate?: any | null, retiredDate?: any | null, distemperDate?: any | null, rabiesDate?: any | null, lastDonationDate?: any | null, nextDonationDate?: any | null, lastLabworkDate?: any | null, hasMicrochip?: boolean | null, acceptSimparicaTrio: boolean, isDaycare?: boolean | null, donationFrequency: number, canRegularlyAttendDaycare?: boolean | null, attendDaycareDays?: Array<string> | null, retiredReason?: RetiredReasons | null, retiredReasonComment?: string | null, dateOfBirth: any, user?: { __typename?: 'OwnerOutput', email: string, id: string, firstName: string, lastName: string, hasMultipleDonors?: boolean | null, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number, type?: OwnerType | null, isArchived: boolean, contactPreferences?: string | null, createdAt: any, deletedAt?: any | null } | null } }>, meta: { __typename?: 'MetaData', total: number } } };

export type GetPetBreedsListQueryVariables = Exact<{
  input: PetBreedsListInput;
}>;


export type GetPetBreedsListQuery = { __typename?: 'Query', getPetBreedsList: { __typename?: 'PetBreedsListOutput', data: Array<{ __typename?: 'BreedOutput', id: string, species: AnimalSpecies, name: string }>, meta: { __typename?: 'MetaData', total: number } } };

export type GetDvmExamQueryVariables = Exact<{
  input: GetDvmExamInput;
}>;


export type GetDvmExamQuery = { __typename?: 'Query', getDvmExam: { __typename?: 'DvmExamOutput', id: string, examinationDate: any, notes?: string | null, nextExamDue?: any | null, donorRegion?: string | null, donorLocation?: string | null, performedBy: { __typename?: 'UserOutput', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number, type?: OwnerType | null, isArchived: boolean, deletionIntentionAt?: any | null, contactPreferences?: string | null, deletedAt?: any | null, assignedLocations?: Array<{ __typename?: 'LocationOutput', id: string, createdAt: any, updatedAt: any, name: string, type: LocationType, region?: { __typename?: 'RegionOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null } | null }> | null, assignedRegions?: Array<{ __typename?: 'RegionOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null }> | null, productRegionPreference?: { __typename?: 'RegionOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null } | null, assignedOffice?: { __typename?: 'OfficeOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null, region: { __typename?: 'RegionOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null } } | null }, donor: { __typename?: 'DonorOutput', id: string, age: number, gender: AnimalGender, hasTransfusion?: boolean | null, name: string, neutered: boolean, primaryVeterinarian: string, species: AnimalSpecies, takeMedications?: boolean | null, weight: number, approvedDonationML: number, donationMLApprovedAmount?: number | null, bloodType?: BloodType | null, status: DonorStatus, type: DonorType, location: string, distinguishableMarks?: string | null, microchipNumber?: string | null, medicationCourse?: string | null, comment?: string | null, breed?: string | null, color?: string | null, createdAt: any, shortId: number, firstCertificatePrinted: boolean, secondCertificatePrinted: boolean, becameReservedDonorDate?: any | null, retiredDate?: any | null, distemperDate?: any | null, rabiesDate?: any | null, lastDonationDate?: any | null, nextDonationDate?: any | null, lastLabworkDate?: any | null, hasMicrochip?: boolean | null, acceptSimparicaTrio: boolean, isDaycare?: boolean | null, donationFrequency: number, canRegularlyAttendDaycare?: boolean | null, attendDaycareDays?: Array<string> | null, retiredReason?: RetiredReasons | null, retiredReasonComment?: string | null, dateOfBirth: any, user?: { __typename?: 'OwnerOutput', email: string, id: string, firstName: string, lastName: string, hasMultipleDonors?: boolean | null, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number, type?: OwnerType | null, isArchived: boolean, contactPreferences?: string | null, createdAt: any, deletedAt?: any | null } | null } } };

export type GetDonorDvmExamsQueryVariables = Exact<{
  input: GetDonorDvmExamsInput;
}>;


export type GetDonorDvmExamsQuery = { __typename?: 'Query', getDonorDvmExams: Array<{ __typename?: 'DvmExamOutput', id: string, examinationDate: any, notes?: string | null, nextExamDue?: any | null, donorRegion?: string | null, donorLocation?: string | null, performedBy: { __typename?: 'UserOutput', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number, type?: OwnerType | null, isArchived: boolean, deletionIntentionAt?: any | null, contactPreferences?: string | null, deletedAt?: any | null, assignedLocations?: Array<{ __typename?: 'LocationOutput', id: string, createdAt: any, updatedAt: any, name: string, type: LocationType, region?: { __typename?: 'RegionOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null } | null }> | null, assignedRegions?: Array<{ __typename?: 'RegionOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null }> | null, productRegionPreference?: { __typename?: 'RegionOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null } | null, assignedOffice?: { __typename?: 'OfficeOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null, region: { __typename?: 'RegionOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null } } | null }, donor: { __typename?: 'DonorOutput', id: string, age: number, gender: AnimalGender, hasTransfusion?: boolean | null, name: string, neutered: boolean, primaryVeterinarian: string, species: AnimalSpecies, takeMedications?: boolean | null, weight: number, approvedDonationML: number, donationMLApprovedAmount?: number | null, bloodType?: BloodType | null, status: DonorStatus, type: DonorType, location: string, distinguishableMarks?: string | null, microchipNumber?: string | null, medicationCourse?: string | null, comment?: string | null, breed?: string | null, color?: string | null, createdAt: any, shortId: number, firstCertificatePrinted: boolean, secondCertificatePrinted: boolean, becameReservedDonorDate?: any | null, retiredDate?: any | null, distemperDate?: any | null, rabiesDate?: any | null, lastDonationDate?: any | null, nextDonationDate?: any | null, lastLabworkDate?: any | null, hasMicrochip?: boolean | null, acceptSimparicaTrio: boolean, isDaycare?: boolean | null, donationFrequency: number, canRegularlyAttendDaycare?: boolean | null, attendDaycareDays?: Array<string> | null, retiredReason?: RetiredReasons | null, retiredReasonComment?: string | null, dateOfBirth: any, user?: { __typename?: 'OwnerOutput', email: string, id: string, firstName: string, lastName: string, hasMultipleDonors?: boolean | null, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number, type?: OwnerType | null, isArchived: boolean, contactPreferences?: string | null, createdAt: any, deletedAt?: any | null } | null } }> };

export type FindDonorsForTeamQueryVariables = Exact<{
  input: DonorsListForTeamInput;
}>;


export type FindDonorsForTeamQuery = { __typename?: 'Query', findDonorsForTeam: { __typename?: 'DonorsListOutput', data: Array<{ __typename?: 'DonorOutput', id: string, age: number, gender: AnimalGender, hasTransfusion?: boolean | null, name: string, neutered: boolean, primaryVeterinarian: string, species: AnimalSpecies, takeMedications?: boolean | null, weight: number, approvedDonationML: number, donationMLApprovedAmount?: number | null, bloodType?: BloodType | null, status: DonorStatus, type: DonorType, location: string, distinguishableMarks?: string | null, microchipNumber?: string | null, medicationCourse?: string | null, comment?: string | null, breed?: string | null, color?: string | null, createdAt: any, shortId: number, firstCertificatePrinted: boolean, secondCertificatePrinted: boolean, becameReservedDonorDate?: any | null, retiredDate?: any | null, distemperDate?: any | null, rabiesDate?: any | null, lastDonationDate?: any | null, nextDonationDate?: any | null, lastLabworkDate?: any | null, hasMicrochip?: boolean | null, acceptSimparicaTrio: boolean, isDaycare?: boolean | null, donationFrequency: number, canRegularlyAttendDaycare?: boolean | null, attendDaycareDays?: Array<string> | null, retiredReason?: RetiredReasons | null, retiredReasonComment?: string | null, dateOfBirth: any, team?: { __typename?: 'TeamOutput', id: string, title: string } | null, user?: { __typename?: 'OwnerOutput', email: string, id: string, firstName: string, lastName: string, hasMultipleDonors?: boolean | null, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number, type?: OwnerType | null, isArchived: boolean, contactPreferences?: string | null, createdAt: any, deletedAt?: any | null, contacts?: Array<{ __typename?: 'ContactOutput', streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, email?: string | null, firstName?: string | null, id: string, lastName?: string | null, phoneNumber?: string | null }> | null } | null, reserveNotes?: Array<{ __typename?: 'ReserveDonorNoteOutput', id: string, text: string, createdAt: any }> | null }>, meta: { __typename?: 'MetaData', total: number } } };

export type GetDonorQueryVariables = Exact<{
  input: GetDonorInput;
}>;


export type GetDonorQuery = { __typename?: 'Query', getDonor: { __typename?: 'DonorOutput', id: string, age: number, gender: AnimalGender, hasTransfusion?: boolean | null, name: string, neutered: boolean, primaryVeterinarian: string, species: AnimalSpecies, takeMedications?: boolean | null, weight: number, approvedDonationML: number, donationMLApprovedAmount?: number | null, bloodType?: BloodType | null, status: DonorStatus, type: DonorType, location: string, distinguishableMarks?: string | null, microchipNumber?: string | null, medicationCourse?: string | null, comment?: string | null, breed?: string | null, color?: string | null, createdAt: any, shortId: number, firstCertificatePrinted: boolean, secondCertificatePrinted: boolean, becameReservedDonorDate?: any | null, retiredDate?: any | null, distemperDate?: any | null, rabiesDate?: any | null, lastDonationDate?: any | null, nextDonationDate?: any | null, lastLabworkDate?: any | null, hasMicrochip?: boolean | null, acceptSimparicaTrio: boolean, isDaycare?: boolean | null, donationFrequency: number, canRegularlyAttendDaycare?: boolean | null, attendDaycareDays?: Array<string> | null, retiredReason?: RetiredReasons | null, retiredReasonComment?: string | null, dateOfBirth: any, lastLabworkFile?: Array<{ __typename?: 'FileOutput', id: string, filename: string }> | null, team?: { __typename?: 'TeamOutput', id: string, title: string } | null, user?: { __typename?: 'OwnerOutput', email: string, id: string, firstName: string, lastName: string, hasMultipleDonors?: boolean | null, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number, type?: OwnerType | null, isArchived: boolean, contactPreferences?: string | null, createdAt: any, deletedAt?: any | null, contacts?: Array<{ __typename?: 'ContactOutput', streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, email?: string | null, firstName?: string | null, id: string, lastName?: string | null, phoneNumber?: string | null }> | null } | null, reserveNotes?: Array<{ __typename?: 'ReserveDonorNoteOutput', id: string, text: string, createdAt: any }> | null, pictures?: Array<{ __typename?: 'DonorPictureOutput', id: string, isPrimary: boolean, file: { __typename?: 'FileOutput', id: string, filename: string } }> | null } };

export type GetCurrentUserDonorsListQueryVariables = Exact<{
  input: CurrentUserDonorListInput;
}>;


export type GetCurrentUserDonorsListQuery = { __typename?: 'Query', getCurrentUserDonorsList: { __typename?: 'DonorsListOutput', data: Array<{ __typename?: 'DonorOutput', id: string, age: number, gender: AnimalGender, hasTransfusion?: boolean | null, name: string, neutered: boolean, primaryVeterinarian: string, species: AnimalSpecies, takeMedications?: boolean | null, weight: number, approvedDonationML: number, donationMLApprovedAmount?: number | null, bloodType?: BloodType | null, status: DonorStatus, type: DonorType, location: string, distinguishableMarks?: string | null, microchipNumber?: string | null, medicationCourse?: string | null, comment?: string | null, breed?: string | null, color?: string | null, createdAt: any, shortId: number, firstCertificatePrinted: boolean, secondCertificatePrinted: boolean, becameReservedDonorDate?: any | null, retiredDate?: any | null, distemperDate?: any | null, rabiesDate?: any | null, lastDonationDate?: any | null, nextDonationDate?: any | null, lastLabworkDate?: any | null, hasMicrochip?: boolean | null, acceptSimparicaTrio: boolean, isDaycare?: boolean | null, donationFrequency: number, canRegularlyAttendDaycare?: boolean | null, attendDaycareDays?: Array<string> | null, retiredReason?: RetiredReasons | null, retiredReasonComment?: string | null, dateOfBirth: any, lastLabworkFile?: Array<{ __typename?: 'FileOutput', id: string, filename: string }> | null, team?: { __typename?: 'TeamOutput', id: string, title: string } | null, user?: { __typename?: 'OwnerOutput', email: string, id: string, firstName: string, lastName: string, hasMultipleDonors?: boolean | null, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number, type?: OwnerType | null, isArchived: boolean, contactPreferences?: string | null, createdAt: any, deletedAt?: any | null, contacts?: Array<{ __typename?: 'ContactOutput', streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, email?: string | null, firstName?: string | null, id: string, lastName?: string | null, phoneNumber?: string | null }> | null } | null, reserveNotes?: Array<{ __typename?: 'ReserveDonorNoteOutput', id: string, text: string, createdAt: any }> | null }>, meta: { __typename?: 'MetaData', total: number } } };

export type FindAllGroupQueryVariables = Exact<{
  input: GroupListInput;
}>;


export type FindAllGroupQuery = { __typename?: 'Query', findAllGroup: { __typename?: 'GroupListOutput', data: Array<{ __typename?: 'GroupListItemOutput', teamCount: number, donorCount?: number | null, title: string, id: string, teams?: Array<{ __typename?: 'GroupTeamOutput', id: string, title: string }> | null, user?: { __typename?: 'GroupListItemUserOutput', firstName: string, lastName: string, id: string } | null }>, meta: { __typename?: 'MetaData', total: number } } };

export type FindGroupQueryVariables = Exact<{
  input: FindGroupInput;
}>;


export type FindGroupQuery = { __typename?: 'Query', findGroup: { __typename?: 'GroupOutput', id: string, title: string, teams: Array<{ __typename?: 'TeamOutput', id: string, title: string, donors?: Array<{ __typename?: 'DonorOutput', id: string, age: number, gender: AnimalGender, hasTransfusion?: boolean | null, name: string, neutered: boolean, primaryVeterinarian: string, species: AnimalSpecies, takeMedications?: boolean | null, weight: number, approvedDonationML: number, donationMLApprovedAmount?: number | null, bloodType?: BloodType | null, status: DonorStatus, type: DonorType, location: string, distinguishableMarks?: string | null, microchipNumber?: string | null, medicationCourse?: string | null, comment?: string | null, breed?: string | null, color?: string | null, createdAt: any, shortId: number, firstCertificatePrinted: boolean, secondCertificatePrinted: boolean, becameReservedDonorDate?: any | null, retiredDate?: any | null, distemperDate?: any | null, rabiesDate?: any | null, lastDonationDate?: any | null, nextDonationDate?: any | null, lastLabworkDate?: any | null, hasMicrochip?: boolean | null, acceptSimparicaTrio: boolean, isDaycare?: boolean | null, donationFrequency: number, canRegularlyAttendDaycare?: boolean | null, attendDaycareDays?: Array<string> | null, retiredReason?: RetiredReasons | null, retiredReasonComment?: string | null, dateOfBirth: any, user?: { __typename?: 'OwnerOutput', email: string, id: string, firstName: string, lastName: string, hasMultipleDonors?: boolean | null, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number, type?: OwnerType | null, isArchived: boolean, contactPreferences?: string | null, createdAt: any, deletedAt?: any | null, role: { __typename?: 'RoleWithoutPermissionsOutput', id: string, value: UserRole }, contacts?: Array<{ __typename?: 'ContactOutput', streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, email?: string | null, firstName?: string | null, id: string, lastName?: string | null, phoneNumber?: string | null }> | null } | null }> | null }>, user?: { __typename?: 'OwnerOutput', email: string, id: string, firstName: string, lastName: string, hasMultipleDonors?: boolean | null, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number, type?: OwnerType | null, isArchived: boolean, contactPreferences?: string | null, createdAt: any, deletedAt?: any | null, role: { __typename?: 'RoleWithoutPermissionsOutput', id: string, value: UserRole }, contacts?: Array<{ __typename?: 'ContactOutput', streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, email?: string | null, firstName?: string | null, id: string, lastName?: string | null, phoneNumber?: string | null }> | null } | null } };

export type GetDonorLivesSavedQueryVariables = Exact<{
  input: GetLivesSavedByDonorInput;
}>;


export type GetDonorLivesSavedQuery = { __typename?: 'Query', getDonorLivesSaved: { __typename?: 'LivesSavedOutput', lives: number } };

export type GetDonorStatsQueryVariables = Exact<{
  input: GetDonorStatsInput;
}>;


export type GetDonorStatsQuery = { __typename?: 'Query', getDonorStats: { __typename?: 'DonorStatsOutput', totalMlsDonated: number, totalDonations: number, prbcCreated: number, ffpUnitsCreated: number } };

export type GetChartsDataQueryVariables = Exact<{
  input: GetSpecificDonorDonationsListInput;
}>;


export type GetChartsDataQuery = { __typename?: 'Query', getChartsData: { __typename?: 'DonationListOutput', data: Array<{ __typename?: 'DonationOutput', id: string, collectionSet: CollectionSet, capillaryRefillTime: CapillaryRefillTime, approvedDonationsMl: number, jugularVein: JugularVein, maxLimit: number, mucousMembrane: Mm, packedCellVolume: number, pulse: number, respiration: number, shouldDonate?: boolean | null, temperature: number, totalSolids: number, unit?: DonationUnit | null, failedReason?: DonationFailedReason | null, actual?: number | null, weatherTemperature: number, weatherTypes: Array<WeatherType>, weight: number, examinationNotes?: string | null, preferences?: string | null, createdAt: any, comment?: string | null, shortId: number, donationDate: any, ineligible: boolean, ineligibleReason?: IneligibleReason | null, ineligibleReasonDetails?: string | null, products?: Array<{ __typename?: 'DonationProductOutput', anticoagulant?: Anticoagulant | null, createdAt: any, id: string, shortId: number, status: ProductStatus, storageRequirements: Array<string>, updatedAt: any, value: number, woocommerceProductId: number, woocommerceCategoryId: number, expirationDate: any, discardedProduct?: { __typename?: 'DiscardedProductDataOutput', processingType: ProcessingProductType, reason: ReasonDiscardProduct, notes?: string | null } | null, bloodIdentifiers?: Array<{ __typename?: 'BloodUnitIdentifiersOutput', unitId?: number | null, product?: { __typename?: 'ProductOutput', id: string, shortId: number } | null }> | null }> | null, donor: { __typename?: 'DonationDonor', id: string, age: number, gender: AnimalGender, hasTransfusion?: boolean | null, name: string, neutered: boolean, primaryVeterinarian: string, species: AnimalSpecies, takeMedications?: boolean | null, weight: number, bloodType?: BloodType | null, status: DonorStatus, type: DonorType, location: string, distinguishableMarks?: string | null, microchipNumber?: string | null, medicationCourse?: string | null, comment?: string | null, breed?: string | null, color?: string | null, createdAt: any, shortId: number, firstCertificatePrinted: boolean, secondCertificatePrinted: boolean, lastDonationDate?: any | null, lastLabworkDate?: any | null, nextDonationDate?: any | null, team?: { __typename?: 'TeamOutput', id: string, title: string } | null, user?: { __typename?: 'HolderOutput', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number } | null, pictures?: Array<{ __typename?: 'DonorPictureOutput', id: string, isPrimary: boolean, file: { __typename?: 'FileOutput', id: string, filename: string } }> | null }, additionalInfo?: { __typename?: 'AdditionalDonationInfoOutput', id: string, numberOfCollectionUnitsUsed: CollectionUnitsUsed, veinUsed: VeinUsed, vascularStructure?: VascularStructure | null, flowRate: FlowRate, donationPosition?: string | null, holdersPosition?: Array<string> | null, donorMovement: string, typeOfMovement?: string | null, emotionalSupport?: Array<string> | null, dislikes?: Array<string> | null, likes?: Array<string> | null, treatPreferences?: Array<string> | null, totalCollectedMls?: number | null, primaryHolder?: { __typename?: 'HolderOutput', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number } | null, secondaryHolder?: { __typename?: 'HolderOutput', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number } | null, poker?: { __typename?: 'HolderOutput', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number } | null } | null }>, meta: { __typename?: 'MetaData', total: number } } };

export type GetLabworkListQueryVariables = Exact<{
  input: LabworkListInput;
}>;


export type GetLabworkListQuery = { __typename?: 'Query', getLabworkList: { __typename?: 'LabworkListOutput', data: Array<{ __typename?: 'LabworkOutput', id: string, collectionDate: any, status: LabworkStatus, donor: { __typename?: 'DonorOutput', id: string, age: number, gender: AnimalGender, hasTransfusion?: boolean | null, name: string, neutered: boolean, primaryVeterinarian: string, species: AnimalSpecies, takeMedications?: boolean | null, weight: number, approvedDonationML: number, donationMLApprovedAmount?: number | null, bloodType?: BloodType | null, status: DonorStatus, type: DonorType, location: string, distinguishableMarks?: string | null, microchipNumber?: string | null, medicationCourse?: string | null, comment?: string | null, breed?: string | null, color?: string | null, createdAt: any, shortId: number, firstCertificatePrinted: boolean, secondCertificatePrinted: boolean, becameReservedDonorDate?: any | null, retiredDate?: any | null, distemperDate?: any | null, rabiesDate?: any | null, lastDonationDate?: any | null, nextDonationDate?: any | null, lastLabworkDate?: any | null, hasMicrochip?: boolean | null, acceptSimparicaTrio: boolean, isDaycare?: boolean | null, donationFrequency: number, canRegularlyAttendDaycare?: boolean | null, attendDaycareDays?: Array<string> | null, retiredReason?: RetiredReasons | null, retiredReasonComment?: string | null, dateOfBirth: any, user?: { __typename?: 'OwnerOutput', email: string, id: string, firstName: string, lastName: string, hasMultipleDonors?: boolean | null, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number, type?: OwnerType | null, isArchived: boolean, contactPreferences?: string | null, createdAt: any, deletedAt?: any | null } | null } }>, meta: { __typename?: 'MetaData', total: number } } };

export type GetLabworkQueryVariables = Exact<{
  input: GetLabworkInput;
}>;


export type GetLabworkQuery = { __typename?: 'Query', getLabwork: { __typename?: 'LabworkOutput', id: string, collectionDate: any, status: LabworkStatus, donor: { __typename?: 'DonorOutput', id: string, age: number, gender: AnimalGender, hasTransfusion?: boolean | null, name: string, neutered: boolean, primaryVeterinarian: string, species: AnimalSpecies, takeMedications?: boolean | null, weight: number, approvedDonationML: number, donationMLApprovedAmount?: number | null, bloodType?: BloodType | null, status: DonorStatus, type: DonorType, location: string, distinguishableMarks?: string | null, microchipNumber?: string | null, medicationCourse?: string | null, comment?: string | null, breed?: string | null, color?: string | null, createdAt: any, shortId: number, firstCertificatePrinted: boolean, secondCertificatePrinted: boolean, becameReservedDonorDate?: any | null, retiredDate?: any | null, distemperDate?: any | null, rabiesDate?: any | null, lastDonationDate?: any | null, nextDonationDate?: any | null, lastLabworkDate?: any | null, hasMicrochip?: boolean | null, acceptSimparicaTrio: boolean, isDaycare?: boolean | null, donationFrequency: number, canRegularlyAttendDaycare?: boolean | null, attendDaycareDays?: Array<string> | null, retiredReason?: RetiredReasons | null, retiredReasonComment?: string | null, dateOfBirth: any, user?: { __typename?: 'OwnerOutput', email: string, id: string, firstName: string, lastName: string, hasMultipleDonors?: boolean | null, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number, type?: OwnerType | null, isArchived: boolean, contactPreferences?: string | null, createdAt: any, deletedAt?: any | null } | null } } };

export type GetVitalsParameterListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetVitalsParameterListQuery = { __typename?: 'Query', getVitalsParameterList: Array<{ __typename?: 'VitalsParameterOutput', id: string, criticalValues?: Array<string> | null, type: VitalsParametersType, max?: number | null, min?: number | null, percentageDifference?: number | null }> };

export type GetAppointmentsDonorsListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAppointmentsDonorsListQuery = { __typename?: 'Query', getAppointmentsDonorsList: Array<{ __typename?: 'DonorOutput', id: string, age: number, gender: AnimalGender, hasTransfusion?: boolean | null, name: string, neutered: boolean, primaryVeterinarian: string, species: AnimalSpecies, takeMedications?: boolean | null, weight: number, approvedDonationML: number, donationMLApprovedAmount?: number | null, bloodType?: BloodType | null, status: DonorStatus, type: DonorType, location: string, distinguishableMarks?: string | null, microchipNumber?: string | null, medicationCourse?: string | null, comment?: string | null, breed?: string | null, color?: string | null, createdAt: any, shortId: number, firstCertificatePrinted: boolean, secondCertificatePrinted: boolean, becameReservedDonorDate?: any | null, retiredDate?: any | null, distemperDate?: any | null, rabiesDate?: any | null, lastDonationDate?: any | null, nextDonationDate?: any | null, lastLabworkDate?: any | null, hasMicrochip?: boolean | null, acceptSimparicaTrio: boolean, isDaycare?: boolean | null, donationFrequency: number, canRegularlyAttendDaycare?: boolean | null, attendDaycareDays?: Array<string> | null, retiredReason?: RetiredReasons | null, retiredReasonComment?: string | null, dateOfBirth: any, team?: { __typename?: 'TeamOutput', id: string, title: string } | null, user?: { __typename?: 'OwnerOutput', email: string, id: string, firstName: string, lastName: string, hasMultipleDonors?: boolean | null, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number, type?: OwnerType | null, isArchived: boolean, contactPreferences?: string | null, createdAt: any, deletedAt?: any | null, contacts?: Array<{ __typename?: 'ContactOutput', streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, email?: string | null, firstName?: string | null, id: string, lastName?: string | null, phoneNumber?: string | null }> | null } | null, reserveNotes?: Array<{ __typename?: 'ReserveDonorNoteOutput', id: string, text: string, createdAt: any }> | null }> };

export type GetDonorsListByIdsQueryVariables = Exact<{
  input: GetDonorsByIdsInput;
}>;


export type GetDonorsListByIdsQuery = { __typename?: 'Query', getDonorsListByIds: Array<{ __typename?: 'DonorOutput', id: string, age: number, gender: AnimalGender, hasTransfusion?: boolean | null, name: string, neutered: boolean, primaryVeterinarian: string, species: AnimalSpecies, takeMedications?: boolean | null, weight: number, approvedDonationML: number, donationMLApprovedAmount?: number | null, bloodType?: BloodType | null, status: DonorStatus, type: DonorType, location: string, distinguishableMarks?: string | null, microchipNumber?: string | null, medicationCourse?: string | null, comment?: string | null, breed?: string | null, color?: string | null, createdAt: any, shortId: number, firstCertificatePrinted: boolean, secondCertificatePrinted: boolean, becameReservedDonorDate?: any | null, retiredDate?: any | null, distemperDate?: any | null, rabiesDate?: any | null, lastDonationDate?: any | null, nextDonationDate?: any | null, lastLabworkDate?: any | null, hasMicrochip?: boolean | null, acceptSimparicaTrio: boolean, isDaycare?: boolean | null, donationFrequency: number, canRegularlyAttendDaycare?: boolean | null, attendDaycareDays?: Array<string> | null, retiredReason?: RetiredReasons | null, retiredReasonComment?: string | null, dateOfBirth: any, team?: { __typename?: 'TeamOutput', id: string, title: string } | null, user?: { __typename?: 'OwnerOutput', email: string, id: string, firstName: string, lastName: string, hasMultipleDonors?: boolean | null, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number, type?: OwnerType | null, isArchived: boolean, contactPreferences?: string | null, createdAt: any, deletedAt?: any | null, contacts?: Array<{ __typename?: 'ContactOutput', streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, email?: string | null, firstName?: string | null, id: string, lastName?: string | null, phoneNumber?: string | null }> | null } | null, reserveNotes?: Array<{ __typename?: 'ReserveDonorNoteOutput', id: string, text: string, createdAt: any }> | null }> };

export type FindTeamQueryVariables = Exact<{
  input: FindTeamInput;
}>;


export type FindTeamQuery = { __typename?: 'Query', findTeam: { __typename?: 'TeamOutput', id: string, title: string, donors?: Array<{ __typename?: 'DonorOutput', id: string, age: number, gender: AnimalGender, hasTransfusion?: boolean | null, name: string, neutered: boolean, primaryVeterinarian: string, species: AnimalSpecies, takeMedications?: boolean | null, weight: number, approvedDonationML: number, donationMLApprovedAmount?: number | null, bloodType?: BloodType | null, status: DonorStatus, type: DonorType, location: string, distinguishableMarks?: string | null, microchipNumber?: string | null, medicationCourse?: string | null, comment?: string | null, breed?: string | null, color?: string | null, createdAt: any, shortId: number, firstCertificatePrinted: boolean, secondCertificatePrinted: boolean, becameReservedDonorDate?: any | null, retiredDate?: any | null, distemperDate?: any | null, rabiesDate?: any | null, lastDonationDate?: any | null, nextDonationDate?: any | null, lastLabworkDate?: any | null, hasMicrochip?: boolean | null, acceptSimparicaTrio: boolean, isDaycare?: boolean | null, donationFrequency: number, canRegularlyAttendDaycare?: boolean | null, attendDaycareDays?: Array<string> | null, retiredReason?: RetiredReasons | null, retiredReasonComment?: string | null, dateOfBirth: any }> | null } };

export type GetLabworkAttachmentsQueryVariables = Exact<{
  input: GetLabworkAttachmentsListInput;
}>;


export type GetLabworkAttachmentsQuery = { __typename?: 'Query', getLabworkAttachments: Array<{ __typename?: 'LabworkAttachmentOutput', id: string, createdAt: any, updatedAt: any, file: { __typename?: 'FileOutput', id: string, filename: string } }> };

export type HasDonorRelateddataSourcesQueryVariables = Exact<{
  input: DeleteDonorInput;
}>;


export type HasDonorRelateddataSourcesQuery = { __typename?: 'Query', hasDonorRelateddataSources: boolean };

export type GetAppointmentsDatesForDonorQueryVariables = Exact<{
  donorId: Scalars['String'];
}>;


export type GetAppointmentsDatesForDonorQuery = { __typename?: 'Query', getAppointmentsDatesForDonor: Array<{ __typename?: 'AppointmentDatesInfoOutput', id: string, start: any, end: any }> };

export type GetDonorNotesQueryVariables = Exact<{
  donorId: Scalars['String'];
}>;


export type GetDonorNotesQuery = { __typename?: 'Query', getDonorNotes: Array<{ __typename?: 'DonorNoteOutput', id: string, text: string, isPinned: boolean, createdAt: any, updatedAt: any, files: Array<{ __typename?: 'DonorNoteFileOutput', id: string, file: { __typename?: 'FileOutput', id: string, filename: string } }>, user: { __typename?: 'UserOutput', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number, type?: OwnerType | null, isArchived: boolean, deletionIntentionAt?: any | null, contactPreferences?: string | null, deletedAt?: any | null, assignedLocations?: Array<{ __typename?: 'LocationOutput', id: string, createdAt: any, updatedAt: any, name: string, type: LocationType, region?: { __typename?: 'RegionOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null } | null }> | null, assignedRegions?: Array<{ __typename?: 'RegionOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null }> | null, productRegionPreference?: { __typename?: 'RegionOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null } | null, assignedOffice?: { __typename?: 'OfficeOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null, region: { __typename?: 'RegionOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null } } | null } }> };

export type GetDonorsListForAnalyticsQueryVariables = Exact<{
  input: DonorsAnalyticsInput;
}>;


export type GetDonorsListForAnalyticsQuery = { __typename?: 'Query', getDonorsListForAnalytics: { __typename?: 'DonorsListOutput', data: Array<{ __typename?: 'DonorOutput', id: string, age: number, gender: AnimalGender, hasTransfusion?: boolean | null, name: string, neutered: boolean, primaryVeterinarian: string, species: AnimalSpecies, takeMedications?: boolean | null, weight: number, approvedDonationML: number, donationMLApprovedAmount?: number | null, bloodType?: BloodType | null, status: DonorStatus, type: DonorType, location: string, distinguishableMarks?: string | null, microchipNumber?: string | null, medicationCourse?: string | null, comment?: string | null, breed?: string | null, color?: string | null, createdAt: any, shortId: number, firstCertificatePrinted: boolean, secondCertificatePrinted: boolean, becameReservedDonorDate?: any | null, retiredDate?: any | null, distemperDate?: any | null, rabiesDate?: any | null, lastDonationDate?: any | null, nextDonationDate?: any | null, lastLabworkDate?: any | null, hasMicrochip?: boolean | null, acceptSimparicaTrio: boolean, isDaycare?: boolean | null, donationFrequency: number, canRegularlyAttendDaycare?: boolean | null, attendDaycareDays?: Array<string> | null, retiredReason?: RetiredReasons | null, retiredReasonComment?: string | null, dateOfBirth: any, team?: { __typename?: 'TeamOutput', id: string, title: string } | null, user?: { __typename?: 'OwnerOutput', email: string, id: string, firstName: string, lastName: string, hasMultipleDonors?: boolean | null, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number, type?: OwnerType | null, isArchived: boolean, contactPreferences?: string | null, createdAt: any, deletedAt?: any | null, contacts?: Array<{ __typename?: 'ContactOutput', streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, email?: string | null, firstName?: string | null, id: string, lastName?: string | null, phoneNumber?: string | null }> | null } | null, reserveNotes?: Array<{ __typename?: 'ReserveDonorNoteOutput', id: string, text: string, createdAt: any }> | null }>, meta: { __typename?: 'MetaData', total: number } } };

export type GetDonorAnalyticsQueryVariables = Exact<{
  input: DonorAnalyticsQueryInput;
}>;


export type GetDonorAnalyticsQuery = { __typename?: 'Query', getDonorAnalytics: { __typename?: 'DonorAnalyticsOutput', totalSingleDonors: number, totalDoubleDonors: number, totalNewDonors: number, totalExperiencedDonors: number, statusBreakdown: Array<{ __typename?: 'DonorStatusCount', status: DonorStatus, count: number }> } };

export type GetDonorPicturesQueryVariables = Exact<{
  input: GetDonorPicturesInput;
}>;


export type GetDonorPicturesQuery = { __typename?: 'Query', getDonorPictures: Array<{ __typename?: 'DonorPictureOutput', id: string, isPrimary: boolean, file: { __typename?: 'FileOutput', id: string, filename: string } }> };

export type GetDonorPipelineStatsQueryVariables = Exact<{
  input: GetDonorPipelineStatsInput;
}>;


export type GetDonorPipelineStatsQuery = { __typename?: 'Query', getDonorPipelineStats: { __typename?: 'DonorPipelineStatsOutput', activeDonorCount: number, pendingDonorCount: number, approvedDonorCount: number, registrationsByPeriod: Array<{ __typename?: 'PeriodRegistrationOutput', period: string, count: number, startDate: any, endDate: any }>, lastWeekDaily: Array<{ __typename?: 'DailyRegistrationOutput', date: string, isoWeekday: number, count: number }> } };

export type GetRecruiterDashboardMetricsQueryVariables = Exact<{
  input: GetRecruiterDashboardMetricsInput;
}>;


export type GetRecruiterDashboardMetricsQuery = { __typename?: 'Query', getRecruiterDashboardMetrics: { __typename?: 'RecruiterDashboardMetricsOutput', repeatDonorCount: number, activeDonorCount: number, historicalActiveDonorCount?: number | null, comparedPeriodActiveDonorCount?: number | null, firstTimeDonorCount: number, quarterlyDropoutCount: number, quarterlyActiveAtStart: number, periodDropoutCount: number, periodNewEnrollmentCount: number, periodActiveAtStart: number, quarterlyNewEnrollmentCount: number, donorsWhoDonated: number, expectedDonations: number, showRate: number, singleDonorCount: number, doubleDonorCount: number, lapsedDonorCounts: Array<number>, retiredDonorCounts: Array<number> } };

export type GetPrbcDonationDonorsQueryVariables = Exact<{
  input: GetPrbcDonationDonorsInput;
}>;


export type GetPrbcDonationDonorsQuery = { __typename?: 'Query', getPrbcDonationDonors: { __typename?: 'PrbcDonationDonorsListOutput', total: number, donors: Array<{ __typename?: 'PrbcDonationDonorOutput', donorId: string, donorShortId: number, donorName: string, ownerFullName?: string | null, ownerShortId?: number | null, bloodTypeDisplay: string, status: string, lastDonationDate?: any | null, sglDbl: string, totalDonations: number, periodUnits: number, location: string, registeredAt?: any | null, ownerPhone?: string | null, ownerEmail?: string | null, ownerCity?: string | null, ownerState?: string | null, ownerContactPreferences?: string | null, ownerAssignedLocations?: string | null, breed?: string | null, dateOfBirth?: any | null, region?: string | null, retiredDate?: any | null, retiredReason?: string | null, activeDate?: any | null, approvedDate?: any | null, archivedDate?: any | null }> } };

export type GetDonorDonationHistoryQueryVariables = Exact<{
  input: GetDonorDonationHistoryInput;
}>;


export type GetDonorDonationHistoryQuery = { __typename?: 'Query', getDonorDonationHistory: { __typename?: 'DonorDonationHistoryOutput', total: number, donations: Array<{ __typename?: 'DonorDonationHistoryRecordOutput', id: string, shortId: number, date: any, donorName: string, locationName: string, regionName: string, type: string, approvedML: number, status: string }> } };

export type GetChurnRateHistoryQueryVariables = Exact<{
  input: GetChurnRateHistoryInput;
}>;


export type GetChurnRateHistoryQuery = { __typename?: 'Query', getChurnRateHistory: { __typename?: 'ChurnRateHistoryOutput', periods: Array<{ __typename?: 'ChurnRatePeriodOutput', label: string, churnRate: number, dropoutCount: number, enrollmentCount: number, activeAtStart: number, periodStart: string, periodEnd: string }> } };

export type GetRetentionHistoryQueryVariables = Exact<{
  input: GetMetricsHistoryInput;
}>;


export type GetRetentionHistoryQuery = { __typename?: 'Query', getRetentionHistory: { __typename?: 'RetentionHistoryOutput', periods: Array<{ __typename?: 'RetentionHistoryPeriodOutput', label: string, retentionScore: number, repeatDonorCount: number, activeDonorCount: number, periodStart: string, periodEnd: string }> } };

export type GetDropoutHistoryQueryVariables = Exact<{
  input: GetMetricsHistoryInput;
}>;


export type GetDropoutHistoryQuery = { __typename?: 'Query', getDropoutHistory: { __typename?: 'DropoutHistoryOutput', periods: Array<{ __typename?: 'DropoutHistoryPeriodOutput', label: string, dropoutRate: number, dropoutCount: number, activeAtStart: number, periodStart: string, periodEnd: string }> } };

export type GetRatioHistoryQueryVariables = Exact<{
  input: GetMetricsHistoryInput;
}>;


export type GetRatioHistoryQuery = { __typename?: 'Query', getRatioHistory: { __typename?: 'RatioHistoryOutput', periods: Array<{ __typename?: 'RatioHistoryPeriodOutput', label: string, firstTimePct: number, firstTimeDonorCount: number, repeatDonorCount: number, activeDonorCount: number, periodStart: string, periodEnd: string }> } };

export type GetShowRateHistoryQueryVariables = Exact<{
  input: GetMetricsHistoryInput;
}>;


export type GetShowRateHistoryQuery = { __typename?: 'Query', getShowRateHistory: { __typename?: 'ShowRateHistoryOutput', periods: Array<{ __typename?: 'ShowRateHistoryPeriodOutput', label: string, showRate: number, donorsWhoDonated: number, expectedDonations: number, periodStart: string, periodEnd: string }> } };

export type GetMicrochipPriceQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMicrochipPriceQuery = { __typename?: 'Query', getMicrochipPrice: { __typename?: 'GetMicrochipPriceOutput', price: number } };

export type GetDonorContactFlagsQueryVariables = Exact<{
  donorIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type GetDonorContactFlagsQuery = { __typename?: 'Query', getDonorContactFlags: string };

export type GetDonorContactsQueryVariables = Exact<{
  donorId: Scalars['String'];
}>;


export type GetDonorContactsQuery = { __typename?: 'Query', getDonorContacts: Array<{ __typename?: 'DonorContactOutput', id: string, donorId: string, contactType: ContactType, notes?: string | null, followUpDate?: string | null, createdAt: string, user: { __typename?: 'DonorContactUserOutput', id: string, firstName: string, lastName: string } }> };

export type InvitationFragment = { __typename?: 'InvitationOutput', id: string, email: string, firstName: string, lastName: string, phoneNumber: string, role: string, createdAt: any };

export type DeleteInvitationMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteInvitationMutation = { __typename?: 'Mutation', deleteInvitation: boolean };

export type GetInvitationsListQueryVariables = Exact<{
  input: GetInvitationListInput;
}>;


export type GetInvitationsListQuery = { __typename?: 'Query', getInvitationsList: { __typename?: 'PaginatedInvitationListOutput', data: Array<{ __typename?: 'InvitationOutput', id: string, email: string, firstName: string, lastName: string, phoneNumber: string, role: string, createdAt: any }>, meta: { __typename?: 'MetaData', total: number } } };

export type RegionFragment = { __typename?: 'RegionOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null };

export type OfficeFragment = { __typename?: 'OfficeOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null, region: { __typename?: 'RegionOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null } };

export type LocationFragment = { __typename?: 'LocationOutput', id: string, createdAt: any, updatedAt: any, name: string, type: LocationType, region?: { __typename?: 'RegionOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null } | null };

export type CreateLocationMutationVariables = Exact<{
  input: CreateLocationInput;
}>;


export type CreateLocationMutation = { __typename?: 'Mutation', createLocation: Array<{ __typename?: 'LocationOutput', id: string, createdAt: any, updatedAt: any, name: string, type: LocationType, region?: { __typename?: 'RegionOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null } | null }> };

export type UpdateLocationMutationVariables = Exact<{
  input: UpdateLocationInput;
}>;


export type UpdateLocationMutation = { __typename?: 'Mutation', updateLocation: Array<{ __typename?: 'LocationOutput', id: string, createdAt: any, updatedAt: any, name: string, type: LocationType, region?: { __typename?: 'RegionOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null } | null }> };

export type DeleteLocationMutationVariables = Exact<{
  input: DeleteLocationInput;
}>;


export type DeleteLocationMutation = { __typename?: 'Mutation', deleteLocation: boolean };

export type CreateRegionMutationVariables = Exact<{
  input: CreateRegionInput;
}>;


export type CreateRegionMutation = { __typename?: 'Mutation', createRegion: Array<{ __typename?: 'RegionOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null }> };

export type UpdateRegionMutationVariables = Exact<{
  input: UpdateRegionInput;
}>;


export type UpdateRegionMutation = { __typename?: 'Mutation', updateRegion: Array<{ __typename?: 'RegionOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null }> };

export type DeleteRegionMutationVariables = Exact<{
  input: DeleteRegionInput;
}>;


export type DeleteRegionMutation = { __typename?: 'Mutation', deleteRegion: boolean };

export type CreateOfficeMutationVariables = Exact<{
  input: CreateOfficeInput;
}>;


export type CreateOfficeMutation = { __typename?: 'Mutation', createOffice: Array<{ __typename?: 'OfficeOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null, region: { __typename?: 'RegionOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null } }> };

export type UpdateOfficeMutationVariables = Exact<{
  input: UpdateOfficeInput;
}>;


export type UpdateOfficeMutation = { __typename?: 'Mutation', updateOffice: Array<{ __typename?: 'OfficeOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null, region: { __typename?: 'RegionOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null } }> };

export type DeleteOfficeMutationVariables = Exact<{
  input: DeleteOfficeInput;
}>;


export type DeleteOfficeMutation = { __typename?: 'Mutation', deleteOffice: boolean };

export type GetLocationsQueryVariables = Exact<{
  input: GetLocationsInput;
}>;


export type GetLocationsQuery = { __typename?: 'Query', getLocations: { __typename?: 'PaginatedLocationsOutput', data: Array<{ __typename?: 'LocationOutput', id: string, createdAt: any, updatedAt: any, name: string, type: LocationType, region?: { __typename?: 'RegionOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null } | null }>, meta: { __typename?: 'MetaData', total: number } } };

export type GetPublicLocationsQueryVariables = Exact<{
  input: GetPublicLocationsInput;
}>;


export type GetPublicLocationsQuery = { __typename?: 'Query', getPublicLocations: { __typename?: 'PaginatedLocationsOutput', data: Array<{ __typename?: 'LocationOutput', id: string, createdAt: any, updatedAt: any, name: string, type: LocationType, region?: { __typename?: 'RegionOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null } | null }>, meta: { __typename?: 'MetaData', total: number } } };

export type GetLocationWithAvailableDaycareQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLocationWithAvailableDaycareQuery = { __typename?: 'Query', getLocationWithAvailableDaycare: Array<{ __typename?: 'LocationOutput', id: string, createdAt: any, updatedAt: any, name: string, type: LocationType, region?: { __typename?: 'RegionOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null } | null }> };

export type GetRegionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRegionsQuery = { __typename?: 'Query', getRegions: Array<{ __typename?: 'RegionOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null }> };

export type GetPublicRegionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPublicRegionsQuery = { __typename?: 'Query', getPublicRegions: Array<{ __typename?: 'PublicRegionOutput', id: string, name: string }> };

export type GetOfficesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOfficesQuery = { __typename?: 'Query', getOffices: Array<{ __typename?: 'OfficeOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null, region: { __typename?: 'RegionOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null } }> };

export type SaveNightlyCountMutationVariables = Exact<{
  input: SaveNightlyCountInput;
}>;


export type SaveNightlyCountMutation = { __typename?: 'Mutation', saveNightlyCount: { __typename?: 'NightlyCountOutput', id: string, officeId: string, countDate: string, createdByUserId: string, lastEditedByUserId?: string | null, lastEditedAt?: any | null, createdAt: any, updatedAt: any, office?: { __typename?: 'NightlyCountOfficeOutput', id: string, name: string, regionName?: string | null } | null, createdByUser?: { __typename?: 'NightlyCountUserOutput', id: string, firstName: string, lastName: string, email: string } | null, lastEditedByUser?: { __typename?: 'NightlyCountUserOutput', id: string, firstName: string, lastName: string, email: string } | null, items: Array<{ __typename?: 'NightlyCountItemOutput', id: string, productKey: string, productTitle: string, woocommerceProductId: number, productClass: NightlyCountProductClass, productBloodType?: NightlyCountProductBloodType | null, count: number }> } };

export type DeleteNightlyCountMutationVariables = Exact<{
  input: NightlyCountIdInput;
}>;


export type DeleteNightlyCountMutation = { __typename?: 'Mutation', deleteNightlyCount: boolean };

export type ResendNightlyCountMutationVariables = Exact<{
  input: NightlyCountIdInput;
}>;


export type ResendNightlyCountMutation = { __typename?: 'Mutation', resendNightlyCount: boolean };

export type NightlyCountFragment = { __typename?: 'NightlyCountOutput', id: string, officeId: string, countDate: string, createdByUserId: string, lastEditedByUserId?: string | null, lastEditedAt?: any | null, createdAt: any, updatedAt: any, office?: { __typename?: 'NightlyCountOfficeOutput', id: string, name: string, regionName?: string | null } | null, createdByUser?: { __typename?: 'NightlyCountUserOutput', id: string, firstName: string, lastName: string, email: string } | null, lastEditedByUser?: { __typename?: 'NightlyCountUserOutput', id: string, firstName: string, lastName: string, email: string } | null, items: Array<{ __typename?: 'NightlyCountItemOutput', id: string, productKey: string, productTitle: string, woocommerceProductId: number, productClass: NightlyCountProductClass, productBloodType?: NightlyCountProductBloodType | null, count: number }> };

export type GetNightlyCountForTodayQueryVariables = Exact<{
  input: GetNightlyCountForTodayInput;
}>;


export type GetNightlyCountForTodayQuery = { __typename?: 'Query', getNightlyCountForToday?: { __typename?: 'NightlyCountOutput', id: string, officeId: string, countDate: string, createdByUserId: string, lastEditedByUserId?: string | null, lastEditedAt?: any | null, createdAt: any, updatedAt: any, office?: { __typename?: 'NightlyCountOfficeOutput', id: string, name: string, regionName?: string | null } | null, createdByUser?: { __typename?: 'NightlyCountUserOutput', id: string, firstName: string, lastName: string, email: string } | null, lastEditedByUser?: { __typename?: 'NightlyCountUserOutput', id: string, firstName: string, lastName: string, email: string } | null, items: Array<{ __typename?: 'NightlyCountItemOutput', id: string, productKey: string, productTitle: string, woocommerceProductId: number, productClass: NightlyCountProductClass, productBloodType?: NightlyCountProductBloodType | null, count: number }> } | null };

export type GetNightlyCountsListQueryVariables = Exact<{
  input: GetNightlyCountsListInput;
}>;


export type GetNightlyCountsListQuery = { __typename?: 'Query', getNightlyCountsList: { __typename?: 'NightlyCountListOutput', data: Array<{ __typename?: 'NightlyCountOutput', id: string, officeId: string, countDate: string, createdByUserId: string, lastEditedByUserId?: string | null, lastEditedAt?: any | null, createdAt: any, updatedAt: any, office?: { __typename?: 'NightlyCountOfficeOutput', id: string, name: string, regionName?: string | null } | null, createdByUser?: { __typename?: 'NightlyCountUserOutput', id: string, firstName: string, lastName: string, email: string } | null, lastEditedByUser?: { __typename?: 'NightlyCountUserOutput', id: string, firstName: string, lastName: string, email: string } | null, items: Array<{ __typename?: 'NightlyCountItemOutput', id: string, productKey: string, productTitle: string, woocommerceProductId: number, productClass: NightlyCountProductClass, productBloodType?: NightlyCountProductBloodType | null, count: number }> }>, meta: { __typename?: 'MetaData', total: number } } };

export type GetNightlyCountOfficesForCurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNightlyCountOfficesForCurrentUserQuery = { __typename?: 'Query', getNightlyCountOfficesForCurrentUser: Array<{ __typename?: 'NightlyCountAllowedOfficeOutput', id: string, name: string, regionName: string }> };

export type NotificationConfigFragment = { __typename?: 'NotificationConfigOutput', name: Notification, value: boolean };

export type NotificationFragment = { __typename?: 'NotificationOutput', id: string, type: NotificationType, isRead: boolean, createdAt: any };

export type NotificationSubscriptionFragment = { __typename?: 'NotificationWebSocketOutput', id: string, type: NotificationType, isRead: boolean };

export type UpdateNotificationConfigListMutationVariables = Exact<{
  input: UpdateNotificationConfigListInput;
}>;


export type UpdateNotificationConfigListMutation = { __typename?: 'Mutation', updateNotificationConfigList: Array<{ __typename?: 'NotificationConfigOutput', name: Notification, value: boolean }> };

export type GetNotificationConfigListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNotificationConfigListQuery = { __typename?: 'Query', getNotificationConfigList: Array<{ __typename?: 'NotificationConfigOutput', name: Notification, value: boolean }> };

export type GetNotificationListQueryVariables = Exact<{
  input: GetNotificationListInput;
}>;


export type GetNotificationListQuery = { __typename?: 'Query', getNotificationsList: { __typename?: 'NotificationListOutput', data: Array<{ __typename?: 'NotificationOutput', id: string, type: NotificationType, isRead: boolean, createdAt: any, payload: { __typename?: 'NotificationPayloadOutput', appointment?: { __typename?: 'AppointmentOutput', id: string, createdAt: any, updatedAt: any, title: string, start: any, end: any, location: string, notes?: string | null, isDaycare?: boolean | null, isPrivate?: boolean | null, users: Array<{ __typename?: 'AppointmentUser', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number, contacts?: Array<{ __typename?: 'ContactOutput', streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, email?: string | null, firstName?: string | null, id: string, lastName?: string | null, phoneNumber?: string | null }> | null }>, donor?: { __typename?: 'AppointmentDonor', id: string, age: number, gender: AnimalGender, hasTransfusion?: boolean | null, name: string, neutered: boolean, primaryVeterinarian: string, species: AnimalSpecies, takeMedications?: boolean | null, weight: number, bloodType?: BloodType | null, status: DonorStatus, type: DonorType, location: string, distinguishableMarks?: string | null, microchipNumber?: string | null, medicationCourse?: string | null, comment?: string | null, breed?: string | null, color?: string | null, createdAt: any, shortId: number, firstCertificatePrinted: boolean, secondCertificatePrinted: boolean, user?: { __typename?: 'AppointmentUser', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number, contacts?: Array<{ __typename?: 'ContactOutput', streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, email?: string | null, firstName?: string | null, id: string, lastName?: string | null, phoneNumber?: string | null }> | null } | null } | null, group?: { __typename?: 'AppointmentGroupOutput', id: string, title: string, user?: { __typename?: 'AppointmentUser', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number, contacts?: Array<{ __typename?: 'ContactOutput', streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, email?: string | null, firstName?: string | null, id: string, lastName?: string | null, phoneNumber?: string | null }> | null } | null } | null, team?: { __typename?: 'AppointmentTeamOutput', id: string, title: string } | null } | null, request?: { __typename?: 'PartialRequestOutput', id: string, number: number, updatedAt: any, donor: { __typename?: 'PartialDonorOutput', id?: string | null, age?: number | null, gender?: AnimalGender | null, hasTransfusion?: boolean | null, name?: string | null, neutered?: boolean | null, primaryVeterinarian?: string | null, species?: AnimalSpecies | null, takeMedications?: boolean | null, weight?: number | null, approvedDonationML?: number | null, donationMLApprovedAmount?: number | null, bloodType?: BloodType | null, status?: DonorStatus | null, type?: DonorType | null, location?: string | null, distinguishableMarks?: string | null, microchipNumber?: string | null, medicationCourse?: string | null, comment?: string | null, breed?: string | null, color?: string | null, createdAt?: any | null, shortId?: number | null, firstCertificatePrinted?: boolean | null, secondCertificatePrinted?: boolean | null, becameReservedDonorDate?: any | null, retiredDate?: any | null, distemperDate?: any | null, rabiesDate?: any | null, lastDonationDate?: any | null, nextDonationDate?: any | null, lastLabworkDate?: any | null, hasMicrochip?: boolean | null, acceptSimparicaTrio?: boolean | null, isDaycare?: boolean | null, donationFrequency?: number | null, canRegularlyAttendDaycare?: boolean | null, attendDaycareDays?: Array<string> | null, retiredReason?: RetiredReasons | null, retiredReasonComment?: string | null, dateOfBirth?: any | null, team?: { __typename?: 'TeamOutput', id: string, title: string } | null, user?: { __typename?: 'OwnerOutput', email: string, id: string, firstName: string, lastName: string, hasMultipleDonors?: boolean | null, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number, type?: OwnerType | null, isArchived: boolean, contactPreferences?: string | null, createdAt: any, deletedAt?: any | null, contacts?: Array<{ __typename?: 'ContactOutput', streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, email?: string | null, firstName?: string | null, id: string, lastName?: string | null, phoneNumber?: string | null }> | null } | null } } | null }, user: { __typename?: 'NotificationUserOutput', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number, type?: OwnerType | null, isArchived: boolean, contactPreferences?: string | null, contacts?: Array<{ __typename?: 'ContactOutput', streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, email?: string | null, firstName?: string | null, id: string, lastName?: string | null, phoneNumber?: string | null }> | null, role: { __typename?: 'RoleWithoutPermissionsOutput', id: string, value: UserRole } } }>, meta: { __typename?: 'MetaData', total: number } } };

export type NotificationAddedSubscriptionVariables = Exact<{
  input: NotificationAddedSubscriptionInput;
}>;


export type NotificationAddedSubscription = { __typename?: 'Subscription', notificationAdded: { __typename?: 'NotificationWebSocketOutput', id: string, type: NotificationType, isRead: boolean } };

export type OrderBillingFragment = { __typename?: 'BillingOutput', city: string, company: string, country: string, email: string, firstAddress: string, firstName: string, lastName: string, phone: string, postcode: string, secondAddress?: string | null, state: string };

export type OrderShippingFragment = { __typename?: 'ShippingOutput', city: string, company: string, country: string, firstAddress: string, firstName: string, lastName: string, phone: string, postcode: string, secondAddress?: string | null, state: string };

export type ShippingLineFragment = { __typename?: 'ShippingLineOutput', id: number, instanceId: string, methodId: string, methodTitle: string, total: string, totalTax: string };

export type FeeLineFragment = { __typename?: 'FeeLineOutput', amount: string, id: number, name: string, taxClass: string, taxStatus: TaxStatus, total: string, totalTax: string };

export type OrderItemFragment = { __typename?: 'OrderItemOutput', id: number, name: string, price: number, quantity: number, sku?: string | null };

export type GetOrdersListQueryVariables = Exact<{
  input: GetOrdersListInput;
}>;


export type GetOrdersListQuery = { __typename?: 'Query', getOrdersList: { __typename?: 'OrderListOutput', data: Array<{ __typename?: 'OrderOutput', id: string, date: string, number: number, status: string, trackingCode?: string | null, paymentMethod: string, total: string, customerId: string, items: Array<{ __typename?: 'OrderItemOutput', id: number, name: string, price: number, quantity: number, sku?: string | null }>, billing: { __typename?: 'BillingOutput', city: string, company: string, country: string, email: string, firstAddress: string, firstName: string, lastName: string, phone: string, postcode: string, secondAddress?: string | null, state: string }, shipping: { __typename?: 'ShippingOutput', city: string, company: string, country: string, firstAddress: string, firstName: string, lastName: string, phone: string, postcode: string, secondAddress?: string | null, state: string }, shippingLines: Array<{ __typename?: 'ShippingLineOutput', id: number, instanceId: string, methodId: string, methodTitle: string, total: string, totalTax: string }>, feeLines: Array<{ __typename?: 'FeeLineOutput', amount: string, id: number, name: string, taxClass: string, taxStatus: TaxStatus, total: string, totalTax: string }> }>, meta: { __typename?: 'MetaData', total: number } } };

export type GetCustomerQueryVariables = Exact<{
  input: GetCustomerInput;
}>;


export type GetCustomerQuery = { __typename?: 'Query', getCustomer: { __typename?: 'CustomerOutput', email?: string | null, firstName: string, id: string, lastName: string, username: string, billing: { __typename?: 'BillingOutput', city: string, company: string, country: string, email: string, firstAddress: string, firstName: string, lastName: string, phone: string, postcode: string, secondAddress?: string | null, state: string }, shipping: { __typename?: 'ShippingOutput', city: string, company: string, country: string, firstAddress: string, firstName: string, lastName: string, phone: string, postcode: string, secondAddress?: string | null, state: string } } };

export type GetOrderQueryVariables = Exact<{
  input: GetOrderInput;
}>;


export type GetOrderQuery = { __typename?: 'Query', getOrder: { __typename?: 'OrderOutput', id: string, date: string, number: number, status: string, trackingCode?: string | null, paymentMethod: string, total: string, customerId: string, items: Array<{ __typename?: 'OrderItemOutput', id: number, name: string, price: number, quantity: number, sku?: string | null }>, billing: { __typename?: 'BillingOutput', city: string, company: string, country: string, email: string, firstAddress: string, firstName: string, lastName: string, phone: string, postcode: string, secondAddress?: string | null, state: string }, shipping: { __typename?: 'ShippingOutput', city: string, company: string, country: string, firstAddress: string, firstName: string, lastName: string, phone: string, postcode: string, secondAddress?: string | null, state: string }, shippingLines: Array<{ __typename?: 'ShippingLineOutput', id: number, instanceId: string, methodId: string, methodTitle: string, total: string, totalTax: string }>, feeLines: Array<{ __typename?: 'FeeLineOutput', amount: string, id: number, name: string, taxClass: string, taxStatus: TaxStatus, total: string, totalTax: string }> } };

export type OwnerFragment = { __typename?: 'OwnerOutput', email: string, id: string, firstName: string, lastName: string, hasMultipleDonors?: boolean | null, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number, type?: OwnerType | null, isArchived: boolean, contactPreferences?: string | null, createdAt: any, deletedAt?: any | null };

export type UserAttachmentFragment = { __typename?: 'UserAttachmentOutput', id: string, createdAt: any, updatedAt: any };

export type UpdateContactMutationVariables = Exact<{
  input: UpdateContactInput;
}>;


export type UpdateContactMutation = { __typename?: 'Mutation', updateContact: { __typename?: 'ContactOutput', streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, lastName?: string | null, firstName?: string | null, email?: string | null, id: string, phoneNumber?: string | null } };

export type CreateContactMutationVariables = Exact<{
  input: CreateContactInput;
}>;


export type CreateContactMutation = { __typename?: 'Mutation', createContact: { __typename?: 'ContactOutput', streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, lastName?: string | null, firstName?: string | null, email?: string | null, id: string, phoneNumber?: string | null } };

export type UpdateOwnerInfoMutationVariables = Exact<{
  input: UpdateOwnerInput;
}>;


export type UpdateOwnerInfoMutation = { __typename?: 'Mutation', updateOwnerInfo: { __typename?: 'UserOutput', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number, type?: OwnerType | null, isArchived: boolean, deletionIntentionAt?: any | null, contactPreferences?: string | null, deletedAt?: any | null, contacts?: Array<{ __typename?: 'ContactOutput', streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, email?: string | null, firstName?: string | null, id: string, lastName?: string | null, phoneNumber?: string | null }> | null, role: { __typename?: 'RoleOutput', id: string, value: UserRole }, assignedLocations?: Array<{ __typename?: 'LocationOutput', id: string, createdAt: any, updatedAt: any, name: string, type: LocationType, region?: { __typename?: 'RegionOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null } | null }> | null, assignedRegions?: Array<{ __typename?: 'RegionOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null }> | null, productRegionPreference?: { __typename?: 'RegionOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null } | null, assignedOffice?: { __typename?: 'OfficeOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null, region: { __typename?: 'RegionOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null } } | null } };

export type UpdateOwnerEmailMutationVariables = Exact<{
  input: UpdateUserEmailInput;
}>;


export type UpdateOwnerEmailMutation = { __typename?: 'Mutation', updateOwnerEmail: { __typename?: 'UserOutput', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number, type?: OwnerType | null, isArchived: boolean, deletionIntentionAt?: any | null, contactPreferences?: string | null, deletedAt?: any | null, contacts?: Array<{ __typename?: 'ContactOutput', streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, email?: string | null, firstName?: string | null, id: string, lastName?: string | null, phoneNumber?: string | null }> | null, role: { __typename?: 'RoleOutput', id: string, value: UserRole }, assignedLocations?: Array<{ __typename?: 'LocationOutput', id: string, createdAt: any, updatedAt: any, name: string, type: LocationType, region?: { __typename?: 'RegionOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null } | null }> | null, assignedRegions?: Array<{ __typename?: 'RegionOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null }> | null, productRegionPreference?: { __typename?: 'RegionOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null } | null, assignedOffice?: { __typename?: 'OfficeOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null, region: { __typename?: 'RegionOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null } } | null } };

export type UpdateCurrentOwnerInfoMutationVariables = Exact<{
  input: UpdateOwnerInput;
}>;


export type UpdateCurrentOwnerInfoMutation = { __typename?: 'Mutation', updateCurrentOwnerInfo: { __typename?: 'UserOutput', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number, type?: OwnerType | null, isArchived: boolean, deletionIntentionAt?: any | null, contactPreferences?: string | null, deletedAt?: any | null, contacts?: Array<{ __typename?: 'ContactOutput', streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, email?: string | null, firstName?: string | null, id: string, lastName?: string | null, phoneNumber?: string | null }> | null, role: { __typename?: 'RoleOutput', id: string, value: UserRole }, assignedLocations?: Array<{ __typename?: 'LocationOutput', id: string, createdAt: any, updatedAt: any, name: string, type: LocationType, region?: { __typename?: 'RegionOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null } | null }> | null, assignedRegions?: Array<{ __typename?: 'RegionOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null }> | null, productRegionPreference?: { __typename?: 'RegionOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null } | null, assignedOffice?: { __typename?: 'OfficeOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null, region: { __typename?: 'RegionOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null } } | null } };

export type UpdateCurrentOwnerEmailMutationVariables = Exact<{
  input: UpdateUserEmailInput;
}>;


export type UpdateCurrentOwnerEmailMutation = { __typename?: 'Mutation', updateCurrentOwnerEmail: { __typename?: 'UserOutput', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number, type?: OwnerType | null, isArchived: boolean, deletionIntentionAt?: any | null, contactPreferences?: string | null, deletedAt?: any | null, contacts?: Array<{ __typename?: 'ContactOutput', streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, email?: string | null, firstName?: string | null, id: string, lastName?: string | null, phoneNumber?: string | null }> | null, role: { __typename?: 'RoleOutput', id: string, value: UserRole }, assignedLocations?: Array<{ __typename?: 'LocationOutput', id: string, createdAt: any, updatedAt: any, name: string, type: LocationType, region?: { __typename?: 'RegionOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null } | null }> | null, assignedRegions?: Array<{ __typename?: 'RegionOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null }> | null, productRegionPreference?: { __typename?: 'RegionOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null } | null, assignedOffice?: { __typename?: 'OfficeOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null, region: { __typename?: 'RegionOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null } } | null } };

export type RemoveCurrentOwnerMutationVariables = Exact<{ [key: string]: never; }>;


export type RemoveCurrentOwnerMutation = { __typename?: 'Mutation', removeCurrentOwner: boolean };

export type CancelDeletingCurrentOwnerMutationVariables = Exact<{ [key: string]: never; }>;


export type CancelDeletingCurrentOwnerMutation = { __typename?: 'Mutation', cancelDeletingCurrentOwner: boolean };

export type DetachUserFileMutationVariables = Exact<{
  input: DetachUserAttachmentInput;
}>;


export type DetachUserFileMutation = { __typename?: 'Mutation', detachUserFile: boolean };

export type GetUserContactsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserContactsQuery = { __typename?: 'Query', getUserContacts: Array<{ __typename?: 'ContactOutput', streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, id: string }> };

export type GetOwnerQueryVariables = Exact<{
  input: GetUserInput;
}>;


export type GetOwnerQuery = { __typename?: 'Query', getOwner: { __typename?: 'OwnerOutput', email: string, id: string, firstName: string, lastName: string, hasMultipleDonors?: boolean | null, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number, type?: OwnerType | null, isArchived: boolean, contactPreferences?: string | null, createdAt: any, deletedAt?: any | null, contacts?: Array<{ __typename?: 'ContactOutput', streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, email?: string | null, firstName?: string | null, id: string, lastName?: string | null, phoneNumber?: string | null }> | null } };

export type GetUserDonorsListQueryVariables = Exact<{
  input: UserDonorListInput;
}>;


export type GetUserDonorsListQuery = { __typename?: 'Query', getUserDonorsList: { __typename?: 'DonorsListOutput', data: Array<{ __typename?: 'DonorOutput', id: string, age: number, gender: AnimalGender, hasTransfusion?: boolean | null, name: string, neutered: boolean, primaryVeterinarian: string, species: AnimalSpecies, takeMedications?: boolean | null, weight: number, approvedDonationML: number, donationMLApprovedAmount?: number | null, bloodType?: BloodType | null, status: DonorStatus, type: DonorType, location: string, distinguishableMarks?: string | null, microchipNumber?: string | null, medicationCourse?: string | null, comment?: string | null, breed?: string | null, color?: string | null, createdAt: any, shortId: number, firstCertificatePrinted: boolean, secondCertificatePrinted: boolean, becameReservedDonorDate?: any | null, retiredDate?: any | null, distemperDate?: any | null, rabiesDate?: any | null, lastDonationDate?: any | null, nextDonationDate?: any | null, lastLabworkDate?: any | null, hasMicrochip?: boolean | null, acceptSimparicaTrio: boolean, isDaycare?: boolean | null, donationFrequency: number, canRegularlyAttendDaycare?: boolean | null, attendDaycareDays?: Array<string> | null, retiredReason?: RetiredReasons | null, retiredReasonComment?: string | null, dateOfBirth: any, team?: { __typename?: 'TeamOutput', id: string, title: string } | null, user?: { __typename?: 'OwnerOutput', email: string, id: string, firstName: string, lastName: string, hasMultipleDonors?: boolean | null, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number, type?: OwnerType | null, isArchived: boolean, contactPreferences?: string | null, createdAt: any, deletedAt?: any | null, contacts?: Array<{ __typename?: 'ContactOutput', streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, email?: string | null, firstName?: string | null, id: string, lastName?: string | null, phoneNumber?: string | null }> | null } | null }>, meta: { __typename?: 'MetaData', total: number } } };

export type GetUserAttachmentsQueryVariables = Exact<{
  input: GetUserAttachmentsListInput;
}>;


export type GetUserAttachmentsQuery = { __typename?: 'Query', getUserAttachments: Array<{ __typename?: 'UserAttachmentOutput', id: string, createdAt: any, updatedAt: any, file: { __typename?: 'FileOutput', id: string, filename: string } }> };

export type ProductFragment = { __typename?: 'ProductOutput', anticoagulant?: Anticoagulant | null, createdAt: any, id: string, shortId: number, status: ProductStatus, storageRequirements: Array<string>, updatedAt: any, value: number, woocommerceProductId: number, woocommerceCategoryId: number, woocommerceOrderId?: number | null, expirationDate: any, published: boolean, publishable: boolean, isMantelAssigned?: boolean | null, bloodIdentifiers?: Array<{ __typename?: 'BloodUnitIdentifiersOutput', unitId?: number | null }> | null, regionPreference?: { __typename?: 'RegionOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null } | null };

export type DiscardedProductDataFragment = { __typename?: 'DiscardedProductDataOutput', processingType: ProcessingProductType, reason: ReasonDiscardProduct, notes?: string | null };

export type ProductProcessorFragment = { __typename?: 'ProductProcessorOutput', id: string, firstName: string, lastName: string };

export type CreateProductMutationVariables = Exact<{
  input: CreateProductInput;
}>;


export type CreateProductMutation = { __typename?: 'Mutation', createProduct: { __typename?: 'ProductOutput', anticoagulant?: Anticoagulant | null, createdAt: any, id: string, shortId: number, status: ProductStatus, storageRequirements: Array<string>, updatedAt: any, value: number, woocommerceProductId: number, woocommerceCategoryId: number, woocommerceOrderId?: number | null, expirationDate: any, published: boolean, publishable: boolean, isMantelAssigned?: boolean | null, discardedProduct?: { __typename?: 'DiscardedProductDataOutput', processingType: ProcessingProductType, reason: ReasonDiscardProduct, notes?: string | null, processor?: { __typename?: 'ProductProcessorOutput', id: string, firstName: string, lastName: string } | null } | null, donation: { __typename?: 'DonationOutput', id: string, collectionSet: CollectionSet, capillaryRefillTime: CapillaryRefillTime, approvedDonationsMl: number, jugularVein: JugularVein, maxLimit: number, mucousMembrane: Mm, packedCellVolume: number, pulse: number, respiration: number, shouldDonate?: boolean | null, temperature: number, totalSolids: number, unit?: DonationUnit | null, failedReason?: DonationFailedReason | null, actual?: number | null, weatherTemperature: number, weatherTypes: Array<WeatherType>, weight: number, examinationNotes?: string | null, preferences?: string | null, createdAt: any, comment?: string | null, shortId: number, donationDate: any, ineligible: boolean, ineligibleReason?: IneligibleReason | null, ineligibleReasonDetails?: string | null, products?: Array<{ __typename?: 'DonationProductOutput', anticoagulant?: Anticoagulant | null, createdAt: any, id: string, shortId: number, status: ProductStatus, storageRequirements: Array<string>, updatedAt: any, value: number, woocommerceProductId: number, woocommerceCategoryId: number, expirationDate: any, discardedProduct?: { __typename?: 'DiscardedProductDataOutput', processingType: ProcessingProductType, reason: ReasonDiscardProduct, notes?: string | null } | null, bloodIdentifiers?: Array<{ __typename?: 'BloodUnitIdentifiersOutput', unitId?: number | null, product?: { __typename?: 'ProductOutput', id: string, shortId: number } | null }> | null }> | null, donor: { __typename?: 'DonationDonor', id: string, age: number, gender: AnimalGender, hasTransfusion?: boolean | null, name: string, neutered: boolean, primaryVeterinarian: string, species: AnimalSpecies, takeMedications?: boolean | null, weight: number, bloodType?: BloodType | null, status: DonorStatus, type: DonorType, location: string, distinguishableMarks?: string | null, microchipNumber?: string | null, medicationCourse?: string | null, comment?: string | null, breed?: string | null, color?: string | null, createdAt: any, shortId: number, firstCertificatePrinted: boolean, secondCertificatePrinted: boolean, lastDonationDate?: any | null, lastLabworkDate?: any | null, nextDonationDate?: any | null, team?: { __typename?: 'TeamOutput', id: string, title: string } | null, user?: { __typename?: 'HolderOutput', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number } | null, pictures?: Array<{ __typename?: 'DonorPictureOutput', id: string, isPrimary: boolean, file: { __typename?: 'FileOutput', id: string, filename: string } }> | null }, additionalInfo?: { __typename?: 'AdditionalDonationInfoOutput', id: string, numberOfCollectionUnitsUsed: CollectionUnitsUsed, veinUsed: VeinUsed, vascularStructure?: VascularStructure | null, flowRate: FlowRate, donationPosition?: string | null, holdersPosition?: Array<string> | null, donorMovement: string, typeOfMovement?: string | null, emotionalSupport?: Array<string> | null, dislikes?: Array<string> | null, likes?: Array<string> | null, treatPreferences?: Array<string> | null, totalCollectedMls?: number | null, primaryHolder?: { __typename?: 'HolderOutput', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number } | null, secondaryHolder?: { __typename?: 'HolderOutput', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number } | null, poker?: { __typename?: 'HolderOutput', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number } | null } | null }, bloodIdentifiers?: Array<{ __typename?: 'BloodUnitIdentifiersOutput', unitId?: number | null }> | null, regionPreference?: { __typename?: 'RegionOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null } | null } };

export type CreateProductsMutationVariables = Exact<{
  input: CreateProductsInput;
}>;


export type CreateProductsMutation = { __typename?: 'Mutation', createProducts: Array<{ __typename?: 'ProductOutput', anticoagulant?: Anticoagulant | null, createdAt: any, id: string, shortId: number, status: ProductStatus, storageRequirements: Array<string>, updatedAt: any, value: number, woocommerceProductId: number, woocommerceCategoryId: number, woocommerceOrderId?: number | null, expirationDate: any, published: boolean, publishable: boolean, isMantelAssigned?: boolean | null, discardedProduct?: { __typename?: 'DiscardedProductDataOutput', processingType: ProcessingProductType, reason: ReasonDiscardProduct, notes?: string | null, processor?: { __typename?: 'ProductProcessorOutput', id: string, firstName: string, lastName: string } | null } | null, donation: { __typename?: 'DonationOutput', id: string, collectionSet: CollectionSet, capillaryRefillTime: CapillaryRefillTime, approvedDonationsMl: number, jugularVein: JugularVein, maxLimit: number, mucousMembrane: Mm, packedCellVolume: number, pulse: number, respiration: number, shouldDonate?: boolean | null, temperature: number, totalSolids: number, unit?: DonationUnit | null, failedReason?: DonationFailedReason | null, actual?: number | null, weatherTemperature: number, weatherTypes: Array<WeatherType>, weight: number, examinationNotes?: string | null, preferences?: string | null, createdAt: any, comment?: string | null, shortId: number, donationDate: any, ineligible: boolean, ineligibleReason?: IneligibleReason | null, ineligibleReasonDetails?: string | null, products?: Array<{ __typename?: 'DonationProductOutput', anticoagulant?: Anticoagulant | null, createdAt: any, id: string, shortId: number, status: ProductStatus, storageRequirements: Array<string>, updatedAt: any, value: number, woocommerceProductId: number, woocommerceCategoryId: number, expirationDate: any, discardedProduct?: { __typename?: 'DiscardedProductDataOutput', processingType: ProcessingProductType, reason: ReasonDiscardProduct, notes?: string | null } | null, bloodIdentifiers?: Array<{ __typename?: 'BloodUnitIdentifiersOutput', unitId?: number | null, product?: { __typename?: 'ProductOutput', id: string, shortId: number } | null }> | null }> | null, donor: { __typename?: 'DonationDonor', id: string, age: number, gender: AnimalGender, hasTransfusion?: boolean | null, name: string, neutered: boolean, primaryVeterinarian: string, species: AnimalSpecies, takeMedications?: boolean | null, weight: number, bloodType?: BloodType | null, status: DonorStatus, type: DonorType, location: string, distinguishableMarks?: string | null, microchipNumber?: string | null, medicationCourse?: string | null, comment?: string | null, breed?: string | null, color?: string | null, createdAt: any, shortId: number, firstCertificatePrinted: boolean, secondCertificatePrinted: boolean, lastDonationDate?: any | null, lastLabworkDate?: any | null, nextDonationDate?: any | null, team?: { __typename?: 'TeamOutput', id: string, title: string } | null, user?: { __typename?: 'HolderOutput', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number } | null, pictures?: Array<{ __typename?: 'DonorPictureOutput', id: string, isPrimary: boolean, file: { __typename?: 'FileOutput', id: string, filename: string } }> | null }, additionalInfo?: { __typename?: 'AdditionalDonationInfoOutput', id: string, numberOfCollectionUnitsUsed: CollectionUnitsUsed, veinUsed: VeinUsed, vascularStructure?: VascularStructure | null, flowRate: FlowRate, donationPosition?: string | null, holdersPosition?: Array<string> | null, donorMovement: string, typeOfMovement?: string | null, emotionalSupport?: Array<string> | null, dislikes?: Array<string> | null, likes?: Array<string> | null, treatPreferences?: Array<string> | null, totalCollectedMls?: number | null, primaryHolder?: { __typename?: 'HolderOutput', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number } | null, secondaryHolder?: { __typename?: 'HolderOutput', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number } | null, poker?: { __typename?: 'HolderOutput', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number } | null } | null }, bloodIdentifiers?: Array<{ __typename?: 'BloodUnitIdentifiersOutput', unitId?: number | null }> | null, regionPreference?: { __typename?: 'RegionOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null } | null }> };

export type MakeProductAvailableMutationVariables = Exact<{
  input: MakeProductAvailableInput;
}>;


export type MakeProductAvailableMutation = { __typename?: 'Mutation', makeProductAvailable: { __typename?: 'ProductOutput', anticoagulant?: Anticoagulant | null, createdAt: any, id: string, shortId: number, status: ProductStatus, storageRequirements: Array<string>, updatedAt: any, value: number, woocommerceProductId: number, woocommerceCategoryId: number, woocommerceOrderId?: number | null, expirationDate: any, published: boolean, publishable: boolean, isMantelAssigned?: boolean | null, donation: { __typename?: 'DonationOutput', id: string, collectionSet: CollectionSet, capillaryRefillTime: CapillaryRefillTime, approvedDonationsMl: number, jugularVein: JugularVein, maxLimit: number, mucousMembrane: Mm, packedCellVolume: number, pulse: number, respiration: number, shouldDonate?: boolean | null, temperature: number, totalSolids: number, unit?: DonationUnit | null, failedReason?: DonationFailedReason | null, actual?: number | null, weatherTemperature: number, weatherTypes: Array<WeatherType>, weight: number, examinationNotes?: string | null, preferences?: string | null, createdAt: any, comment?: string | null, shortId: number, donationDate: any, ineligible: boolean, ineligibleReason?: IneligibleReason | null, ineligibleReasonDetails?: string | null, products?: Array<{ __typename?: 'DonationProductOutput', anticoagulant?: Anticoagulant | null, createdAt: any, id: string, shortId: number, status: ProductStatus, storageRequirements: Array<string>, updatedAt: any, value: number, woocommerceProductId: number, woocommerceCategoryId: number, expirationDate: any, discardedProduct?: { __typename?: 'DiscardedProductDataOutput', processingType: ProcessingProductType, reason: ReasonDiscardProduct, notes?: string | null } | null, bloodIdentifiers?: Array<{ __typename?: 'BloodUnitIdentifiersOutput', unitId?: number | null, product?: { __typename?: 'ProductOutput', id: string, shortId: number } | null }> | null }> | null, donor: { __typename?: 'DonationDonor', id: string, age: number, gender: AnimalGender, hasTransfusion?: boolean | null, name: string, neutered: boolean, primaryVeterinarian: string, species: AnimalSpecies, takeMedications?: boolean | null, weight: number, bloodType?: BloodType | null, status: DonorStatus, type: DonorType, location: string, distinguishableMarks?: string | null, microchipNumber?: string | null, medicationCourse?: string | null, comment?: string | null, breed?: string | null, color?: string | null, createdAt: any, shortId: number, firstCertificatePrinted: boolean, secondCertificatePrinted: boolean, lastDonationDate?: any | null, lastLabworkDate?: any | null, nextDonationDate?: any | null, team?: { __typename?: 'TeamOutput', id: string, title: string } | null, user?: { __typename?: 'HolderOutput', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number } | null, pictures?: Array<{ __typename?: 'DonorPictureOutput', id: string, isPrimary: boolean, file: { __typename?: 'FileOutput', id: string, filename: string } }> | null }, additionalInfo?: { __typename?: 'AdditionalDonationInfoOutput', id: string, numberOfCollectionUnitsUsed: CollectionUnitsUsed, veinUsed: VeinUsed, vascularStructure?: VascularStructure | null, flowRate: FlowRate, donationPosition?: string | null, holdersPosition?: Array<string> | null, donorMovement: string, typeOfMovement?: string | null, emotionalSupport?: Array<string> | null, dislikes?: Array<string> | null, likes?: Array<string> | null, treatPreferences?: Array<string> | null, totalCollectedMls?: number | null, primaryHolder?: { __typename?: 'HolderOutput', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number } | null, secondaryHolder?: { __typename?: 'HolderOutput', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number } | null, poker?: { __typename?: 'HolderOutput', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number } | null } | null }, bloodIdentifiers?: Array<{ __typename?: 'BloodUnitIdentifiersOutput', unitId?: number | null }> | null, regionPreference?: { __typename?: 'RegionOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null } | null } };

export type UpdateProductStatusMutationVariables = Exact<{
  input: UpdateProductStatusInput;
}>;


export type UpdateProductStatusMutation = { __typename?: 'Mutation', updateProductStatus: { __typename?: 'ProductOutput', anticoagulant?: Anticoagulant | null, createdAt: any, id: string, shortId: number, status: ProductStatus, storageRequirements: Array<string>, updatedAt: any, value: number, woocommerceProductId: number, woocommerceCategoryId: number, woocommerceOrderId?: number | null, expirationDate: any, published: boolean, publishable: boolean, isMantelAssigned?: boolean | null, discardedProduct?: { __typename?: 'DiscardedProductDataOutput', processingType: ProcessingProductType, reason: ReasonDiscardProduct, notes?: string | null, processor?: { __typename?: 'ProductProcessorOutput', id: string, firstName: string, lastName: string } | null } | null, donation: { __typename?: 'DonationOutput', id: string, collectionSet: CollectionSet, capillaryRefillTime: CapillaryRefillTime, approvedDonationsMl: number, jugularVein: JugularVein, maxLimit: number, mucousMembrane: Mm, packedCellVolume: number, pulse: number, respiration: number, shouldDonate?: boolean | null, temperature: number, totalSolids: number, unit?: DonationUnit | null, failedReason?: DonationFailedReason | null, actual?: number | null, weatherTemperature: number, weatherTypes: Array<WeatherType>, weight: number, examinationNotes?: string | null, preferences?: string | null, createdAt: any, comment?: string | null, shortId: number, donationDate: any, ineligible: boolean, ineligibleReason?: IneligibleReason | null, ineligibleReasonDetails?: string | null, products?: Array<{ __typename?: 'DonationProductOutput', anticoagulant?: Anticoagulant | null, createdAt: any, id: string, shortId: number, status: ProductStatus, storageRequirements: Array<string>, updatedAt: any, value: number, woocommerceProductId: number, woocommerceCategoryId: number, expirationDate: any, discardedProduct?: { __typename?: 'DiscardedProductDataOutput', processingType: ProcessingProductType, reason: ReasonDiscardProduct, notes?: string | null } | null, bloodIdentifiers?: Array<{ __typename?: 'BloodUnitIdentifiersOutput', unitId?: number | null, product?: { __typename?: 'ProductOutput', id: string, shortId: number } | null }> | null }> | null, donor: { __typename?: 'DonationDonor', id: string, age: number, gender: AnimalGender, hasTransfusion?: boolean | null, name: string, neutered: boolean, primaryVeterinarian: string, species: AnimalSpecies, takeMedications?: boolean | null, weight: number, bloodType?: BloodType | null, status: DonorStatus, type: DonorType, location: string, distinguishableMarks?: string | null, microchipNumber?: string | null, medicationCourse?: string | null, comment?: string | null, breed?: string | null, color?: string | null, createdAt: any, shortId: number, firstCertificatePrinted: boolean, secondCertificatePrinted: boolean, lastDonationDate?: any | null, lastLabworkDate?: any | null, nextDonationDate?: any | null, team?: { __typename?: 'TeamOutput', id: string, title: string } | null, user?: { __typename?: 'HolderOutput', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number } | null, pictures?: Array<{ __typename?: 'DonorPictureOutput', id: string, isPrimary: boolean, file: { __typename?: 'FileOutput', id: string, filename: string } }> | null }, additionalInfo?: { __typename?: 'AdditionalDonationInfoOutput', id: string, numberOfCollectionUnitsUsed: CollectionUnitsUsed, veinUsed: VeinUsed, vascularStructure?: VascularStructure | null, flowRate: FlowRate, donationPosition?: string | null, holdersPosition?: Array<string> | null, donorMovement: string, typeOfMovement?: string | null, emotionalSupport?: Array<string> | null, dislikes?: Array<string> | null, likes?: Array<string> | null, treatPreferences?: Array<string> | null, totalCollectedMls?: number | null, primaryHolder?: { __typename?: 'HolderOutput', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number } | null, secondaryHolder?: { __typename?: 'HolderOutput', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number } | null, poker?: { __typename?: 'HolderOutput', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number } | null } | null }, bloodIdentifiers?: Array<{ __typename?: 'BloodUnitIdentifiersOutput', unitId?: number | null }> | null, regionPreference?: { __typename?: 'RegionOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null } | null } };

export type UpdateProductMutationVariables = Exact<{
  input: UpdateProductInput;
}>;


export type UpdateProductMutation = { __typename?: 'Mutation', updateProduct: { __typename?: 'ProductOutput', anticoagulant?: Anticoagulant | null, createdAt: any, id: string, shortId: number, status: ProductStatus, storageRequirements: Array<string>, updatedAt: any, value: number, woocommerceProductId: number, woocommerceCategoryId: number, woocommerceOrderId?: number | null, expirationDate: any, published: boolean, publishable: boolean, isMantelAssigned?: boolean | null, discardedProduct?: { __typename?: 'DiscardedProductDataOutput', processingType: ProcessingProductType, reason: ReasonDiscardProduct, notes?: string | null, processor?: { __typename?: 'ProductProcessorOutput', id: string, firstName: string, lastName: string } | null } | null, donation: { __typename?: 'DonationOutput', id: string, collectionSet: CollectionSet, capillaryRefillTime: CapillaryRefillTime, approvedDonationsMl: number, jugularVein: JugularVein, maxLimit: number, mucousMembrane: Mm, packedCellVolume: number, pulse: number, respiration: number, shouldDonate?: boolean | null, temperature: number, totalSolids: number, unit?: DonationUnit | null, failedReason?: DonationFailedReason | null, actual?: number | null, weatherTemperature: number, weatherTypes: Array<WeatherType>, weight: number, examinationNotes?: string | null, preferences?: string | null, createdAt: any, comment?: string | null, shortId: number, donationDate: any, ineligible: boolean, ineligibleReason?: IneligibleReason | null, ineligibleReasonDetails?: string | null, products?: Array<{ __typename?: 'DonationProductOutput', anticoagulant?: Anticoagulant | null, createdAt: any, id: string, shortId: number, status: ProductStatus, storageRequirements: Array<string>, updatedAt: any, value: number, woocommerceProductId: number, woocommerceCategoryId: number, expirationDate: any, discardedProduct?: { __typename?: 'DiscardedProductDataOutput', processingType: ProcessingProductType, reason: ReasonDiscardProduct, notes?: string | null } | null, bloodIdentifiers?: Array<{ __typename?: 'BloodUnitIdentifiersOutput', unitId?: number | null, product?: { __typename?: 'ProductOutput', id: string, shortId: number } | null }> | null }> | null, donor: { __typename?: 'DonationDonor', id: string, age: number, gender: AnimalGender, hasTransfusion?: boolean | null, name: string, neutered: boolean, primaryVeterinarian: string, species: AnimalSpecies, takeMedications?: boolean | null, weight: number, bloodType?: BloodType | null, status: DonorStatus, type: DonorType, location: string, distinguishableMarks?: string | null, microchipNumber?: string | null, medicationCourse?: string | null, comment?: string | null, breed?: string | null, color?: string | null, createdAt: any, shortId: number, firstCertificatePrinted: boolean, secondCertificatePrinted: boolean, lastDonationDate?: any | null, lastLabworkDate?: any | null, nextDonationDate?: any | null, team?: { __typename?: 'TeamOutput', id: string, title: string } | null, user?: { __typename?: 'HolderOutput', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number } | null, pictures?: Array<{ __typename?: 'DonorPictureOutput', id: string, isPrimary: boolean, file: { __typename?: 'FileOutput', id: string, filename: string } }> | null }, additionalInfo?: { __typename?: 'AdditionalDonationInfoOutput', id: string, numberOfCollectionUnitsUsed: CollectionUnitsUsed, veinUsed: VeinUsed, vascularStructure?: VascularStructure | null, flowRate: FlowRate, donationPosition?: string | null, holdersPosition?: Array<string> | null, donorMovement: string, typeOfMovement?: string | null, emotionalSupport?: Array<string> | null, dislikes?: Array<string> | null, likes?: Array<string> | null, treatPreferences?: Array<string> | null, totalCollectedMls?: number | null, primaryHolder?: { __typename?: 'HolderOutput', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number } | null, secondaryHolder?: { __typename?: 'HolderOutput', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number } | null, poker?: { __typename?: 'HolderOutput', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number } | null } | null }, bloodIdentifiers?: Array<{ __typename?: 'BloodUnitIdentifiersOutput', unitId?: number | null }> | null, regionPreference?: { __typename?: 'RegionOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null } | null } };

export type DeleteProductMutationVariables = Exact<{
  input: DeleteProductInput;
}>;


export type DeleteProductMutation = { __typename?: 'Mutation', deleteProduct: boolean };

export type UntieWoocommerceOrderFromProductMutationVariables = Exact<{
  input: UntieWoocommerceOrderInput;
}>;


export type UntieWoocommerceOrderFromProductMutation = { __typename?: 'Mutation', untieWoocommerceOrderFromProduct: { __typename?: 'ProductOutput', id: string, woocommerceOrderId?: number | null } };

export type GetWoocommerceCategoriesQueryVariables = Exact<{
  input: GetWoocommerceProductCategoriesInput;
}>;


export type GetWoocommerceCategoriesQuery = { __typename?: 'Query', getWoocommerceCategories: Array<{ __typename?: 'WoocommerceProductCategoryOutput', id: number, count: number, name: string, slug: string, parent: number }> };

export type GetWoocommerceProductsQueryVariables = Exact<{
  input: GetWoocommerceProductsInput;
}>;


export type GetWoocommerceProductsQuery = { __typename?: 'Query', getWoocommerceProducts: { __typename?: 'WoocommerceProductListOutput', data: Array<{ __typename?: 'WoocommerceProductOutput', date_created: string, date_modified: string, description: string, id: number, name: string, price: string, slug: string, status: string, stock_status: string, stock_quantity?: number | null, type: string, categories: Array<{ __typename?: 'Category', id: number, name: string, slug: string }> }>, meta: { __typename?: 'MetaData', total: number } } };

export type GetProductsQueryVariables = Exact<{
  input: ProductListInput;
}>;


export type GetProductsQuery = { __typename?: 'Query', getProducts: { __typename?: 'ProductListOutput', data: Array<{ __typename?: 'ProductOutput', anticoagulant?: Anticoagulant | null, createdAt: any, id: string, shortId: number, status: ProductStatus, storageRequirements: Array<string>, updatedAt: any, value: number, woocommerceProductId: number, woocommerceCategoryId: number, woocommerceOrderId?: number | null, expirationDate: any, published: boolean, publishable: boolean, isMantelAssigned?: boolean | null, discardedProduct?: { __typename?: 'DiscardedProductDataOutput', processingType: ProcessingProductType, reason: ReasonDiscardProduct, notes?: string | null, processor?: { __typename?: 'ProductProcessorOutput', id: string, firstName: string, lastName: string } | null } | null, donation: { __typename?: 'DonationOutput', id: string, collectionSet: CollectionSet, capillaryRefillTime: CapillaryRefillTime, approvedDonationsMl: number, jugularVein: JugularVein, maxLimit: number, mucousMembrane: Mm, packedCellVolume: number, pulse: number, respiration: number, shouldDonate?: boolean | null, temperature: number, totalSolids: number, unit?: DonationUnit | null, failedReason?: DonationFailedReason | null, actual?: number | null, weatherTemperature: number, weatherTypes: Array<WeatherType>, weight: number, examinationNotes?: string | null, preferences?: string | null, createdAt: any, comment?: string | null, shortId: number, donationDate: any, ineligible: boolean, ineligibleReason?: IneligibleReason | null, donor: { __typename?: 'DonationDonor', id: string, age: number, gender: AnimalGender, hasTransfusion?: boolean | null, name: string, neutered: boolean, primaryVeterinarian: string, species: AnimalSpecies, takeMedications?: boolean | null, weight: number, bloodType?: BloodType | null, status: DonorStatus, type: DonorType, location: string, distinguishableMarks?: string | null, microchipNumber?: string | null, medicationCourse?: string | null, comment?: string | null, breed?: string | null, color?: string | null, createdAt: any, shortId: number, firstCertificatePrinted: boolean, secondCertificatePrinted: boolean, lastDonationDate?: any | null, lastLabworkDate?: any | null, nextDonationDate?: any | null, team?: { __typename?: 'TeamOutput', id: string, title: string } | null, user?: { __typename?: 'HolderOutput', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number } | null, pictures?: Array<{ __typename?: 'DonorPictureOutput', id: string, isPrimary: boolean, file: { __typename?: 'FileOutput', id: string, filename: string } }> | null }, additionalInfo?: { __typename?: 'AdditionalDonationInfoOutput', id: string, numberOfCollectionUnitsUsed: CollectionUnitsUsed, veinUsed: VeinUsed, vascularStructure?: VascularStructure | null, flowRate: FlowRate, donationPosition?: string | null, holdersPosition?: Array<string> | null, donorMovement: string, typeOfMovement?: string | null, emotionalSupport?: Array<string> | null, dislikes?: Array<string> | null, likes?: Array<string> | null, treatPreferences?: Array<string> | null, totalCollectedMls?: number | null, primaryHolder?: { __typename?: 'HolderOutput', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number } | null, secondaryHolder?: { __typename?: 'HolderOutput', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number } | null, poker?: { __typename?: 'HolderOutput', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number } | null } | null }, bloodIdentifiers?: Array<{ __typename?: 'BloodUnitIdentifiersOutput', unitId?: number | null }> | null, regionPreference?: { __typename?: 'RegionOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null } | null }>, meta: { __typename?: 'MetaData', total: number } } };

export type GetProductQueryVariables = Exact<{
  input: GetProductInput;
}>;


export type GetProductQuery = { __typename?: 'Query', getProduct: { __typename?: 'ProductOutput', anticoagulant?: Anticoagulant | null, createdAt: any, id: string, shortId: number, status: ProductStatus, storageRequirements: Array<string>, updatedAt: any, value: number, woocommerceProductId: number, woocommerceCategoryId: number, woocommerceOrderId?: number | null, expirationDate: any, published: boolean, publishable: boolean, isMantelAssigned?: boolean | null, donation: { __typename?: 'DonationOutput', id: string, collectionSet: CollectionSet, capillaryRefillTime: CapillaryRefillTime, approvedDonationsMl: number, jugularVein: JugularVein, maxLimit: number, mucousMembrane: Mm, packedCellVolume: number, pulse: number, respiration: number, shouldDonate?: boolean | null, temperature: number, totalSolids: number, unit?: DonationUnit | null, failedReason?: DonationFailedReason | null, actual?: number | null, weatherTemperature: number, weatherTypes: Array<WeatherType>, weight: number, examinationNotes?: string | null, preferences?: string | null, createdAt: any, comment?: string | null, shortId: number, donationDate: any, ineligible: boolean, ineligibleReason?: IneligibleReason | null, ineligibleReasonDetails?: string | null, products?: Array<{ __typename?: 'DonationProductOutput', anticoagulant?: Anticoagulant | null, createdAt: any, id: string, shortId: number, status: ProductStatus, storageRequirements: Array<string>, updatedAt: any, value: number, woocommerceProductId: number, woocommerceCategoryId: number, expirationDate: any, discardedProduct?: { __typename?: 'DiscardedProductDataOutput', processingType: ProcessingProductType, reason: ReasonDiscardProduct, notes?: string | null } | null, bloodIdentifiers?: Array<{ __typename?: 'BloodUnitIdentifiersOutput', unitId?: number | null, product?: { __typename?: 'ProductOutput', id: string, shortId: number } | null }> | null }> | null, donor: { __typename?: 'DonationDonor', id: string, age: number, gender: AnimalGender, hasTransfusion?: boolean | null, name: string, neutered: boolean, primaryVeterinarian: string, species: AnimalSpecies, takeMedications?: boolean | null, weight: number, bloodType?: BloodType | null, status: DonorStatus, type: DonorType, location: string, distinguishableMarks?: string | null, microchipNumber?: string | null, medicationCourse?: string | null, comment?: string | null, breed?: string | null, color?: string | null, createdAt: any, shortId: number, firstCertificatePrinted: boolean, secondCertificatePrinted: boolean, lastDonationDate?: any | null, lastLabworkDate?: any | null, nextDonationDate?: any | null, team?: { __typename?: 'TeamOutput', id: string, title: string } | null, user?: { __typename?: 'HolderOutput', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number } | null, pictures?: Array<{ __typename?: 'DonorPictureOutput', id: string, isPrimary: boolean, file: { __typename?: 'FileOutput', id: string, filename: string } }> | null }, additionalInfo?: { __typename?: 'AdditionalDonationInfoOutput', id: string, numberOfCollectionUnitsUsed: CollectionUnitsUsed, veinUsed: VeinUsed, vascularStructure?: VascularStructure | null, flowRate: FlowRate, donationPosition?: string | null, holdersPosition?: Array<string> | null, donorMovement: string, typeOfMovement?: string | null, emotionalSupport?: Array<string> | null, dislikes?: Array<string> | null, likes?: Array<string> | null, treatPreferences?: Array<string> | null, totalCollectedMls?: number | null, primaryHolder?: { __typename?: 'HolderOutput', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number } | null, secondaryHolder?: { __typename?: 'HolderOutput', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number } | null, poker?: { __typename?: 'HolderOutput', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number } | null } | null }, bloodIdentifiers?: Array<{ __typename?: 'BloodUnitIdentifiersOutput', unitId?: number | null }> | null, regionPreference?: { __typename?: 'RegionOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null } | null } };

export type GetProductsCountQueryVariables = Exact<{
  input: GetProductsCountInput;
}>;


export type GetProductsCountQuery = { __typename?: 'Query', getProductsCount: number };

export type GetWoocommerceTopSellersQueryVariables = Exact<{
  input: GetWoocommerceTopSellersInput;
}>;


export type GetWoocommerceTopSellersQuery = { __typename?: 'Query', getWoocommerceTopSellers: Array<{ __typename?: 'WoocommerceTopSellerOutput', name: string, product_id: number, quantity: number }> };

export type DonorReportFragment = { __typename?: 'DonorReportOutput', id: string, name: string, location: string, region?: string | null, age: number, neutered: boolean, weight: number, primaryVeterinarian: string, species: AnimalSpecies, gender: AnimalGender, type: DonorType, bloodType?: BloodType | null, status: DonorStatus, breed?: string | null, color?: string | null, shortId: number, becameReservedDonorDate?: any | null, rabiesDate?: any | null, distemperDate?: any | null, retiredDate?: any | null, retiredReason?: RetiredReasons | null, retiredReasonComment?: string | null, nextDonationDate?: any | null, microchipNumber?: string | null, donationFrequency: number, approvedDonationML: number, donationMLApprovedAmount?: number | null, acceptSimparicaTrio: boolean, labWorkDue?: any | null, dvmExamDue?: any | null, dvmExamPerformedBy?: string | null, isDaycare: boolean, canRegularlyAttendDaycare?: boolean | null, donorStatusUpdatedAt: any };

export type DonationReportFragment = { __typename?: 'DonationReportOutput', id: string, shortId: number, temperature: number, pulse: number, respiration: number, capillaryRefillTime: CapillaryRefillTime, mucousMembrane: Mm, packedCellVolume: number, totalSolids: number, weight: number, failedReason?: DonationFailedReason | null, unit?: DonationUnit | null, actual?: number | null, approvedDonationsMl: number, donationDate: any, jugularVein: JugularVein, comment?: string | null, ineligibleReason?: IneligibleReason | null, donationNumber: number };

export type HolderReportDataFragment = { __typename?: 'HolderOutput', firstName: string, lastName: string };

export type AdditionalDonationInfoReportFragment = { __typename?: 'AdditionalDonationInfoReportOutput', id: string, numberOfCollectionUnitsUsed: CollectionUnitsUsed, totalCollectedMls?: number | null };

export type ProductReportFragment = { __typename?: 'ProductReportOutput', id: string, shortId: number, createdAt: any, woocommerceProductId: number, woocommerceCategoryId: number, status: ProductStatus, value: number, storageRequirements: Array<string>, anticoagulant?: Anticoagulant | null, expirationDate: any, respin?: boolean | null, regionPreference?: { __typename?: 'RegionOutput', name: string } | null, discardedProduct?: { __typename?: 'DiscardedProductDataReportOutput', processingType: ProcessingProductType, reason: ReasonDiscardProduct, notes?: string | null, processor?: { __typename?: 'ProductProcessorOutput', id: string, firstName: string, lastName: string } | null } | null, donation: { __typename?: 'ProductDonationReportOutput', id: string, approvedDonationsMl?: number | null, actual?: number | null, donor?: { __typename?: 'ProductDonorReportOutput', id: string, name: string, location: string, bloodType?: BloodType | null, user?: { __typename?: 'ProductDonorOwnerReportOutput', id: string, lastName: string } | null } | null, additionalInfo?: { __typename?: 'ProductAdditionlaDonationInfoReportOutput', id: string, poker?: { __typename?: 'ProductDonationHolderReportOutput', id: string, firstName: string, lastName: string } | null, primaryHolder?: { __typename?: 'ProductDonationHolderReportOutput', id: string, firstName: string, lastName: string } | null } | null } };

export type OwnerReportFragment = { __typename?: 'OwnerReportOutput', id: string, shortId: number, email: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, regionPreferences?: string | null, regions: Array<string>, birthday?: any | null, type?: OwnerType | null, isArchived: boolean, contactPreferences?: string | null };

export type DonorOwnerReportFragment = { __typename?: 'DonorOwnerReportOutput', id: string, shortId: number, email: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, type?: OwnerType | null, isArchived: boolean };

export type DonationDonorReportFragment = { __typename?: 'DonationDonorReportOutput', id: string, name: string, location: string, region?: string | null, age: number, neutered: boolean, weight: number, primaryVeterinarian: string, species: AnimalSpecies, gender: AnimalGender, type: DonorType, bloodType?: BloodType | null, status: DonorStatus, breed?: string | null, color?: string | null, shortId: number, becameReservedDonorDate?: any | null, rabiesDate?: any | null, distemperDate?: any | null, retiredDate?: any | null, nextDonationDate?: any | null };

export type DonationOwnerReportFragment = { __typename?: 'DonationOwnerReportOutput', id: string, shortId: number, email: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, type?: OwnerType | null, isArchived: boolean };

export type IneligibleParticipantFieldsFragment = { __typename?: 'IneligibleParticipantOutput', id: string, createdAt: any, donorData: string, ownerData: string };

export type CursorPaginationMetaDataFieldsFragment = { __typename?: 'CursorPaginationMetaData', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, total: number };

export type GetDonorsReportQueryVariables = Exact<{
  input: GetDonorsReportInput;
}>;


export type GetDonorsReportQuery = { __typename?: 'Query', getDonorsReport: { __typename?: 'PaginatedDonorReportOutput', data: Array<{ __typename?: 'DonorReportOutput', totalCollected?: number | null, id: string, name: string, location: string, region?: string | null, age: number, neutered: boolean, weight: number, primaryVeterinarian: string, species: AnimalSpecies, gender: AnimalGender, type: DonorType, bloodType?: BloodType | null, status: DonorStatus, breed?: string | null, color?: string | null, shortId: number, becameReservedDonorDate?: any | null, rabiesDate?: any | null, distemperDate?: any | null, retiredDate?: any | null, retiredReason?: RetiredReasons | null, retiredReasonComment?: string | null, nextDonationDate?: any | null, microchipNumber?: string | null, donationFrequency: number, approvedDonationML: number, donationMLApprovedAmount?: number | null, acceptSimparicaTrio: boolean, labWorkDue?: any | null, dvmExamDue?: any | null, dvmExamPerformedBy?: string | null, isDaycare: boolean, canRegularlyAttendDaycare?: boolean | null, donorStatusUpdatedAt: any, user?: { __typename?: 'DonorOwnerReportOutput', id: string, shortId: number, email: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, type?: OwnerType | null, isArchived: boolean } | null, notes: Array<{ __typename?: 'DonorNoteOutput', id: string, text: string, isPinned: boolean, createdAt: any, updatedAt: any, files: Array<{ __typename?: 'DonorNoteFileOutput', id: string, file: { __typename?: 'FileOutput', id: string, filename: string } }>, user: { __typename?: 'UserOutput', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number, type?: OwnerType | null, isArchived: boolean, deletionIntentionAt?: any | null, contactPreferences?: string | null, deletedAt?: any | null, assignedLocations?: Array<{ __typename?: 'LocationOutput', id: string, createdAt: any, updatedAt: any, name: string, type: LocationType, region?: { __typename?: 'RegionOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null } | null }> | null, assignedRegions?: Array<{ __typename?: 'RegionOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null }> | null, productRegionPreference?: { __typename?: 'RegionOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null } | null, assignedOffice?: { __typename?: 'OfficeOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null, region: { __typename?: 'RegionOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null } } | null } }> }>, meta: { __typename?: 'CursorPaginationMetaData', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, total: number } } };

export type GetDonationReportQueryVariables = Exact<{
  input: GetDonationReportsInput;
}>;


export type GetDonationReportQuery = { __typename?: 'Query', getDonationReports: { __typename?: 'PaginatedDonationReportOutput', data: Array<{ __typename?: 'DonationReportOutput', id: string, shortId: number, temperature: number, pulse: number, respiration: number, capillaryRefillTime: CapillaryRefillTime, mucousMembrane: Mm, packedCellVolume: number, totalSolids: number, weight: number, failedReason?: DonationFailedReason | null, unit?: DonationUnit | null, actual?: number | null, approvedDonationsMl: number, donationDate: any, jugularVein: JugularVein, comment?: string | null, ineligibleReason?: IneligibleReason | null, donationNumber: number, donor?: { __typename?: 'DonationDonorReportOutput', id: string, name: string, location: string, region?: string | null, age: number, neutered: boolean, weight: number, primaryVeterinarian: string, species: AnimalSpecies, gender: AnimalGender, type: DonorType, bloodType?: BloodType | null, status: DonorStatus, breed?: string | null, color?: string | null, shortId: number, becameReservedDonorDate?: any | null, rabiesDate?: any | null, distemperDate?: any | null, retiredDate?: any | null, nextDonationDate?: any | null, user?: { __typename?: 'DonationOwnerReportOutput', id: string, shortId: number, email: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, type?: OwnerType | null, isArchived: boolean } | null } | null, additionalInfo?: { __typename?: 'AdditionalDonationInfoReportOutput', id: string, numberOfCollectionUnitsUsed: CollectionUnitsUsed, totalCollectedMls?: number | null, primaryHolder?: { __typename?: 'HolderOutput', firstName: string, lastName: string } | null, poker?: { __typename?: 'HolderOutput', firstName: string, lastName: string } | null } | null, products?: Array<{ __typename?: 'ProductReportOutput', id: string, shortId: number, createdAt: any, woocommerceProductId: number, woocommerceCategoryId: number, status: ProductStatus, value: number, storageRequirements: Array<string>, anticoagulant?: Anticoagulant | null, expirationDate: any, respin?: boolean | null, regionPreference?: { __typename?: 'RegionOutput', name: string } | null, discardedProduct?: { __typename?: 'DiscardedProductDataReportOutput', processingType: ProcessingProductType, reason: ReasonDiscardProduct, notes?: string | null, processor?: { __typename?: 'ProductProcessorOutput', id: string, firstName: string, lastName: string } | null } | null, donation: { __typename?: 'ProductDonationReportOutput', id: string, approvedDonationsMl?: number | null, actual?: number | null, donor?: { __typename?: 'ProductDonorReportOutput', id: string, name: string, location: string, bloodType?: BloodType | null, user?: { __typename?: 'ProductDonorOwnerReportOutput', id: string, lastName: string } | null } | null, additionalInfo?: { __typename?: 'ProductAdditionlaDonationInfoReportOutput', id: string, poker?: { __typename?: 'ProductDonationHolderReportOutput', id: string, firstName: string, lastName: string } | null, primaryHolder?: { __typename?: 'ProductDonationHolderReportOutput', id: string, firstName: string, lastName: string } | null } | null } }> | null }>, meta: { __typename?: 'CursorPaginationMetaData', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, total: number } } };

export type GetProductReportsQueryVariables = Exact<{
  input: GetProductReportsInput;
}>;


export type GetProductReportsQuery = { __typename?: 'Query', getProductReports: { __typename?: 'PaginatedProductReportOutput', data: Array<{ __typename?: 'ProductReportOutput', id: string, shortId: number, createdAt: any, woocommerceProductId: number, woocommerceCategoryId: number, status: ProductStatus, value: number, storageRequirements: Array<string>, anticoagulant?: Anticoagulant | null, expirationDate: any, respin?: boolean | null, donation: { __typename?: 'ProductDonationReportOutput', id: string, approvedDonationsMl?: number | null, actual?: number | null, donor?: { __typename?: 'ProductDonorReportOutput', id: string, name: string, location: string, bloodType?: BloodType | null, user?: { __typename?: 'ProductDonorOwnerReportOutput', id: string, lastName: string } | null } | null, additionalInfo?: { __typename?: 'ProductAdditionlaDonationInfoReportOutput', id: string, poker?: { __typename?: 'ProductDonationHolderReportOutput', id: string, firstName: string, lastName: string } | null, primaryHolder?: { __typename?: 'ProductDonationHolderReportOutput', id: string, firstName: string, lastName: string } | null } | null }, regionPreference?: { __typename?: 'RegionOutput', name: string } | null, discardedProduct?: { __typename?: 'DiscardedProductDataReportOutput', processingType: ProcessingProductType, reason: ReasonDiscardProduct, notes?: string | null, processor?: { __typename?: 'ProductProcessorOutput', id: string, firstName: string, lastName: string } | null } | null }>, meta: { __typename?: 'CursorPaginationMetaData', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, total: number } } };

export type GetOwnerReportsQueryVariables = Exact<{
  input: GetOwnersReportsInput;
}>;


export type GetOwnerReportsQuery = { __typename?: 'Query', getOwnerReports: { __typename?: 'PaginatedOwnerReportOutput', data: Array<{ __typename?: 'OwnerReportOutput', id: string, shortId: number, email: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, regionPreferences?: string | null, regions: Array<string>, birthday?: any | null, type?: OwnerType | null, isArchived: boolean, contactPreferences?: string | null, donors?: Array<{ __typename?: 'OwnerDonorReportOutput', name: string, status: DonorStatus, location?: string | null }> | null }>, meta: { __typename?: 'CursorPaginationMetaData', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, total: number } } };

export type GetIneligibleParticipantsReportsQueryVariables = Exact<{
  input: GetIneligibleParticipantsReportsInput;
}>;


export type GetIneligibleParticipantsReportsQuery = { __typename?: 'Query', getIneligibleParticipantsReports: { __typename?: 'PaginatedIneligibleParticipantsOutput', data: Array<{ __typename?: 'IneligibleParticipantOutput', id: string, createdAt: any, donorData: string, ownerData: string }>, meta: { __typename?: 'CursorPaginationMetaData', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, total: number } } };

export type ProcessRequestMutationVariables = Exact<{
  input: UpdateRequestInput;
}>;


export type ProcessRequestMutation = { __typename?: 'Mutation', processRequest: boolean };

export type RemoveRequestMutationVariables = Exact<{
  input: RemoveRequestInput;
}>;


export type RemoveRequestMutation = { __typename?: 'Mutation', removeRequest: boolean };

export type GetRequestListQueryVariables = Exact<{
  input: RequestsListInput;
}>;


export type GetRequestListQuery = { __typename?: 'Query', getRequestList: { __typename?: 'RequestListOutput', data: Array<{ __typename?: 'RequestOutput', id: string, number: number, updatedAt: any, donor: { __typename?: 'DonorOutput', id: string, age: number, gender: AnimalGender, hasTransfusion?: boolean | null, name: string, neutered: boolean, primaryVeterinarian: string, species: AnimalSpecies, takeMedications?: boolean | null, weight: number, approvedDonationML: number, donationMLApprovedAmount?: number | null, bloodType?: BloodType | null, status: DonorStatus, type: DonorType, location: string, distinguishableMarks?: string | null, microchipNumber?: string | null, medicationCourse?: string | null, comment?: string | null, breed?: string | null, color?: string | null, createdAt: any, shortId: number, firstCertificatePrinted: boolean, secondCertificatePrinted: boolean, becameReservedDonorDate?: any | null, retiredDate?: any | null, distemperDate?: any | null, rabiesDate?: any | null, lastDonationDate?: any | null, nextDonationDate?: any | null, lastLabworkDate?: any | null, hasMicrochip?: boolean | null, acceptSimparicaTrio: boolean, isDaycare?: boolean | null, donationFrequency: number, canRegularlyAttendDaycare?: boolean | null, attendDaycareDays?: Array<string> | null, retiredReason?: RetiredReasons | null, retiredReasonComment?: string | null, dateOfBirth: any, team?: { __typename?: 'TeamOutput', id: string, title: string } | null, user?: { __typename?: 'OwnerOutput', email: string, id: string, firstName: string, lastName: string, hasMultipleDonors?: boolean | null, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number, type?: OwnerType | null, isArchived: boolean, contactPreferences?: string | null, createdAt: any, deletedAt?: any | null, contacts?: Array<{ __typename?: 'ContactOutput', streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, email?: string | null, firstName?: string | null, id: string, lastName?: string | null, phoneNumber?: string | null }> | null } | null } }>, meta: { __typename?: 'MetaData', total: number } } };

export type GetRequestQueryVariables = Exact<{
  input: GetRequestInput;
}>;


export type GetRequestQuery = { __typename?: 'Query', getRequest: { __typename?: 'RequestOutput', id: string, number: number, updatedAt: any, donor: { __typename?: 'DonorOutput', id: string, age: number, gender: AnimalGender, hasTransfusion?: boolean | null, name: string, neutered: boolean, primaryVeterinarian: string, species: AnimalSpecies, takeMedications?: boolean | null, weight: number, approvedDonationML: number, donationMLApprovedAmount?: number | null, bloodType?: BloodType | null, status: DonorStatus, type: DonorType, location: string, distinguishableMarks?: string | null, microchipNumber?: string | null, medicationCourse?: string | null, comment?: string | null, breed?: string | null, color?: string | null, createdAt: any, shortId: number, firstCertificatePrinted: boolean, secondCertificatePrinted: boolean, becameReservedDonorDate?: any | null, retiredDate?: any | null, distemperDate?: any | null, rabiesDate?: any | null, lastDonationDate?: any | null, nextDonationDate?: any | null, lastLabworkDate?: any | null, hasMicrochip?: boolean | null, acceptSimparicaTrio: boolean, isDaycare?: boolean | null, donationFrequency: number, canRegularlyAttendDaycare?: boolean | null, attendDaycareDays?: Array<string> | null, retiredReason?: RetiredReasons | null, retiredReasonComment?: string | null, dateOfBirth: any, team?: { __typename?: 'TeamOutput', id: string, title: string } | null, user?: { __typename?: 'OwnerOutput', email: string, id: string, firstName: string, lastName: string, hasMultipleDonors?: boolean | null, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number, type?: OwnerType | null, isArchived: boolean, contactPreferences?: string | null, createdAt: any, deletedAt?: any | null, contacts?: Array<{ __typename?: 'ContactOutput', streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, email?: string | null, firstName?: string | null, id: string, lastName?: string | null, phoneNumber?: string | null }> | null } | null } } };

export type SaveAppSettingsMutationVariables = Exact<{
  input: SaveAppSettingsInput;
}>;


export type SaveAppSettingsMutation = { __typename?: 'Mutation', saveAppSettings: { __typename?: 'AppSettingsOutput', id: string, settingsTab: string, settingsJson: any, createdAt: any, updatedAt: any } };

export type GetAppSettingsQueryVariables = Exact<{
  input: GetAppSettingsInput;
}>;


export type GetAppSettingsQuery = { __typename?: 'Query', getAppSettings?: { __typename?: 'AppSettingsOutput', id: string, settingsTab: string, settingsJson: any, createdAt: any, updatedAt: any } | null };

export type PermissionFragment = { __typename?: 'PermissionsOutput', id: string, value: boolean, permission: PermissionsEnum };

export type RoleFragment = { __typename?: 'RoleOutput', id: string, value: UserRole };

export type RoleWithoutPermissionsFragment = { __typename?: 'RoleWithoutPermissionsOutput', id: string, value: UserRole };

export type UserFragment = { __typename?: 'UserOutput', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number, type?: OwnerType | null, isArchived: boolean, deletionIntentionAt?: any | null, contactPreferences?: string | null, deletedAt?: any | null, assignedLocations?: Array<{ __typename?: 'LocationOutput', id: string, createdAt: any, updatedAt: any, name: string, type: LocationType, region?: { __typename?: 'RegionOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null } | null }> | null, assignedRegions?: Array<{ __typename?: 'RegionOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null }> | null, productRegionPreference?: { __typename?: 'RegionOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null } | null, assignedOffice?: { __typename?: 'OfficeOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null, region: { __typename?: 'RegionOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null } } | null };

export type NotificationUserFragment = { __typename?: 'NotificationUserOutput', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number, type?: OwnerType | null, isArchived: boolean, contactPreferences?: string | null };

export type ContactFragment = { __typename?: 'ContactOutput', streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, email?: string | null, firstName?: string | null, id: string, lastName?: string | null, phoneNumber?: string | null };

export type SignUpMutationVariables = Exact<{
  input: SignUpInput;
}>;


export type SignUpMutation = { __typename?: 'Mutation', signUp: { __typename?: 'UserOutput', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number, type?: OwnerType | null, isArchived: boolean, deletionIntentionAt?: any | null, contactPreferences?: string | null, deletedAt?: any | null, contacts?: Array<{ __typename?: 'ContactOutput', streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, email?: string | null, firstName?: string | null, id: string, lastName?: string | null, phoneNumber?: string | null }> | null, role: { __typename?: 'RoleOutput', id: string, value: UserRole }, assignedLocations?: Array<{ __typename?: 'LocationOutput', id: string, createdAt: any, updatedAt: any, name: string, type: LocationType, region?: { __typename?: 'RegionOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null } | null }> | null, assignedRegions?: Array<{ __typename?: 'RegionOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null }> | null, productRegionPreference?: { __typename?: 'RegionOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null } | null, assignedOffice?: { __typename?: 'OfficeOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null, region: { __typename?: 'RegionOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null } } | null } };

export type ForgotPasswordMutationVariables = Exact<{
  input: ForgotPasswordInput;
}>;


export type ForgotPasswordMutation = { __typename?: 'Mutation', forgotPassword: boolean };

export type ResetPasswordMutationVariables = Exact<{
  input: ResetPasswordInput;
}>;


export type ResetPasswordMutation = { __typename?: 'Mutation', resetPassword: boolean };

export type ConfirmEmailMutationVariables = Exact<{
  input: EmailConfirmationInput;
}>;


export type ConfirmEmailMutation = { __typename?: 'Mutation', confirmEmail: boolean };

export type MakeNotificationsReadMutationVariables = Exact<{ [key: string]: never; }>;


export type MakeNotificationsReadMutation = { __typename?: 'Mutation', makeNotificationsRead: boolean };

export type DeleteNotificationMutationVariables = Exact<{
  input: RemoveNotificationInput;
}>;


export type DeleteNotificationMutation = { __typename?: 'Mutation', deleteNotification: boolean };

export type ArchiveUserMutationVariables = Exact<{
  input: ArchiveUserInput;
}>;


export type ArchiveUserMutation = { __typename?: 'Mutation', archiveUser: boolean };

export type UnArchiveUserMutationVariables = Exact<{
  input: ArchiveUserInput;
}>;


export type UnArchiveUserMutation = { __typename?: 'Mutation', unArchiveUser: boolean };

export type SignUpWithDonorsMutationVariables = Exact<{
  input: SignUpWithDonorsInput;
}>;


export type SignUpWithDonorsMutation = { __typename?: 'Mutation', signUpWithDonors: boolean };

export type GetAllIneligibleQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllIneligibleQuery = { __typename?: 'Query', getAllIneligibleParticipants: { __typename?: 'AllIneligibleParticipantsOutput', ineligible: Array<{ __typename?: 'IneligibleParticipantOutput', id: string, createdAt: any, ownerData: string, donorData: string }> } };

export type GetCurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentUserQuery = { __typename?: 'Query', currentUser: { __typename?: 'UserOutput', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number, type?: OwnerType | null, isArchived: boolean, deletionIntentionAt?: any | null, contactPreferences?: string | null, deletedAt?: any | null, contacts?: Array<{ __typename?: 'ContactOutput', streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, email?: string | null, firstName?: string | null, id: string, lastName?: string | null, phoneNumber?: string | null }> | null, role: { __typename?: 'RoleOutput', id: string, value: UserRole }, assignedLocations?: Array<{ __typename?: 'LocationOutput', id: string, createdAt: any, updatedAt: any, name: string, type: LocationType, region?: { __typename?: 'RegionOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null } | null }> | null, assignedRegions?: Array<{ __typename?: 'RegionOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null }> | null, productRegionPreference?: { __typename?: 'RegionOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null } | null, assignedOffice?: { __typename?: 'OfficeOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null, region: { __typename?: 'RegionOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null } } | null } };

export type GetMyPermissionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyPermissionsQuery = { __typename?: 'Query', getMyPermissions: Array<{ __typename?: 'PermissionsOutput', id: string, value: boolean, permission: PermissionsEnum, role: { __typename?: 'RoleOutput', id: string, value: UserRole } }> };

export type GetUsersListQueryVariables = Exact<{
  input: GetUserListInput;
}>;


export type GetUsersListQuery = { __typename?: 'Query', getUsersList: { __typename?: 'PaginatedUserListOutput', data: Array<{ __typename?: 'UserOutput', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number, type?: OwnerType | null, isArchived: boolean, deletionIntentionAt?: any | null, contactPreferences?: string | null, deletedAt?: any | null, contacts?: Array<{ __typename?: 'ContactOutput', streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, email?: string | null, firstName?: string | null, id: string, lastName?: string | null, phoneNumber?: string | null }> | null, role: { __typename?: 'RoleOutput', id: string, value: UserRole }, assignedLocations?: Array<{ __typename?: 'LocationOutput', id: string, createdAt: any, updatedAt: any, name: string, type: LocationType, region?: { __typename?: 'RegionOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null } | null }> | null, assignedRegions?: Array<{ __typename?: 'RegionOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null }> | null, productRegionPreference?: { __typename?: 'RegionOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null } | null, assignedOffice?: { __typename?: 'OfficeOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null, region: { __typename?: 'RegionOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null } } | null }>, meta: { __typename?: 'MetaData', total: number } } };

export type GetOwnersListQueryVariables = Exact<{
  input: GetOwnerListInput;
}>;


export type GetOwnersListQuery = { __typename?: 'Query', getOwnersList: { __typename?: 'PaginatedUserListOutput', data: Array<{ __typename?: 'UserOutput', email: string, id: string, firstName: string, lastName: string, phoneNumber?: string | null, streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, locationPreferences?: string | null, birthday?: any | null, shortId: number, type?: OwnerType | null, isArchived: boolean, deletionIntentionAt?: any | null, contactPreferences?: string | null, deletedAt?: any | null, contacts?: Array<{ __typename?: 'ContactOutput', streetAddress?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, email?: string | null, firstName?: string | null, id: string, lastName?: string | null, phoneNumber?: string | null }> | null, role: { __typename?: 'RoleOutput', id: string, value: UserRole }, assignedLocations?: Array<{ __typename?: 'LocationOutput', id: string, createdAt: any, updatedAt: any, name: string, type: LocationType, region?: { __typename?: 'RegionOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null } | null }> | null, assignedRegions?: Array<{ __typename?: 'RegionOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null }> | null, productRegionPreference?: { __typename?: 'RegionOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null } | null, assignedOffice?: { __typename?: 'OfficeOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null, region: { __typename?: 'RegionOutput', id: string, createdAt: any, updatedAt: any, name: string, idexxAccountNumber?: string | null, zoetisAccountNumber?: string | null } } | null }>, meta: { __typename?: 'MetaData', total: number } } };

export type CheckUserConnectionQueryVariables = Exact<{ [key: string]: never; }>;


export type CheckUserConnectionQuery = { __typename?: 'Query', checkUserConnection: boolean };

export const AppointmentFragmentDoc = gql`
    fragment Appointment on AppointmentOutput {
  id
  createdAt
  updatedAt
  title
  start
  end
  location
  notes
  isDaycare
  isPrivate
}
    `;
export const AppointmentUserFragmentDoc = gql`
    fragment AppointmentUser on AppointmentUser {
  email
  id
  firstName
  lastName
  phoneNumber
  streetAddress
  city
  state
  zipCode
  locationPreferences
  birthday
  shortId
}
    `;
export const AppointmentGroupFragmentDoc = gql`
    fragment AppointmentGroup on AppointmentGroupOutput {
  id
  title
}
    `;
export const AppointmentTeamFragmentDoc = gql`
    fragment AppointmentTeam on AppointmentTeamOutput {
  id
  title
}
    `;
export const AppointmentDonorFragmentDoc = gql`
    fragment AppointmentDonor on AppointmentDonor {
  id
  age
  gender
  hasTransfusion
  name
  neutered
  primaryVeterinarian
  species
  takeMedications
  weight
  bloodType
  status
  type
  location
  distinguishableMarks
  microchipNumber
  medicationCourse
  comment
  breed
  color
  createdAt
  shortId
  firstCertificatePrinted
  secondCertificatePrinted
  shortId
}
    `;
export const DonationProductFragmentDoc = gql`
    fragment DonationProduct on DonationProductOutput {
  anticoagulant
  createdAt
  id
  shortId
  status
  storageRequirements
  updatedAt
  value
  woocommerceProductId
  woocommerceCategoryId
  expirationDate
  bloodIdentifiers {
    unitId
    product {
      id
      shortId
    }
  }
}
    `;
export const DiscardedProductDataFragmentDoc = gql`
    fragment DiscardedProductData on DiscardedProductDataOutput {
  processingType
  reason
  notes
}
    `;
export const DonationDonorFragmentDoc = gql`
    fragment DonationDonor on DonationDonor {
  id
  age
  gender
  hasTransfusion
  name
  neutered
  primaryVeterinarian
  species
  takeMedications
  weight
  bloodType
  status
  type
  location
  distinguishableMarks
  microchipNumber
  medicationCourse
  comment
  breed
  color
  createdAt
  shortId
  firstCertificatePrinted
  secondCertificatePrinted
  shortId
  lastDonationDate
  lastLabworkDate
  nextDonationDate
}
    `;
export const HolderFragmentDoc = gql`
    fragment Holder on HolderOutput {
  email
  id
  firstName
  lastName
  phoneNumber
  streetAddress
  city
  state
  zipCode
  locationPreferences
  birthday
  shortId
}
    `;
export const PictureFragmentDoc = gql`
    fragment Picture on DonorPictureOutput {
  id
  isPrimary
  file {
    id
    filename
  }
}
    `;
export const AdditionalDonationInfoFragmentDoc = gql`
    fragment AdditionalDonationInfo on AdditionalDonationInfoOutput {
  id
  numberOfCollectionUnitsUsed
  veinUsed
  vascularStructure
  flowRate
  donationPosition
  holdersPosition
  donorMovement
  typeOfMovement
  emotionalSupport
  dislikes
  likes
  treatPreferences
  totalCollectedMls
  primaryHolder {
    ...Holder
  }
  secondaryHolder {
    ...Holder
  }
  poker {
    ...Holder
  }
}
    ${HolderFragmentDoc}`;
export const DonationFragmentDoc = gql`
    fragment Donation on DonationOutput {
  id
  collectionSet
  capillaryRefillTime
  approvedDonationsMl
  jugularVein
  maxLimit
  mucousMembrane
  packedCellVolume
  pulse
  respiration
  shouldDonate
  temperature
  totalSolids
  unit
  failedReason
  actual
  weatherTemperature
  weatherTypes
  weight
  examinationNotes
  preferences
  createdAt
  comment
  shortId
  donationDate
  ineligible
  ineligibleReason
  ineligibleReasonDetails
  products {
    ...DonationProduct
    discardedProduct {
      ...DiscardedProductData
    }
  }
  donor {
    ...DonationDonor
    team {
      id
      title
    }
    user {
      ...Holder
    }
    pictures {
      ...Picture
    }
  }
  additionalInfo {
    ...AdditionalDonationInfo
  }
}
    ${DonationProductFragmentDoc}
${DiscardedProductDataFragmentDoc}
${DonationDonorFragmentDoc}
${HolderFragmentDoc}
${PictureFragmentDoc}
${AdditionalDonationInfoFragmentDoc}`;
export const DonorFragmentDoc = gql`
    fragment Donor on DonorOutput {
  id
  age
  gender
  hasTransfusion
  name
  neutered
  primaryVeterinarian
  species
  takeMedications
  weight
  approvedDonationML
  donationMLApprovedAmount
  bloodType
  status
  type
  location
  distinguishableMarks
  microchipNumber
  medicationCourse
  comment
  breed
  color
  createdAt
  shortId
  firstCertificatePrinted
  secondCertificatePrinted
  becameReservedDonorDate
  retiredDate
  distemperDate
  rabiesDate
  lastDonationDate
  nextDonationDate
  lastLabworkDate
  hasMicrochip
  acceptSimparicaTrio
  isDaycare
  donationFrequency
  canRegularlyAttendDaycare
  attendDaycareDays
  retiredReason
  retiredReasonComment
  dateOfBirth
}
    `;
export const PartialDonorFragmentDoc = gql`
    fragment PartialDonor on PartialDonorOutput {
  id
  age
  gender
  hasTransfusion
  name
  neutered
  primaryVeterinarian
  species
  takeMedications
  weight
  approvedDonationML
  donationMLApprovedAmount
  bloodType
  status
  type
  location
  distinguishableMarks
  microchipNumber
  medicationCourse
  comment
  breed
  color
  createdAt
  shortId
  firstCertificatePrinted
  secondCertificatePrinted
  becameReservedDonorDate
  retiredDate
  distemperDate
  rabiesDate
  lastDonationDate
  nextDonationDate
  lastLabworkDate
  hasMicrochip
  acceptSimparicaTrio
  isDaycare
  donationFrequency
  canRegularlyAttendDaycare
  attendDaycareDays
  retiredReason
  retiredReasonComment
  dateOfBirth
}
    `;
export const TeamFragmentDoc = gql`
    fragment Team on TeamOutput {
  id
  title
}
    `;
export const GroupTeamFragmentDoc = gql`
    fragment GroupTeam on GroupTeamOutput {
  id
  title
}
    `;
export const GroupFragmentDoc = gql`
    fragment Group on GroupOutput {
  id
  title
}
    `;
export const GroupListItemFragmentDoc = gql`
    fragment GroupListItem on GroupListItemOutput {
  teamCount
  donorCount
  title
  user {
    firstName
    lastName
    id
  }
  id
}
    `;
export const ReserveDonorNoteFragmentDoc = gql`
    fragment ReserveDonorNote on ReserveDonorNoteOutput {
  id
  text
  createdAt
}
    `;
export const RegionFragmentDoc = gql`
    fragment Region on RegionOutput {
  id
  createdAt
  updatedAt
  name
  idexxAccountNumber
  zoetisAccountNumber
}
    `;
export const LocationFragmentDoc = gql`
    fragment Location on LocationOutput {
  id
  createdAt
  updatedAt
  name
  type
  region {
    ...Region
  }
}
    ${RegionFragmentDoc}`;
export const OfficeFragmentDoc = gql`
    fragment Office on OfficeOutput {
  id
  createdAt
  updatedAt
  name
  idexxAccountNumber
  zoetisAccountNumber
  region {
    ...Region
  }
}
    ${RegionFragmentDoc}`;
export const UserFragmentDoc = gql`
    fragment User on UserOutput {
  email
  id
  firstName
  lastName
  phoneNumber
  streetAddress
  city
  state
  zipCode
  locationPreferences
  assignedLocations {
    ...Location
  }
  assignedRegions {
    ...Region
  }
  productRegionPreference {
    ...Region
  }
  assignedOffice {
    ...Office
  }
  birthday
  shortId
  type
  isArchived
  deletionIntentionAt
  contactPreferences
  deletedAt
}
    ${LocationFragmentDoc}
${RegionFragmentDoc}
${OfficeFragmentDoc}`;
export const DonorNoteFragmentDoc = gql`
    fragment DonorNote on DonorNoteOutput {
  id
  text
  isPinned
  files {
    id
    file {
      id
      filename
    }
  }
  createdAt
  updatedAt
  user {
    ...User
  }
}
    ${UserFragmentDoc}`;
export const DonorBreedFragmentDoc = gql`
    fragment DonorBreed on BreedOutput {
  id
  species
  name
}
    `;
export const LabworkFragmentDoc = gql`
    fragment Labwork on LabworkOutput {
  id
  collectionDate
  status
}
    `;
export const DvmExamFragmentDoc = gql`
    fragment DvmExam on DvmExamOutput {
  id
  examinationDate
  notes
  nextExamDue
  donorRegion
  donorLocation
}
    `;
export const FileFragmentDoc = gql`
    fragment File on FileOutput {
  id
  filename
}
    `;
export const VitalsParameterFragmentDoc = gql`
    fragment VitalsParameter on VitalsParameterOutput {
  id
  criticalValues
  type
  max
  min
  percentageDifference
}
    `;
export const LabworkAttachmentFragmentDoc = gql`
    fragment LabworkAttachment on LabworkAttachmentOutput {
  id
  createdAt
  updatedAt
}
    `;
export const InvitationFragmentDoc = gql`
    fragment Invitation on InvitationOutput {
  id
  email
  firstName
  lastName
  phoneNumber
  role
  createdAt
}
    `;
export const NightlyCountFragmentDoc = gql`
    fragment NightlyCount on NightlyCountOutput {
  id
  officeId
  office {
    id
    name
    regionName
  }
  countDate
  createdByUserId
  createdByUser {
    id
    firstName
    lastName
    email
  }
  lastEditedByUserId
  lastEditedByUser {
    id
    firstName
    lastName
    email
  }
  lastEditedAt
  createdAt
  updatedAt
  items {
    id
    productKey
    productTitle
    woocommerceProductId
    productClass
    productBloodType
    count
  }
}
    `;
export const NotificationConfigFragmentDoc = gql`
    fragment NotificationConfig on NotificationConfigOutput {
  name
  value
}
    `;
export const NotificationFragmentDoc = gql`
    fragment Notification on NotificationOutput {
  id
  type
  isRead
  createdAt
}
    `;
export const NotificationSubscriptionFragmentDoc = gql`
    fragment NotificationSubscription on NotificationWebSocketOutput {
  id
  type
  isRead
}
    `;
export const OrderBillingFragmentDoc = gql`
    fragment orderBilling on BillingOutput {
  city
  company
  country
  email
  firstAddress
  firstName
  lastName
  phone
  postcode
  secondAddress
  state
}
    `;
export const OrderShippingFragmentDoc = gql`
    fragment orderShipping on ShippingOutput {
  city
  company
  country
  firstAddress
  firstName
  lastName
  phone
  postcode
  secondAddress
  state
}
    `;
export const ShippingLineFragmentDoc = gql`
    fragment shippingLine on ShippingLineOutput {
  id
  instanceId
  methodId
  methodTitle
  total
  totalTax
}
    `;
export const FeeLineFragmentDoc = gql`
    fragment feeLine on FeeLineOutput {
  amount
  id
  name
  taxClass
  taxStatus
  total
  totalTax
}
    `;
export const OrderItemFragmentDoc = gql`
    fragment orderItem on OrderItemOutput {
  id
  name
  price
  quantity
  sku
}
    `;
export const OwnerFragmentDoc = gql`
    fragment Owner on OwnerOutput {
  email
  id
  firstName
  lastName
  hasMultipleDonors
  phoneNumber
  streetAddress
  city
  state
  zipCode
  locationPreferences
  birthday
  shortId
  type
  isArchived
  contactPreferences
  createdAt
  deletedAt
}
    `;
export const UserAttachmentFragmentDoc = gql`
    fragment UserAttachment on UserAttachmentOutput {
  id
  createdAt
  updatedAt
}
    `;
export const ProductFragmentDoc = gql`
    fragment Product on ProductOutput {
  anticoagulant
  createdAt
  id
  shortId
  status
  storageRequirements
  updatedAt
  value
  bloodIdentifiers {
    unitId
  }
  woocommerceProductId
  woocommerceCategoryId
  woocommerceOrderId
  expirationDate
  published
  publishable
  isMantelAssigned
  regionPreference {
    ...Region
  }
}
    ${RegionFragmentDoc}`;
export const ProductProcessorFragmentDoc = gql`
    fragment ProductProcessor on ProductProcessorOutput {
  id
  firstName
  lastName
}
    `;
export const DonorReportFragmentDoc = gql`
    fragment DonorReport on DonorReportOutput {
  id
  name
  location
  region
  age
  neutered
  weight
  primaryVeterinarian
  species
  gender
  type
  bloodType
  status
  breed
  color
  shortId
  becameReservedDonorDate
  rabiesDate
  distemperDate
  retiredDate
  retiredReason
  retiredReasonComment
  nextDonationDate
  microchipNumber
  donationFrequency
  approvedDonationML
  donationMLApprovedAmount
  acceptSimparicaTrio
  labWorkDue
  dvmExamDue
  dvmExamPerformedBy
  isDaycare
  canRegularlyAttendDaycare
  donorStatusUpdatedAt
}
    `;
export const DonationReportFragmentDoc = gql`
    fragment DonationReport on DonationReportOutput {
  id
  shortId
  temperature
  pulse
  respiration
  capillaryRefillTime
  mucousMembrane
  packedCellVolume
  totalSolids
  weight
  failedReason
  unit
  actual
  approvedDonationsMl
  donationDate
  jugularVein
  comment
  ineligibleReason
  donationNumber
}
    `;
export const HolderReportDataFragmentDoc = gql`
    fragment HolderReportData on HolderOutput {
  firstName
  lastName
}
    `;
export const AdditionalDonationInfoReportFragmentDoc = gql`
    fragment AdditionalDonationInfoReport on AdditionalDonationInfoReportOutput {
  id
  numberOfCollectionUnitsUsed
  totalCollectedMls
}
    `;
export const ProductReportFragmentDoc = gql`
    fragment ProductReport on ProductReportOutput {
  id
  shortId
  createdAt
  woocommerceProductId
  woocommerceCategoryId
  status
  value
  storageRequirements
  anticoagulant
  expirationDate
  respin
  regionPreference {
    name
  }
  discardedProduct {
    processingType
    reason
    notes
    processor {
      id
      firstName
      lastName
    }
  }
  donation {
    id
    approvedDonationsMl
    actual
    donor {
      id
      name
      location
      bloodType
      user {
        id
        lastName
      }
    }
    additionalInfo {
      id
      poker {
        id
        firstName
        lastName
      }
      primaryHolder {
        id
        firstName
        lastName
      }
    }
  }
}
    `;
export const OwnerReportFragmentDoc = gql`
    fragment OwnerReport on OwnerReportOutput {
  id
  shortId
  email
  firstName
  lastName
  phoneNumber
  streetAddress
  city
  state
  zipCode
  locationPreferences
  regionPreferences
  regions
  birthday
  type
  isArchived
  contactPreferences
}
    `;
export const DonorOwnerReportFragmentDoc = gql`
    fragment DonorOwnerReport on DonorOwnerReportOutput {
  id
  shortId
  email
  firstName
  lastName
  phoneNumber
  streetAddress
  city
  state
  zipCode
  locationPreferences
  birthday
  type
  isArchived
}
    `;
export const DonationDonorReportFragmentDoc = gql`
    fragment DonationDonorReport on DonationDonorReportOutput {
  id
  name
  location
  region
  age
  neutered
  weight
  primaryVeterinarian
  species
  gender
  type
  bloodType
  status
  breed
  color
  shortId
  becameReservedDonorDate
  rabiesDate
  distemperDate
  retiredDate
  nextDonationDate
}
    `;
export const DonationOwnerReportFragmentDoc = gql`
    fragment DonationOwnerReport on DonationOwnerReportOutput {
  id
  shortId
  email
  firstName
  lastName
  phoneNumber
  streetAddress
  city
  state
  zipCode
  locationPreferences
  birthday
  type
  isArchived
}
    `;
export const IneligibleParticipantFieldsFragmentDoc = gql`
    fragment IneligibleParticipantFields on IneligibleParticipantOutput {
  id
  createdAt
  donorData
  ownerData
}
    `;
export const CursorPaginationMetaDataFieldsFragmentDoc = gql`
    fragment CursorPaginationMetaDataFields on CursorPaginationMetaData {
  endCursor
  hasNextPage
  hasPreviousPage
  startCursor
  total
}
    `;
export const PermissionFragmentDoc = gql`
    fragment Permission on PermissionsOutput {
  id
  value
  permission
}
    `;
export const RoleFragmentDoc = gql`
    fragment Role on RoleOutput {
  id
  value
}
    `;
export const RoleWithoutPermissionsFragmentDoc = gql`
    fragment RoleWithoutPermissions on RoleWithoutPermissionsOutput {
  id
  value
}
    `;
export const NotificationUserFragmentDoc = gql`
    fragment NotificationUser on NotificationUserOutput {
  email
  id
  firstName
  lastName
  phoneNumber
  streetAddress
  city
  state
  zipCode
  locationPreferences
  birthday
  shortId
  type
  isArchived
  contactPreferences
}
    `;
export const ContactFragmentDoc = gql`
    fragment Contact on ContactOutput {
  streetAddress
  city
  state
  zipCode
  email
  firstName
  id
  lastName
  phoneNumber
}
    `;
export const UpdateAllPermissionsDocument = gql`
    mutation updateAllPermissions($input: PermissionsInput!) {
  updatePermissions(input: $input) {
    ...Permission
  }
}
    ${PermissionFragmentDoc}`;
export type UpdateAllPermissionsMutationFn = Apollo.MutationFunction<UpdateAllPermissionsMutation, UpdateAllPermissionsMutationVariables>;

/**
 * __useUpdateAllPermissionsMutation__
 *
 * To run a mutation, you first call `useUpdateAllPermissionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAllPermissionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAllPermissionsMutation, { data, loading, error }] = useUpdateAllPermissionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAllPermissionsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAllPermissionsMutation, UpdateAllPermissionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAllPermissionsMutation, UpdateAllPermissionsMutationVariables>(UpdateAllPermissionsDocument, options);
      }
export type UpdateAllPermissionsMutationHookResult = ReturnType<typeof useUpdateAllPermissionsMutation>;
export type UpdateAllPermissionsMutationResult = Apollo.MutationResult<UpdateAllPermissionsMutation>;
export type UpdateAllPermissionsMutationOptions = Apollo.BaseMutationOptions<UpdateAllPermissionsMutation, UpdateAllPermissionsMutationVariables>;
export const InviteUserDocument = gql`
    mutation inviteUser($input: InviteUserInput!) {
  inviteUser(input: $input)
}
    `;
export type InviteUserMutationFn = Apollo.MutationFunction<InviteUserMutation, InviteUserMutationVariables>;

/**
 * __useInviteUserMutation__
 *
 * To run a mutation, you first call `useInviteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteUserMutation, { data, loading, error }] = useInviteUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInviteUserMutation(baseOptions?: Apollo.MutationHookOptions<InviteUserMutation, InviteUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InviteUserMutation, InviteUserMutationVariables>(InviteUserDocument, options);
      }
export type InviteUserMutationHookResult = ReturnType<typeof useInviteUserMutation>;
export type InviteUserMutationResult = Apollo.MutationResult<InviteUserMutation>;
export type InviteUserMutationOptions = Apollo.BaseMutationOptions<InviteUserMutation, InviteUserMutationVariables>;
export const AcceptInviteDocument = gql`
    mutation acceptInvite($input: AcceptInviteInput!) {
  acceptInvite(input: $input) {
    email
  }
}
    `;
export type AcceptInviteMutationFn = Apollo.MutationFunction<AcceptInviteMutation, AcceptInviteMutationVariables>;

/**
 * __useAcceptInviteMutation__
 *
 * To run a mutation, you first call `useAcceptInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptInviteMutation, { data, loading, error }] = useAcceptInviteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAcceptInviteMutation(baseOptions?: Apollo.MutationHookOptions<AcceptInviteMutation, AcceptInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptInviteMutation, AcceptInviteMutationVariables>(AcceptInviteDocument, options);
      }
export type AcceptInviteMutationHookResult = ReturnType<typeof useAcceptInviteMutation>;
export type AcceptInviteMutationResult = Apollo.MutationResult<AcceptInviteMutation>;
export type AcceptInviteMutationOptions = Apollo.BaseMutationOptions<AcceptInviteMutation, AcceptInviteMutationVariables>;
export const RemoveUserDocument = gql`
    mutation removeUser($input: RemoveUserInput!) {
  removeUser(input: $input)
}
    `;
export type RemoveUserMutationFn = Apollo.MutationFunction<RemoveUserMutation, RemoveUserMutationVariables>;

/**
 * __useRemoveUserMutation__
 *
 * To run a mutation, you first call `useRemoveUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUserMutation, { data, loading, error }] = useRemoveUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveUserMutation(baseOptions?: Apollo.MutationHookOptions<RemoveUserMutation, RemoveUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveUserMutation, RemoveUserMutationVariables>(RemoveUserDocument, options);
      }
export type RemoveUserMutationHookResult = ReturnType<typeof useRemoveUserMutation>;
export type RemoveUserMutationResult = Apollo.MutationResult<RemoveUserMutation>;
export type RemoveUserMutationOptions = Apollo.BaseMutationOptions<RemoveUserMutation, RemoveUserMutationVariables>;
export const RemoveOwnerDocument = gql`
    mutation removeOwner($input: RemoveUserInput!) {
  removeOwner(input: $input)
}
    `;
export type RemoveOwnerMutationFn = Apollo.MutationFunction<RemoveOwnerMutation, RemoveOwnerMutationVariables>;

/**
 * __useRemoveOwnerMutation__
 *
 * To run a mutation, you first call `useRemoveOwnerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveOwnerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeOwnerMutation, { data, loading, error }] = useRemoveOwnerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveOwnerMutation(baseOptions?: Apollo.MutationHookOptions<RemoveOwnerMutation, RemoveOwnerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveOwnerMutation, RemoveOwnerMutationVariables>(RemoveOwnerDocument, options);
      }
export type RemoveOwnerMutationHookResult = ReturnType<typeof useRemoveOwnerMutation>;
export type RemoveOwnerMutationResult = Apollo.MutationResult<RemoveOwnerMutation>;
export type RemoveOwnerMutationOptions = Apollo.BaseMutationOptions<RemoveOwnerMutation, RemoveOwnerMutationVariables>;
export const UpdateUserInfoDocument = gql`
    mutation updateUserInfo($input: UpdateUserInputPartial!) {
  updateUserInfo(input: $input) {
    ...User
    contacts {
      ...Contact
    }
    role {
      ...Role
    }
  }
}
    ${UserFragmentDoc}
${ContactFragmentDoc}
${RoleFragmentDoc}`;
export type UpdateUserInfoMutationFn = Apollo.MutationFunction<UpdateUserInfoMutation, UpdateUserInfoMutationVariables>;

/**
 * __useUpdateUserInfoMutation__
 *
 * To run a mutation, you first call `useUpdateUserInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserInfoMutation, { data, loading, error }] = useUpdateUserInfoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserInfoMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserInfoMutation, UpdateUserInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserInfoMutation, UpdateUserInfoMutationVariables>(UpdateUserInfoDocument, options);
      }
export type UpdateUserInfoMutationHookResult = ReturnType<typeof useUpdateUserInfoMutation>;
export type UpdateUserInfoMutationResult = Apollo.MutationResult<UpdateUserInfoMutation>;
export type UpdateUserInfoMutationOptions = Apollo.BaseMutationOptions<UpdateUserInfoMutation, UpdateUserInfoMutationVariables>;
export const UpdateUserEmailDocument = gql`
    mutation updateUserEmail($input: UpdateUserEmailInput!) {
  updateUserEmail(input: $input) {
    ...User
    contacts {
      ...Contact
    }
    role {
      ...Role
    }
  }
}
    ${UserFragmentDoc}
${ContactFragmentDoc}
${RoleFragmentDoc}`;
export type UpdateUserEmailMutationFn = Apollo.MutationFunction<UpdateUserEmailMutation, UpdateUserEmailMutationVariables>;

/**
 * __useUpdateUserEmailMutation__
 *
 * To run a mutation, you first call `useUpdateUserEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserEmailMutation, { data, loading, error }] = useUpdateUserEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserEmailMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserEmailMutation, UpdateUserEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserEmailMutation, UpdateUserEmailMutationVariables>(UpdateUserEmailDocument, options);
      }
export type UpdateUserEmailMutationHookResult = ReturnType<typeof useUpdateUserEmailMutation>;
export type UpdateUserEmailMutationResult = Apollo.MutationResult<UpdateUserEmailMutation>;
export type UpdateUserEmailMutationOptions = Apollo.BaseMutationOptions<UpdateUserEmailMutation, UpdateUserEmailMutationVariables>;
export const UpdateUserRoleDocument = gql`
    mutation updateUserRole($input: UpdateUserRoleInput!) {
  updateUserRole(input: $input) {
    ...User
    contacts {
      ...Contact
    }
    role {
      ...Role
    }
  }
}
    ${UserFragmentDoc}
${ContactFragmentDoc}
${RoleFragmentDoc}`;
export type UpdateUserRoleMutationFn = Apollo.MutationFunction<UpdateUserRoleMutation, UpdateUserRoleMutationVariables>;

/**
 * __useUpdateUserRoleMutation__
 *
 * To run a mutation, you first call `useUpdateUserRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserRoleMutation, { data, loading, error }] = useUpdateUserRoleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserRoleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserRoleMutation, UpdateUserRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserRoleMutation, UpdateUserRoleMutationVariables>(UpdateUserRoleDocument, options);
      }
export type UpdateUserRoleMutationHookResult = ReturnType<typeof useUpdateUserRoleMutation>;
export type UpdateUserRoleMutationResult = Apollo.MutationResult<UpdateUserRoleMutation>;
export type UpdateUserRoleMutationOptions = Apollo.BaseMutationOptions<UpdateUserRoleMutation, UpdateUserRoleMutationVariables>;
export const GetPermissionsDocument = gql`
    query getPermissions($input: GetPermissionsInput!) {
  getPermissions(input: $input) {
    ...Permission
    role {
      ...Role
    }
  }
}
    ${PermissionFragmentDoc}
${RoleFragmentDoc}`;

/**
 * __useGetPermissionsQuery__
 *
 * To run a query within a React component, call `useGetPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPermissionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetPermissionsQuery(baseOptions: Apollo.QueryHookOptions<GetPermissionsQuery, GetPermissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPermissionsQuery, GetPermissionsQueryVariables>(GetPermissionsDocument, options);
      }
export function useGetPermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPermissionsQuery, GetPermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPermissionsQuery, GetPermissionsQueryVariables>(GetPermissionsDocument, options);
        }
export type GetPermissionsQueryHookResult = ReturnType<typeof useGetPermissionsQuery>;
export type GetPermissionsLazyQueryHookResult = ReturnType<typeof useGetPermissionsLazyQuery>;
export type GetPermissionsQueryResult = Apollo.QueryResult<GetPermissionsQuery, GetPermissionsQueryVariables>;
export const GetUserDocument = gql`
    query getUser($input: GetUserInput!) {
  getUser(input: $input) {
    ...User
    contacts {
      ...Contact
    }
    role {
      ...Role
    }
  }
}
    ${UserFragmentDoc}
${ContactFragmentDoc}
${RoleFragmentDoc}`;

/**
 * __useGetUserQuery__
 *
 * To run a query within a React component, call `useGetUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetUserQuery(baseOptions: Apollo.QueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
      }
export function useGetUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
        }
export type GetUserQueryHookResult = ReturnType<typeof useGetUserQuery>;
export type GetUserLazyQueryHookResult = ReturnType<typeof useGetUserLazyQuery>;
export type GetUserQueryResult = Apollo.QueryResult<GetUserQuery, GetUserQueryVariables>;
export const CreateAppointmentsDocument = gql`
    mutation createAppointments($input: CreateEmptyAppointmentInput!) {
  createAppointments(input: $input) {
    ...Appointment
    users {
      ...AppointmentUser
      contacts {
        ...Contact
      }
    }
    donor {
      ...AppointmentDonor
      user {
        ...AppointmentUser
        contacts {
          ...Contact
        }
      }
    }
    group {
      ...AppointmentGroup
      user {
        ...AppointmentUser
        contacts {
          ...Contact
        }
      }
    }
    team {
      ...AppointmentTeam
    }
  }
}
    ${AppointmentFragmentDoc}
${AppointmentUserFragmentDoc}
${ContactFragmentDoc}
${AppointmentDonorFragmentDoc}
${AppointmentGroupFragmentDoc}
${AppointmentTeamFragmentDoc}`;
export type CreateAppointmentsMutationFn = Apollo.MutationFunction<CreateAppointmentsMutation, CreateAppointmentsMutationVariables>;

/**
 * __useCreateAppointmentsMutation__
 *
 * To run a mutation, you first call `useCreateAppointmentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAppointmentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAppointmentsMutation, { data, loading, error }] = useCreateAppointmentsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAppointmentsMutation(baseOptions?: Apollo.MutationHookOptions<CreateAppointmentsMutation, CreateAppointmentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAppointmentsMutation, CreateAppointmentsMutationVariables>(CreateAppointmentsDocument, options);
      }
export type CreateAppointmentsMutationHookResult = ReturnType<typeof useCreateAppointmentsMutation>;
export type CreateAppointmentsMutationResult = Apollo.MutationResult<CreateAppointmentsMutation>;
export type CreateAppointmentsMutationOptions = Apollo.BaseMutationOptions<CreateAppointmentsMutation, CreateAppointmentsMutationVariables>;
export const CreateAppointmentsWithDonorDocument = gql`
    mutation createAppointmentsWithDonor($input: CreateAppointmentWithDonorInput!) {
  createAppointmentsWithDonor(input: $input) {
    ...Appointment
    users {
      ...AppointmentUser
      contacts {
        ...Contact
      }
    }
    donor {
      ...AppointmentDonor
      user {
        ...AppointmentUser
        contacts {
          ...Contact
        }
      }
    }
    group {
      ...AppointmentGroup
      user {
        ...AppointmentUser
        contacts {
          ...Contact
        }
      }
    }
    team {
      ...AppointmentTeam
    }
  }
}
    ${AppointmentFragmentDoc}
${AppointmentUserFragmentDoc}
${ContactFragmentDoc}
${AppointmentDonorFragmentDoc}
${AppointmentGroupFragmentDoc}
${AppointmentTeamFragmentDoc}`;
export type CreateAppointmentsWithDonorMutationFn = Apollo.MutationFunction<CreateAppointmentsWithDonorMutation, CreateAppointmentsWithDonorMutationVariables>;

/**
 * __useCreateAppointmentsWithDonorMutation__
 *
 * To run a mutation, you first call `useCreateAppointmentsWithDonorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAppointmentsWithDonorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAppointmentsWithDonorMutation, { data, loading, error }] = useCreateAppointmentsWithDonorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAppointmentsWithDonorMutation(baseOptions?: Apollo.MutationHookOptions<CreateAppointmentsWithDonorMutation, CreateAppointmentsWithDonorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAppointmentsWithDonorMutation, CreateAppointmentsWithDonorMutationVariables>(CreateAppointmentsWithDonorDocument, options);
      }
export type CreateAppointmentsWithDonorMutationHookResult = ReturnType<typeof useCreateAppointmentsWithDonorMutation>;
export type CreateAppointmentsWithDonorMutationResult = Apollo.MutationResult<CreateAppointmentsWithDonorMutation>;
export type CreateAppointmentsWithDonorMutationOptions = Apollo.BaseMutationOptions<CreateAppointmentsWithDonorMutation, CreateAppointmentsWithDonorMutationVariables>;
export const CreateAppointmentsWithGroupDocument = gql`
    mutation createAppointmentsWithGroup($input: CreateAppointmentWithGroupInput!) {
  createAppointmentsWithGroup(input: $input) {
    ...Appointment
    users {
      ...AppointmentUser
      contacts {
        ...Contact
      }
    }
    donor {
      ...AppointmentDonor
      user {
        ...AppointmentUser
        contacts {
          ...Contact
        }
      }
    }
    group {
      ...AppointmentGroup
      user {
        ...AppointmentUser
        contacts {
          ...Contact
        }
      }
    }
    team {
      ...AppointmentTeam
    }
  }
}
    ${AppointmentFragmentDoc}
${AppointmentUserFragmentDoc}
${ContactFragmentDoc}
${AppointmentDonorFragmentDoc}
${AppointmentGroupFragmentDoc}
${AppointmentTeamFragmentDoc}`;
export type CreateAppointmentsWithGroupMutationFn = Apollo.MutationFunction<CreateAppointmentsWithGroupMutation, CreateAppointmentsWithGroupMutationVariables>;

/**
 * __useCreateAppointmentsWithGroupMutation__
 *
 * To run a mutation, you first call `useCreateAppointmentsWithGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAppointmentsWithGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAppointmentsWithGroupMutation, { data, loading, error }] = useCreateAppointmentsWithGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAppointmentsWithGroupMutation(baseOptions?: Apollo.MutationHookOptions<CreateAppointmentsWithGroupMutation, CreateAppointmentsWithGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAppointmentsWithGroupMutation, CreateAppointmentsWithGroupMutationVariables>(CreateAppointmentsWithGroupDocument, options);
      }
export type CreateAppointmentsWithGroupMutationHookResult = ReturnType<typeof useCreateAppointmentsWithGroupMutation>;
export type CreateAppointmentsWithGroupMutationResult = Apollo.MutationResult<CreateAppointmentsWithGroupMutation>;
export type CreateAppointmentsWithGroupMutationOptions = Apollo.BaseMutationOptions<CreateAppointmentsWithGroupMutation, CreateAppointmentsWithGroupMutationVariables>;
export const EnrollDonorToAppointmentDocument = gql`
    mutation enrollDonorToAppointment($input: EnrollDonorInput!) {
  enrollDonorToAppointment(input: $input)
}
    `;
export type EnrollDonorToAppointmentMutationFn = Apollo.MutationFunction<EnrollDonorToAppointmentMutation, EnrollDonorToAppointmentMutationVariables>;

/**
 * __useEnrollDonorToAppointmentMutation__
 *
 * To run a mutation, you first call `useEnrollDonorToAppointmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnrollDonorToAppointmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enrollDonorToAppointmentMutation, { data, loading, error }] = useEnrollDonorToAppointmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEnrollDonorToAppointmentMutation(baseOptions?: Apollo.MutationHookOptions<EnrollDonorToAppointmentMutation, EnrollDonorToAppointmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EnrollDonorToAppointmentMutation, EnrollDonorToAppointmentMutationVariables>(EnrollDonorToAppointmentDocument, options);
      }
export type EnrollDonorToAppointmentMutationHookResult = ReturnType<typeof useEnrollDonorToAppointmentMutation>;
export type EnrollDonorToAppointmentMutationResult = Apollo.MutationResult<EnrollDonorToAppointmentMutation>;
export type EnrollDonorToAppointmentMutationOptions = Apollo.BaseMutationOptions<EnrollDonorToAppointmentMutation, EnrollDonorToAppointmentMutationVariables>;
export const UnenrollMyDonorFromAppointmentDocument = gql`
    mutation unenrollMyDonorFromAppointment($input: UnenrollDonorInput!) {
  unenrollMyDonorFromAppointment(input: $input)
}
    `;
export type UnenrollMyDonorFromAppointmentMutationFn = Apollo.MutationFunction<UnenrollMyDonorFromAppointmentMutation, UnenrollMyDonorFromAppointmentMutationVariables>;

/**
 * __useUnenrollMyDonorFromAppointmentMutation__
 *
 * To run a mutation, you first call `useUnenrollMyDonorFromAppointmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnenrollMyDonorFromAppointmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unenrollMyDonorFromAppointmentMutation, { data, loading, error }] = useUnenrollMyDonorFromAppointmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnenrollMyDonorFromAppointmentMutation(baseOptions?: Apollo.MutationHookOptions<UnenrollMyDonorFromAppointmentMutation, UnenrollMyDonorFromAppointmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnenrollMyDonorFromAppointmentMutation, UnenrollMyDonorFromAppointmentMutationVariables>(UnenrollMyDonorFromAppointmentDocument, options);
      }
export type UnenrollMyDonorFromAppointmentMutationHookResult = ReturnType<typeof useUnenrollMyDonorFromAppointmentMutation>;
export type UnenrollMyDonorFromAppointmentMutationResult = Apollo.MutationResult<UnenrollMyDonorFromAppointmentMutation>;
export type UnenrollMyDonorFromAppointmentMutationOptions = Apollo.BaseMutationOptions<UnenrollMyDonorFromAppointmentMutation, UnenrollMyDonorFromAppointmentMutationVariables>;
export const EnrollMyDonorToAppointmentDocument = gql`
    mutation enrollMyDonorToAppointment($input: EnrollDonorInput!) {
  enrollMyDonorToAppointment(input: $input)
}
    `;
export type EnrollMyDonorToAppointmentMutationFn = Apollo.MutationFunction<EnrollMyDonorToAppointmentMutation, EnrollMyDonorToAppointmentMutationVariables>;

/**
 * __useEnrollMyDonorToAppointmentMutation__
 *
 * To run a mutation, you first call `useEnrollMyDonorToAppointmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnrollMyDonorToAppointmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enrollMyDonorToAppointmentMutation, { data, loading, error }] = useEnrollMyDonorToAppointmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEnrollMyDonorToAppointmentMutation(baseOptions?: Apollo.MutationHookOptions<EnrollMyDonorToAppointmentMutation, EnrollMyDonorToAppointmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EnrollMyDonorToAppointmentMutation, EnrollMyDonorToAppointmentMutationVariables>(EnrollMyDonorToAppointmentDocument, options);
      }
export type EnrollMyDonorToAppointmentMutationHookResult = ReturnType<typeof useEnrollMyDonorToAppointmentMutation>;
export type EnrollMyDonorToAppointmentMutationResult = Apollo.MutationResult<EnrollMyDonorToAppointmentMutation>;
export type EnrollMyDonorToAppointmentMutationOptions = Apollo.BaseMutationOptions<EnrollMyDonorToAppointmentMutation, EnrollMyDonorToAppointmentMutationVariables>;
export const RemoveAppointmentDocument = gql`
    mutation removeAppointment($input: RemoveAppointmentInput!) {
  removeAppointment(input: $input)
}
    `;
export type RemoveAppointmentMutationFn = Apollo.MutationFunction<RemoveAppointmentMutation, RemoveAppointmentMutationVariables>;

/**
 * __useRemoveAppointmentMutation__
 *
 * To run a mutation, you first call `useRemoveAppointmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveAppointmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeAppointmentMutation, { data, loading, error }] = useRemoveAppointmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveAppointmentMutation(baseOptions?: Apollo.MutationHookOptions<RemoveAppointmentMutation, RemoveAppointmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveAppointmentMutation, RemoveAppointmentMutationVariables>(RemoveAppointmentDocument, options);
      }
export type RemoveAppointmentMutationHookResult = ReturnType<typeof useRemoveAppointmentMutation>;
export type RemoveAppointmentMutationResult = Apollo.MutationResult<RemoveAppointmentMutation>;
export type RemoveAppointmentMutationOptions = Apollo.BaseMutationOptions<RemoveAppointmentMutation, RemoveAppointmentMutationVariables>;
export const UpdateAppointmentDocument = gql`
    mutation updateAppointment($input: UpdateAppointmentInput!) {
  updateAppointment(updateAppointmentInput: $input) {
    ...Appointment
    users {
      ...AppointmentUser
      contacts {
        ...Contact
      }
    }
    donor {
      ...AppointmentDonor
      user {
        ...AppointmentUser
        contacts {
          ...Contact
        }
      }
    }
    group {
      ...AppointmentGroup
      user {
        ...AppointmentUser
        contacts {
          ...Contact
        }
      }
    }
    team {
      ...AppointmentTeam
    }
  }
}
    ${AppointmentFragmentDoc}
${AppointmentUserFragmentDoc}
${ContactFragmentDoc}
${AppointmentDonorFragmentDoc}
${AppointmentGroupFragmentDoc}
${AppointmentTeamFragmentDoc}`;
export type UpdateAppointmentMutationFn = Apollo.MutationFunction<UpdateAppointmentMutation, UpdateAppointmentMutationVariables>;

/**
 * __useUpdateAppointmentMutation__
 *
 * To run a mutation, you first call `useUpdateAppointmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAppointmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAppointmentMutation, { data, loading, error }] = useUpdateAppointmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAppointmentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAppointmentMutation, UpdateAppointmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAppointmentMutation, UpdateAppointmentMutationVariables>(UpdateAppointmentDocument, options);
      }
export type UpdateAppointmentMutationHookResult = ReturnType<typeof useUpdateAppointmentMutation>;
export type UpdateAppointmentMutationResult = Apollo.MutationResult<UpdateAppointmentMutation>;
export type UpdateAppointmentMutationOptions = Apollo.BaseMutationOptions<UpdateAppointmentMutation, UpdateAppointmentMutationVariables>;
export const RegisterOnDaycareAppointmentDocument = gql`
    mutation registerOnDaycareAppointment($input: RegisterOnDaycareAppointmentInput!) {
  registerOnDaycareAppointment(input: $input)
}
    `;
export type RegisterOnDaycareAppointmentMutationFn = Apollo.MutationFunction<RegisterOnDaycareAppointmentMutation, RegisterOnDaycareAppointmentMutationVariables>;

/**
 * __useRegisterOnDaycareAppointmentMutation__
 *
 * To run a mutation, you first call `useRegisterOnDaycareAppointmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterOnDaycareAppointmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerOnDaycareAppointmentMutation, { data, loading, error }] = useRegisterOnDaycareAppointmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegisterOnDaycareAppointmentMutation(baseOptions?: Apollo.MutationHookOptions<RegisterOnDaycareAppointmentMutation, RegisterOnDaycareAppointmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterOnDaycareAppointmentMutation, RegisterOnDaycareAppointmentMutationVariables>(RegisterOnDaycareAppointmentDocument, options);
      }
export type RegisterOnDaycareAppointmentMutationHookResult = ReturnType<typeof useRegisterOnDaycareAppointmentMutation>;
export type RegisterOnDaycareAppointmentMutationResult = Apollo.MutationResult<RegisterOnDaycareAppointmentMutation>;
export type RegisterOnDaycareAppointmentMutationOptions = Apollo.BaseMutationOptions<RegisterOnDaycareAppointmentMutation, RegisterOnDaycareAppointmentMutationVariables>;
export const ApproveDaycareAppointmentRequestDocument = gql`
    mutation approveDaycareAppointmentRequest($id: String!) {
  approveDaycareAppointmentRequest(requestId: $id)
}
    `;
export type ApproveDaycareAppointmentRequestMutationFn = Apollo.MutationFunction<ApproveDaycareAppointmentRequestMutation, ApproveDaycareAppointmentRequestMutationVariables>;

/**
 * __useApproveDaycareAppointmentRequestMutation__
 *
 * To run a mutation, you first call `useApproveDaycareAppointmentRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveDaycareAppointmentRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveDaycareAppointmentRequestMutation, { data, loading, error }] = useApproveDaycareAppointmentRequestMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useApproveDaycareAppointmentRequestMutation(baseOptions?: Apollo.MutationHookOptions<ApproveDaycareAppointmentRequestMutation, ApproveDaycareAppointmentRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveDaycareAppointmentRequestMutation, ApproveDaycareAppointmentRequestMutationVariables>(ApproveDaycareAppointmentRequestDocument, options);
      }
export type ApproveDaycareAppointmentRequestMutationHookResult = ReturnType<typeof useApproveDaycareAppointmentRequestMutation>;
export type ApproveDaycareAppointmentRequestMutationResult = Apollo.MutationResult<ApproveDaycareAppointmentRequestMutation>;
export type ApproveDaycareAppointmentRequestMutationOptions = Apollo.BaseMutationOptions<ApproveDaycareAppointmentRequestMutation, ApproveDaycareAppointmentRequestMutationVariables>;
export const DisproveDaycareAppointmentRequestDocument = gql`
    mutation disproveDaycareAppointmentRequest($id: String!) {
  disproveDaycareAppointmentRequest(requestId: $id)
}
    `;
export type DisproveDaycareAppointmentRequestMutationFn = Apollo.MutationFunction<DisproveDaycareAppointmentRequestMutation, DisproveDaycareAppointmentRequestMutationVariables>;

/**
 * __useDisproveDaycareAppointmentRequestMutation__
 *
 * To run a mutation, you first call `useDisproveDaycareAppointmentRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisproveDaycareAppointmentRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disproveDaycareAppointmentRequestMutation, { data, loading, error }] = useDisproveDaycareAppointmentRequestMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDisproveDaycareAppointmentRequestMutation(baseOptions?: Apollo.MutationHookOptions<DisproveDaycareAppointmentRequestMutation, DisproveDaycareAppointmentRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisproveDaycareAppointmentRequestMutation, DisproveDaycareAppointmentRequestMutationVariables>(DisproveDaycareAppointmentRequestDocument, options);
      }
export type DisproveDaycareAppointmentRequestMutationHookResult = ReturnType<typeof useDisproveDaycareAppointmentRequestMutation>;
export type DisproveDaycareAppointmentRequestMutationResult = Apollo.MutationResult<DisproveDaycareAppointmentRequestMutation>;
export type DisproveDaycareAppointmentRequestMutationOptions = Apollo.BaseMutationOptions<DisproveDaycareAppointmentRequestMutation, DisproveDaycareAppointmentRequestMutationVariables>;
export const CancelDaycareAppointmentRequestDocument = gql`
    mutation cancelDaycareAppointmentRequest($id: String!) {
  cancelDaycareAppointmentRequest(requestId: $id)
}
    `;
export type CancelDaycareAppointmentRequestMutationFn = Apollo.MutationFunction<CancelDaycareAppointmentRequestMutation, CancelDaycareAppointmentRequestMutationVariables>;

/**
 * __useCancelDaycareAppointmentRequestMutation__
 *
 * To run a mutation, you first call `useCancelDaycareAppointmentRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelDaycareAppointmentRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelDaycareAppointmentRequestMutation, { data, loading, error }] = useCancelDaycareAppointmentRequestMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCancelDaycareAppointmentRequestMutation(baseOptions?: Apollo.MutationHookOptions<CancelDaycareAppointmentRequestMutation, CancelDaycareAppointmentRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelDaycareAppointmentRequestMutation, CancelDaycareAppointmentRequestMutationVariables>(CancelDaycareAppointmentRequestDocument, options);
      }
export type CancelDaycareAppointmentRequestMutationHookResult = ReturnType<typeof useCancelDaycareAppointmentRequestMutation>;
export type CancelDaycareAppointmentRequestMutationResult = Apollo.MutationResult<CancelDaycareAppointmentRequestMutation>;
export type CancelDaycareAppointmentRequestMutationOptions = Apollo.BaseMutationOptions<CancelDaycareAppointmentRequestMutation, CancelDaycareAppointmentRequestMutationVariables>;
export const CreateDaycareAppointmentsWithDonorsDocument = gql`
    mutation createDaycareAppointmentsWithDonors($input: CreateDaycareAppointmentWithDonorsInput!) {
  createDaycareAppointmentsWithDonors(input: $input)
}
    `;
export type CreateDaycareAppointmentsWithDonorsMutationFn = Apollo.MutationFunction<CreateDaycareAppointmentsWithDonorsMutation, CreateDaycareAppointmentsWithDonorsMutationVariables>;

/**
 * __useCreateDaycareAppointmentsWithDonorsMutation__
 *
 * To run a mutation, you first call `useCreateDaycareAppointmentsWithDonorsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDaycareAppointmentsWithDonorsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDaycareAppointmentsWithDonorsMutation, { data, loading, error }] = useCreateDaycareAppointmentsWithDonorsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDaycareAppointmentsWithDonorsMutation(baseOptions?: Apollo.MutationHookOptions<CreateDaycareAppointmentsWithDonorsMutation, CreateDaycareAppointmentsWithDonorsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDaycareAppointmentsWithDonorsMutation, CreateDaycareAppointmentsWithDonorsMutationVariables>(CreateDaycareAppointmentsWithDonorsDocument, options);
      }
export type CreateDaycareAppointmentsWithDonorsMutationHookResult = ReturnType<typeof useCreateDaycareAppointmentsWithDonorsMutation>;
export type CreateDaycareAppointmentsWithDonorsMutationResult = Apollo.MutationResult<CreateDaycareAppointmentsWithDonorsMutation>;
export type CreateDaycareAppointmentsWithDonorsMutationOptions = Apollo.BaseMutationOptions<CreateDaycareAppointmentsWithDonorsMutation, CreateDaycareAppointmentsWithDonorsMutationVariables>;
export const UnenrollDonorFromDaycareDocument = gql`
    mutation unenrollDonorFromDaycare($input: DaycareUnenrollDonorInput!) {
  unenrollDonorFromDaycare(input: $input)
}
    `;
export type UnenrollDonorFromDaycareMutationFn = Apollo.MutationFunction<UnenrollDonorFromDaycareMutation, UnenrollDonorFromDaycareMutationVariables>;

/**
 * __useUnenrollDonorFromDaycareMutation__
 *
 * To run a mutation, you first call `useUnenrollDonorFromDaycareMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnenrollDonorFromDaycareMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unenrollDonorFromDaycareMutation, { data, loading, error }] = useUnenrollDonorFromDaycareMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnenrollDonorFromDaycareMutation(baseOptions?: Apollo.MutationHookOptions<UnenrollDonorFromDaycareMutation, UnenrollDonorFromDaycareMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnenrollDonorFromDaycareMutation, UnenrollDonorFromDaycareMutationVariables>(UnenrollDonorFromDaycareDocument, options);
      }
export type UnenrollDonorFromDaycareMutationHookResult = ReturnType<typeof useUnenrollDonorFromDaycareMutation>;
export type UnenrollDonorFromDaycareMutationResult = Apollo.MutationResult<UnenrollDonorFromDaycareMutation>;
export type UnenrollDonorFromDaycareMutationOptions = Apollo.BaseMutationOptions<UnenrollDonorFromDaycareMutation, UnenrollDonorFromDaycareMutationVariables>;
export const AddDonorsToDaycareDocument = gql`
    mutation addDonorsToDaycare($input: AddDonorsToDaycareInput!) {
  addDonorsToDaycare(input: $input)
}
    `;
export type AddDonorsToDaycareMutationFn = Apollo.MutationFunction<AddDonorsToDaycareMutation, AddDonorsToDaycareMutationVariables>;

/**
 * __useAddDonorsToDaycareMutation__
 *
 * To run a mutation, you first call `useAddDonorsToDaycareMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddDonorsToDaycareMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addDonorsToDaycareMutation, { data, loading, error }] = useAddDonorsToDaycareMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddDonorsToDaycareMutation(baseOptions?: Apollo.MutationHookOptions<AddDonorsToDaycareMutation, AddDonorsToDaycareMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddDonorsToDaycareMutation, AddDonorsToDaycareMutationVariables>(AddDonorsToDaycareDocument, options);
      }
export type AddDonorsToDaycareMutationHookResult = ReturnType<typeof useAddDonorsToDaycareMutation>;
export type AddDonorsToDaycareMutationResult = Apollo.MutationResult<AddDonorsToDaycareMutation>;
export type AddDonorsToDaycareMutationOptions = Apollo.BaseMutationOptions<AddDonorsToDaycareMutation, AddDonorsToDaycareMutationVariables>;
export const GetAppointmentsDocument = gql`
    query getAppointments($input: GetAppointmentsInput!) {
  getAppointments(input: $input) {
    ...Appointment
    users {
      ...AppointmentUser
      contacts {
        ...Contact
      }
    }
    donor {
      ...AppointmentDonor
      user {
        ...AppointmentUser
        contacts {
          ...Contact
        }
      }
    }
    group {
      ...AppointmentGroup
      user {
        ...AppointmentUser
        contacts {
          ...Contact
        }
      }
    }
    team {
      ...AppointmentTeam
    }
  }
}
    ${AppointmentFragmentDoc}
${AppointmentUserFragmentDoc}
${ContactFragmentDoc}
${AppointmentDonorFragmentDoc}
${AppointmentGroupFragmentDoc}
${AppointmentTeamFragmentDoc}`;

/**
 * __useGetAppointmentsQuery__
 *
 * To run a query within a React component, call `useGetAppointmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppointmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppointmentsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAppointmentsQuery(baseOptions: Apollo.QueryHookOptions<GetAppointmentsQuery, GetAppointmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppointmentsQuery, GetAppointmentsQueryVariables>(GetAppointmentsDocument, options);
      }
export function useGetAppointmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppointmentsQuery, GetAppointmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppointmentsQuery, GetAppointmentsQueryVariables>(GetAppointmentsDocument, options);
        }
export type GetAppointmentsQueryHookResult = ReturnType<typeof useGetAppointmentsQuery>;
export type GetAppointmentsLazyQueryHookResult = ReturnType<typeof useGetAppointmentsLazyQuery>;
export type GetAppointmentsQueryResult = Apollo.QueryResult<GetAppointmentsQuery, GetAppointmentsQueryVariables>;
export const GetAppointmentDocument = gql`
    query getAppointment($input: GetAppointmentInput!) {
  getAppointment(input: $input) {
    ...Appointment
    users {
      ...AppointmentUser
      contacts {
        ...Contact
      }
    }
    donor {
      ...AppointmentDonor
      user {
        ...AppointmentUser
        contacts {
          ...Contact
        }
      }
    }
    group {
      ...AppointmentGroup
      user {
        ...AppointmentUser
        contacts {
          ...Contact
        }
      }
    }
    team {
      ...AppointmentTeam
    }
  }
}
    ${AppointmentFragmentDoc}
${AppointmentUserFragmentDoc}
${ContactFragmentDoc}
${AppointmentDonorFragmentDoc}
${AppointmentGroupFragmentDoc}
${AppointmentTeamFragmentDoc}`;

/**
 * __useGetAppointmentQuery__
 *
 * To run a query within a React component, call `useGetAppointmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppointmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppointmentQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAppointmentQuery(baseOptions: Apollo.QueryHookOptions<GetAppointmentQuery, GetAppointmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppointmentQuery, GetAppointmentQueryVariables>(GetAppointmentDocument, options);
      }
export function useGetAppointmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppointmentQuery, GetAppointmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppointmentQuery, GetAppointmentQueryVariables>(GetAppointmentDocument, options);
        }
export type GetAppointmentQueryHookResult = ReturnType<typeof useGetAppointmentQuery>;
export type GetAppointmentLazyQueryHookResult = ReturnType<typeof useGetAppointmentLazyQuery>;
export type GetAppointmentQueryResult = Apollo.QueryResult<GetAppointmentQuery, GetAppointmentQueryVariables>;
export const GetAppointmentsForCurrentUserDocument = gql`
    query getAppointmentsForCurrentUser($input: GetAppointmentsForCurrentUserInput!) {
  getAppointmentsForCurrentUser(input: $input) {
    ...Appointment
    users {
      ...AppointmentUser
      contacts {
        ...Contact
      }
    }
    donor {
      ...AppointmentDonor
      user {
        ...AppointmentUser
        contacts {
          ...Contact
        }
      }
    }
    group {
      ...AppointmentGroup
      user {
        ...AppointmentUser
        contacts {
          ...Contact
        }
      }
    }
    team {
      ...AppointmentTeam
    }
  }
}
    ${AppointmentFragmentDoc}
${AppointmentUserFragmentDoc}
${ContactFragmentDoc}
${AppointmentDonorFragmentDoc}
${AppointmentGroupFragmentDoc}
${AppointmentTeamFragmentDoc}`;

/**
 * __useGetAppointmentsForCurrentUserQuery__
 *
 * To run a query within a React component, call `useGetAppointmentsForCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppointmentsForCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppointmentsForCurrentUserQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAppointmentsForCurrentUserQuery(baseOptions: Apollo.QueryHookOptions<GetAppointmentsForCurrentUserQuery, GetAppointmentsForCurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppointmentsForCurrentUserQuery, GetAppointmentsForCurrentUserQueryVariables>(GetAppointmentsForCurrentUserDocument, options);
      }
export function useGetAppointmentsForCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppointmentsForCurrentUserQuery, GetAppointmentsForCurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppointmentsForCurrentUserQuery, GetAppointmentsForCurrentUserQueryVariables>(GetAppointmentsForCurrentUserDocument, options);
        }
export type GetAppointmentsForCurrentUserQueryHookResult = ReturnType<typeof useGetAppointmentsForCurrentUserQuery>;
export type GetAppointmentsForCurrentUserLazyQueryHookResult = ReturnType<typeof useGetAppointmentsForCurrentUserLazyQuery>;
export type GetAppointmentsForCurrentUserQueryResult = Apollo.QueryResult<GetAppointmentsForCurrentUserQuery, GetAppointmentsForCurrentUserQueryVariables>;
export const GetPrivateDaycareAppointmentForCurrentUserDocument = gql`
    query getPrivateDaycareAppointmentForCurrentUser($input: GetAppointmentsForCurrentUserInput!) {
  getPrivateDaycareAppointmentForCurrentUser(input: $input) {
    ...Appointment
    users {
      ...AppointmentUser
      contacts {
        ...Contact
      }
    }
    donor {
      ...AppointmentDonor
      user {
        ...AppointmentUser
        contacts {
          ...Contact
        }
      }
    }
    group {
      ...AppointmentGroup
      user {
        ...AppointmentUser
        contacts {
          ...Contact
        }
      }
    }
    team {
      ...AppointmentTeam
    }
  }
}
    ${AppointmentFragmentDoc}
${AppointmentUserFragmentDoc}
${ContactFragmentDoc}
${AppointmentDonorFragmentDoc}
${AppointmentGroupFragmentDoc}
${AppointmentTeamFragmentDoc}`;

/**
 * __useGetPrivateDaycareAppointmentForCurrentUserQuery__
 *
 * To run a query within a React component, call `useGetPrivateDaycareAppointmentForCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPrivateDaycareAppointmentForCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPrivateDaycareAppointmentForCurrentUserQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetPrivateDaycareAppointmentForCurrentUserQuery(baseOptions: Apollo.QueryHookOptions<GetPrivateDaycareAppointmentForCurrentUserQuery, GetPrivateDaycareAppointmentForCurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPrivateDaycareAppointmentForCurrentUserQuery, GetPrivateDaycareAppointmentForCurrentUserQueryVariables>(GetPrivateDaycareAppointmentForCurrentUserDocument, options);
      }
export function useGetPrivateDaycareAppointmentForCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPrivateDaycareAppointmentForCurrentUserQuery, GetPrivateDaycareAppointmentForCurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPrivateDaycareAppointmentForCurrentUserQuery, GetPrivateDaycareAppointmentForCurrentUserQueryVariables>(GetPrivateDaycareAppointmentForCurrentUserDocument, options);
        }
export type GetPrivateDaycareAppointmentForCurrentUserQueryHookResult = ReturnType<typeof useGetPrivateDaycareAppointmentForCurrentUserQuery>;
export type GetPrivateDaycareAppointmentForCurrentUserLazyQueryHookResult = ReturnType<typeof useGetPrivateDaycareAppointmentForCurrentUserLazyQuery>;
export type GetPrivateDaycareAppointmentForCurrentUserQueryResult = Apollo.QueryResult<GetPrivateDaycareAppointmentForCurrentUserQuery, GetPrivateDaycareAppointmentForCurrentUserQueryVariables>;
export const GetDaycareAppointmentInfoDocument = gql`
    query getDaycareAppointmentInfo($input: String!) {
  getDaycareAppointmentInfo(input: $input) {
    interactions {
      id
      note
      owner {
        ...Owner
      }
      ownerResponse
      registeredDonors {
        ...Donor
      }
    }
    meta {
      maxDonorsCapacity
      registeredDonors
    }
    requests {
      id
      user {
        ...Owner
      }
      donor {
        ...Donor
      }
      note
    }
  }
}
    ${OwnerFragmentDoc}
${DonorFragmentDoc}`;

/**
 * __useGetDaycareAppointmentInfoQuery__
 *
 * To run a query within a React component, call `useGetDaycareAppointmentInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDaycareAppointmentInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDaycareAppointmentInfoQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetDaycareAppointmentInfoQuery(baseOptions: Apollo.QueryHookOptions<GetDaycareAppointmentInfoQuery, GetDaycareAppointmentInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDaycareAppointmentInfoQuery, GetDaycareAppointmentInfoQueryVariables>(GetDaycareAppointmentInfoDocument, options);
      }
export function useGetDaycareAppointmentInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDaycareAppointmentInfoQuery, GetDaycareAppointmentInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDaycareAppointmentInfoQuery, GetDaycareAppointmentInfoQueryVariables>(GetDaycareAppointmentInfoDocument, options);
        }
export type GetDaycareAppointmentInfoQueryHookResult = ReturnType<typeof useGetDaycareAppointmentInfoQuery>;
export type GetDaycareAppointmentInfoLazyQueryHookResult = ReturnType<typeof useGetDaycareAppointmentInfoLazyQuery>;
export type GetDaycareAppointmentInfoQueryResult = Apollo.QueryResult<GetDaycareAppointmentInfoQuery, GetDaycareAppointmentInfoQueryVariables>;
export const GetDaycareAppointmentInfoForCurrentUserDocument = gql`
    query getDaycareAppointmentInfoForCurrentUser($appointmentId: String!) {
  getDaycareAppointmentInfoForCurrentUser(appointmentId: $appointmentId) {
    status
    daycareId
    registeredDonors {
      ...Donor
    }
    requests {
      id
      donor {
        ...Donor
      }
    }
  }
}
    ${DonorFragmentDoc}`;

/**
 * __useGetDaycareAppointmentInfoForCurrentUserQuery__
 *
 * To run a query within a React component, call `useGetDaycareAppointmentInfoForCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDaycareAppointmentInfoForCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDaycareAppointmentInfoForCurrentUserQuery({
 *   variables: {
 *      appointmentId: // value for 'appointmentId'
 *   },
 * });
 */
export function useGetDaycareAppointmentInfoForCurrentUserQuery(baseOptions: Apollo.QueryHookOptions<GetDaycareAppointmentInfoForCurrentUserQuery, GetDaycareAppointmentInfoForCurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDaycareAppointmentInfoForCurrentUserQuery, GetDaycareAppointmentInfoForCurrentUserQueryVariables>(GetDaycareAppointmentInfoForCurrentUserDocument, options);
      }
export function useGetDaycareAppointmentInfoForCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDaycareAppointmentInfoForCurrentUserQuery, GetDaycareAppointmentInfoForCurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDaycareAppointmentInfoForCurrentUserQuery, GetDaycareAppointmentInfoForCurrentUserQueryVariables>(GetDaycareAppointmentInfoForCurrentUserDocument, options);
        }
export type GetDaycareAppointmentInfoForCurrentUserQueryHookResult = ReturnType<typeof useGetDaycareAppointmentInfoForCurrentUserQuery>;
export type GetDaycareAppointmentInfoForCurrentUserLazyQueryHookResult = ReturnType<typeof useGetDaycareAppointmentInfoForCurrentUserLazyQuery>;
export type GetDaycareAppointmentInfoForCurrentUserQueryResult = Apollo.QueryResult<GetDaycareAppointmentInfoForCurrentUserQuery, GetDaycareAppointmentInfoForCurrentUserQueryVariables>;
export const LoginDocument = gql`
    mutation login($input: LoginInput!) {
  login(input: $input) {
    accessToken
    refreshToken
  }
}
    `;
export type LoginMutationFn = Apollo.MutationFunction<LoginMutation, LoginMutationVariables>;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLoginMutation(baseOptions?: Apollo.MutationHookOptions<LoginMutation, LoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, options);
      }
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = Apollo.MutationResult<LoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<LoginMutation, LoginMutationVariables>;
export const RefreshTokenDocument = gql`
    mutation refreshToken {
  refreshToken {
    accessToken
    refreshToken
  }
}
    `;
export type RefreshTokenMutationFn = Apollo.MutationFunction<RefreshTokenMutation, RefreshTokenMutationVariables>;

/**
 * __useRefreshTokenMutation__
 *
 * To run a mutation, you first call `useRefreshTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshTokenMutation, { data, loading, error }] = useRefreshTokenMutation({
 *   variables: {
 *   },
 * });
 */
export function useRefreshTokenMutation(baseOptions?: Apollo.MutationHookOptions<RefreshTokenMutation, RefreshTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefreshTokenMutation, RefreshTokenMutationVariables>(RefreshTokenDocument, options);
      }
export type RefreshTokenMutationHookResult = ReturnType<typeof useRefreshTokenMutation>;
export type RefreshTokenMutationResult = Apollo.MutationResult<RefreshTokenMutation>;
export type RefreshTokenMutationOptions = Apollo.BaseMutationOptions<RefreshTokenMutation, RefreshTokenMutationVariables>;
export const LogoutDocument = gql`
    mutation logout {
  logout
}
    `;
export type LogoutMutationFn = Apollo.MutationFunction<LogoutMutation, LogoutMutationVariables>;

/**
 * __useLogoutMutation__
 *
 * To run a mutation, you first call `useLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutMutation, { data, loading, error }] = useLogoutMutation({
 *   variables: {
 *   },
 * });
 */
export function useLogoutMutation(baseOptions?: Apollo.MutationHookOptions<LogoutMutation, LogoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogoutMutation, LogoutMutationVariables>(LogoutDocument, options);
      }
export type LogoutMutationHookResult = ReturnType<typeof useLogoutMutation>;
export type LogoutMutationResult = Apollo.MutationResult<LogoutMutation>;
export type LogoutMutationOptions = Apollo.BaseMutationOptions<LogoutMutation, LogoutMutationVariables>;
export const ResendEmailConfirmationCodeDocument = gql`
    mutation resendEmailConfirmationCode($input: ResendEmailConfirmationCodeInput!) {
  resendEmailConfirmationCode(input: $input)
}
    `;
export type ResendEmailConfirmationCodeMutationFn = Apollo.MutationFunction<ResendEmailConfirmationCodeMutation, ResendEmailConfirmationCodeMutationVariables>;

/**
 * __useResendEmailConfirmationCodeMutation__
 *
 * To run a mutation, you first call `useResendEmailConfirmationCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendEmailConfirmationCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendEmailConfirmationCodeMutation, { data, loading, error }] = useResendEmailConfirmationCodeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResendEmailConfirmationCodeMutation(baseOptions?: Apollo.MutationHookOptions<ResendEmailConfirmationCodeMutation, ResendEmailConfirmationCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendEmailConfirmationCodeMutation, ResendEmailConfirmationCodeMutationVariables>(ResendEmailConfirmationCodeDocument, options);
      }
export type ResendEmailConfirmationCodeMutationHookResult = ReturnType<typeof useResendEmailConfirmationCodeMutation>;
export type ResendEmailConfirmationCodeMutationResult = Apollo.MutationResult<ResendEmailConfirmationCodeMutation>;
export type ResendEmailConfirmationCodeMutationOptions = Apollo.BaseMutationOptions<ResendEmailConfirmationCodeMutation, ResendEmailConfirmationCodeMutationVariables>;
export const GetAppVersionDocument = gql`
    query getAppVersion {
  getAppVersion
}
    `;

/**
 * __useGetAppVersionQuery__
 *
 * To run a query within a React component, call `useGetAppVersionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppVersionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppVersionQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAppVersionQuery(baseOptions?: Apollo.QueryHookOptions<GetAppVersionQuery, GetAppVersionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppVersionQuery, GetAppVersionQueryVariables>(GetAppVersionDocument, options);
      }
export function useGetAppVersionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppVersionQuery, GetAppVersionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppVersionQuery, GetAppVersionQueryVariables>(GetAppVersionDocument, options);
        }
export type GetAppVersionQueryHookResult = ReturnType<typeof useGetAppVersionQuery>;
export type GetAppVersionLazyQueryHookResult = ReturnType<typeof useGetAppVersionLazyQuery>;
export type GetAppVersionQueryResult = Apollo.QueryResult<GetAppVersionQuery, GetAppVersionQueryVariables>;
export const GetDataAuditUnitsDocument = gql`
    query GetDataAuditUnits($input: GetDataAuditUnitsInput!) {
  getDataAuditUnits(input: $input) {
    periodStart
    periodEnd
    unitCount
    donorCount
    rows {
      productId
      productShortId
      unitType
      categoryId
      woocommerceProductId
      productStatus
      productCreatedAt
      donationId
      donorId
      donorShortId
      donorName
      ownerFullName
      donorLocation
      regionName
      donorStatus
    }
  }
}
    `;

/**
 * __useGetDataAuditUnitsQuery__
 *
 * To run a query within a React component, call `useGetDataAuditUnitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDataAuditUnitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDataAuditUnitsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetDataAuditUnitsQuery(baseOptions: Apollo.QueryHookOptions<GetDataAuditUnitsQuery, GetDataAuditUnitsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDataAuditUnitsQuery, GetDataAuditUnitsQueryVariables>(GetDataAuditUnitsDocument, options);
      }
export function useGetDataAuditUnitsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDataAuditUnitsQuery, GetDataAuditUnitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDataAuditUnitsQuery, GetDataAuditUnitsQueryVariables>(GetDataAuditUnitsDocument, options);
        }
export type GetDataAuditUnitsQueryHookResult = ReturnType<typeof useGetDataAuditUnitsQuery>;
export type GetDataAuditUnitsLazyQueryHookResult = ReturnType<typeof useGetDataAuditUnitsLazyQuery>;
export type GetDataAuditUnitsQueryResult = Apollo.QueryResult<GetDataAuditUnitsQuery, GetDataAuditUnitsQueryVariables>;
export const GetDataAuditUnitDonorsDocument = gql`
    query GetDataAuditUnitDonors($input: GetDataAuditUnitsInput!) {
  getDataAuditUnitDonors(input: $input) {
    periodStart
    periodEnd
    unitCount
    rows {
      donorId
      donorName
      ownerFullName
      donorLocation
      regionName
      donorStatus
      units
    }
  }
}
    `;

/**
 * __useGetDataAuditUnitDonorsQuery__
 *
 * To run a query within a React component, call `useGetDataAuditUnitDonorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDataAuditUnitDonorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDataAuditUnitDonorsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetDataAuditUnitDonorsQuery(baseOptions: Apollo.QueryHookOptions<GetDataAuditUnitDonorsQuery, GetDataAuditUnitDonorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDataAuditUnitDonorsQuery, GetDataAuditUnitDonorsQueryVariables>(GetDataAuditUnitDonorsDocument, options);
      }
export function useGetDataAuditUnitDonorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDataAuditUnitDonorsQuery, GetDataAuditUnitDonorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDataAuditUnitDonorsQuery, GetDataAuditUnitDonorsQueryVariables>(GetDataAuditUnitDonorsDocument, options);
        }
export type GetDataAuditUnitDonorsQueryHookResult = ReturnType<typeof useGetDataAuditUnitDonorsQuery>;
export type GetDataAuditUnitDonorsLazyQueryHookResult = ReturnType<typeof useGetDataAuditUnitDonorsLazyQuery>;
export type GetDataAuditUnitDonorsQueryResult = Apollo.QueryResult<GetDataAuditUnitDonorsQuery, GetDataAuditUnitDonorsQueryVariables>;
export const GetDataAuditRecruitedDonorsDocument = gql`
    query GetDataAuditRecruitedDonors($input: GetDataAuditDonorsInput!) {
  getDataAuditRecruitedDonors(input: $input) {
    periodStart
    periodEnd
    donorCount
    rows {
      donorId
      donorName
      createdAt
      ownerFullName
      donorLocation
      regionName
      donorStatus
    }
  }
}
    `;

/**
 * __useGetDataAuditRecruitedDonorsQuery__
 *
 * To run a query within a React component, call `useGetDataAuditRecruitedDonorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDataAuditRecruitedDonorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDataAuditRecruitedDonorsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetDataAuditRecruitedDonorsQuery(baseOptions: Apollo.QueryHookOptions<GetDataAuditRecruitedDonorsQuery, GetDataAuditRecruitedDonorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDataAuditRecruitedDonorsQuery, GetDataAuditRecruitedDonorsQueryVariables>(GetDataAuditRecruitedDonorsDocument, options);
      }
export function useGetDataAuditRecruitedDonorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDataAuditRecruitedDonorsQuery, GetDataAuditRecruitedDonorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDataAuditRecruitedDonorsQuery, GetDataAuditRecruitedDonorsQueryVariables>(GetDataAuditRecruitedDonorsDocument, options);
        }
export type GetDataAuditRecruitedDonorsQueryHookResult = ReturnType<typeof useGetDataAuditRecruitedDonorsQuery>;
export type GetDataAuditRecruitedDonorsLazyQueryHookResult = ReturnType<typeof useGetDataAuditRecruitedDonorsLazyQuery>;
export type GetDataAuditRecruitedDonorsQueryResult = Apollo.QueryResult<GetDataAuditRecruitedDonorsQuery, GetDataAuditRecruitedDonorsQueryVariables>;
export const GetOpsLocationUnitsDocument = gql`
    query GetOpsLocationUnits($input: GetDataAuditUnitsInput!) {
  getOpsLocationUnits(input: $input) {
    periodStart
    periodEnd
    unitCount
    donorCount
    rows {
      productId
      productShortId
      unitType
      categoryId
      woocommerceProductId
      productStatus
      productCreatedAt
      donationId
      donorId
      donorShortId
      donorName
      ownerFullName
      ownerShortId
      donorLocation
      regionName
      donorStatus
      donationDate
    }
  }
}
    `;

/**
 * __useGetOpsLocationUnitsQuery__
 *
 * To run a query within a React component, call `useGetOpsLocationUnitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOpsLocationUnitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOpsLocationUnitsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetOpsLocationUnitsQuery(baseOptions: Apollo.QueryHookOptions<GetOpsLocationUnitsQuery, GetOpsLocationUnitsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOpsLocationUnitsQuery, GetOpsLocationUnitsQueryVariables>(GetOpsLocationUnitsDocument, options);
      }
export function useGetOpsLocationUnitsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOpsLocationUnitsQuery, GetOpsLocationUnitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOpsLocationUnitsQuery, GetOpsLocationUnitsQueryVariables>(GetOpsLocationUnitsDocument, options);
        }
export type GetOpsLocationUnitsQueryHookResult = ReturnType<typeof useGetOpsLocationUnitsQuery>;
export type GetOpsLocationUnitsLazyQueryHookResult = ReturnType<typeof useGetOpsLocationUnitsLazyQuery>;
export type GetOpsLocationUnitsQueryResult = Apollo.QueryResult<GetOpsLocationUnitsQuery, GetOpsLocationUnitsQueryVariables>;
export const GetProductUnitCountsDocument = gql`
    query GetProductUnitCounts($input: GetProductUnitCountsInput!) {
  getProductUnitCounts(input: $input) {
    unitCount
    donorCount
  }
}
    `;

/**
 * __useGetProductUnitCountsQuery__
 *
 * To run a query within a React component, call `useGetProductUnitCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductUnitCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductUnitCountsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetProductUnitCountsQuery(baseOptions: Apollo.QueryHookOptions<GetProductUnitCountsQuery, GetProductUnitCountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductUnitCountsQuery, GetProductUnitCountsQueryVariables>(GetProductUnitCountsDocument, options);
      }
export function useGetProductUnitCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductUnitCountsQuery, GetProductUnitCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductUnitCountsQuery, GetProductUnitCountsQueryVariables>(GetProductUnitCountsDocument, options);
        }
export type GetProductUnitCountsQueryHookResult = ReturnType<typeof useGetProductUnitCountsQuery>;
export type GetProductUnitCountsLazyQueryHookResult = ReturnType<typeof useGetProductUnitCountsLazyQuery>;
export type GetProductUnitCountsQueryResult = Apollo.QueryResult<GetProductUnitCountsQuery, GetProductUnitCountsQueryVariables>;
export const GetDataAuditPipelineDonorsDocument = gql`
    query GetDataAuditPipelineDonors($input: GetDataAuditDonorsInput!) {
  getDataAuditPipelineDonors(input: $input) {
    donorCount
    statuses
    rows {
      donorId
      donorName
      createdAt
      ownerFullName
      donorLocation
      regionName
      donorStatus
    }
  }
}
    `;

/**
 * __useGetDataAuditPipelineDonorsQuery__
 *
 * To run a query within a React component, call `useGetDataAuditPipelineDonorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDataAuditPipelineDonorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDataAuditPipelineDonorsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetDataAuditPipelineDonorsQuery(baseOptions: Apollo.QueryHookOptions<GetDataAuditPipelineDonorsQuery, GetDataAuditPipelineDonorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDataAuditPipelineDonorsQuery, GetDataAuditPipelineDonorsQueryVariables>(GetDataAuditPipelineDonorsDocument, options);
      }
export function useGetDataAuditPipelineDonorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDataAuditPipelineDonorsQuery, GetDataAuditPipelineDonorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDataAuditPipelineDonorsQuery, GetDataAuditPipelineDonorsQueryVariables>(GetDataAuditPipelineDonorsDocument, options);
        }
export type GetDataAuditPipelineDonorsQueryHookResult = ReturnType<typeof useGetDataAuditPipelineDonorsQuery>;
export type GetDataAuditPipelineDonorsLazyQueryHookResult = ReturnType<typeof useGetDataAuditPipelineDonorsLazyQuery>;
export type GetDataAuditPipelineDonorsQueryResult = Apollo.QueryResult<GetDataAuditPipelineDonorsQuery, GetDataAuditPipelineDonorsQueryVariables>;
export const GetRegistrationDonorsDocument = gql`
    query GetRegistrationDonors($input: GetRegistrationDonorsInput!) {
  getRegistrationDonors(input: $input) {
    donors {
      donorId
      donorShortId
      donorName
      ownerFullName
      ownerShortId
      bloodTypeDisplay
      status
      lastDonationDate
      sglDbl
      totalDonations
      periodUnits
      location
      registeredAt
      approvedDonationML
      weight
      ownerPhone
      ownerEmail
      ownerCity
      ownerState
      ownerContactPreferences
      ownerAssignedLocations
      breed
      dateOfBirth
      region
      activeDate
    }
    total
  }
}
    `;

/**
 * __useGetRegistrationDonorsQuery__
 *
 * To run a query within a React component, call `useGetRegistrationDonorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegistrationDonorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegistrationDonorsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetRegistrationDonorsQuery(baseOptions: Apollo.QueryHookOptions<GetRegistrationDonorsQuery, GetRegistrationDonorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRegistrationDonorsQuery, GetRegistrationDonorsQueryVariables>(GetRegistrationDonorsDocument, options);
      }
export function useGetRegistrationDonorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRegistrationDonorsQuery, GetRegistrationDonorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRegistrationDonorsQuery, GetRegistrationDonorsQueryVariables>(GetRegistrationDonorsDocument, options);
        }
export type GetRegistrationDonorsQueryHookResult = ReturnType<typeof useGetRegistrationDonorsQuery>;
export type GetRegistrationDonorsLazyQueryHookResult = ReturnType<typeof useGetRegistrationDonorsLazyQuery>;
export type GetRegistrationDonorsQueryResult = Apollo.QueryResult<GetRegistrationDonorsQuery, GetRegistrationDonorsQueryVariables>;
export const GetLeaderboardHistoryDocument = gql`
    query GetLeaderboardHistory($input: GetLeaderboardHistoryInput!) {
  getLeaderboardHistory(input: $input) {
    weeks {
      weekNumber
      year
      weekEndDate
      winnerName
      winnerRegion
      winnerUserId
      recruitedCount
    }
  }
}
    `;

/**
 * __useGetLeaderboardHistoryQuery__
 *
 * To run a query within a React component, call `useGetLeaderboardHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLeaderboardHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLeaderboardHistoryQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetLeaderboardHistoryQuery(baseOptions: Apollo.QueryHookOptions<GetLeaderboardHistoryQuery, GetLeaderboardHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLeaderboardHistoryQuery, GetLeaderboardHistoryQueryVariables>(GetLeaderboardHistoryDocument, options);
      }
export function useGetLeaderboardHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLeaderboardHistoryQuery, GetLeaderboardHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLeaderboardHistoryQuery, GetLeaderboardHistoryQueryVariables>(GetLeaderboardHistoryDocument, options);
        }
export type GetLeaderboardHistoryQueryHookResult = ReturnType<typeof useGetLeaderboardHistoryQuery>;
export type GetLeaderboardHistoryLazyQueryHookResult = ReturnType<typeof useGetLeaderboardHistoryLazyQuery>;
export type GetLeaderboardHistoryQueryResult = Apollo.QueryResult<GetLeaderboardHistoryQuery, GetLeaderboardHistoryQueryVariables>;
export const CreateDonationDocument = gql`
    mutation createDonation($input: CreateDonationInput!) {
  createDonation(input: $input) {
    ...Donation
  }
}
    ${DonationFragmentDoc}`;
export type CreateDonationMutationFn = Apollo.MutationFunction<CreateDonationMutation, CreateDonationMutationVariables>;

/**
 * __useCreateDonationMutation__
 *
 * To run a mutation, you first call `useCreateDonationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDonationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDonationMutation, { data, loading, error }] = useCreateDonationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDonationMutation(baseOptions?: Apollo.MutationHookOptions<CreateDonationMutation, CreateDonationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDonationMutation, CreateDonationMutationVariables>(CreateDonationDocument, options);
      }
export type CreateDonationMutationHookResult = ReturnType<typeof useCreateDonationMutation>;
export type CreateDonationMutationResult = Apollo.MutationResult<CreateDonationMutation>;
export type CreateDonationMutationOptions = Apollo.BaseMutationOptions<CreateDonationMutation, CreateDonationMutationVariables>;
export const UpdateDonationDocument = gql`
    mutation updateDonation($input: UpdateDonationInput!) {
  updateDonation(input: $input) {
    ...Donation
  }
}
    ${DonationFragmentDoc}`;
export type UpdateDonationMutationFn = Apollo.MutationFunction<UpdateDonationMutation, UpdateDonationMutationVariables>;

/**
 * __useUpdateDonationMutation__
 *
 * To run a mutation, you first call `useUpdateDonationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDonationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDonationMutation, { data, loading, error }] = useUpdateDonationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDonationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDonationMutation, UpdateDonationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDonationMutation, UpdateDonationMutationVariables>(UpdateDonationDocument, options);
      }
export type UpdateDonationMutationHookResult = ReturnType<typeof useUpdateDonationMutation>;
export type UpdateDonationMutationResult = Apollo.MutationResult<UpdateDonationMutation>;
export type UpdateDonationMutationOptions = Apollo.BaseMutationOptions<UpdateDonationMutation, UpdateDonationMutationVariables>;
export const UpdateDonationCommentDocument = gql`
    mutation updateDonationComment($input: UpdateDonationCommentInput!) {
  updateDonationComment(input: $input) {
    ...Donation
  }
}
    ${DonationFragmentDoc}`;
export type UpdateDonationCommentMutationFn = Apollo.MutationFunction<UpdateDonationCommentMutation, UpdateDonationCommentMutationVariables>;

/**
 * __useUpdateDonationCommentMutation__
 *
 * To run a mutation, you first call `useUpdateDonationCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDonationCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDonationCommentMutation, { data, loading, error }] = useUpdateDonationCommentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDonationCommentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDonationCommentMutation, UpdateDonationCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDonationCommentMutation, UpdateDonationCommentMutationVariables>(UpdateDonationCommentDocument, options);
      }
export type UpdateDonationCommentMutationHookResult = ReturnType<typeof useUpdateDonationCommentMutation>;
export type UpdateDonationCommentMutationResult = Apollo.MutationResult<UpdateDonationCommentMutation>;
export type UpdateDonationCommentMutationOptions = Apollo.BaseMutationOptions<UpdateDonationCommentMutation, UpdateDonationCommentMutationVariables>;
export const UpdateDonationDonorDocument = gql`
    mutation updateDonationDonor($input: UpdateDonationDonorInput!) {
  updateDonationDonor(input: $input) {
    ...Donation
  }
}
    ${DonationFragmentDoc}`;
export type UpdateDonationDonorMutationFn = Apollo.MutationFunction<UpdateDonationDonorMutation, UpdateDonationDonorMutationVariables>;

/**
 * __useUpdateDonationDonorMutation__
 *
 * To run a mutation, you first call `useUpdateDonationDonorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDonationDonorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDonationDonorMutation, { data, loading, error }] = useUpdateDonationDonorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDonationDonorMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDonationDonorMutation, UpdateDonationDonorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDonationDonorMutation, UpdateDonationDonorMutationVariables>(UpdateDonationDonorDocument, options);
      }
export type UpdateDonationDonorMutationHookResult = ReturnType<typeof useUpdateDonationDonorMutation>;
export type UpdateDonationDonorMutationResult = Apollo.MutationResult<UpdateDonationDonorMutation>;
export type UpdateDonationDonorMutationOptions = Apollo.BaseMutationOptions<UpdateDonationDonorMutation, UpdateDonationDonorMutationVariables>;
export const CreateAdditionalDonationInfoDocument = gql`
    mutation createAdditionalDonationInfo($input: CreateAdditionalDonationInfoInput!) {
  createAdditionalDonationInfo(input: $input) {
    ...AdditionalDonationInfo
  }
}
    ${AdditionalDonationInfoFragmentDoc}`;
export type CreateAdditionalDonationInfoMutationFn = Apollo.MutationFunction<CreateAdditionalDonationInfoMutation, CreateAdditionalDonationInfoMutationVariables>;

/**
 * __useCreateAdditionalDonationInfoMutation__
 *
 * To run a mutation, you first call `useCreateAdditionalDonationInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAdditionalDonationInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAdditionalDonationInfoMutation, { data, loading, error }] = useCreateAdditionalDonationInfoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAdditionalDonationInfoMutation(baseOptions?: Apollo.MutationHookOptions<CreateAdditionalDonationInfoMutation, CreateAdditionalDonationInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAdditionalDonationInfoMutation, CreateAdditionalDonationInfoMutationVariables>(CreateAdditionalDonationInfoDocument, options);
      }
export type CreateAdditionalDonationInfoMutationHookResult = ReturnType<typeof useCreateAdditionalDonationInfoMutation>;
export type CreateAdditionalDonationInfoMutationResult = Apollo.MutationResult<CreateAdditionalDonationInfoMutation>;
export type CreateAdditionalDonationInfoMutationOptions = Apollo.BaseMutationOptions<CreateAdditionalDonationInfoMutation, CreateAdditionalDonationInfoMutationVariables>;
export const UpdateAdditionalDonationInfoDocument = gql`
    mutation updateAdditionalDonationInfo($input: UpdateAdditionalDonationInfoInput!) {
  updateAdditionalDonationInfo(input: $input) {
    ...AdditionalDonationInfo
  }
}
    ${AdditionalDonationInfoFragmentDoc}`;
export type UpdateAdditionalDonationInfoMutationFn = Apollo.MutationFunction<UpdateAdditionalDonationInfoMutation, UpdateAdditionalDonationInfoMutationVariables>;

/**
 * __useUpdateAdditionalDonationInfoMutation__
 *
 * To run a mutation, you first call `useUpdateAdditionalDonationInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAdditionalDonationInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAdditionalDonationInfoMutation, { data, loading, error }] = useUpdateAdditionalDonationInfoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAdditionalDonationInfoMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAdditionalDonationInfoMutation, UpdateAdditionalDonationInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAdditionalDonationInfoMutation, UpdateAdditionalDonationInfoMutationVariables>(UpdateAdditionalDonationInfoDocument, options);
      }
export type UpdateAdditionalDonationInfoMutationHookResult = ReturnType<typeof useUpdateAdditionalDonationInfoMutation>;
export type UpdateAdditionalDonationInfoMutationResult = Apollo.MutationResult<UpdateAdditionalDonationInfoMutation>;
export type UpdateAdditionalDonationInfoMutationOptions = Apollo.BaseMutationOptions<UpdateAdditionalDonationInfoMutation, UpdateAdditionalDonationInfoMutationVariables>;
export const CreateDonationWithAdditionalInfoDocument = gql`
    mutation createDonationWithAdditionalInfo($input: CreateDonationWithAdditionalInfoInput!) {
  createDonationWithAdditionalInfo(input: $input) {
    ...Donation
  }
}
    ${DonationFragmentDoc}`;
export type CreateDonationWithAdditionalInfoMutationFn = Apollo.MutationFunction<CreateDonationWithAdditionalInfoMutation, CreateDonationWithAdditionalInfoMutationVariables>;

/**
 * __useCreateDonationWithAdditionalInfoMutation__
 *
 * To run a mutation, you first call `useCreateDonationWithAdditionalInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDonationWithAdditionalInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDonationWithAdditionalInfoMutation, { data, loading, error }] = useCreateDonationWithAdditionalInfoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDonationWithAdditionalInfoMutation(baseOptions?: Apollo.MutationHookOptions<CreateDonationWithAdditionalInfoMutation, CreateDonationWithAdditionalInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDonationWithAdditionalInfoMutation, CreateDonationWithAdditionalInfoMutationVariables>(CreateDonationWithAdditionalInfoDocument, options);
      }
export type CreateDonationWithAdditionalInfoMutationHookResult = ReturnType<typeof useCreateDonationWithAdditionalInfoMutation>;
export type CreateDonationWithAdditionalInfoMutationResult = Apollo.MutationResult<CreateDonationWithAdditionalInfoMutation>;
export type CreateDonationWithAdditionalInfoMutationOptions = Apollo.BaseMutationOptions<CreateDonationWithAdditionalInfoMutation, CreateDonationWithAdditionalInfoMutationVariables>;
export const CreateDonationsWithAdditionalInfoDocument = gql`
    mutation createDonationsWithAdditionalInfo($input: CreateDonationsWithAdditionalInfoInput!) {
  createDonationsWithAdditionalInfo(input: $input)
}
    `;
export type CreateDonationsWithAdditionalInfoMutationFn = Apollo.MutationFunction<CreateDonationsWithAdditionalInfoMutation, CreateDonationsWithAdditionalInfoMutationVariables>;

/**
 * __useCreateDonationsWithAdditionalInfoMutation__
 *
 * To run a mutation, you first call `useCreateDonationsWithAdditionalInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDonationsWithAdditionalInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDonationsWithAdditionalInfoMutation, { data, loading, error }] = useCreateDonationsWithAdditionalInfoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDonationsWithAdditionalInfoMutation(baseOptions?: Apollo.MutationHookOptions<CreateDonationsWithAdditionalInfoMutation, CreateDonationsWithAdditionalInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDonationsWithAdditionalInfoMutation, CreateDonationsWithAdditionalInfoMutationVariables>(CreateDonationsWithAdditionalInfoDocument, options);
      }
export type CreateDonationsWithAdditionalInfoMutationHookResult = ReturnType<typeof useCreateDonationsWithAdditionalInfoMutation>;
export type CreateDonationsWithAdditionalInfoMutationResult = Apollo.MutationResult<CreateDonationsWithAdditionalInfoMutation>;
export type CreateDonationsWithAdditionalInfoMutationOptions = Apollo.BaseMutationOptions<CreateDonationsWithAdditionalInfoMutation, CreateDonationsWithAdditionalInfoMutationVariables>;
export const DeleteDonationDocument = gql`
    mutation deleteDonation($donationId: String!) {
  deleteDonation(donationId: $donationId)
}
    `;
export type DeleteDonationMutationFn = Apollo.MutationFunction<DeleteDonationMutation, DeleteDonationMutationVariables>;

/**
 * __useDeleteDonationMutation__
 *
 * To run a mutation, you first call `useDeleteDonationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDonationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDonationMutation, { data, loading, error }] = useDeleteDonationMutation({
 *   variables: {
 *      donationId: // value for 'donationId'
 *   },
 * });
 */
export function useDeleteDonationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDonationMutation, DeleteDonationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDonationMutation, DeleteDonationMutationVariables>(DeleteDonationDocument, options);
      }
export type DeleteDonationMutationHookResult = ReturnType<typeof useDeleteDonationMutation>;
export type DeleteDonationMutationResult = Apollo.MutationResult<DeleteDonationMutation>;
export type DeleteDonationMutationOptions = Apollo.BaseMutationOptions<DeleteDonationMutation, DeleteDonationMutationVariables>;
export const GetPreviousDonationDocument = gql`
    query getPreviousDonation($input: GetPreviousDonationInput!) {
  getPreviousDonation(input: $input) {
    ...Donation
  }
}
    ${DonationFragmentDoc}`;

/**
 * __useGetPreviousDonationQuery__
 *
 * To run a query within a React component, call `useGetPreviousDonationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPreviousDonationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPreviousDonationQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetPreviousDonationQuery(baseOptions: Apollo.QueryHookOptions<GetPreviousDonationQuery, GetPreviousDonationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPreviousDonationQuery, GetPreviousDonationQueryVariables>(GetPreviousDonationDocument, options);
      }
export function useGetPreviousDonationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPreviousDonationQuery, GetPreviousDonationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPreviousDonationQuery, GetPreviousDonationQueryVariables>(GetPreviousDonationDocument, options);
        }
export type GetPreviousDonationQueryHookResult = ReturnType<typeof useGetPreviousDonationQuery>;
export type GetPreviousDonationLazyQueryHookResult = ReturnType<typeof useGetPreviousDonationLazyQuery>;
export type GetPreviousDonationQueryResult = Apollo.QueryResult<GetPreviousDonationQuery, GetPreviousDonationQueryVariables>;
export const GetDonationDocument = gql`
    query getDonation($input: GetDonationInput!) {
  getDonation(input: $input) {
    ...Donation
  }
}
    ${DonationFragmentDoc}`;

/**
 * __useGetDonationQuery__
 *
 * To run a query within a React component, call `useGetDonationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDonationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDonationQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetDonationQuery(baseOptions: Apollo.QueryHookOptions<GetDonationQuery, GetDonationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDonationQuery, GetDonationQueryVariables>(GetDonationDocument, options);
      }
export function useGetDonationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDonationQuery, GetDonationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDonationQuery, GetDonationQueryVariables>(GetDonationDocument, options);
        }
export type GetDonationQueryHookResult = ReturnType<typeof useGetDonationQuery>;
export type GetDonationLazyQueryHookResult = ReturnType<typeof useGetDonationLazyQuery>;
export type GetDonationQueryResult = Apollo.QueryResult<GetDonationQuery, GetDonationQueryVariables>;
export const GetDonationListDocument = gql`
    query getDonationList($input: GetDonationsListInput!) {
  getDonationsList(input: $input) {
    data {
      ...Donation
    }
    meta {
      total
    }
  }
}
    ${DonationFragmentDoc}`;

/**
 * __useGetDonationListQuery__
 *
 * To run a query within a React component, call `useGetDonationListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDonationListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDonationListQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetDonationListQuery(baseOptions: Apollo.QueryHookOptions<GetDonationListQuery, GetDonationListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDonationListQuery, GetDonationListQueryVariables>(GetDonationListDocument, options);
      }
export function useGetDonationListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDonationListQuery, GetDonationListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDonationListQuery, GetDonationListQueryVariables>(GetDonationListDocument, options);
        }
export type GetDonationListQueryHookResult = ReturnType<typeof useGetDonationListQuery>;
export type GetDonationListLazyQueryHookResult = ReturnType<typeof useGetDonationListLazyQuery>;
export type GetDonationListQueryResult = Apollo.QueryResult<GetDonationListQuery, GetDonationListQueryVariables>;
export const GetSpecificDonorDonationsListDocument = gql`
    query getSpecificDonorDonationsList($input: GetSpecificDonorDonationsListInput!) {
  getSpecificDonorDonationsList(input: $input) {
    data {
      ...Donation
    }
    meta {
      total
    }
  }
}
    ${DonationFragmentDoc}`;

/**
 * __useGetSpecificDonorDonationsListQuery__
 *
 * To run a query within a React component, call `useGetSpecificDonorDonationsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSpecificDonorDonationsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSpecificDonorDonationsListQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetSpecificDonorDonationsListQuery(baseOptions: Apollo.QueryHookOptions<GetSpecificDonorDonationsListQuery, GetSpecificDonorDonationsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSpecificDonorDonationsListQuery, GetSpecificDonorDonationsListQueryVariables>(GetSpecificDonorDonationsListDocument, options);
      }
export function useGetSpecificDonorDonationsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSpecificDonorDonationsListQuery, GetSpecificDonorDonationsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSpecificDonorDonationsListQuery, GetSpecificDonorDonationsListQueryVariables>(GetSpecificDonorDonationsListDocument, options);
        }
export type GetSpecificDonorDonationsListQueryHookResult = ReturnType<typeof useGetSpecificDonorDonationsListQuery>;
export type GetSpecificDonorDonationsListLazyQueryHookResult = ReturnType<typeof useGetSpecificDonorDonationsListLazyQuery>;
export type GetSpecificDonorDonationsListQueryResult = Apollo.QueryResult<GetSpecificDonorDonationsListQuery, GetSpecificDonorDonationsListQueryVariables>;
export const GetDonationsListForAnalyticsDocument = gql`
    query getDonationsListForAnalytics($input: DonationsAnalyticsInput!) {
  getDonationsListForAnalytics(input: $input) {
    data {
      ...Donation
    }
    meta {
      total
    }
  }
}
    ${DonationFragmentDoc}`;

/**
 * __useGetDonationsListForAnalyticsQuery__
 *
 * To run a query within a React component, call `useGetDonationsListForAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDonationsListForAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDonationsListForAnalyticsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetDonationsListForAnalyticsQuery(baseOptions: Apollo.QueryHookOptions<GetDonationsListForAnalyticsQuery, GetDonationsListForAnalyticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDonationsListForAnalyticsQuery, GetDonationsListForAnalyticsQueryVariables>(GetDonationsListForAnalyticsDocument, options);
      }
export function useGetDonationsListForAnalyticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDonationsListForAnalyticsQuery, GetDonationsListForAnalyticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDonationsListForAnalyticsQuery, GetDonationsListForAnalyticsQueryVariables>(GetDonationsListForAnalyticsDocument, options);
        }
export type GetDonationsListForAnalyticsQueryHookResult = ReturnType<typeof useGetDonationsListForAnalyticsQuery>;
export type GetDonationsListForAnalyticsLazyQueryHookResult = ReturnType<typeof useGetDonationsListForAnalyticsLazyQuery>;
export type GetDonationsListForAnalyticsQueryResult = Apollo.QueryResult<GetDonationsListForAnalyticsQuery, GetDonationsListForAnalyticsQueryVariables>;
export const GetPhlebotomistStatsDocument = gql`
    query getPhlebotomistStats($input: GetPhlebotomistStatsInput!) {
  getPhlebotomistStats(input: $input) {
    phlebotomistId
    phlebotomistName
    phlebotomistEmail
    regionId
    regionName
    locationPreference
    assignedOfficeId
    assignedOfficeName
    attemptedDonations
    successfulDonations
    pendingDonations
    singleDonors
    doubleDonors
    successfulSingleDonors
    successfulDoubleDonors
    expectedTotal
    expectedPRBC
    expectedPRBCSingle
    expectedPRBCDouble
    expectedFFPSingle
    expectedFFPDouble
    actualTotal
    actualPRBC
    actualPRBCSingle
    actualPRBCDouble
    actualFFPSingle
    actualFFPDouble
    dblDonorsSglYield
    overallSuccessRate
    prbcSuccessRate
    sglDonorsSuccessRate
    dblDonorsSuccessRate
    teamCount
    totalOfficeSuccessful
    donationSharePercent
    officeSharePercent
    completelyFailedDonations
    completelyFailedDiscards {
      reason
      count
    }
    partiallyFailedDonations
    partiallyFailedDiscards {
      reason
      count
    }
    recentDonations {
      id
      shortId
      date
      donorName
      donorId
      type
      approvedML
      actualML
      collectionSet
      veinSide
      donationUnit
      examinationNotes
      ineligibleReason
      expectedPRBC
      expectedFFPSingle
      expectedFFPDouble
      actualPRBC
      actualFFPSingle
      actualFFPDouble
      status
      phlebotomistName
      locationName
      regionName
      failureReasons
      products {
        type
        productId
        status
        orderId
        discardReason
      }
    }
  }
}
    `;

/**
 * __useGetPhlebotomistStatsQuery__
 *
 * To run a query within a React component, call `useGetPhlebotomistStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPhlebotomistStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPhlebotomistStatsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetPhlebotomistStatsQuery(baseOptions: Apollo.QueryHookOptions<GetPhlebotomistStatsQuery, GetPhlebotomistStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPhlebotomistStatsQuery, GetPhlebotomistStatsQueryVariables>(GetPhlebotomistStatsDocument, options);
      }
export function useGetPhlebotomistStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPhlebotomistStatsQuery, GetPhlebotomistStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPhlebotomistStatsQuery, GetPhlebotomistStatsQueryVariables>(GetPhlebotomistStatsDocument, options);
        }
export type GetPhlebotomistStatsQueryHookResult = ReturnType<typeof useGetPhlebotomistStatsQuery>;
export type GetPhlebotomistStatsLazyQueryHookResult = ReturnType<typeof useGetPhlebotomistStatsLazyQuery>;
export type GetPhlebotomistStatsQueryResult = Apollo.QueryResult<GetPhlebotomistStatsQuery, GetPhlebotomistStatsQueryVariables>;
export const GetPhlebotomistTrendStatsDocument = gql`
    query getPhlebotomistTrendStats($input: GetPhlebotomistTrendStatsInput!) {
  getPhlebotomistTrendStats(input: $input) {
    period
    periodStart
    periodEnd
    attemptedDonations
    successfulDonations
    singleDonors
    doubleDonors
    successfulSingleDonors
    successfulDoubleDonors
    expectedTotal
    expectedPRBC
    expectedFFPSingle
    expectedFFPDouble
    actualTotal
    actualPRBC
    actualFFPSingle
    actualFFPDouble
    overallSuccessRate
    prbcSuccessRate
    sglDonorsSuccessRate
    dblDonorsSuccessRate
  }
}
    `;

/**
 * __useGetPhlebotomistTrendStatsQuery__
 *
 * To run a query within a React component, call `useGetPhlebotomistTrendStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPhlebotomistTrendStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPhlebotomistTrendStatsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetPhlebotomistTrendStatsQuery(baseOptions: Apollo.QueryHookOptions<GetPhlebotomistTrendStatsQuery, GetPhlebotomistTrendStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPhlebotomistTrendStatsQuery, GetPhlebotomistTrendStatsQueryVariables>(GetPhlebotomistTrendStatsDocument, options);
      }
export function useGetPhlebotomistTrendStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPhlebotomistTrendStatsQuery, GetPhlebotomistTrendStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPhlebotomistTrendStatsQuery, GetPhlebotomistTrendStatsQueryVariables>(GetPhlebotomistTrendStatsDocument, options);
        }
export type GetPhlebotomistTrendStatsQueryHookResult = ReturnType<typeof useGetPhlebotomistTrendStatsQuery>;
export type GetPhlebotomistTrendStatsLazyQueryHookResult = ReturnType<typeof useGetPhlebotomistTrendStatsLazyQuery>;
export type GetPhlebotomistTrendStatsQueryResult = Apollo.QueryResult<GetPhlebotomistTrendStatsQuery, GetPhlebotomistTrendStatsQueryVariables>;
export const CreateDonorsForUserDocument = gql`
    mutation createDonorsForUser($input: CreateDonorsForUserInput!) {
  createDonorsForUser(input: $input)
}
    `;
export type CreateDonorsForUserMutationFn = Apollo.MutationFunction<CreateDonorsForUserMutation, CreateDonorsForUserMutationVariables>;

/**
 * __useCreateDonorsForUserMutation__
 *
 * To run a mutation, you first call `useCreateDonorsForUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDonorsForUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDonorsForUserMutation, { data, loading, error }] = useCreateDonorsForUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDonorsForUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateDonorsForUserMutation, CreateDonorsForUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDonorsForUserMutation, CreateDonorsForUserMutationVariables>(CreateDonorsForUserDocument, options);
      }
export type CreateDonorsForUserMutationHookResult = ReturnType<typeof useCreateDonorsForUserMutation>;
export type CreateDonorsForUserMutationResult = Apollo.MutationResult<CreateDonorsForUserMutation>;
export type CreateDonorsForUserMutationOptions = Apollo.BaseMutationOptions<CreateDonorsForUserMutation, CreateDonorsForUserMutationVariables>;
export const CreateDonorsDocument = gql`
    mutation createDonors($input: CreateDonors!) {
  createDonors(input: $input)
}
    `;
export type CreateDonorsMutationFn = Apollo.MutationFunction<CreateDonorsMutation, CreateDonorsMutationVariables>;

/**
 * __useCreateDonorsMutation__
 *
 * To run a mutation, you first call `useCreateDonorsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDonorsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDonorsMutation, { data, loading, error }] = useCreateDonorsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDonorsMutation(baseOptions?: Apollo.MutationHookOptions<CreateDonorsMutation, CreateDonorsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDonorsMutation, CreateDonorsMutationVariables>(CreateDonorsDocument, options);
      }
export type CreateDonorsMutationHookResult = ReturnType<typeof useCreateDonorsMutation>;
export type CreateDonorsMutationResult = Apollo.MutationResult<CreateDonorsMutation>;
export type CreateDonorsMutationOptions = Apollo.BaseMutationOptions<CreateDonorsMutation, CreateDonorsMutationVariables>;
export const CreateDonorDocument = gql`
    mutation createDonor($input: CreateDonorInput!) {
  createDonor(input: $input) {
    ...Donor
    team {
      id
      title
    }
    user {
      ...Owner
      contacts {
        ...Contact
      }
    }
    reserveNotes {
      ...ReserveDonorNote
    }
  }
}
    ${DonorFragmentDoc}
${OwnerFragmentDoc}
${ContactFragmentDoc}
${ReserveDonorNoteFragmentDoc}`;
export type CreateDonorMutationFn = Apollo.MutationFunction<CreateDonorMutation, CreateDonorMutationVariables>;

/**
 * __useCreateDonorMutation__
 *
 * To run a mutation, you first call `useCreateDonorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDonorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDonorMutation, { data, loading, error }] = useCreateDonorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDonorMutation(baseOptions?: Apollo.MutationHookOptions<CreateDonorMutation, CreateDonorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDonorMutation, CreateDonorMutationVariables>(CreateDonorDocument, options);
      }
export type CreateDonorMutationHookResult = ReturnType<typeof useCreateDonorMutation>;
export type CreateDonorMutationResult = Apollo.MutationResult<CreateDonorMutation>;
export type CreateDonorMutationOptions = Apollo.BaseMutationOptions<CreateDonorMutation, CreateDonorMutationVariables>;
export const UpdateGroupDocument = gql`
    mutation updateGroup($input: UpdateGroupInput!) {
  updateGroup(input: $input) {
    title
  }
}
    `;
export type UpdateGroupMutationFn = Apollo.MutationFunction<UpdateGroupMutation, UpdateGroupMutationVariables>;

/**
 * __useUpdateGroupMutation__
 *
 * To run a mutation, you first call `useUpdateGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGroupMutation, { data, loading, error }] = useUpdateGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateGroupMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGroupMutation, UpdateGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGroupMutation, UpdateGroupMutationVariables>(UpdateGroupDocument, options);
      }
export type UpdateGroupMutationHookResult = ReturnType<typeof useUpdateGroupMutation>;
export type UpdateGroupMutationResult = Apollo.MutationResult<UpdateGroupMutation>;
export type UpdateGroupMutationOptions = Apollo.BaseMutationOptions<UpdateGroupMutation, UpdateGroupMutationVariables>;
export const UpdateTeamDocument = gql`
    mutation updateTeam($input: UpdateTeamInput!) {
  updateTeam(input: $input) {
    title
  }
}
    `;
export type UpdateTeamMutationFn = Apollo.MutationFunction<UpdateTeamMutation, UpdateTeamMutationVariables>;

/**
 * __useUpdateTeamMutation__
 *
 * To run a mutation, you first call `useUpdateTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTeamMutation, { data, loading, error }] = useUpdateTeamMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTeamMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTeamMutation, UpdateTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTeamMutation, UpdateTeamMutationVariables>(UpdateTeamDocument, options);
      }
export type UpdateTeamMutationHookResult = ReturnType<typeof useUpdateTeamMutation>;
export type UpdateTeamMutationResult = Apollo.MutationResult<UpdateTeamMutation>;
export type UpdateTeamMutationOptions = Apollo.BaseMutationOptions<UpdateTeamMutation, UpdateTeamMutationVariables>;
export const RemoveGroupDocument = gql`
    mutation removeGroup($input: RemoveGroupInput!) {
  removeGroup(input: $input)
}
    `;
export type RemoveGroupMutationFn = Apollo.MutationFunction<RemoveGroupMutation, RemoveGroupMutationVariables>;

/**
 * __useRemoveGroupMutation__
 *
 * To run a mutation, you first call `useRemoveGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeGroupMutation, { data, loading, error }] = useRemoveGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveGroupMutation(baseOptions?: Apollo.MutationHookOptions<RemoveGroupMutation, RemoveGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveGroupMutation, RemoveGroupMutationVariables>(RemoveGroupDocument, options);
      }
export type RemoveGroupMutationHookResult = ReturnType<typeof useRemoveGroupMutation>;
export type RemoveGroupMutationResult = Apollo.MutationResult<RemoveGroupMutation>;
export type RemoveGroupMutationOptions = Apollo.BaseMutationOptions<RemoveGroupMutation, RemoveGroupMutationVariables>;
export const CreateTeamDocument = gql`
    mutation createTeam($input: CreateTeamInput!) {
  createTeam(input: $input) {
    id
  }
}
    `;
export type CreateTeamMutationFn = Apollo.MutationFunction<CreateTeamMutation, CreateTeamMutationVariables>;

/**
 * __useCreateTeamMutation__
 *
 * To run a mutation, you first call `useCreateTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTeamMutation, { data, loading, error }] = useCreateTeamMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTeamMutation(baseOptions?: Apollo.MutationHookOptions<CreateTeamMutation, CreateTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTeamMutation, CreateTeamMutationVariables>(CreateTeamDocument, options);
      }
export type CreateTeamMutationHookResult = ReturnType<typeof useCreateTeamMutation>;
export type CreateTeamMutationResult = Apollo.MutationResult<CreateTeamMutation>;
export type CreateTeamMutationOptions = Apollo.BaseMutationOptions<CreateTeamMutation, CreateTeamMutationVariables>;
export const RemoveTeamDocument = gql`
    mutation removeTeam($input: RemoveTeamInput!) {
  removeTeam(input: $input)
}
    `;
export type RemoveTeamMutationFn = Apollo.MutationFunction<RemoveTeamMutation, RemoveTeamMutationVariables>;

/**
 * __useRemoveTeamMutation__
 *
 * To run a mutation, you first call `useRemoveTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeTeamMutation, { data, loading, error }] = useRemoveTeamMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveTeamMutation(baseOptions?: Apollo.MutationHookOptions<RemoveTeamMutation, RemoveTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveTeamMutation, RemoveTeamMutationVariables>(RemoveTeamDocument, options);
      }
export type RemoveTeamMutationHookResult = ReturnType<typeof useRemoveTeamMutation>;
export type RemoveTeamMutationResult = Apollo.MutationResult<RemoveTeamMutation>;
export type RemoveTeamMutationOptions = Apollo.BaseMutationOptions<RemoveTeamMutation, RemoveTeamMutationVariables>;
export const RemoveDonorDocument = gql`
    mutation removeDonor($input: DeleteDonorInput!) {
  deleteDonor(input: $input)
}
    `;
export type RemoveDonorMutationFn = Apollo.MutationFunction<RemoveDonorMutation, RemoveDonorMutationVariables>;

/**
 * __useRemoveDonorMutation__
 *
 * To run a mutation, you first call `useRemoveDonorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveDonorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeDonorMutation, { data, loading, error }] = useRemoveDonorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveDonorMutation(baseOptions?: Apollo.MutationHookOptions<RemoveDonorMutation, RemoveDonorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveDonorMutation, RemoveDonorMutationVariables>(RemoveDonorDocument, options);
      }
export type RemoveDonorMutationHookResult = ReturnType<typeof useRemoveDonorMutation>;
export type RemoveDonorMutationResult = Apollo.MutationResult<RemoveDonorMutation>;
export type RemoveDonorMutationOptions = Apollo.BaseMutationOptions<RemoveDonorMutation, RemoveDonorMutationVariables>;
export const CreateGroupDocument = gql`
    mutation createGroup($input: CreateGroupInput!) {
  createGroup(input: $input) {
    id
  }
}
    `;
export type CreateGroupMutationFn = Apollo.MutationFunction<CreateGroupMutation, CreateGroupMutationVariables>;

/**
 * __useCreateGroupMutation__
 *
 * To run a mutation, you first call `useCreateGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGroupMutation, { data, loading, error }] = useCreateGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateGroupMutation(baseOptions?: Apollo.MutationHookOptions<CreateGroupMutation, CreateGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateGroupMutation, CreateGroupMutationVariables>(CreateGroupDocument, options);
      }
export type CreateGroupMutationHookResult = ReturnType<typeof useCreateGroupMutation>;
export type CreateGroupMutationResult = Apollo.MutationResult<CreateGroupMutation>;
export type CreateGroupMutationOptions = Apollo.BaseMutationOptions<CreateGroupMutation, CreateGroupMutationVariables>;
export const InviteOwnerWithDonorDocument = gql`
    mutation inviteOwnerWithDonor($input: InviteOwnerWithDonorInput!) {
  inviteOwnerWithDonor(input: $input)
}
    `;
export type InviteOwnerWithDonorMutationFn = Apollo.MutationFunction<InviteOwnerWithDonorMutation, InviteOwnerWithDonorMutationVariables>;

/**
 * __useInviteOwnerWithDonorMutation__
 *
 * To run a mutation, you first call `useInviteOwnerWithDonorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteOwnerWithDonorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteOwnerWithDonorMutation, { data, loading, error }] = useInviteOwnerWithDonorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInviteOwnerWithDonorMutation(baseOptions?: Apollo.MutationHookOptions<InviteOwnerWithDonorMutation, InviteOwnerWithDonorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InviteOwnerWithDonorMutation, InviteOwnerWithDonorMutationVariables>(InviteOwnerWithDonorDocument, options);
      }
export type InviteOwnerWithDonorMutationHookResult = ReturnType<typeof useInviteOwnerWithDonorMutation>;
export type InviteOwnerWithDonorMutationResult = Apollo.MutationResult<InviteOwnerWithDonorMutation>;
export type InviteOwnerWithDonorMutationOptions = Apollo.BaseMutationOptions<InviteOwnerWithDonorMutation, InviteOwnerWithDonorMutationVariables>;
export const CreateDonorForUserDocument = gql`
    mutation createDonorForUser($input: CreateDonorForUserInput!) {
  createDonorForUser(input: $input) {
    ...Donor
    team {
      id
      title
    }
    user {
      ...Owner
      contacts {
        ...Contact
      }
    }
    reserveNotes {
      ...ReserveDonorNote
    }
  }
}
    ${DonorFragmentDoc}
${OwnerFragmentDoc}
${ContactFragmentDoc}
${ReserveDonorNoteFragmentDoc}`;
export type CreateDonorForUserMutationFn = Apollo.MutationFunction<CreateDonorForUserMutation, CreateDonorForUserMutationVariables>;

/**
 * __useCreateDonorForUserMutation__
 *
 * To run a mutation, you first call `useCreateDonorForUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDonorForUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDonorForUserMutation, { data, loading, error }] = useCreateDonorForUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDonorForUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateDonorForUserMutation, CreateDonorForUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDonorForUserMutation, CreateDonorForUserMutationVariables>(CreateDonorForUserDocument, options);
      }
export type CreateDonorForUserMutationHookResult = ReturnType<typeof useCreateDonorForUserMutation>;
export type CreateDonorForUserMutationResult = Apollo.MutationResult<CreateDonorForUserMutation>;
export type CreateDonorForUserMutationOptions = Apollo.BaseMutationOptions<CreateDonorForUserMutation, CreateDonorForUserMutationVariables>;
export const UpdateDonorDocument = gql`
    mutation updateDonor($input: UpdateDonorInput!) {
  updateDonor(input: $input) {
    ...Donor
    team {
      id
      title
    }
    user {
      ...Owner
      contacts {
        ...Contact
      }
    }
    reserveNotes {
      ...ReserveDonorNote
    }
  }
}
    ${DonorFragmentDoc}
${OwnerFragmentDoc}
${ContactFragmentDoc}
${ReserveDonorNoteFragmentDoc}`;
export type UpdateDonorMutationFn = Apollo.MutationFunction<UpdateDonorMutation, UpdateDonorMutationVariables>;

/**
 * __useUpdateDonorMutation__
 *
 * To run a mutation, you first call `useUpdateDonorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDonorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDonorMutation, { data, loading, error }] = useUpdateDonorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDonorMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDonorMutation, UpdateDonorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDonorMutation, UpdateDonorMutationVariables>(UpdateDonorDocument, options);
      }
export type UpdateDonorMutationHookResult = ReturnType<typeof useUpdateDonorMutation>;
export type UpdateDonorMutationResult = Apollo.MutationResult<UpdateDonorMutation>;
export type UpdateDonorMutationOptions = Apollo.BaseMutationOptions<UpdateDonorMutation, UpdateDonorMutationVariables>;
export const AddNoteToReserveDonorDocument = gql`
    mutation addNoteToReserveDonor($input: CreateDonorNoteInput!) {
  addNoteToReserveDonor(input: $input) {
    ...ReserveDonorNote
  }
}
    ${ReserveDonorNoteFragmentDoc}`;
export type AddNoteToReserveDonorMutationFn = Apollo.MutationFunction<AddNoteToReserveDonorMutation, AddNoteToReserveDonorMutationVariables>;

/**
 * __useAddNoteToReserveDonorMutation__
 *
 * To run a mutation, you first call `useAddNoteToReserveDonorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddNoteToReserveDonorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addNoteToReserveDonorMutation, { data, loading, error }] = useAddNoteToReserveDonorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddNoteToReserveDonorMutation(baseOptions?: Apollo.MutationHookOptions<AddNoteToReserveDonorMutation, AddNoteToReserveDonorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddNoteToReserveDonorMutation, AddNoteToReserveDonorMutationVariables>(AddNoteToReserveDonorDocument, options);
      }
export type AddNoteToReserveDonorMutationHookResult = ReturnType<typeof useAddNoteToReserveDonorMutation>;
export type AddNoteToReserveDonorMutationResult = Apollo.MutationResult<AddNoteToReserveDonorMutation>;
export type AddNoteToReserveDonorMutationOptions = Apollo.BaseMutationOptions<AddNoteToReserveDonorMutation, AddNoteToReserveDonorMutationVariables>;
export const UpdateReserveDonorNoteDocument = gql`
    mutation updateReserveDonorNote($input: UpdateDonorNoteInput!) {
  updateReserveDonorNote(input: $input) {
    ...ReserveDonorNote
  }
}
    ${ReserveDonorNoteFragmentDoc}`;
export type UpdateReserveDonorNoteMutationFn = Apollo.MutationFunction<UpdateReserveDonorNoteMutation, UpdateReserveDonorNoteMutationVariables>;

/**
 * __useUpdateReserveDonorNoteMutation__
 *
 * To run a mutation, you first call `useUpdateReserveDonorNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReserveDonorNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReserveDonorNoteMutation, { data, loading, error }] = useUpdateReserveDonorNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateReserveDonorNoteMutation(baseOptions?: Apollo.MutationHookOptions<UpdateReserveDonorNoteMutation, UpdateReserveDonorNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateReserveDonorNoteMutation, UpdateReserveDonorNoteMutationVariables>(UpdateReserveDonorNoteDocument, options);
      }
export type UpdateReserveDonorNoteMutationHookResult = ReturnType<typeof useUpdateReserveDonorNoteMutation>;
export type UpdateReserveDonorNoteMutationResult = Apollo.MutationResult<UpdateReserveDonorNoteMutation>;
export type UpdateReserveDonorNoteMutationOptions = Apollo.BaseMutationOptions<UpdateReserveDonorNoteMutation, UpdateReserveDonorNoteMutationVariables>;
export const DeleteReserveDonorNoteDocument = gql`
    mutation deleteReserveDonorNote($input: DeleteDonorNoteInput!) {
  deleteReserveDonorNote(input: $input)
}
    `;
export type DeleteReserveDonorNoteMutationFn = Apollo.MutationFunction<DeleteReserveDonorNoteMutation, DeleteReserveDonorNoteMutationVariables>;

/**
 * __useDeleteReserveDonorNoteMutation__
 *
 * To run a mutation, you first call `useDeleteReserveDonorNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteReserveDonorNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteReserveDonorNoteMutation, { data, loading, error }] = useDeleteReserveDonorNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteReserveDonorNoteMutation(baseOptions?: Apollo.MutationHookOptions<DeleteReserveDonorNoteMutation, DeleteReserveDonorNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteReserveDonorNoteMutation, DeleteReserveDonorNoteMutationVariables>(DeleteReserveDonorNoteDocument, options);
      }
export type DeleteReserveDonorNoteMutationHookResult = ReturnType<typeof useDeleteReserveDonorNoteMutation>;
export type DeleteReserveDonorNoteMutationResult = Apollo.MutationResult<DeleteReserveDonorNoteMutation>;
export type DeleteReserveDonorNoteMutationOptions = Apollo.BaseMutationOptions<DeleteReserveDonorNoteMutation, DeleteReserveDonorNoteMutationVariables>;
export const UpdateLabworkDocument = gql`
    mutation updateLabwork($input: UpdateLabworkInput!) {
  updateLabwork(input: $input) {
    ...Labwork
    donor {
      ...Donor
      user {
        ...Owner
      }
    }
  }
}
    ${LabworkFragmentDoc}
${DonorFragmentDoc}
${OwnerFragmentDoc}`;
export type UpdateLabworkMutationFn = Apollo.MutationFunction<UpdateLabworkMutation, UpdateLabworkMutationVariables>;

/**
 * __useUpdateLabworkMutation__
 *
 * To run a mutation, you first call `useUpdateLabworkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLabworkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLabworkMutation, { data, loading, error }] = useUpdateLabworkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLabworkMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLabworkMutation, UpdateLabworkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLabworkMutation, UpdateLabworkMutationVariables>(UpdateLabworkDocument, options);
      }
export type UpdateLabworkMutationHookResult = ReturnType<typeof useUpdateLabworkMutation>;
export type UpdateLabworkMutationResult = Apollo.MutationResult<UpdateLabworkMutation>;
export type UpdateLabworkMutationOptions = Apollo.BaseMutationOptions<UpdateLabworkMutation, UpdateLabworkMutationVariables>;
export const UpdateDvmExamDocument = gql`
    mutation updateDvmExam($input: UpdateDvmExamInput!) {
  updateDvmExam(input: $input) {
    ...DvmExam
    performedBy {
      ...User
    }
  }
}
    ${DvmExamFragmentDoc}
${UserFragmentDoc}`;
export type UpdateDvmExamMutationFn = Apollo.MutationFunction<UpdateDvmExamMutation, UpdateDvmExamMutationVariables>;

/**
 * __useUpdateDvmExamMutation__
 *
 * To run a mutation, you first call `useUpdateDvmExamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDvmExamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDvmExamMutation, { data, loading, error }] = useUpdateDvmExamMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDvmExamMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDvmExamMutation, UpdateDvmExamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDvmExamMutation, UpdateDvmExamMutationVariables>(UpdateDvmExamDocument, options);
      }
export type UpdateDvmExamMutationHookResult = ReturnType<typeof useUpdateDvmExamMutation>;
export type UpdateDvmExamMutationResult = Apollo.MutationResult<UpdateDvmExamMutation>;
export type UpdateDvmExamMutationOptions = Apollo.BaseMutationOptions<UpdateDvmExamMutation, UpdateDvmExamMutationVariables>;
export const UpdateLabworkStatusDocument = gql`
    mutation updateLabworkStatus($input: UpdateLabworkStatusInput!) {
  updateLabworkStatus(input: $input) {
    ...Labwork
    donor {
      ...Donor
      user {
        ...Owner
      }
    }
  }
}
    ${LabworkFragmentDoc}
${DonorFragmentDoc}
${OwnerFragmentDoc}`;
export type UpdateLabworkStatusMutationFn = Apollo.MutationFunction<UpdateLabworkStatusMutation, UpdateLabworkStatusMutationVariables>;

/**
 * __useUpdateLabworkStatusMutation__
 *
 * To run a mutation, you first call `useUpdateLabworkStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLabworkStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLabworkStatusMutation, { data, loading, error }] = useUpdateLabworkStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLabworkStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLabworkStatusMutation, UpdateLabworkStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLabworkStatusMutation, UpdateLabworkStatusMutationVariables>(UpdateLabworkStatusDocument, options);
      }
export type UpdateLabworkStatusMutationHookResult = ReturnType<typeof useUpdateLabworkStatusMutation>;
export type UpdateLabworkStatusMutationResult = Apollo.MutationResult<UpdateLabworkStatusMutation>;
export type UpdateLabworkStatusMutationOptions = Apollo.BaseMutationOptions<UpdateLabworkStatusMutation, UpdateLabworkStatusMutationVariables>;
export const CreateLabworkDocument = gql`
    mutation createLabwork($input: CreateLabworkInput!) {
  createLabwork(input: $input) {
    ...Labwork
    donor {
      ...Donor
      user {
        ...Owner
      }
    }
  }
}
    ${LabworkFragmentDoc}
${DonorFragmentDoc}
${OwnerFragmentDoc}`;
export type CreateLabworkMutationFn = Apollo.MutationFunction<CreateLabworkMutation, CreateLabworkMutationVariables>;

/**
 * __useCreateLabworkMutation__
 *
 * To run a mutation, you first call `useCreateLabworkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLabworkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLabworkMutation, { data, loading, error }] = useCreateLabworkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateLabworkMutation(baseOptions?: Apollo.MutationHookOptions<CreateLabworkMutation, CreateLabworkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLabworkMutation, CreateLabworkMutationVariables>(CreateLabworkDocument, options);
      }
export type CreateLabworkMutationHookResult = ReturnType<typeof useCreateLabworkMutation>;
export type CreateLabworkMutationResult = Apollo.MutationResult<CreateLabworkMutation>;
export type CreateLabworkMutationOptions = Apollo.BaseMutationOptions<CreateLabworkMutation, CreateLabworkMutationVariables>;
export const CreateDvmExamDocument = gql`
    mutation createDvmExam($input: CreateDvmExamInput!) {
  createDvmExam(input: $input) {
    ...DvmExam
    performedBy {
      ...User
    }
  }
}
    ${DvmExamFragmentDoc}
${UserFragmentDoc}`;
export type CreateDvmExamMutationFn = Apollo.MutationFunction<CreateDvmExamMutation, CreateDvmExamMutationVariables>;

/**
 * __useCreateDvmExamMutation__
 *
 * To run a mutation, you first call `useCreateDvmExamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDvmExamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDvmExamMutation, { data, loading, error }] = useCreateDvmExamMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDvmExamMutation(baseOptions?: Apollo.MutationHookOptions<CreateDvmExamMutation, CreateDvmExamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDvmExamMutation, CreateDvmExamMutationVariables>(CreateDvmExamDocument, options);
      }
export type CreateDvmExamMutationHookResult = ReturnType<typeof useCreateDvmExamMutation>;
export type CreateDvmExamMutationResult = Apollo.MutationResult<CreateDvmExamMutation>;
export type CreateDvmExamMutationOptions = Apollo.BaseMutationOptions<CreateDvmExamMutation, CreateDvmExamMutationVariables>;
export const ShareLabworkResultsDocument = gql`
    mutation shareLabworkResults($input: ShareLabworkResultsWithOwnerInput!) {
  shareLabworkResults(input: $input)
}
    `;
export type ShareLabworkResultsMutationFn = Apollo.MutationFunction<ShareLabworkResultsMutation, ShareLabworkResultsMutationVariables>;

/**
 * __useShareLabworkResultsMutation__
 *
 * To run a mutation, you first call `useShareLabworkResultsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShareLabworkResultsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shareLabworkResultsMutation, { data, loading, error }] = useShareLabworkResultsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useShareLabworkResultsMutation(baseOptions?: Apollo.MutationHookOptions<ShareLabworkResultsMutation, ShareLabworkResultsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ShareLabworkResultsMutation, ShareLabworkResultsMutationVariables>(ShareLabworkResultsDocument, options);
      }
export type ShareLabworkResultsMutationHookResult = ReturnType<typeof useShareLabworkResultsMutation>;
export type ShareLabworkResultsMutationResult = Apollo.MutationResult<ShareLabworkResultsMutation>;
export type ShareLabworkResultsMutationOptions = Apollo.BaseMutationOptions<ShareLabworkResultsMutation, ShareLabworkResultsMutationVariables>;
export const RemoveLabworkDocument = gql`
    mutation removeLabwork($input: RemoveLabworkInput!) {
  removeLabwork(input: $input)
}
    `;
export type RemoveLabworkMutationFn = Apollo.MutationFunction<RemoveLabworkMutation, RemoveLabworkMutationVariables>;

/**
 * __useRemoveLabworkMutation__
 *
 * To run a mutation, you first call `useRemoveLabworkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveLabworkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeLabworkMutation, { data, loading, error }] = useRemoveLabworkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveLabworkMutation(baseOptions?: Apollo.MutationHookOptions<RemoveLabworkMutation, RemoveLabworkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveLabworkMutation, RemoveLabworkMutationVariables>(RemoveLabworkDocument, options);
      }
export type RemoveLabworkMutationHookResult = ReturnType<typeof useRemoveLabworkMutation>;
export type RemoveLabworkMutationResult = Apollo.MutationResult<RemoveLabworkMutation>;
export type RemoveLabworkMutationOptions = Apollo.BaseMutationOptions<RemoveLabworkMutation, RemoveLabworkMutationVariables>;
export const RemoveDvmExamDocument = gql`
    mutation removeDvmExam($input: RemoveDvmExamInput!) {
  removeDvmExam(input: $input)
}
    `;
export type RemoveDvmExamMutationFn = Apollo.MutationFunction<RemoveDvmExamMutation, RemoveDvmExamMutationVariables>;

/**
 * __useRemoveDvmExamMutation__
 *
 * To run a mutation, you first call `useRemoveDvmExamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveDvmExamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeDvmExamMutation, { data, loading, error }] = useRemoveDvmExamMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveDvmExamMutation(baseOptions?: Apollo.MutationHookOptions<RemoveDvmExamMutation, RemoveDvmExamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveDvmExamMutation, RemoveDvmExamMutationVariables>(RemoveDvmExamDocument, options);
      }
export type RemoveDvmExamMutationHookResult = ReturnType<typeof useRemoveDvmExamMutation>;
export type RemoveDvmExamMutationResult = Apollo.MutationResult<RemoveDvmExamMutation>;
export type RemoveDvmExamMutationOptions = Apollo.BaseMutationOptions<RemoveDvmExamMutation, RemoveDvmExamMutationVariables>;
export const DetachLabworkFileDocument = gql`
    mutation detachLabworkFile($input: DetachLabworkFileInput!) {
  detachLabworkFile(input: $input)
}
    `;
export type DetachLabworkFileMutationFn = Apollo.MutationFunction<DetachLabworkFileMutation, DetachLabworkFileMutationVariables>;

/**
 * __useDetachLabworkFileMutation__
 *
 * To run a mutation, you first call `useDetachLabworkFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDetachLabworkFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [detachLabworkFileMutation, { data, loading, error }] = useDetachLabworkFileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDetachLabworkFileMutation(baseOptions?: Apollo.MutationHookOptions<DetachLabworkFileMutation, DetachLabworkFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DetachLabworkFileMutation, DetachLabworkFileMutationVariables>(DetachLabworkFileDocument, options);
      }
export type DetachLabworkFileMutationHookResult = ReturnType<typeof useDetachLabworkFileMutation>;
export type DetachLabworkFileMutationResult = Apollo.MutationResult<DetachLabworkFileMutation>;
export type DetachLabworkFileMutationOptions = Apollo.BaseMutationOptions<DetachLabworkFileMutation, DetachLabworkFileMutationVariables>;
export const UpdateVitalsParametersListDocument = gql`
    mutation updateVitalsParametersList($input: UpdateVitalsParametersListInput!) {
  updateVitalsParameterList(input: $input) {
    ...VitalsParameter
  }
}
    ${VitalsParameterFragmentDoc}`;
export type UpdateVitalsParametersListMutationFn = Apollo.MutationFunction<UpdateVitalsParametersListMutation, UpdateVitalsParametersListMutationVariables>;

/**
 * __useUpdateVitalsParametersListMutation__
 *
 * To run a mutation, you first call `useUpdateVitalsParametersListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVitalsParametersListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVitalsParametersListMutation, { data, loading, error }] = useUpdateVitalsParametersListMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateVitalsParametersListMutation(baseOptions?: Apollo.MutationHookOptions<UpdateVitalsParametersListMutation, UpdateVitalsParametersListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateVitalsParametersListMutation, UpdateVitalsParametersListMutationVariables>(UpdateVitalsParametersListDocument, options);
      }
export type UpdateVitalsParametersListMutationHookResult = ReturnType<typeof useUpdateVitalsParametersListMutation>;
export type UpdateVitalsParametersListMutationResult = Apollo.MutationResult<UpdateVitalsParametersListMutation>;
export type UpdateVitalsParametersListMutationOptions = Apollo.BaseMutationOptions<UpdateVitalsParametersListMutation, UpdateVitalsParametersListMutationVariables>;
export const UpdateDonorsOwnerDocument = gql`
    mutation updateDonorsOwner($input: UpdateDonorsOwnerInput!) {
  updateDonorsOwner(input: $input) {
    ...Donor
    team {
      id
      title
    }
    user {
      ...Owner
      contacts {
        ...Contact
      }
    }
    reserveNotes {
      ...ReserveDonorNote
    }
  }
}
    ${DonorFragmentDoc}
${OwnerFragmentDoc}
${ContactFragmentDoc}
${ReserveDonorNoteFragmentDoc}`;
export type UpdateDonorsOwnerMutationFn = Apollo.MutationFunction<UpdateDonorsOwnerMutation, UpdateDonorsOwnerMutationVariables>;

/**
 * __useUpdateDonorsOwnerMutation__
 *
 * To run a mutation, you first call `useUpdateDonorsOwnerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDonorsOwnerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDonorsOwnerMutation, { data, loading, error }] = useUpdateDonorsOwnerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDonorsOwnerMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDonorsOwnerMutation, UpdateDonorsOwnerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDonorsOwnerMutation, UpdateDonorsOwnerMutationVariables>(UpdateDonorsOwnerDocument, options);
      }
export type UpdateDonorsOwnerMutationHookResult = ReturnType<typeof useUpdateDonorsOwnerMutation>;
export type UpdateDonorsOwnerMutationResult = Apollo.MutationResult<UpdateDonorsOwnerMutation>;
export type UpdateDonorsOwnerMutationOptions = Apollo.BaseMutationOptions<UpdateDonorsOwnerMutation, UpdateDonorsOwnerMutationVariables>;
export const UpdateGroupOwnerDocument = gql`
    mutation updateGroupOwner($input: UpdateGroupOwnerInput!) {
  updateGroupOwner(input: $input) {
    ...Group
    teams {
      ...Team
      donors {
        ...Donor
      }
    }
    user {
      ...Owner
      contacts {
        ...Contact
      }
    }
  }
}
    ${GroupFragmentDoc}
${TeamFragmentDoc}
${DonorFragmentDoc}
${OwnerFragmentDoc}
${ContactFragmentDoc}`;
export type UpdateGroupOwnerMutationFn = Apollo.MutationFunction<UpdateGroupOwnerMutation, UpdateGroupOwnerMutationVariables>;

/**
 * __useUpdateGroupOwnerMutation__
 *
 * To run a mutation, you first call `useUpdateGroupOwnerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGroupOwnerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGroupOwnerMutation, { data, loading, error }] = useUpdateGroupOwnerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateGroupOwnerMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGroupOwnerMutation, UpdateGroupOwnerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGroupOwnerMutation, UpdateGroupOwnerMutationVariables>(UpdateGroupOwnerDocument, options);
      }
export type UpdateGroupOwnerMutationHookResult = ReturnType<typeof useUpdateGroupOwnerMutation>;
export type UpdateGroupOwnerMutationResult = Apollo.MutationResult<UpdateGroupOwnerMutation>;
export type UpdateGroupOwnerMutationOptions = Apollo.BaseMutationOptions<UpdateGroupOwnerMutation, UpdateGroupOwnerMutationVariables>;
export const ManageDonorsInTeamDocument = gql`
    mutation manageDonorsInTeam($input: ManageDonorsInTeamInput!) {
  manageDonorsInTeam(input: $input)
}
    `;
export type ManageDonorsInTeamMutationFn = Apollo.MutationFunction<ManageDonorsInTeamMutation, ManageDonorsInTeamMutationVariables>;

/**
 * __useManageDonorsInTeamMutation__
 *
 * To run a mutation, you first call `useManageDonorsInTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useManageDonorsInTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [manageDonorsInTeamMutation, { data, loading, error }] = useManageDonorsInTeamMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useManageDonorsInTeamMutation(baseOptions?: Apollo.MutationHookOptions<ManageDonorsInTeamMutation, ManageDonorsInTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ManageDonorsInTeamMutation, ManageDonorsInTeamMutationVariables>(ManageDonorsInTeamDocument, options);
      }
export type ManageDonorsInTeamMutationHookResult = ReturnType<typeof useManageDonorsInTeamMutation>;
export type ManageDonorsInTeamMutationResult = Apollo.MutationResult<ManageDonorsInTeamMutation>;
export type ManageDonorsInTeamMutationOptions = Apollo.BaseMutationOptions<ManageDonorsInTeamMutation, ManageDonorsInTeamMutationVariables>;
export const AddNoteDocument = gql`
    mutation addNote($input: CreateDonorNoteInput!) {
  addNote(input: $input) {
    ...DonorNote
  }
}
    ${DonorNoteFragmentDoc}`;
export type AddNoteMutationFn = Apollo.MutationFunction<AddNoteMutation, AddNoteMutationVariables>;

/**
 * __useAddNoteMutation__
 *
 * To run a mutation, you first call `useAddNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addNoteMutation, { data, loading, error }] = useAddNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddNoteMutation(baseOptions?: Apollo.MutationHookOptions<AddNoteMutation, AddNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddNoteMutation, AddNoteMutationVariables>(AddNoteDocument, options);
      }
export type AddNoteMutationHookResult = ReturnType<typeof useAddNoteMutation>;
export type AddNoteMutationResult = Apollo.MutationResult<AddNoteMutation>;
export type AddNoteMutationOptions = Apollo.BaseMutationOptions<AddNoteMutation, AddNoteMutationVariables>;
export const UpdateNoteDocument = gql`
    mutation updateNote($input: UpdateDonorNoteInput!) {
  updateNote(input: $input) {
    ...DonorNote
  }
}
    ${DonorNoteFragmentDoc}`;
export type UpdateNoteMutationFn = Apollo.MutationFunction<UpdateNoteMutation, UpdateNoteMutationVariables>;

/**
 * __useUpdateNoteMutation__
 *
 * To run a mutation, you first call `useUpdateNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNoteMutation, { data, loading, error }] = useUpdateNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateNoteMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNoteMutation, UpdateNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNoteMutation, UpdateNoteMutationVariables>(UpdateNoteDocument, options);
      }
export type UpdateNoteMutationHookResult = ReturnType<typeof useUpdateNoteMutation>;
export type UpdateNoteMutationResult = Apollo.MutationResult<UpdateNoteMutation>;
export type UpdateNoteMutationOptions = Apollo.BaseMutationOptions<UpdateNoteMutation, UpdateNoteMutationVariables>;
export const DeleteNoteDocument = gql`
    mutation deleteNote($input: DeleteDonorNoteInput!) {
  deleteNote(input: $input)
}
    `;
export type DeleteNoteMutationFn = Apollo.MutationFunction<DeleteNoteMutation, DeleteNoteMutationVariables>;

/**
 * __useDeleteNoteMutation__
 *
 * To run a mutation, you first call `useDeleteNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteNoteMutation, { data, loading, error }] = useDeleteNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteNoteMutation(baseOptions?: Apollo.MutationHookOptions<DeleteNoteMutation, DeleteNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteNoteMutation, DeleteNoteMutationVariables>(DeleteNoteDocument, options);
      }
export type DeleteNoteMutationHookResult = ReturnType<typeof useDeleteNoteMutation>;
export type DeleteNoteMutationResult = Apollo.MutationResult<DeleteNoteMutation>;
export type DeleteNoteMutationOptions = Apollo.BaseMutationOptions<DeleteNoteMutation, DeleteNoteMutationVariables>;
export const MakeDonorPicturePrimaryDocument = gql`
    mutation makeDonorPicturePrimary($input: MakePicturePrimaryInput!) {
  makeDonorPicturePrimary(input: $input)
}
    `;
export type MakeDonorPicturePrimaryMutationFn = Apollo.MutationFunction<MakeDonorPicturePrimaryMutation, MakeDonorPicturePrimaryMutationVariables>;

/**
 * __useMakeDonorPicturePrimaryMutation__
 *
 * To run a mutation, you first call `useMakeDonorPicturePrimaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMakeDonorPicturePrimaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [makeDonorPicturePrimaryMutation, { data, loading, error }] = useMakeDonorPicturePrimaryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMakeDonorPicturePrimaryMutation(baseOptions?: Apollo.MutationHookOptions<MakeDonorPicturePrimaryMutation, MakeDonorPicturePrimaryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MakeDonorPicturePrimaryMutation, MakeDonorPicturePrimaryMutationVariables>(MakeDonorPicturePrimaryDocument, options);
      }
export type MakeDonorPicturePrimaryMutationHookResult = ReturnType<typeof useMakeDonorPicturePrimaryMutation>;
export type MakeDonorPicturePrimaryMutationResult = Apollo.MutationResult<MakeDonorPicturePrimaryMutation>;
export type MakeDonorPicturePrimaryMutationOptions = Apollo.BaseMutationOptions<MakeDonorPicturePrimaryMutation, MakeDonorPicturePrimaryMutationVariables>;
export const ResetPrimaryDonorPicturesDocument = gql`
    mutation resetPrimaryDonorPictures($input: ResetPrimaryPicturesInput!) {
  resetPrimaryDonorPictures(input: $input)
}
    `;
export type ResetPrimaryDonorPicturesMutationFn = Apollo.MutationFunction<ResetPrimaryDonorPicturesMutation, ResetPrimaryDonorPicturesMutationVariables>;

/**
 * __useResetPrimaryDonorPicturesMutation__
 *
 * To run a mutation, you first call `useResetPrimaryDonorPicturesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPrimaryDonorPicturesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPrimaryDonorPicturesMutation, { data, loading, error }] = useResetPrimaryDonorPicturesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResetPrimaryDonorPicturesMutation(baseOptions?: Apollo.MutationHookOptions<ResetPrimaryDonorPicturesMutation, ResetPrimaryDonorPicturesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetPrimaryDonorPicturesMutation, ResetPrimaryDonorPicturesMutationVariables>(ResetPrimaryDonorPicturesDocument, options);
      }
export type ResetPrimaryDonorPicturesMutationHookResult = ReturnType<typeof useResetPrimaryDonorPicturesMutation>;
export type ResetPrimaryDonorPicturesMutationResult = Apollo.MutationResult<ResetPrimaryDonorPicturesMutation>;
export type ResetPrimaryDonorPicturesMutationOptions = Apollo.BaseMutationOptions<ResetPrimaryDonorPicturesMutation, ResetPrimaryDonorPicturesMutationVariables>;
export const CreateDonorContactDocument = gql`
    mutation createDonorContact($input: CreateDonorContactInput!) {
  createDonorContact(input: $input) {
    id
    donorId
    contactType
    notes
    followUpDate
    user {
      id
      firstName
      lastName
    }
    createdAt
  }
}
    `;
export type CreateDonorContactMutationFn = Apollo.MutationFunction<CreateDonorContactMutation, CreateDonorContactMutationVariables>;

/**
 * __useCreateDonorContactMutation__
 *
 * To run a mutation, you first call `useCreateDonorContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDonorContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDonorContactMutation, { data, loading, error }] = useCreateDonorContactMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDonorContactMutation(baseOptions?: Apollo.MutationHookOptions<CreateDonorContactMutation, CreateDonorContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDonorContactMutation, CreateDonorContactMutationVariables>(CreateDonorContactDocument, options);
      }
export type CreateDonorContactMutationHookResult = ReturnType<typeof useCreateDonorContactMutation>;
export type CreateDonorContactMutationResult = Apollo.MutationResult<CreateDonorContactMutation>;
export type CreateDonorContactMutationOptions = Apollo.BaseMutationOptions<CreateDonorContactMutation, CreateDonorContactMutationVariables>;
export const DeleteDonorContactDocument = gql`
    mutation deleteDonorContact($id: String!) {
  deleteDonorContact(id: $id)
}
    `;
export type DeleteDonorContactMutationFn = Apollo.MutationFunction<DeleteDonorContactMutation, DeleteDonorContactMutationVariables>;

/**
 * __useDeleteDonorContactMutation__
 *
 * To run a mutation, you first call `useDeleteDonorContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDonorContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDonorContactMutation, { data, loading, error }] = useDeleteDonorContactMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteDonorContactMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDonorContactMutation, DeleteDonorContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDonorContactMutation, DeleteDonorContactMutationVariables>(DeleteDonorContactDocument, options);
      }
export type DeleteDonorContactMutationHookResult = ReturnType<typeof useDeleteDonorContactMutation>;
export type DeleteDonorContactMutationResult = Apollo.MutationResult<DeleteDonorContactMutation>;
export type DeleteDonorContactMutationOptions = Apollo.BaseMutationOptions<DeleteDonorContactMutation, DeleteDonorContactMutationVariables>;
export const UpsertDonorContactFlagDocument = gql`
    mutation upsertDonorContactFlag($donorId: String!, $flagValue: String!) {
  upsertDonorContactFlag(donorId: $donorId, flagValue: $flagValue) {
    id
    donorId
    contactType
    notes
    createdAt
  }
}
    `;
export type UpsertDonorContactFlagMutationFn = Apollo.MutationFunction<UpsertDonorContactFlagMutation, UpsertDonorContactFlagMutationVariables>;

/**
 * __useUpsertDonorContactFlagMutation__
 *
 * To run a mutation, you first call `useUpsertDonorContactFlagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertDonorContactFlagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertDonorContactFlagMutation, { data, loading, error }] = useUpsertDonorContactFlagMutation({
 *   variables: {
 *      donorId: // value for 'donorId'
 *      flagValue: // value for 'flagValue'
 *   },
 * });
 */
export function useUpsertDonorContactFlagMutation(baseOptions?: Apollo.MutationHookOptions<UpsertDonorContactFlagMutation, UpsertDonorContactFlagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertDonorContactFlagMutation, UpsertDonorContactFlagMutationVariables>(UpsertDonorContactFlagDocument, options);
      }
export type UpsertDonorContactFlagMutationHookResult = ReturnType<typeof useUpsertDonorContactFlagMutation>;
export type UpsertDonorContactFlagMutationResult = Apollo.MutationResult<UpsertDonorContactFlagMutation>;
export type UpsertDonorContactFlagMutationOptions = Apollo.BaseMutationOptions<UpsertDonorContactFlagMutation, UpsertDonorContactFlagMutationVariables>;
export const GetDonorsListDocument = gql`
    query getDonorsList($input: DonorsListInput!) {
  getDonorsList(input: $input) {
    data {
      ...Donor
      team {
        id
        title
      }
      user {
        ...Owner
        contacts {
          ...Contact
        }
      }
      reserveNotes {
        ...ReserveDonorNote
      }
    }
    meta {
      total
    }
  }
}
    ${DonorFragmentDoc}
${OwnerFragmentDoc}
${ContactFragmentDoc}
${ReserveDonorNoteFragmentDoc}`;

/**
 * __useGetDonorsListQuery__
 *
 * To run a query within a React component, call `useGetDonorsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDonorsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDonorsListQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetDonorsListQuery(baseOptions: Apollo.QueryHookOptions<GetDonorsListQuery, GetDonorsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDonorsListQuery, GetDonorsListQueryVariables>(GetDonorsListDocument, options);
      }
export function useGetDonorsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDonorsListQuery, GetDonorsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDonorsListQuery, GetDonorsListQueryVariables>(GetDonorsListDocument, options);
        }
export type GetDonorsListQueryHookResult = ReturnType<typeof useGetDonorsListQuery>;
export type GetDonorsListLazyQueryHookResult = ReturnType<typeof useGetDonorsListLazyQuery>;
export type GetDonorsListQueryResult = Apollo.QueryResult<GetDonorsListQuery, GetDonorsListQueryVariables>;
export const GetDvmExamListDocument = gql`
    query getDvmExamList($input: DvmExamInput!) {
  getDvmExamList(input: $input) {
    data {
      ...DvmExam
      performedBy {
        ...User
      }
      donor {
        ...Donor
        user {
          ...Owner
        }
      }
    }
    meta {
      total
    }
  }
}
    ${DvmExamFragmentDoc}
${UserFragmentDoc}
${DonorFragmentDoc}
${OwnerFragmentDoc}`;

/**
 * __useGetDvmExamListQuery__
 *
 * To run a query within a React component, call `useGetDvmExamListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDvmExamListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDvmExamListQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetDvmExamListQuery(baseOptions: Apollo.QueryHookOptions<GetDvmExamListQuery, GetDvmExamListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDvmExamListQuery, GetDvmExamListQueryVariables>(GetDvmExamListDocument, options);
      }
export function useGetDvmExamListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDvmExamListQuery, GetDvmExamListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDvmExamListQuery, GetDvmExamListQueryVariables>(GetDvmExamListDocument, options);
        }
export type GetDvmExamListQueryHookResult = ReturnType<typeof useGetDvmExamListQuery>;
export type GetDvmExamListLazyQueryHookResult = ReturnType<typeof useGetDvmExamListLazyQuery>;
export type GetDvmExamListQueryResult = Apollo.QueryResult<GetDvmExamListQuery, GetDvmExamListQueryVariables>;
export const GetPetBreedsListDocument = gql`
    query getPetBreedsList($input: PetBreedsListInput!) {
  getPetBreedsList(input: $input) {
    data {
      ...DonorBreed
    }
    meta {
      total
    }
  }
}
    ${DonorBreedFragmentDoc}`;

/**
 * __useGetPetBreedsListQuery__
 *
 * To run a query within a React component, call `useGetPetBreedsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPetBreedsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPetBreedsListQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetPetBreedsListQuery(baseOptions: Apollo.QueryHookOptions<GetPetBreedsListQuery, GetPetBreedsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPetBreedsListQuery, GetPetBreedsListQueryVariables>(GetPetBreedsListDocument, options);
      }
export function useGetPetBreedsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPetBreedsListQuery, GetPetBreedsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPetBreedsListQuery, GetPetBreedsListQueryVariables>(GetPetBreedsListDocument, options);
        }
export type GetPetBreedsListQueryHookResult = ReturnType<typeof useGetPetBreedsListQuery>;
export type GetPetBreedsListLazyQueryHookResult = ReturnType<typeof useGetPetBreedsListLazyQuery>;
export type GetPetBreedsListQueryResult = Apollo.QueryResult<GetPetBreedsListQuery, GetPetBreedsListQueryVariables>;
export const GetDvmExamDocument = gql`
    query getDvmExam($input: GetDvmExamInput!) {
  getDvmExam(input: $input) {
    ...DvmExam
    performedBy {
      ...User
    }
    donor {
      ...Donor
      user {
        ...Owner
      }
    }
  }
}
    ${DvmExamFragmentDoc}
${UserFragmentDoc}
${DonorFragmentDoc}
${OwnerFragmentDoc}`;

/**
 * __useGetDvmExamQuery__
 *
 * To run a query within a React component, call `useGetDvmExamQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDvmExamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDvmExamQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetDvmExamQuery(baseOptions: Apollo.QueryHookOptions<GetDvmExamQuery, GetDvmExamQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDvmExamQuery, GetDvmExamQueryVariables>(GetDvmExamDocument, options);
      }
export function useGetDvmExamLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDvmExamQuery, GetDvmExamQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDvmExamQuery, GetDvmExamQueryVariables>(GetDvmExamDocument, options);
        }
export type GetDvmExamQueryHookResult = ReturnType<typeof useGetDvmExamQuery>;
export type GetDvmExamLazyQueryHookResult = ReturnType<typeof useGetDvmExamLazyQuery>;
export type GetDvmExamQueryResult = Apollo.QueryResult<GetDvmExamQuery, GetDvmExamQueryVariables>;
export const GetDonorDvmExamsDocument = gql`
    query getDonorDvmExams($input: GetDonorDvmExamsInput!) {
  getDonorDvmExams(input: $input) {
    ...DvmExam
    performedBy {
      ...User
    }
    donor {
      ...Donor
      user {
        ...Owner
      }
    }
  }
}
    ${DvmExamFragmentDoc}
${UserFragmentDoc}
${DonorFragmentDoc}
${OwnerFragmentDoc}`;

/**
 * __useGetDonorDvmExamsQuery__
 *
 * To run a query within a React component, call `useGetDonorDvmExamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDonorDvmExamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDonorDvmExamsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetDonorDvmExamsQuery(baseOptions: Apollo.QueryHookOptions<GetDonorDvmExamsQuery, GetDonorDvmExamsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDonorDvmExamsQuery, GetDonorDvmExamsQueryVariables>(GetDonorDvmExamsDocument, options);
      }
export function useGetDonorDvmExamsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDonorDvmExamsQuery, GetDonorDvmExamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDonorDvmExamsQuery, GetDonorDvmExamsQueryVariables>(GetDonorDvmExamsDocument, options);
        }
export type GetDonorDvmExamsQueryHookResult = ReturnType<typeof useGetDonorDvmExamsQuery>;
export type GetDonorDvmExamsLazyQueryHookResult = ReturnType<typeof useGetDonorDvmExamsLazyQuery>;
export type GetDonorDvmExamsQueryResult = Apollo.QueryResult<GetDonorDvmExamsQuery, GetDonorDvmExamsQueryVariables>;
export const FindDonorsForTeamDocument = gql`
    query findDonorsForTeam($input: DonorsListForTeamInput!) {
  findDonorsForTeam(input: $input) {
    data {
      ...Donor
      team {
        id
        title
      }
      user {
        ...Owner
        contacts {
          ...Contact
        }
      }
      reserveNotes {
        ...ReserveDonorNote
      }
    }
    meta {
      total
    }
  }
}
    ${DonorFragmentDoc}
${OwnerFragmentDoc}
${ContactFragmentDoc}
${ReserveDonorNoteFragmentDoc}`;

/**
 * __useFindDonorsForTeamQuery__
 *
 * To run a query within a React component, call `useFindDonorsForTeamQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindDonorsForTeamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindDonorsForTeamQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFindDonorsForTeamQuery(baseOptions: Apollo.QueryHookOptions<FindDonorsForTeamQuery, FindDonorsForTeamQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindDonorsForTeamQuery, FindDonorsForTeamQueryVariables>(FindDonorsForTeamDocument, options);
      }
export function useFindDonorsForTeamLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindDonorsForTeamQuery, FindDonorsForTeamQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindDonorsForTeamQuery, FindDonorsForTeamQueryVariables>(FindDonorsForTeamDocument, options);
        }
export type FindDonorsForTeamQueryHookResult = ReturnType<typeof useFindDonorsForTeamQuery>;
export type FindDonorsForTeamLazyQueryHookResult = ReturnType<typeof useFindDonorsForTeamLazyQuery>;
export type FindDonorsForTeamQueryResult = Apollo.QueryResult<FindDonorsForTeamQuery, FindDonorsForTeamQueryVariables>;
export const GetDonorDocument = gql`
    query getDonor($input: GetDonorInput!) {
  getDonor(input: $input) {
    ...Donor
    lastLabworkFile {
      ...File
    }
    team {
      id
      title
    }
    user {
      ...Owner
      contacts {
        ...Contact
      }
    }
    reserveNotes {
      ...ReserveDonorNote
    }
    pictures {
      ...Picture
    }
  }
}
    ${DonorFragmentDoc}
${FileFragmentDoc}
${OwnerFragmentDoc}
${ContactFragmentDoc}
${ReserveDonorNoteFragmentDoc}
${PictureFragmentDoc}`;

/**
 * __useGetDonorQuery__
 *
 * To run a query within a React component, call `useGetDonorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDonorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDonorQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetDonorQuery(baseOptions: Apollo.QueryHookOptions<GetDonorQuery, GetDonorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDonorQuery, GetDonorQueryVariables>(GetDonorDocument, options);
      }
export function useGetDonorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDonorQuery, GetDonorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDonorQuery, GetDonorQueryVariables>(GetDonorDocument, options);
        }
export type GetDonorQueryHookResult = ReturnType<typeof useGetDonorQuery>;
export type GetDonorLazyQueryHookResult = ReturnType<typeof useGetDonorLazyQuery>;
export type GetDonorQueryResult = Apollo.QueryResult<GetDonorQuery, GetDonorQueryVariables>;
export const GetCurrentUserDonorsListDocument = gql`
    query getCurrentUserDonorsList($input: CurrentUserDonorListInput!) {
  getCurrentUserDonorsList(input: $input) {
    data {
      ...Donor
      lastLabworkFile {
        ...File
      }
      team {
        id
        title
      }
      user {
        ...Owner
        contacts {
          ...Contact
        }
      }
      reserveNotes {
        ...ReserveDonorNote
      }
    }
    meta {
      total
    }
  }
}
    ${DonorFragmentDoc}
${FileFragmentDoc}
${OwnerFragmentDoc}
${ContactFragmentDoc}
${ReserveDonorNoteFragmentDoc}`;

/**
 * __useGetCurrentUserDonorsListQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserDonorsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserDonorsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserDonorsListQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetCurrentUserDonorsListQuery(baseOptions: Apollo.QueryHookOptions<GetCurrentUserDonorsListQuery, GetCurrentUserDonorsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentUserDonorsListQuery, GetCurrentUserDonorsListQueryVariables>(GetCurrentUserDonorsListDocument, options);
      }
export function useGetCurrentUserDonorsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentUserDonorsListQuery, GetCurrentUserDonorsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentUserDonorsListQuery, GetCurrentUserDonorsListQueryVariables>(GetCurrentUserDonorsListDocument, options);
        }
export type GetCurrentUserDonorsListQueryHookResult = ReturnType<typeof useGetCurrentUserDonorsListQuery>;
export type GetCurrentUserDonorsListLazyQueryHookResult = ReturnType<typeof useGetCurrentUserDonorsListLazyQuery>;
export type GetCurrentUserDonorsListQueryResult = Apollo.QueryResult<GetCurrentUserDonorsListQuery, GetCurrentUserDonorsListQueryVariables>;
export const FindAllGroupDocument = gql`
    query findAllGroup($input: GroupListInput!) {
  findAllGroup(input: $input) {
    data {
      ...GroupListItem
      teams {
        ...GroupTeam
      }
    }
    meta {
      total
    }
  }
}
    ${GroupListItemFragmentDoc}
${GroupTeamFragmentDoc}`;

/**
 * __useFindAllGroupQuery__
 *
 * To run a query within a React component, call `useFindAllGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllGroupQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFindAllGroupQuery(baseOptions: Apollo.QueryHookOptions<FindAllGroupQuery, FindAllGroupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllGroupQuery, FindAllGroupQueryVariables>(FindAllGroupDocument, options);
      }
export function useFindAllGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllGroupQuery, FindAllGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllGroupQuery, FindAllGroupQueryVariables>(FindAllGroupDocument, options);
        }
export type FindAllGroupQueryHookResult = ReturnType<typeof useFindAllGroupQuery>;
export type FindAllGroupLazyQueryHookResult = ReturnType<typeof useFindAllGroupLazyQuery>;
export type FindAllGroupQueryResult = Apollo.QueryResult<FindAllGroupQuery, FindAllGroupQueryVariables>;
export const FindGroupDocument = gql`
    query findGroup($input: FindGroupInput!) {
  findGroup(input: $input) {
    ...Group
    teams {
      ...Team
      donors {
        ...Donor
        user {
          ...Owner
          role {
            ...RoleWithoutPermissions
          }
          contacts {
            ...Contact
          }
        }
      }
    }
    user {
      ...Owner
      role {
        ...RoleWithoutPermissions
      }
      contacts {
        ...Contact
      }
    }
  }
}
    ${GroupFragmentDoc}
${TeamFragmentDoc}
${DonorFragmentDoc}
${OwnerFragmentDoc}
${RoleWithoutPermissionsFragmentDoc}
${ContactFragmentDoc}`;

/**
 * __useFindGroupQuery__
 *
 * To run a query within a React component, call `useFindGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindGroupQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFindGroupQuery(baseOptions: Apollo.QueryHookOptions<FindGroupQuery, FindGroupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindGroupQuery, FindGroupQueryVariables>(FindGroupDocument, options);
      }
export function useFindGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindGroupQuery, FindGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindGroupQuery, FindGroupQueryVariables>(FindGroupDocument, options);
        }
export type FindGroupQueryHookResult = ReturnType<typeof useFindGroupQuery>;
export type FindGroupLazyQueryHookResult = ReturnType<typeof useFindGroupLazyQuery>;
export type FindGroupQueryResult = Apollo.QueryResult<FindGroupQuery, FindGroupQueryVariables>;
export const GetDonorLivesSavedDocument = gql`
    query getDonorLivesSaved($input: GetLivesSavedByDonorInput!) {
  getDonorLivesSaved(input: $input) {
    lives
  }
}
    `;

/**
 * __useGetDonorLivesSavedQuery__
 *
 * To run a query within a React component, call `useGetDonorLivesSavedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDonorLivesSavedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDonorLivesSavedQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetDonorLivesSavedQuery(baseOptions: Apollo.QueryHookOptions<GetDonorLivesSavedQuery, GetDonorLivesSavedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDonorLivesSavedQuery, GetDonorLivesSavedQueryVariables>(GetDonorLivesSavedDocument, options);
      }
export function useGetDonorLivesSavedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDonorLivesSavedQuery, GetDonorLivesSavedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDonorLivesSavedQuery, GetDonorLivesSavedQueryVariables>(GetDonorLivesSavedDocument, options);
        }
export type GetDonorLivesSavedQueryHookResult = ReturnType<typeof useGetDonorLivesSavedQuery>;
export type GetDonorLivesSavedLazyQueryHookResult = ReturnType<typeof useGetDonorLivesSavedLazyQuery>;
export type GetDonorLivesSavedQueryResult = Apollo.QueryResult<GetDonorLivesSavedQuery, GetDonorLivesSavedQueryVariables>;
export const GetDonorStatsDocument = gql`
    query getDonorStats($input: GetDonorStatsInput!) {
  getDonorStats(input: $input) {
    totalMlsDonated
    totalDonations
    prbcCreated
    ffpUnitsCreated
  }
}
    `;

/**
 * __useGetDonorStatsQuery__
 *
 * To run a query within a React component, call `useGetDonorStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDonorStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDonorStatsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetDonorStatsQuery(baseOptions: Apollo.QueryHookOptions<GetDonorStatsQuery, GetDonorStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDonorStatsQuery, GetDonorStatsQueryVariables>(GetDonorStatsDocument, options);
      }
export function useGetDonorStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDonorStatsQuery, GetDonorStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDonorStatsQuery, GetDonorStatsQueryVariables>(GetDonorStatsDocument, options);
        }
export type GetDonorStatsQueryHookResult = ReturnType<typeof useGetDonorStatsQuery>;
export type GetDonorStatsLazyQueryHookResult = ReturnType<typeof useGetDonorStatsLazyQuery>;
export type GetDonorStatsQueryResult = Apollo.QueryResult<GetDonorStatsQuery, GetDonorStatsQueryVariables>;
export const GetChartsDataDocument = gql`
    query getChartsData($input: GetSpecificDonorDonationsListInput!) {
  getChartsData(input: $input) {
    data {
      ...Donation
    }
    meta {
      total
    }
  }
}
    ${DonationFragmentDoc}`;

/**
 * __useGetChartsDataQuery__
 *
 * To run a query within a React component, call `useGetChartsDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChartsDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChartsDataQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetChartsDataQuery(baseOptions: Apollo.QueryHookOptions<GetChartsDataQuery, GetChartsDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChartsDataQuery, GetChartsDataQueryVariables>(GetChartsDataDocument, options);
      }
export function useGetChartsDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChartsDataQuery, GetChartsDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChartsDataQuery, GetChartsDataQueryVariables>(GetChartsDataDocument, options);
        }
export type GetChartsDataQueryHookResult = ReturnType<typeof useGetChartsDataQuery>;
export type GetChartsDataLazyQueryHookResult = ReturnType<typeof useGetChartsDataLazyQuery>;
export type GetChartsDataQueryResult = Apollo.QueryResult<GetChartsDataQuery, GetChartsDataQueryVariables>;
export const GetLabworkListDocument = gql`
    query getLabworkList($input: LabworkListInput!) {
  getLabworkList(input: $input) {
    data {
      ...Labwork
      donor {
        ...Donor
        user {
          ...Owner
        }
      }
    }
    meta {
      total
    }
  }
}
    ${LabworkFragmentDoc}
${DonorFragmentDoc}
${OwnerFragmentDoc}`;

/**
 * __useGetLabworkListQuery__
 *
 * To run a query within a React component, call `useGetLabworkListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLabworkListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLabworkListQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetLabworkListQuery(baseOptions: Apollo.QueryHookOptions<GetLabworkListQuery, GetLabworkListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLabworkListQuery, GetLabworkListQueryVariables>(GetLabworkListDocument, options);
      }
export function useGetLabworkListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLabworkListQuery, GetLabworkListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLabworkListQuery, GetLabworkListQueryVariables>(GetLabworkListDocument, options);
        }
export type GetLabworkListQueryHookResult = ReturnType<typeof useGetLabworkListQuery>;
export type GetLabworkListLazyQueryHookResult = ReturnType<typeof useGetLabworkListLazyQuery>;
export type GetLabworkListQueryResult = Apollo.QueryResult<GetLabworkListQuery, GetLabworkListQueryVariables>;
export const GetLabworkDocument = gql`
    query getLabwork($input: GetLabworkInput!) {
  getLabwork(input: $input) {
    ...Labwork
    donor {
      ...Donor
      user {
        ...Owner
      }
    }
  }
}
    ${LabworkFragmentDoc}
${DonorFragmentDoc}
${OwnerFragmentDoc}`;

/**
 * __useGetLabworkQuery__
 *
 * To run a query within a React component, call `useGetLabworkQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLabworkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLabworkQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetLabworkQuery(baseOptions: Apollo.QueryHookOptions<GetLabworkQuery, GetLabworkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLabworkQuery, GetLabworkQueryVariables>(GetLabworkDocument, options);
      }
export function useGetLabworkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLabworkQuery, GetLabworkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLabworkQuery, GetLabworkQueryVariables>(GetLabworkDocument, options);
        }
export type GetLabworkQueryHookResult = ReturnType<typeof useGetLabworkQuery>;
export type GetLabworkLazyQueryHookResult = ReturnType<typeof useGetLabworkLazyQuery>;
export type GetLabworkQueryResult = Apollo.QueryResult<GetLabworkQuery, GetLabworkQueryVariables>;
export const GetVitalsParameterListDocument = gql`
    query getVitalsParameterList {
  getVitalsParameterList {
    ...VitalsParameter
  }
}
    ${VitalsParameterFragmentDoc}`;

/**
 * __useGetVitalsParameterListQuery__
 *
 * To run a query within a React component, call `useGetVitalsParameterListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVitalsParameterListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVitalsParameterListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetVitalsParameterListQuery(baseOptions?: Apollo.QueryHookOptions<GetVitalsParameterListQuery, GetVitalsParameterListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVitalsParameterListQuery, GetVitalsParameterListQueryVariables>(GetVitalsParameterListDocument, options);
      }
export function useGetVitalsParameterListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVitalsParameterListQuery, GetVitalsParameterListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVitalsParameterListQuery, GetVitalsParameterListQueryVariables>(GetVitalsParameterListDocument, options);
        }
export type GetVitalsParameterListQueryHookResult = ReturnType<typeof useGetVitalsParameterListQuery>;
export type GetVitalsParameterListLazyQueryHookResult = ReturnType<typeof useGetVitalsParameterListLazyQuery>;
export type GetVitalsParameterListQueryResult = Apollo.QueryResult<GetVitalsParameterListQuery, GetVitalsParameterListQueryVariables>;
export const GetAppointmentsDonorsListDocument = gql`
    query getAppointmentsDonorsList {
  getAppointmentsDonorsList {
    ...Donor
    team {
      id
      title
    }
    user {
      ...Owner
      contacts {
        ...Contact
      }
    }
    reserveNotes {
      ...ReserveDonorNote
    }
  }
}
    ${DonorFragmentDoc}
${OwnerFragmentDoc}
${ContactFragmentDoc}
${ReserveDonorNoteFragmentDoc}`;

/**
 * __useGetAppointmentsDonorsListQuery__
 *
 * To run a query within a React component, call `useGetAppointmentsDonorsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppointmentsDonorsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppointmentsDonorsListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAppointmentsDonorsListQuery(baseOptions?: Apollo.QueryHookOptions<GetAppointmentsDonorsListQuery, GetAppointmentsDonorsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppointmentsDonorsListQuery, GetAppointmentsDonorsListQueryVariables>(GetAppointmentsDonorsListDocument, options);
      }
export function useGetAppointmentsDonorsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppointmentsDonorsListQuery, GetAppointmentsDonorsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppointmentsDonorsListQuery, GetAppointmentsDonorsListQueryVariables>(GetAppointmentsDonorsListDocument, options);
        }
export type GetAppointmentsDonorsListQueryHookResult = ReturnType<typeof useGetAppointmentsDonorsListQuery>;
export type GetAppointmentsDonorsListLazyQueryHookResult = ReturnType<typeof useGetAppointmentsDonorsListLazyQuery>;
export type GetAppointmentsDonorsListQueryResult = Apollo.QueryResult<GetAppointmentsDonorsListQuery, GetAppointmentsDonorsListQueryVariables>;
export const GetDonorsListByIdsDocument = gql`
    query getDonorsListByIds($input: GetDonorsByIdsInput!) {
  getDonorsListByIds(input: $input) {
    ...Donor
    team {
      id
      title
    }
    user {
      ...Owner
      contacts {
        ...Contact
      }
    }
    reserveNotes {
      ...ReserveDonorNote
    }
  }
}
    ${DonorFragmentDoc}
${OwnerFragmentDoc}
${ContactFragmentDoc}
${ReserveDonorNoteFragmentDoc}`;

/**
 * __useGetDonorsListByIdsQuery__
 *
 * To run a query within a React component, call `useGetDonorsListByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDonorsListByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDonorsListByIdsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetDonorsListByIdsQuery(baseOptions: Apollo.QueryHookOptions<GetDonorsListByIdsQuery, GetDonorsListByIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDonorsListByIdsQuery, GetDonorsListByIdsQueryVariables>(GetDonorsListByIdsDocument, options);
      }
export function useGetDonorsListByIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDonorsListByIdsQuery, GetDonorsListByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDonorsListByIdsQuery, GetDonorsListByIdsQueryVariables>(GetDonorsListByIdsDocument, options);
        }
export type GetDonorsListByIdsQueryHookResult = ReturnType<typeof useGetDonorsListByIdsQuery>;
export type GetDonorsListByIdsLazyQueryHookResult = ReturnType<typeof useGetDonorsListByIdsLazyQuery>;
export type GetDonorsListByIdsQueryResult = Apollo.QueryResult<GetDonorsListByIdsQuery, GetDonorsListByIdsQueryVariables>;
export const FindTeamDocument = gql`
    query findTeam($input: FindTeamInput!) {
  findTeam(input: $input) {
    ...Team
    donors {
      ...Donor
    }
  }
}
    ${TeamFragmentDoc}
${DonorFragmentDoc}`;

/**
 * __useFindTeamQuery__
 *
 * To run a query within a React component, call `useFindTeamQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindTeamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindTeamQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFindTeamQuery(baseOptions: Apollo.QueryHookOptions<FindTeamQuery, FindTeamQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindTeamQuery, FindTeamQueryVariables>(FindTeamDocument, options);
      }
export function useFindTeamLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindTeamQuery, FindTeamQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindTeamQuery, FindTeamQueryVariables>(FindTeamDocument, options);
        }
export type FindTeamQueryHookResult = ReturnType<typeof useFindTeamQuery>;
export type FindTeamLazyQueryHookResult = ReturnType<typeof useFindTeamLazyQuery>;
export type FindTeamQueryResult = Apollo.QueryResult<FindTeamQuery, FindTeamQueryVariables>;
export const GetLabworkAttachmentsDocument = gql`
    query getLabworkAttachments($input: GetLabworkAttachmentsListInput!) {
  getLabworkAttachments(input: $input) {
    ...LabworkAttachment
    file {
      ...File
    }
  }
}
    ${LabworkAttachmentFragmentDoc}
${FileFragmentDoc}`;

/**
 * __useGetLabworkAttachmentsQuery__
 *
 * To run a query within a React component, call `useGetLabworkAttachmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLabworkAttachmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLabworkAttachmentsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetLabworkAttachmentsQuery(baseOptions: Apollo.QueryHookOptions<GetLabworkAttachmentsQuery, GetLabworkAttachmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLabworkAttachmentsQuery, GetLabworkAttachmentsQueryVariables>(GetLabworkAttachmentsDocument, options);
      }
export function useGetLabworkAttachmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLabworkAttachmentsQuery, GetLabworkAttachmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLabworkAttachmentsQuery, GetLabworkAttachmentsQueryVariables>(GetLabworkAttachmentsDocument, options);
        }
export type GetLabworkAttachmentsQueryHookResult = ReturnType<typeof useGetLabworkAttachmentsQuery>;
export type GetLabworkAttachmentsLazyQueryHookResult = ReturnType<typeof useGetLabworkAttachmentsLazyQuery>;
export type GetLabworkAttachmentsQueryResult = Apollo.QueryResult<GetLabworkAttachmentsQuery, GetLabworkAttachmentsQueryVariables>;
export const HasDonorRelateddataSourcesDocument = gql`
    query hasDonorRelateddataSources($input: DeleteDonorInput!) {
  hasDonorRelateddataSources(input: $input)
}
    `;

/**
 * __useHasDonorRelateddataSourcesQuery__
 *
 * To run a query within a React component, call `useHasDonorRelateddataSourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useHasDonorRelateddataSourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHasDonorRelateddataSourcesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useHasDonorRelateddataSourcesQuery(baseOptions: Apollo.QueryHookOptions<HasDonorRelateddataSourcesQuery, HasDonorRelateddataSourcesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HasDonorRelateddataSourcesQuery, HasDonorRelateddataSourcesQueryVariables>(HasDonorRelateddataSourcesDocument, options);
      }
export function useHasDonorRelateddataSourcesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HasDonorRelateddataSourcesQuery, HasDonorRelateddataSourcesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HasDonorRelateddataSourcesQuery, HasDonorRelateddataSourcesQueryVariables>(HasDonorRelateddataSourcesDocument, options);
        }
export type HasDonorRelateddataSourcesQueryHookResult = ReturnType<typeof useHasDonorRelateddataSourcesQuery>;
export type HasDonorRelateddataSourcesLazyQueryHookResult = ReturnType<typeof useHasDonorRelateddataSourcesLazyQuery>;
export type HasDonorRelateddataSourcesQueryResult = Apollo.QueryResult<HasDonorRelateddataSourcesQuery, HasDonorRelateddataSourcesQueryVariables>;
export const GetAppointmentsDatesForDonorDocument = gql`
    query getAppointmentsDatesForDonor($donorId: String!) {
  getAppointmentsDatesForDonor(donorId: $donorId) {
    id
    start
    end
  }
}
    `;

/**
 * __useGetAppointmentsDatesForDonorQuery__
 *
 * To run a query within a React component, call `useGetAppointmentsDatesForDonorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppointmentsDatesForDonorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppointmentsDatesForDonorQuery({
 *   variables: {
 *      donorId: // value for 'donorId'
 *   },
 * });
 */
export function useGetAppointmentsDatesForDonorQuery(baseOptions: Apollo.QueryHookOptions<GetAppointmentsDatesForDonorQuery, GetAppointmentsDatesForDonorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppointmentsDatesForDonorQuery, GetAppointmentsDatesForDonorQueryVariables>(GetAppointmentsDatesForDonorDocument, options);
      }
export function useGetAppointmentsDatesForDonorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppointmentsDatesForDonorQuery, GetAppointmentsDatesForDonorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppointmentsDatesForDonorQuery, GetAppointmentsDatesForDonorQueryVariables>(GetAppointmentsDatesForDonorDocument, options);
        }
export type GetAppointmentsDatesForDonorQueryHookResult = ReturnType<typeof useGetAppointmentsDatesForDonorQuery>;
export type GetAppointmentsDatesForDonorLazyQueryHookResult = ReturnType<typeof useGetAppointmentsDatesForDonorLazyQuery>;
export type GetAppointmentsDatesForDonorQueryResult = Apollo.QueryResult<GetAppointmentsDatesForDonorQuery, GetAppointmentsDatesForDonorQueryVariables>;
export const GetDonorNotesDocument = gql`
    query getDonorNotes($donorId: String!) {
  getDonorNotes(donorId: $donorId) {
    ...DonorNote
  }
}
    ${DonorNoteFragmentDoc}`;

/**
 * __useGetDonorNotesQuery__
 *
 * To run a query within a React component, call `useGetDonorNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDonorNotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDonorNotesQuery({
 *   variables: {
 *      donorId: // value for 'donorId'
 *   },
 * });
 */
export function useGetDonorNotesQuery(baseOptions: Apollo.QueryHookOptions<GetDonorNotesQuery, GetDonorNotesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDonorNotesQuery, GetDonorNotesQueryVariables>(GetDonorNotesDocument, options);
      }
export function useGetDonorNotesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDonorNotesQuery, GetDonorNotesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDonorNotesQuery, GetDonorNotesQueryVariables>(GetDonorNotesDocument, options);
        }
export type GetDonorNotesQueryHookResult = ReturnType<typeof useGetDonorNotesQuery>;
export type GetDonorNotesLazyQueryHookResult = ReturnType<typeof useGetDonorNotesLazyQuery>;
export type GetDonorNotesQueryResult = Apollo.QueryResult<GetDonorNotesQuery, GetDonorNotesQueryVariables>;
export const GetDonorsListForAnalyticsDocument = gql`
    query getDonorsListForAnalytics($input: DonorsAnalyticsInput!) {
  getDonorsListForAnalytics(input: $input) {
    data {
      ...Donor
      team {
        id
        title
      }
      user {
        ...Owner
        contacts {
          ...Contact
        }
      }
      reserveNotes {
        ...ReserveDonorNote
      }
    }
    meta {
      total
    }
  }
}
    ${DonorFragmentDoc}
${OwnerFragmentDoc}
${ContactFragmentDoc}
${ReserveDonorNoteFragmentDoc}`;

/**
 * __useGetDonorsListForAnalyticsQuery__
 *
 * To run a query within a React component, call `useGetDonorsListForAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDonorsListForAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDonorsListForAnalyticsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetDonorsListForAnalyticsQuery(baseOptions: Apollo.QueryHookOptions<GetDonorsListForAnalyticsQuery, GetDonorsListForAnalyticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDonorsListForAnalyticsQuery, GetDonorsListForAnalyticsQueryVariables>(GetDonorsListForAnalyticsDocument, options);
      }
export function useGetDonorsListForAnalyticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDonorsListForAnalyticsQuery, GetDonorsListForAnalyticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDonorsListForAnalyticsQuery, GetDonorsListForAnalyticsQueryVariables>(GetDonorsListForAnalyticsDocument, options);
        }
export type GetDonorsListForAnalyticsQueryHookResult = ReturnType<typeof useGetDonorsListForAnalyticsQuery>;
export type GetDonorsListForAnalyticsLazyQueryHookResult = ReturnType<typeof useGetDonorsListForAnalyticsLazyQuery>;
export type GetDonorsListForAnalyticsQueryResult = Apollo.QueryResult<GetDonorsListForAnalyticsQuery, GetDonorsListForAnalyticsQueryVariables>;
export const GetDonorAnalyticsDocument = gql`
    query getDonorAnalytics($input: DonorAnalyticsQueryInput!) {
  getDonorAnalytics(input: $input) {
    totalSingleDonors
    totalDoubleDonors
    totalNewDonors
    totalExperiencedDonors
    statusBreakdown {
      status
      count
    }
  }
}
    `;

/**
 * __useGetDonorAnalyticsQuery__
 *
 * To run a query within a React component, call `useGetDonorAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDonorAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDonorAnalyticsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetDonorAnalyticsQuery(baseOptions: Apollo.QueryHookOptions<GetDonorAnalyticsQuery, GetDonorAnalyticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDonorAnalyticsQuery, GetDonorAnalyticsQueryVariables>(GetDonorAnalyticsDocument, options);
      }
export function useGetDonorAnalyticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDonorAnalyticsQuery, GetDonorAnalyticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDonorAnalyticsQuery, GetDonorAnalyticsQueryVariables>(GetDonorAnalyticsDocument, options);
        }
export type GetDonorAnalyticsQueryHookResult = ReturnType<typeof useGetDonorAnalyticsQuery>;
export type GetDonorAnalyticsLazyQueryHookResult = ReturnType<typeof useGetDonorAnalyticsLazyQuery>;
export type GetDonorAnalyticsQueryResult = Apollo.QueryResult<GetDonorAnalyticsQuery, GetDonorAnalyticsQueryVariables>;
export const GetDonorPicturesDocument = gql`
    query getDonorPictures($input: GetDonorPicturesInput!) {
  getDonorPictures(input: $input) {
    ...Picture
  }
}
    ${PictureFragmentDoc}`;

/**
 * __useGetDonorPicturesQuery__
 *
 * To run a query within a React component, call `useGetDonorPicturesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDonorPicturesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDonorPicturesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetDonorPicturesQuery(baseOptions: Apollo.QueryHookOptions<GetDonorPicturesQuery, GetDonorPicturesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDonorPicturesQuery, GetDonorPicturesQueryVariables>(GetDonorPicturesDocument, options);
      }
export function useGetDonorPicturesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDonorPicturesQuery, GetDonorPicturesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDonorPicturesQuery, GetDonorPicturesQueryVariables>(GetDonorPicturesDocument, options);
        }
export type GetDonorPicturesQueryHookResult = ReturnType<typeof useGetDonorPicturesQuery>;
export type GetDonorPicturesLazyQueryHookResult = ReturnType<typeof useGetDonorPicturesLazyQuery>;
export type GetDonorPicturesQueryResult = Apollo.QueryResult<GetDonorPicturesQuery, GetDonorPicturesQueryVariables>;
export const GetDonorPipelineStatsDocument = gql`
    query getDonorPipelineStats($input: GetDonorPipelineStatsInput!) {
  getDonorPipelineStats(input: $input) {
    activeDonorCount
    pendingDonorCount
    approvedDonorCount
    registrationsByPeriod {
      period
      count
      startDate
      endDate
    }
    lastWeekDaily {
      date
      isoWeekday
      count
    }
  }
}
    `;

/**
 * __useGetDonorPipelineStatsQuery__
 *
 * To run a query within a React component, call `useGetDonorPipelineStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDonorPipelineStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDonorPipelineStatsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetDonorPipelineStatsQuery(baseOptions: Apollo.QueryHookOptions<GetDonorPipelineStatsQuery, GetDonorPipelineStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDonorPipelineStatsQuery, GetDonorPipelineStatsQueryVariables>(GetDonorPipelineStatsDocument, options);
      }
export function useGetDonorPipelineStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDonorPipelineStatsQuery, GetDonorPipelineStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDonorPipelineStatsQuery, GetDonorPipelineStatsQueryVariables>(GetDonorPipelineStatsDocument, options);
        }
export type GetDonorPipelineStatsQueryHookResult = ReturnType<typeof useGetDonorPipelineStatsQuery>;
export type GetDonorPipelineStatsLazyQueryHookResult = ReturnType<typeof useGetDonorPipelineStatsLazyQuery>;
export type GetDonorPipelineStatsQueryResult = Apollo.QueryResult<GetDonorPipelineStatsQuery, GetDonorPipelineStatsQueryVariables>;
export const GetRecruiterDashboardMetricsDocument = gql`
    query getRecruiterDashboardMetrics($input: GetRecruiterDashboardMetricsInput!) {
  getRecruiterDashboardMetrics(input: $input) {
    repeatDonorCount
    activeDonorCount
    historicalActiveDonorCount
    comparedPeriodActiveDonorCount
    firstTimeDonorCount
    quarterlyDropoutCount
    quarterlyActiveAtStart
    periodDropoutCount
    periodNewEnrollmentCount
    periodActiveAtStart
    quarterlyNewEnrollmentCount
    donorsWhoDonated
    expectedDonations
    showRate
    singleDonorCount
    doubleDonorCount
    lapsedDonorCounts
    retiredDonorCounts
  }
}
    `;

/**
 * __useGetRecruiterDashboardMetricsQuery__
 *
 * To run a query within a React component, call `useGetRecruiterDashboardMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecruiterDashboardMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecruiterDashboardMetricsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetRecruiterDashboardMetricsQuery(baseOptions: Apollo.QueryHookOptions<GetRecruiterDashboardMetricsQuery, GetRecruiterDashboardMetricsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRecruiterDashboardMetricsQuery, GetRecruiterDashboardMetricsQueryVariables>(GetRecruiterDashboardMetricsDocument, options);
      }
export function useGetRecruiterDashboardMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRecruiterDashboardMetricsQuery, GetRecruiterDashboardMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRecruiterDashboardMetricsQuery, GetRecruiterDashboardMetricsQueryVariables>(GetRecruiterDashboardMetricsDocument, options);
        }
export type GetRecruiterDashboardMetricsQueryHookResult = ReturnType<typeof useGetRecruiterDashboardMetricsQuery>;
export type GetRecruiterDashboardMetricsLazyQueryHookResult = ReturnType<typeof useGetRecruiterDashboardMetricsLazyQuery>;
export type GetRecruiterDashboardMetricsQueryResult = Apollo.QueryResult<GetRecruiterDashboardMetricsQuery, GetRecruiterDashboardMetricsQueryVariables>;
export const GetPrbcDonationDonorsDocument = gql`
    query getPrbcDonationDonors($input: GetPrbcDonationDonorsInput!) {
  getPrbcDonationDonors(input: $input) {
    donors {
      donorId
      donorShortId
      donorName
      ownerFullName
      ownerShortId
      bloodTypeDisplay
      status
      lastDonationDate
      sglDbl
      totalDonations
      periodUnits
      location
      registeredAt
      ownerPhone
      ownerEmail
      ownerCity
      ownerState
      ownerContactPreferences
      ownerAssignedLocations
      breed
      dateOfBirth
      region
      retiredDate
      retiredReason
      activeDate
      approvedDate
      archivedDate
    }
    total
  }
}
    `;

/**
 * __useGetPrbcDonationDonorsQuery__
 *
 * To run a query within a React component, call `useGetPrbcDonationDonorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPrbcDonationDonorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPrbcDonationDonorsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetPrbcDonationDonorsQuery(baseOptions: Apollo.QueryHookOptions<GetPrbcDonationDonorsQuery, GetPrbcDonationDonorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPrbcDonationDonorsQuery, GetPrbcDonationDonorsQueryVariables>(GetPrbcDonationDonorsDocument, options);
      }
export function useGetPrbcDonationDonorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPrbcDonationDonorsQuery, GetPrbcDonationDonorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPrbcDonationDonorsQuery, GetPrbcDonationDonorsQueryVariables>(GetPrbcDonationDonorsDocument, options);
        }
export type GetPrbcDonationDonorsQueryHookResult = ReturnType<typeof useGetPrbcDonationDonorsQuery>;
export type GetPrbcDonationDonorsLazyQueryHookResult = ReturnType<typeof useGetPrbcDonationDonorsLazyQuery>;
export type GetPrbcDonationDonorsQueryResult = Apollo.QueryResult<GetPrbcDonationDonorsQuery, GetPrbcDonationDonorsQueryVariables>;
export const GetDonorDonationHistoryDocument = gql`
    query getDonorDonationHistory($input: GetDonorDonationHistoryInput!) {
  getDonorDonationHistory(input: $input) {
    donations {
      id
      shortId
      date
      donorName
      locationName
      regionName
      type
      approvedML
      status
    }
    total
  }
}
    `;

/**
 * __useGetDonorDonationHistoryQuery__
 *
 * To run a query within a React component, call `useGetDonorDonationHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDonorDonationHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDonorDonationHistoryQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetDonorDonationHistoryQuery(baseOptions: Apollo.QueryHookOptions<GetDonorDonationHistoryQuery, GetDonorDonationHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDonorDonationHistoryQuery, GetDonorDonationHistoryQueryVariables>(GetDonorDonationHistoryDocument, options);
      }
export function useGetDonorDonationHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDonorDonationHistoryQuery, GetDonorDonationHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDonorDonationHistoryQuery, GetDonorDonationHistoryQueryVariables>(GetDonorDonationHistoryDocument, options);
        }
export type GetDonorDonationHistoryQueryHookResult = ReturnType<typeof useGetDonorDonationHistoryQuery>;
export type GetDonorDonationHistoryLazyQueryHookResult = ReturnType<typeof useGetDonorDonationHistoryLazyQuery>;
export type GetDonorDonationHistoryQueryResult = Apollo.QueryResult<GetDonorDonationHistoryQuery, GetDonorDonationHistoryQueryVariables>;
export const GetChurnRateHistoryDocument = gql`
    query getChurnRateHistory($input: GetChurnRateHistoryInput!) {
  getChurnRateHistory(input: $input) {
    periods {
      label
      churnRate
      dropoutCount
      enrollmentCount
      activeAtStart
      periodStart
      periodEnd
    }
  }
}
    `;

/**
 * __useGetChurnRateHistoryQuery__
 *
 * To run a query within a React component, call `useGetChurnRateHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChurnRateHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChurnRateHistoryQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetChurnRateHistoryQuery(baseOptions: Apollo.QueryHookOptions<GetChurnRateHistoryQuery, GetChurnRateHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChurnRateHistoryQuery, GetChurnRateHistoryQueryVariables>(GetChurnRateHistoryDocument, options);
      }
export function useGetChurnRateHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChurnRateHistoryQuery, GetChurnRateHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChurnRateHistoryQuery, GetChurnRateHistoryQueryVariables>(GetChurnRateHistoryDocument, options);
        }
export type GetChurnRateHistoryQueryHookResult = ReturnType<typeof useGetChurnRateHistoryQuery>;
export type GetChurnRateHistoryLazyQueryHookResult = ReturnType<typeof useGetChurnRateHistoryLazyQuery>;
export type GetChurnRateHistoryQueryResult = Apollo.QueryResult<GetChurnRateHistoryQuery, GetChurnRateHistoryQueryVariables>;
export const GetRetentionHistoryDocument = gql`
    query getRetentionHistory($input: GetMetricsHistoryInput!) {
  getRetentionHistory(input: $input) {
    periods {
      label
      retentionScore
      repeatDonorCount
      activeDonorCount
      periodStart
      periodEnd
    }
  }
}
    `;

/**
 * __useGetRetentionHistoryQuery__
 *
 * To run a query within a React component, call `useGetRetentionHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRetentionHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRetentionHistoryQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetRetentionHistoryQuery(baseOptions: Apollo.QueryHookOptions<GetRetentionHistoryQuery, GetRetentionHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRetentionHistoryQuery, GetRetentionHistoryQueryVariables>(GetRetentionHistoryDocument, options);
      }
export function useGetRetentionHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRetentionHistoryQuery, GetRetentionHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRetentionHistoryQuery, GetRetentionHistoryQueryVariables>(GetRetentionHistoryDocument, options);
        }
export type GetRetentionHistoryQueryHookResult = ReturnType<typeof useGetRetentionHistoryQuery>;
export type GetRetentionHistoryLazyQueryHookResult = ReturnType<typeof useGetRetentionHistoryLazyQuery>;
export type GetRetentionHistoryQueryResult = Apollo.QueryResult<GetRetentionHistoryQuery, GetRetentionHistoryQueryVariables>;
export const GetDropoutHistoryDocument = gql`
    query getDropoutHistory($input: GetMetricsHistoryInput!) {
  getDropoutHistory(input: $input) {
    periods {
      label
      dropoutRate
      dropoutCount
      activeAtStart
      periodStart
      periodEnd
    }
  }
}
    `;

/**
 * __useGetDropoutHistoryQuery__
 *
 * To run a query within a React component, call `useGetDropoutHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDropoutHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDropoutHistoryQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetDropoutHistoryQuery(baseOptions: Apollo.QueryHookOptions<GetDropoutHistoryQuery, GetDropoutHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDropoutHistoryQuery, GetDropoutHistoryQueryVariables>(GetDropoutHistoryDocument, options);
      }
export function useGetDropoutHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDropoutHistoryQuery, GetDropoutHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDropoutHistoryQuery, GetDropoutHistoryQueryVariables>(GetDropoutHistoryDocument, options);
        }
export type GetDropoutHistoryQueryHookResult = ReturnType<typeof useGetDropoutHistoryQuery>;
export type GetDropoutHistoryLazyQueryHookResult = ReturnType<typeof useGetDropoutHistoryLazyQuery>;
export type GetDropoutHistoryQueryResult = Apollo.QueryResult<GetDropoutHistoryQuery, GetDropoutHistoryQueryVariables>;
export const GetRatioHistoryDocument = gql`
    query getRatioHistory($input: GetMetricsHistoryInput!) {
  getRatioHistory(input: $input) {
    periods {
      label
      firstTimePct
      firstTimeDonorCount
      repeatDonorCount
      activeDonorCount
      periodStart
      periodEnd
    }
  }
}
    `;

/**
 * __useGetRatioHistoryQuery__
 *
 * To run a query within a React component, call `useGetRatioHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRatioHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRatioHistoryQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetRatioHistoryQuery(baseOptions: Apollo.QueryHookOptions<GetRatioHistoryQuery, GetRatioHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRatioHistoryQuery, GetRatioHistoryQueryVariables>(GetRatioHistoryDocument, options);
      }
export function useGetRatioHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRatioHistoryQuery, GetRatioHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRatioHistoryQuery, GetRatioHistoryQueryVariables>(GetRatioHistoryDocument, options);
        }
export type GetRatioHistoryQueryHookResult = ReturnType<typeof useGetRatioHistoryQuery>;
export type GetRatioHistoryLazyQueryHookResult = ReturnType<typeof useGetRatioHistoryLazyQuery>;
export type GetRatioHistoryQueryResult = Apollo.QueryResult<GetRatioHistoryQuery, GetRatioHistoryQueryVariables>;
export const GetShowRateHistoryDocument = gql`
    query getShowRateHistory($input: GetMetricsHistoryInput!) {
  getShowRateHistory(input: $input) {
    periods {
      label
      showRate
      donorsWhoDonated
      expectedDonations
      periodStart
      periodEnd
    }
  }
}
    `;

/**
 * __useGetShowRateHistoryQuery__
 *
 * To run a query within a React component, call `useGetShowRateHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShowRateHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShowRateHistoryQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetShowRateHistoryQuery(baseOptions: Apollo.QueryHookOptions<GetShowRateHistoryQuery, GetShowRateHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetShowRateHistoryQuery, GetShowRateHistoryQueryVariables>(GetShowRateHistoryDocument, options);
      }
export function useGetShowRateHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetShowRateHistoryQuery, GetShowRateHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetShowRateHistoryQuery, GetShowRateHistoryQueryVariables>(GetShowRateHistoryDocument, options);
        }
export type GetShowRateHistoryQueryHookResult = ReturnType<typeof useGetShowRateHistoryQuery>;
export type GetShowRateHistoryLazyQueryHookResult = ReturnType<typeof useGetShowRateHistoryLazyQuery>;
export type GetShowRateHistoryQueryResult = Apollo.QueryResult<GetShowRateHistoryQuery, GetShowRateHistoryQueryVariables>;
export const GetMicrochipPriceDocument = gql`
    query getMicrochipPrice {
  getMicrochipPrice {
    price
  }
}
    `;

/**
 * __useGetMicrochipPriceQuery__
 *
 * To run a query within a React component, call `useGetMicrochipPriceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMicrochipPriceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMicrochipPriceQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMicrochipPriceQuery(baseOptions?: Apollo.QueryHookOptions<GetMicrochipPriceQuery, GetMicrochipPriceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMicrochipPriceQuery, GetMicrochipPriceQueryVariables>(GetMicrochipPriceDocument, options);
      }
export function useGetMicrochipPriceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMicrochipPriceQuery, GetMicrochipPriceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMicrochipPriceQuery, GetMicrochipPriceQueryVariables>(GetMicrochipPriceDocument, options);
        }
export type GetMicrochipPriceQueryHookResult = ReturnType<typeof useGetMicrochipPriceQuery>;
export type GetMicrochipPriceLazyQueryHookResult = ReturnType<typeof useGetMicrochipPriceLazyQuery>;
export type GetMicrochipPriceQueryResult = Apollo.QueryResult<GetMicrochipPriceQuery, GetMicrochipPriceQueryVariables>;
export const GetDonorContactFlagsDocument = gql`
    query getDonorContactFlags($donorIds: [String!]!) {
  getDonorContactFlags(donorIds: $donorIds)
}
    `;

/**
 * __useGetDonorContactFlagsQuery__
 *
 * To run a query within a React component, call `useGetDonorContactFlagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDonorContactFlagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDonorContactFlagsQuery({
 *   variables: {
 *      donorIds: // value for 'donorIds'
 *   },
 * });
 */
export function useGetDonorContactFlagsQuery(baseOptions: Apollo.QueryHookOptions<GetDonorContactFlagsQuery, GetDonorContactFlagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDonorContactFlagsQuery, GetDonorContactFlagsQueryVariables>(GetDonorContactFlagsDocument, options);
      }
export function useGetDonorContactFlagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDonorContactFlagsQuery, GetDonorContactFlagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDonorContactFlagsQuery, GetDonorContactFlagsQueryVariables>(GetDonorContactFlagsDocument, options);
        }
export type GetDonorContactFlagsQueryHookResult = ReturnType<typeof useGetDonorContactFlagsQuery>;
export type GetDonorContactFlagsLazyQueryHookResult = ReturnType<typeof useGetDonorContactFlagsLazyQuery>;
export type GetDonorContactFlagsQueryResult = Apollo.QueryResult<GetDonorContactFlagsQuery, GetDonorContactFlagsQueryVariables>;
export const GetDonorContactsDocument = gql`
    query getDonorContacts($donorId: String!) {
  getDonorContacts(donorId: $donorId) {
    id
    donorId
    contactType
    notes
    followUpDate
    user {
      id
      firstName
      lastName
    }
    createdAt
  }
}
    `;

/**
 * __useGetDonorContactsQuery__
 *
 * To run a query within a React component, call `useGetDonorContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDonorContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDonorContactsQuery({
 *   variables: {
 *      donorId: // value for 'donorId'
 *   },
 * });
 */
export function useGetDonorContactsQuery(baseOptions: Apollo.QueryHookOptions<GetDonorContactsQuery, GetDonorContactsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDonorContactsQuery, GetDonorContactsQueryVariables>(GetDonorContactsDocument, options);
      }
export function useGetDonorContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDonorContactsQuery, GetDonorContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDonorContactsQuery, GetDonorContactsQueryVariables>(GetDonorContactsDocument, options);
        }
export type GetDonorContactsQueryHookResult = ReturnType<typeof useGetDonorContactsQuery>;
export type GetDonorContactsLazyQueryHookResult = ReturnType<typeof useGetDonorContactsLazyQuery>;
export type GetDonorContactsQueryResult = Apollo.QueryResult<GetDonorContactsQuery, GetDonorContactsQueryVariables>;
export const DeleteInvitationDocument = gql`
    mutation deleteInvitation($id: String!) {
  deleteInvitation(id: $id)
}
    `;
export type DeleteInvitationMutationFn = Apollo.MutationFunction<DeleteInvitationMutation, DeleteInvitationMutationVariables>;

/**
 * __useDeleteInvitationMutation__
 *
 * To run a mutation, you first call `useDeleteInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteInvitationMutation, { data, loading, error }] = useDeleteInvitationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteInvitationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteInvitationMutation, DeleteInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteInvitationMutation, DeleteInvitationMutationVariables>(DeleteInvitationDocument, options);
      }
export type DeleteInvitationMutationHookResult = ReturnType<typeof useDeleteInvitationMutation>;
export type DeleteInvitationMutationResult = Apollo.MutationResult<DeleteInvitationMutation>;
export type DeleteInvitationMutationOptions = Apollo.BaseMutationOptions<DeleteInvitationMutation, DeleteInvitationMutationVariables>;
export const GetInvitationsListDocument = gql`
    query getInvitationsList($input: GetInvitationListInput!) {
  getInvitationsList(input: $input) {
    data {
      ...Invitation
    }
    meta {
      total
    }
  }
}
    ${InvitationFragmentDoc}`;

/**
 * __useGetInvitationsListQuery__
 *
 * To run a query within a React component, call `useGetInvitationsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvitationsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvitationsListQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetInvitationsListQuery(baseOptions: Apollo.QueryHookOptions<GetInvitationsListQuery, GetInvitationsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInvitationsListQuery, GetInvitationsListQueryVariables>(GetInvitationsListDocument, options);
      }
export function useGetInvitationsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInvitationsListQuery, GetInvitationsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInvitationsListQuery, GetInvitationsListQueryVariables>(GetInvitationsListDocument, options);
        }
export type GetInvitationsListQueryHookResult = ReturnType<typeof useGetInvitationsListQuery>;
export type GetInvitationsListLazyQueryHookResult = ReturnType<typeof useGetInvitationsListLazyQuery>;
export type GetInvitationsListQueryResult = Apollo.QueryResult<GetInvitationsListQuery, GetInvitationsListQueryVariables>;
export const CreateLocationDocument = gql`
    mutation createLocation($input: CreateLocationInput!) {
  createLocation(input: $input) {
    ...Location
  }
}
    ${LocationFragmentDoc}`;
export type CreateLocationMutationFn = Apollo.MutationFunction<CreateLocationMutation, CreateLocationMutationVariables>;

/**
 * __useCreateLocationMutation__
 *
 * To run a mutation, you first call `useCreateLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLocationMutation, { data, loading, error }] = useCreateLocationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateLocationMutation(baseOptions?: Apollo.MutationHookOptions<CreateLocationMutation, CreateLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLocationMutation, CreateLocationMutationVariables>(CreateLocationDocument, options);
      }
export type CreateLocationMutationHookResult = ReturnType<typeof useCreateLocationMutation>;
export type CreateLocationMutationResult = Apollo.MutationResult<CreateLocationMutation>;
export type CreateLocationMutationOptions = Apollo.BaseMutationOptions<CreateLocationMutation, CreateLocationMutationVariables>;
export const UpdateLocationDocument = gql`
    mutation updateLocation($input: UpdateLocationInput!) {
  updateLocation(input: $input) {
    ...Location
  }
}
    ${LocationFragmentDoc}`;
export type UpdateLocationMutationFn = Apollo.MutationFunction<UpdateLocationMutation, UpdateLocationMutationVariables>;

/**
 * __useUpdateLocationMutation__
 *
 * To run a mutation, you first call `useUpdateLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLocationMutation, { data, loading, error }] = useUpdateLocationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLocationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLocationMutation, UpdateLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLocationMutation, UpdateLocationMutationVariables>(UpdateLocationDocument, options);
      }
export type UpdateLocationMutationHookResult = ReturnType<typeof useUpdateLocationMutation>;
export type UpdateLocationMutationResult = Apollo.MutationResult<UpdateLocationMutation>;
export type UpdateLocationMutationOptions = Apollo.BaseMutationOptions<UpdateLocationMutation, UpdateLocationMutationVariables>;
export const DeleteLocationDocument = gql`
    mutation deleteLocation($input: DeleteLocationInput!) {
  deleteLocation(input: $input)
}
    `;
export type DeleteLocationMutationFn = Apollo.MutationFunction<DeleteLocationMutation, DeleteLocationMutationVariables>;

/**
 * __useDeleteLocationMutation__
 *
 * To run a mutation, you first call `useDeleteLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLocationMutation, { data, loading, error }] = useDeleteLocationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteLocationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLocationMutation, DeleteLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLocationMutation, DeleteLocationMutationVariables>(DeleteLocationDocument, options);
      }
export type DeleteLocationMutationHookResult = ReturnType<typeof useDeleteLocationMutation>;
export type DeleteLocationMutationResult = Apollo.MutationResult<DeleteLocationMutation>;
export type DeleteLocationMutationOptions = Apollo.BaseMutationOptions<DeleteLocationMutation, DeleteLocationMutationVariables>;
export const CreateRegionDocument = gql`
    mutation createRegion($input: CreateRegionInput!) {
  createRegion(input: $input) {
    ...Region
  }
}
    ${RegionFragmentDoc}`;
export type CreateRegionMutationFn = Apollo.MutationFunction<CreateRegionMutation, CreateRegionMutationVariables>;

/**
 * __useCreateRegionMutation__
 *
 * To run a mutation, you first call `useCreateRegionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRegionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRegionMutation, { data, loading, error }] = useCreateRegionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateRegionMutation(baseOptions?: Apollo.MutationHookOptions<CreateRegionMutation, CreateRegionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRegionMutation, CreateRegionMutationVariables>(CreateRegionDocument, options);
      }
export type CreateRegionMutationHookResult = ReturnType<typeof useCreateRegionMutation>;
export type CreateRegionMutationResult = Apollo.MutationResult<CreateRegionMutation>;
export type CreateRegionMutationOptions = Apollo.BaseMutationOptions<CreateRegionMutation, CreateRegionMutationVariables>;
export const UpdateRegionDocument = gql`
    mutation updateRegion($input: UpdateRegionInput!) {
  updateRegion(input: $input) {
    ...Region
  }
}
    ${RegionFragmentDoc}`;
export type UpdateRegionMutationFn = Apollo.MutationFunction<UpdateRegionMutation, UpdateRegionMutationVariables>;

/**
 * __useUpdateRegionMutation__
 *
 * To run a mutation, you first call `useUpdateRegionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRegionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRegionMutation, { data, loading, error }] = useUpdateRegionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateRegionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRegionMutation, UpdateRegionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRegionMutation, UpdateRegionMutationVariables>(UpdateRegionDocument, options);
      }
export type UpdateRegionMutationHookResult = ReturnType<typeof useUpdateRegionMutation>;
export type UpdateRegionMutationResult = Apollo.MutationResult<UpdateRegionMutation>;
export type UpdateRegionMutationOptions = Apollo.BaseMutationOptions<UpdateRegionMutation, UpdateRegionMutationVariables>;
export const DeleteRegionDocument = gql`
    mutation deleteRegion($input: DeleteRegionInput!) {
  deleteRegion(input: $input)
}
    `;
export type DeleteRegionMutationFn = Apollo.MutationFunction<DeleteRegionMutation, DeleteRegionMutationVariables>;

/**
 * __useDeleteRegionMutation__
 *
 * To run a mutation, you first call `useDeleteRegionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRegionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRegionMutation, { data, loading, error }] = useDeleteRegionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteRegionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRegionMutation, DeleteRegionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRegionMutation, DeleteRegionMutationVariables>(DeleteRegionDocument, options);
      }
export type DeleteRegionMutationHookResult = ReturnType<typeof useDeleteRegionMutation>;
export type DeleteRegionMutationResult = Apollo.MutationResult<DeleteRegionMutation>;
export type DeleteRegionMutationOptions = Apollo.BaseMutationOptions<DeleteRegionMutation, DeleteRegionMutationVariables>;
export const CreateOfficeDocument = gql`
    mutation createOffice($input: CreateOfficeInput!) {
  createOffice(input: $input) {
    ...Office
  }
}
    ${OfficeFragmentDoc}`;
export type CreateOfficeMutationFn = Apollo.MutationFunction<CreateOfficeMutation, CreateOfficeMutationVariables>;

/**
 * __useCreateOfficeMutation__
 *
 * To run a mutation, you first call `useCreateOfficeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOfficeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOfficeMutation, { data, loading, error }] = useCreateOfficeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOfficeMutation(baseOptions?: Apollo.MutationHookOptions<CreateOfficeMutation, CreateOfficeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOfficeMutation, CreateOfficeMutationVariables>(CreateOfficeDocument, options);
      }
export type CreateOfficeMutationHookResult = ReturnType<typeof useCreateOfficeMutation>;
export type CreateOfficeMutationResult = Apollo.MutationResult<CreateOfficeMutation>;
export type CreateOfficeMutationOptions = Apollo.BaseMutationOptions<CreateOfficeMutation, CreateOfficeMutationVariables>;
export const UpdateOfficeDocument = gql`
    mutation updateOffice($input: UpdateOfficeInput!) {
  updateOffice(input: $input) {
    ...Office
  }
}
    ${OfficeFragmentDoc}`;
export type UpdateOfficeMutationFn = Apollo.MutationFunction<UpdateOfficeMutation, UpdateOfficeMutationVariables>;

/**
 * __useUpdateOfficeMutation__
 *
 * To run a mutation, you first call `useUpdateOfficeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOfficeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOfficeMutation, { data, loading, error }] = useUpdateOfficeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOfficeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOfficeMutation, UpdateOfficeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOfficeMutation, UpdateOfficeMutationVariables>(UpdateOfficeDocument, options);
      }
export type UpdateOfficeMutationHookResult = ReturnType<typeof useUpdateOfficeMutation>;
export type UpdateOfficeMutationResult = Apollo.MutationResult<UpdateOfficeMutation>;
export type UpdateOfficeMutationOptions = Apollo.BaseMutationOptions<UpdateOfficeMutation, UpdateOfficeMutationVariables>;
export const DeleteOfficeDocument = gql`
    mutation deleteOffice($input: DeleteOfficeInput!) {
  deleteOffice(input: $input)
}
    `;
export type DeleteOfficeMutationFn = Apollo.MutationFunction<DeleteOfficeMutation, DeleteOfficeMutationVariables>;

/**
 * __useDeleteOfficeMutation__
 *
 * To run a mutation, you first call `useDeleteOfficeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOfficeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOfficeMutation, { data, loading, error }] = useDeleteOfficeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteOfficeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOfficeMutation, DeleteOfficeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOfficeMutation, DeleteOfficeMutationVariables>(DeleteOfficeDocument, options);
      }
export type DeleteOfficeMutationHookResult = ReturnType<typeof useDeleteOfficeMutation>;
export type DeleteOfficeMutationResult = Apollo.MutationResult<DeleteOfficeMutation>;
export type DeleteOfficeMutationOptions = Apollo.BaseMutationOptions<DeleteOfficeMutation, DeleteOfficeMutationVariables>;
export const GetLocationsDocument = gql`
    query getLocations($input: GetLocationsInput!) {
  getLocations(input: $input) {
    data {
      ...Location
    }
    meta {
      total
    }
  }
}
    ${LocationFragmentDoc}`;

/**
 * __useGetLocationsQuery__
 *
 * To run a query within a React component, call `useGetLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetLocationsQuery(baseOptions: Apollo.QueryHookOptions<GetLocationsQuery, GetLocationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocationsQuery, GetLocationsQueryVariables>(GetLocationsDocument, options);
      }
export function useGetLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocationsQuery, GetLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocationsQuery, GetLocationsQueryVariables>(GetLocationsDocument, options);
        }
export type GetLocationsQueryHookResult = ReturnType<typeof useGetLocationsQuery>;
export type GetLocationsLazyQueryHookResult = ReturnType<typeof useGetLocationsLazyQuery>;
export type GetLocationsQueryResult = Apollo.QueryResult<GetLocationsQuery, GetLocationsQueryVariables>;
export const GetPublicLocationsDocument = gql`
    query getPublicLocations($input: GetPublicLocationsInput!) {
  getPublicLocations(input: $input) {
    data {
      ...Location
    }
    meta {
      total
    }
  }
}
    ${LocationFragmentDoc}`;

/**
 * __useGetPublicLocationsQuery__
 *
 * To run a query within a React component, call `useGetPublicLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublicLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPublicLocationsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetPublicLocationsQuery(baseOptions: Apollo.QueryHookOptions<GetPublicLocationsQuery, GetPublicLocationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPublicLocationsQuery, GetPublicLocationsQueryVariables>(GetPublicLocationsDocument, options);
      }
export function useGetPublicLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPublicLocationsQuery, GetPublicLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPublicLocationsQuery, GetPublicLocationsQueryVariables>(GetPublicLocationsDocument, options);
        }
export type GetPublicLocationsQueryHookResult = ReturnType<typeof useGetPublicLocationsQuery>;
export type GetPublicLocationsLazyQueryHookResult = ReturnType<typeof useGetPublicLocationsLazyQuery>;
export type GetPublicLocationsQueryResult = Apollo.QueryResult<GetPublicLocationsQuery, GetPublicLocationsQueryVariables>;
export const GetLocationWithAvailableDaycareDocument = gql`
    query getLocationWithAvailableDaycare {
  getLocationWithAvailableDaycare {
    ...Location
  }
}
    ${LocationFragmentDoc}`;

/**
 * __useGetLocationWithAvailableDaycareQuery__
 *
 * To run a query within a React component, call `useGetLocationWithAvailableDaycareQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationWithAvailableDaycareQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationWithAvailableDaycareQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLocationWithAvailableDaycareQuery(baseOptions?: Apollo.QueryHookOptions<GetLocationWithAvailableDaycareQuery, GetLocationWithAvailableDaycareQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocationWithAvailableDaycareQuery, GetLocationWithAvailableDaycareQueryVariables>(GetLocationWithAvailableDaycareDocument, options);
      }
export function useGetLocationWithAvailableDaycareLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocationWithAvailableDaycareQuery, GetLocationWithAvailableDaycareQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocationWithAvailableDaycareQuery, GetLocationWithAvailableDaycareQueryVariables>(GetLocationWithAvailableDaycareDocument, options);
        }
export type GetLocationWithAvailableDaycareQueryHookResult = ReturnType<typeof useGetLocationWithAvailableDaycareQuery>;
export type GetLocationWithAvailableDaycareLazyQueryHookResult = ReturnType<typeof useGetLocationWithAvailableDaycareLazyQuery>;
export type GetLocationWithAvailableDaycareQueryResult = Apollo.QueryResult<GetLocationWithAvailableDaycareQuery, GetLocationWithAvailableDaycareQueryVariables>;
export const GetRegionsDocument = gql`
    query getRegions {
  getRegions {
    ...Region
  }
}
    ${RegionFragmentDoc}`;

/**
 * __useGetRegionsQuery__
 *
 * To run a query within a React component, call `useGetRegionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRegionsQuery(baseOptions?: Apollo.QueryHookOptions<GetRegionsQuery, GetRegionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRegionsQuery, GetRegionsQueryVariables>(GetRegionsDocument, options);
      }
export function useGetRegionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRegionsQuery, GetRegionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRegionsQuery, GetRegionsQueryVariables>(GetRegionsDocument, options);
        }
export type GetRegionsQueryHookResult = ReturnType<typeof useGetRegionsQuery>;
export type GetRegionsLazyQueryHookResult = ReturnType<typeof useGetRegionsLazyQuery>;
export type GetRegionsQueryResult = Apollo.QueryResult<GetRegionsQuery, GetRegionsQueryVariables>;
export const GetPublicRegionsDocument = gql`
    query getPublicRegions {
  getPublicRegions {
    id
    name
  }
}
    `;

/**
 * __useGetPublicRegionsQuery__
 *
 * To run a query within a React component, call `useGetPublicRegionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublicRegionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPublicRegionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPublicRegionsQuery(baseOptions?: Apollo.QueryHookOptions<GetPublicRegionsQuery, GetPublicRegionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPublicRegionsQuery, GetPublicRegionsQueryVariables>(GetPublicRegionsDocument, options);
      }
export function useGetPublicRegionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPublicRegionsQuery, GetPublicRegionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPublicRegionsQuery, GetPublicRegionsQueryVariables>(GetPublicRegionsDocument, options);
        }
export type GetPublicRegionsQueryHookResult = ReturnType<typeof useGetPublicRegionsQuery>;
export type GetPublicRegionsLazyQueryHookResult = ReturnType<typeof useGetPublicRegionsLazyQuery>;
export type GetPublicRegionsQueryResult = Apollo.QueryResult<GetPublicRegionsQuery, GetPublicRegionsQueryVariables>;
export const GetOfficesDocument = gql`
    query getOffices {
  getOffices {
    ...Office
  }
}
    ${OfficeFragmentDoc}`;

/**
 * __useGetOfficesQuery__
 *
 * To run a query within a React component, call `useGetOfficesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOfficesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOfficesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOfficesQuery(baseOptions?: Apollo.QueryHookOptions<GetOfficesQuery, GetOfficesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOfficesQuery, GetOfficesQueryVariables>(GetOfficesDocument, options);
      }
export function useGetOfficesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOfficesQuery, GetOfficesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOfficesQuery, GetOfficesQueryVariables>(GetOfficesDocument, options);
        }
export type GetOfficesQueryHookResult = ReturnType<typeof useGetOfficesQuery>;
export type GetOfficesLazyQueryHookResult = ReturnType<typeof useGetOfficesLazyQuery>;
export type GetOfficesQueryResult = Apollo.QueryResult<GetOfficesQuery, GetOfficesQueryVariables>;
export const SaveNightlyCountDocument = gql`
    mutation saveNightlyCount($input: SaveNightlyCountInput!) {
  saveNightlyCount(input: $input) {
    ...NightlyCount
  }
}
    ${NightlyCountFragmentDoc}`;
export type SaveNightlyCountMutationFn = Apollo.MutationFunction<SaveNightlyCountMutation, SaveNightlyCountMutationVariables>;

/**
 * __useSaveNightlyCountMutation__
 *
 * To run a mutation, you first call `useSaveNightlyCountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveNightlyCountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveNightlyCountMutation, { data, loading, error }] = useSaveNightlyCountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveNightlyCountMutation(baseOptions?: Apollo.MutationHookOptions<SaveNightlyCountMutation, SaveNightlyCountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveNightlyCountMutation, SaveNightlyCountMutationVariables>(SaveNightlyCountDocument, options);
      }
export type SaveNightlyCountMutationHookResult = ReturnType<typeof useSaveNightlyCountMutation>;
export type SaveNightlyCountMutationResult = Apollo.MutationResult<SaveNightlyCountMutation>;
export type SaveNightlyCountMutationOptions = Apollo.BaseMutationOptions<SaveNightlyCountMutation, SaveNightlyCountMutationVariables>;
export const DeleteNightlyCountDocument = gql`
    mutation deleteNightlyCount($input: NightlyCountIdInput!) {
  deleteNightlyCount(input: $input)
}
    `;
export type DeleteNightlyCountMutationFn = Apollo.MutationFunction<DeleteNightlyCountMutation, DeleteNightlyCountMutationVariables>;

/**
 * __useDeleteNightlyCountMutation__
 *
 * To run a mutation, you first call `useDeleteNightlyCountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteNightlyCountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteNightlyCountMutation, { data, loading, error }] = useDeleteNightlyCountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteNightlyCountMutation(baseOptions?: Apollo.MutationHookOptions<DeleteNightlyCountMutation, DeleteNightlyCountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteNightlyCountMutation, DeleteNightlyCountMutationVariables>(DeleteNightlyCountDocument, options);
      }
export type DeleteNightlyCountMutationHookResult = ReturnType<typeof useDeleteNightlyCountMutation>;
export type DeleteNightlyCountMutationResult = Apollo.MutationResult<DeleteNightlyCountMutation>;
export type DeleteNightlyCountMutationOptions = Apollo.BaseMutationOptions<DeleteNightlyCountMutation, DeleteNightlyCountMutationVariables>;
export const ResendNightlyCountDocument = gql`
    mutation resendNightlyCount($input: NightlyCountIdInput!) {
  resendNightlyCount(input: $input)
}
    `;
export type ResendNightlyCountMutationFn = Apollo.MutationFunction<ResendNightlyCountMutation, ResendNightlyCountMutationVariables>;

/**
 * __useResendNightlyCountMutation__
 *
 * To run a mutation, you first call `useResendNightlyCountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendNightlyCountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendNightlyCountMutation, { data, loading, error }] = useResendNightlyCountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResendNightlyCountMutation(baseOptions?: Apollo.MutationHookOptions<ResendNightlyCountMutation, ResendNightlyCountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendNightlyCountMutation, ResendNightlyCountMutationVariables>(ResendNightlyCountDocument, options);
      }
export type ResendNightlyCountMutationHookResult = ReturnType<typeof useResendNightlyCountMutation>;
export type ResendNightlyCountMutationResult = Apollo.MutationResult<ResendNightlyCountMutation>;
export type ResendNightlyCountMutationOptions = Apollo.BaseMutationOptions<ResendNightlyCountMutation, ResendNightlyCountMutationVariables>;
export const GetNightlyCountForTodayDocument = gql`
    query getNightlyCountForToday($input: GetNightlyCountForTodayInput!) {
  getNightlyCountForToday(input: $input) {
    ...NightlyCount
  }
}
    ${NightlyCountFragmentDoc}`;

/**
 * __useGetNightlyCountForTodayQuery__
 *
 * To run a query within a React component, call `useGetNightlyCountForTodayQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNightlyCountForTodayQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNightlyCountForTodayQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetNightlyCountForTodayQuery(baseOptions: Apollo.QueryHookOptions<GetNightlyCountForTodayQuery, GetNightlyCountForTodayQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNightlyCountForTodayQuery, GetNightlyCountForTodayQueryVariables>(GetNightlyCountForTodayDocument, options);
      }
export function useGetNightlyCountForTodayLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNightlyCountForTodayQuery, GetNightlyCountForTodayQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNightlyCountForTodayQuery, GetNightlyCountForTodayQueryVariables>(GetNightlyCountForTodayDocument, options);
        }
export type GetNightlyCountForTodayQueryHookResult = ReturnType<typeof useGetNightlyCountForTodayQuery>;
export type GetNightlyCountForTodayLazyQueryHookResult = ReturnType<typeof useGetNightlyCountForTodayLazyQuery>;
export type GetNightlyCountForTodayQueryResult = Apollo.QueryResult<GetNightlyCountForTodayQuery, GetNightlyCountForTodayQueryVariables>;
export const GetNightlyCountsListDocument = gql`
    query getNightlyCountsList($input: GetNightlyCountsListInput!) {
  getNightlyCountsList(input: $input) {
    data {
      ...NightlyCount
    }
    meta {
      total
    }
  }
}
    ${NightlyCountFragmentDoc}`;

/**
 * __useGetNightlyCountsListQuery__
 *
 * To run a query within a React component, call `useGetNightlyCountsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNightlyCountsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNightlyCountsListQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetNightlyCountsListQuery(baseOptions: Apollo.QueryHookOptions<GetNightlyCountsListQuery, GetNightlyCountsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNightlyCountsListQuery, GetNightlyCountsListQueryVariables>(GetNightlyCountsListDocument, options);
      }
export function useGetNightlyCountsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNightlyCountsListQuery, GetNightlyCountsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNightlyCountsListQuery, GetNightlyCountsListQueryVariables>(GetNightlyCountsListDocument, options);
        }
export type GetNightlyCountsListQueryHookResult = ReturnType<typeof useGetNightlyCountsListQuery>;
export type GetNightlyCountsListLazyQueryHookResult = ReturnType<typeof useGetNightlyCountsListLazyQuery>;
export type GetNightlyCountsListQueryResult = Apollo.QueryResult<GetNightlyCountsListQuery, GetNightlyCountsListQueryVariables>;
export const GetNightlyCountOfficesForCurrentUserDocument = gql`
    query getNightlyCountOfficesForCurrentUser {
  getNightlyCountOfficesForCurrentUser {
    id
    name
    regionName
  }
}
    `;

/**
 * __useGetNightlyCountOfficesForCurrentUserQuery__
 *
 * To run a query within a React component, call `useGetNightlyCountOfficesForCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNightlyCountOfficesForCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNightlyCountOfficesForCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNightlyCountOfficesForCurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<GetNightlyCountOfficesForCurrentUserQuery, GetNightlyCountOfficesForCurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNightlyCountOfficesForCurrentUserQuery, GetNightlyCountOfficesForCurrentUserQueryVariables>(GetNightlyCountOfficesForCurrentUserDocument, options);
      }
export function useGetNightlyCountOfficesForCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNightlyCountOfficesForCurrentUserQuery, GetNightlyCountOfficesForCurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNightlyCountOfficesForCurrentUserQuery, GetNightlyCountOfficesForCurrentUserQueryVariables>(GetNightlyCountOfficesForCurrentUserDocument, options);
        }
export type GetNightlyCountOfficesForCurrentUserQueryHookResult = ReturnType<typeof useGetNightlyCountOfficesForCurrentUserQuery>;
export type GetNightlyCountOfficesForCurrentUserLazyQueryHookResult = ReturnType<typeof useGetNightlyCountOfficesForCurrentUserLazyQuery>;
export type GetNightlyCountOfficesForCurrentUserQueryResult = Apollo.QueryResult<GetNightlyCountOfficesForCurrentUserQuery, GetNightlyCountOfficesForCurrentUserQueryVariables>;
export const UpdateNotificationConfigListDocument = gql`
    mutation updateNotificationConfigList($input: UpdateNotificationConfigListInput!) {
  updateNotificationConfigList(input: $input) {
    ...NotificationConfig
  }
}
    ${NotificationConfigFragmentDoc}`;
export type UpdateNotificationConfigListMutationFn = Apollo.MutationFunction<UpdateNotificationConfigListMutation, UpdateNotificationConfigListMutationVariables>;

/**
 * __useUpdateNotificationConfigListMutation__
 *
 * To run a mutation, you first call `useUpdateNotificationConfigListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNotificationConfigListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNotificationConfigListMutation, { data, loading, error }] = useUpdateNotificationConfigListMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateNotificationConfigListMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNotificationConfigListMutation, UpdateNotificationConfigListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNotificationConfigListMutation, UpdateNotificationConfigListMutationVariables>(UpdateNotificationConfigListDocument, options);
      }
export type UpdateNotificationConfigListMutationHookResult = ReturnType<typeof useUpdateNotificationConfigListMutation>;
export type UpdateNotificationConfigListMutationResult = Apollo.MutationResult<UpdateNotificationConfigListMutation>;
export type UpdateNotificationConfigListMutationOptions = Apollo.BaseMutationOptions<UpdateNotificationConfigListMutation, UpdateNotificationConfigListMutationVariables>;
export const GetNotificationConfigListDocument = gql`
    query getNotificationConfigList {
  getNotificationConfigList {
    ...NotificationConfig
  }
}
    ${NotificationConfigFragmentDoc}`;

/**
 * __useGetNotificationConfigListQuery__
 *
 * To run a query within a React component, call `useGetNotificationConfigListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationConfigListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationConfigListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNotificationConfigListQuery(baseOptions?: Apollo.QueryHookOptions<GetNotificationConfigListQuery, GetNotificationConfigListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNotificationConfigListQuery, GetNotificationConfigListQueryVariables>(GetNotificationConfigListDocument, options);
      }
export function useGetNotificationConfigListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNotificationConfigListQuery, GetNotificationConfigListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNotificationConfigListQuery, GetNotificationConfigListQueryVariables>(GetNotificationConfigListDocument, options);
        }
export type GetNotificationConfigListQueryHookResult = ReturnType<typeof useGetNotificationConfigListQuery>;
export type GetNotificationConfigListLazyQueryHookResult = ReturnType<typeof useGetNotificationConfigListLazyQuery>;
export type GetNotificationConfigListQueryResult = Apollo.QueryResult<GetNotificationConfigListQuery, GetNotificationConfigListQueryVariables>;
export const GetNotificationListDocument = gql`
    query getNotificationList($input: GetNotificationListInput!) {
  getNotificationsList(input: $input) {
    data {
      ...Notification
      payload {
        appointment {
          ...Appointment
          users {
            ...AppointmentUser
            contacts {
              ...Contact
            }
          }
          donor {
            ...AppointmentDonor
            user {
              ...AppointmentUser
              contacts {
                ...Contact
              }
            }
          }
          group {
            ...AppointmentGroup
            user {
              ...AppointmentUser
              contacts {
                ...Contact
              }
            }
          }
          team {
            ...AppointmentTeam
          }
        }
        request {
          donor {
            ...PartialDonor
            team {
              id
              title
            }
            user {
              ...Owner
              contacts {
                ...Contact
              }
            }
          }
          id
          number
          updatedAt
        }
      }
      user {
        ...NotificationUser
        contacts {
          ...Contact
        }
        role {
          ...RoleWithoutPermissions
        }
      }
    }
    meta {
      total
    }
  }
}
    ${NotificationFragmentDoc}
${AppointmentFragmentDoc}
${AppointmentUserFragmentDoc}
${ContactFragmentDoc}
${AppointmentDonorFragmentDoc}
${AppointmentGroupFragmentDoc}
${AppointmentTeamFragmentDoc}
${PartialDonorFragmentDoc}
${OwnerFragmentDoc}
${NotificationUserFragmentDoc}
${RoleWithoutPermissionsFragmentDoc}`;

/**
 * __useGetNotificationListQuery__
 *
 * To run a query within a React component, call `useGetNotificationListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationListQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetNotificationListQuery(baseOptions: Apollo.QueryHookOptions<GetNotificationListQuery, GetNotificationListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNotificationListQuery, GetNotificationListQueryVariables>(GetNotificationListDocument, options);
      }
export function useGetNotificationListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNotificationListQuery, GetNotificationListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNotificationListQuery, GetNotificationListQueryVariables>(GetNotificationListDocument, options);
        }
export type GetNotificationListQueryHookResult = ReturnType<typeof useGetNotificationListQuery>;
export type GetNotificationListLazyQueryHookResult = ReturnType<typeof useGetNotificationListLazyQuery>;
export type GetNotificationListQueryResult = Apollo.QueryResult<GetNotificationListQuery, GetNotificationListQueryVariables>;
export const NotificationAddedDocument = gql`
    subscription notificationAdded($input: NotificationAddedSubscriptionInput!) {
  notificationAdded(input: $input) {
    ...NotificationSubscription
  }
}
    ${NotificationSubscriptionFragmentDoc}`;

/**
 * __useNotificationAddedSubscription__
 *
 * To run a query within a React component, call `useNotificationAddedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useNotificationAddedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationAddedSubscription({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useNotificationAddedSubscription(baseOptions: Apollo.SubscriptionHookOptions<NotificationAddedSubscription, NotificationAddedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<NotificationAddedSubscription, NotificationAddedSubscriptionVariables>(NotificationAddedDocument, options);
      }
export type NotificationAddedSubscriptionHookResult = ReturnType<typeof useNotificationAddedSubscription>;
export type NotificationAddedSubscriptionResult = Apollo.SubscriptionResult<NotificationAddedSubscription>;
export const GetOrdersListDocument = gql`
    query getOrdersList($input: GetOrdersListInput!) {
  getOrdersList(input: $input) {
    data {
      id
      date
      number
      status
      trackingCode
      paymentMethod
      total
      customerId
      items {
        ...orderItem
      }
      billing {
        ...orderBilling
      }
      shipping {
        ...orderShipping
      }
      shippingLines {
        ...shippingLine
      }
      feeLines {
        ...feeLine
      }
    }
    meta {
      total
    }
  }
}
    ${OrderItemFragmentDoc}
${OrderBillingFragmentDoc}
${OrderShippingFragmentDoc}
${ShippingLineFragmentDoc}
${FeeLineFragmentDoc}`;

/**
 * __useGetOrdersListQuery__
 *
 * To run a query within a React component, call `useGetOrdersListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrdersListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrdersListQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetOrdersListQuery(baseOptions: Apollo.QueryHookOptions<GetOrdersListQuery, GetOrdersListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrdersListQuery, GetOrdersListQueryVariables>(GetOrdersListDocument, options);
      }
export function useGetOrdersListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrdersListQuery, GetOrdersListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrdersListQuery, GetOrdersListQueryVariables>(GetOrdersListDocument, options);
        }
export type GetOrdersListQueryHookResult = ReturnType<typeof useGetOrdersListQuery>;
export type GetOrdersListLazyQueryHookResult = ReturnType<typeof useGetOrdersListLazyQuery>;
export type GetOrdersListQueryResult = Apollo.QueryResult<GetOrdersListQuery, GetOrdersListQueryVariables>;
export const GetCustomerDocument = gql`
    query getCustomer($input: GetCustomerInput!) {
  getCustomer(input: $input) {
    email
    firstName
    id
    lastName
    username
    billing {
      ...orderBilling
    }
    shipping {
      ...orderShipping
    }
  }
}
    ${OrderBillingFragmentDoc}
${OrderShippingFragmentDoc}`;

/**
 * __useGetCustomerQuery__
 *
 * To run a query within a React component, call `useGetCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetCustomerQuery(baseOptions: Apollo.QueryHookOptions<GetCustomerQuery, GetCustomerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomerQuery, GetCustomerQueryVariables>(GetCustomerDocument, options);
      }
export function useGetCustomerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomerQuery, GetCustomerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomerQuery, GetCustomerQueryVariables>(GetCustomerDocument, options);
        }
export type GetCustomerQueryHookResult = ReturnType<typeof useGetCustomerQuery>;
export type GetCustomerLazyQueryHookResult = ReturnType<typeof useGetCustomerLazyQuery>;
export type GetCustomerQueryResult = Apollo.QueryResult<GetCustomerQuery, GetCustomerQueryVariables>;
export const GetOrderDocument = gql`
    query getOrder($input: GetOrderInput!) {
  getOrder(input: $input) {
    id
    date
    number
    status
    trackingCode
    paymentMethod
    total
    customerId
    items {
      ...orderItem
    }
    billing {
      ...orderBilling
    }
    shipping {
      ...orderShipping
    }
    shippingLines {
      ...shippingLine
    }
    feeLines {
      ...feeLine
    }
  }
}
    ${OrderItemFragmentDoc}
${OrderBillingFragmentDoc}
${OrderShippingFragmentDoc}
${ShippingLineFragmentDoc}
${FeeLineFragmentDoc}`;

/**
 * __useGetOrderQuery__
 *
 * To run a query within a React component, call `useGetOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetOrderQuery(baseOptions: Apollo.QueryHookOptions<GetOrderQuery, GetOrderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrderQuery, GetOrderQueryVariables>(GetOrderDocument, options);
      }
export function useGetOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrderQuery, GetOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrderQuery, GetOrderQueryVariables>(GetOrderDocument, options);
        }
export type GetOrderQueryHookResult = ReturnType<typeof useGetOrderQuery>;
export type GetOrderLazyQueryHookResult = ReturnType<typeof useGetOrderLazyQuery>;
export type GetOrderQueryResult = Apollo.QueryResult<GetOrderQuery, GetOrderQueryVariables>;
export const UpdateContactDocument = gql`
    mutation updateContact($input: UpdateContactInput!) {
  updateContact(input: $input) {
    streetAddress
    city
    state
    zipCode
    lastName
    firstName
    email
    id
    phoneNumber
  }
}
    `;
export type UpdateContactMutationFn = Apollo.MutationFunction<UpdateContactMutation, UpdateContactMutationVariables>;

/**
 * __useUpdateContactMutation__
 *
 * To run a mutation, you first call `useUpdateContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContactMutation, { data, loading, error }] = useUpdateContactMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateContactMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContactMutation, UpdateContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContactMutation, UpdateContactMutationVariables>(UpdateContactDocument, options);
      }
export type UpdateContactMutationHookResult = ReturnType<typeof useUpdateContactMutation>;
export type UpdateContactMutationResult = Apollo.MutationResult<UpdateContactMutation>;
export type UpdateContactMutationOptions = Apollo.BaseMutationOptions<UpdateContactMutation, UpdateContactMutationVariables>;
export const CreateContactDocument = gql`
    mutation createContact($input: CreateContactInput!) {
  createContact(input: $input) {
    streetAddress
    city
    state
    zipCode
    lastName
    firstName
    email
    id
    phoneNumber
  }
}
    `;
export type CreateContactMutationFn = Apollo.MutationFunction<CreateContactMutation, CreateContactMutationVariables>;

/**
 * __useCreateContactMutation__
 *
 * To run a mutation, you first call `useCreateContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContactMutation, { data, loading, error }] = useCreateContactMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateContactMutation(baseOptions?: Apollo.MutationHookOptions<CreateContactMutation, CreateContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateContactMutation, CreateContactMutationVariables>(CreateContactDocument, options);
      }
export type CreateContactMutationHookResult = ReturnType<typeof useCreateContactMutation>;
export type CreateContactMutationResult = Apollo.MutationResult<CreateContactMutation>;
export type CreateContactMutationOptions = Apollo.BaseMutationOptions<CreateContactMutation, CreateContactMutationVariables>;
export const UpdateOwnerInfoDocument = gql`
    mutation updateOwnerInfo($input: UpdateOwnerInput!) {
  updateOwnerInfo(input: $input) {
    ...User
    contacts {
      ...Contact
    }
    role {
      ...Role
    }
  }
}
    ${UserFragmentDoc}
${ContactFragmentDoc}
${RoleFragmentDoc}`;
export type UpdateOwnerInfoMutationFn = Apollo.MutationFunction<UpdateOwnerInfoMutation, UpdateOwnerInfoMutationVariables>;

/**
 * __useUpdateOwnerInfoMutation__
 *
 * To run a mutation, you first call `useUpdateOwnerInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOwnerInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOwnerInfoMutation, { data, loading, error }] = useUpdateOwnerInfoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOwnerInfoMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOwnerInfoMutation, UpdateOwnerInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOwnerInfoMutation, UpdateOwnerInfoMutationVariables>(UpdateOwnerInfoDocument, options);
      }
export type UpdateOwnerInfoMutationHookResult = ReturnType<typeof useUpdateOwnerInfoMutation>;
export type UpdateOwnerInfoMutationResult = Apollo.MutationResult<UpdateOwnerInfoMutation>;
export type UpdateOwnerInfoMutationOptions = Apollo.BaseMutationOptions<UpdateOwnerInfoMutation, UpdateOwnerInfoMutationVariables>;
export const UpdateOwnerEmailDocument = gql`
    mutation updateOwnerEmail($input: UpdateUserEmailInput!) {
  updateOwnerEmail(input: $input) {
    ...User
    contacts {
      ...Contact
    }
    role {
      ...Role
    }
  }
}
    ${UserFragmentDoc}
${ContactFragmentDoc}
${RoleFragmentDoc}`;
export type UpdateOwnerEmailMutationFn = Apollo.MutationFunction<UpdateOwnerEmailMutation, UpdateOwnerEmailMutationVariables>;

/**
 * __useUpdateOwnerEmailMutation__
 *
 * To run a mutation, you first call `useUpdateOwnerEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOwnerEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOwnerEmailMutation, { data, loading, error }] = useUpdateOwnerEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOwnerEmailMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOwnerEmailMutation, UpdateOwnerEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOwnerEmailMutation, UpdateOwnerEmailMutationVariables>(UpdateOwnerEmailDocument, options);
      }
export type UpdateOwnerEmailMutationHookResult = ReturnType<typeof useUpdateOwnerEmailMutation>;
export type UpdateOwnerEmailMutationResult = Apollo.MutationResult<UpdateOwnerEmailMutation>;
export type UpdateOwnerEmailMutationOptions = Apollo.BaseMutationOptions<UpdateOwnerEmailMutation, UpdateOwnerEmailMutationVariables>;
export const UpdateCurrentOwnerInfoDocument = gql`
    mutation updateCurrentOwnerInfo($input: UpdateOwnerInput!) {
  updateCurrentOwnerInfo(input: $input) {
    ...User
    contacts {
      ...Contact
    }
    role {
      ...Role
    }
  }
}
    ${UserFragmentDoc}
${ContactFragmentDoc}
${RoleFragmentDoc}`;
export type UpdateCurrentOwnerInfoMutationFn = Apollo.MutationFunction<UpdateCurrentOwnerInfoMutation, UpdateCurrentOwnerInfoMutationVariables>;

/**
 * __useUpdateCurrentOwnerInfoMutation__
 *
 * To run a mutation, you first call `useUpdateCurrentOwnerInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCurrentOwnerInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCurrentOwnerInfoMutation, { data, loading, error }] = useUpdateCurrentOwnerInfoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCurrentOwnerInfoMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCurrentOwnerInfoMutation, UpdateCurrentOwnerInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCurrentOwnerInfoMutation, UpdateCurrentOwnerInfoMutationVariables>(UpdateCurrentOwnerInfoDocument, options);
      }
export type UpdateCurrentOwnerInfoMutationHookResult = ReturnType<typeof useUpdateCurrentOwnerInfoMutation>;
export type UpdateCurrentOwnerInfoMutationResult = Apollo.MutationResult<UpdateCurrentOwnerInfoMutation>;
export type UpdateCurrentOwnerInfoMutationOptions = Apollo.BaseMutationOptions<UpdateCurrentOwnerInfoMutation, UpdateCurrentOwnerInfoMutationVariables>;
export const UpdateCurrentOwnerEmailDocument = gql`
    mutation updateCurrentOwnerEmail($input: UpdateUserEmailInput!) {
  updateCurrentOwnerEmail(input: $input) {
    ...User
    contacts {
      ...Contact
    }
    role {
      ...Role
    }
  }
}
    ${UserFragmentDoc}
${ContactFragmentDoc}
${RoleFragmentDoc}`;
export type UpdateCurrentOwnerEmailMutationFn = Apollo.MutationFunction<UpdateCurrentOwnerEmailMutation, UpdateCurrentOwnerEmailMutationVariables>;

/**
 * __useUpdateCurrentOwnerEmailMutation__
 *
 * To run a mutation, you first call `useUpdateCurrentOwnerEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCurrentOwnerEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCurrentOwnerEmailMutation, { data, loading, error }] = useUpdateCurrentOwnerEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCurrentOwnerEmailMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCurrentOwnerEmailMutation, UpdateCurrentOwnerEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCurrentOwnerEmailMutation, UpdateCurrentOwnerEmailMutationVariables>(UpdateCurrentOwnerEmailDocument, options);
      }
export type UpdateCurrentOwnerEmailMutationHookResult = ReturnType<typeof useUpdateCurrentOwnerEmailMutation>;
export type UpdateCurrentOwnerEmailMutationResult = Apollo.MutationResult<UpdateCurrentOwnerEmailMutation>;
export type UpdateCurrentOwnerEmailMutationOptions = Apollo.BaseMutationOptions<UpdateCurrentOwnerEmailMutation, UpdateCurrentOwnerEmailMutationVariables>;
export const RemoveCurrentOwnerDocument = gql`
    mutation removeCurrentOwner {
  removeCurrentOwner
}
    `;
export type RemoveCurrentOwnerMutationFn = Apollo.MutationFunction<RemoveCurrentOwnerMutation, RemoveCurrentOwnerMutationVariables>;

/**
 * __useRemoveCurrentOwnerMutation__
 *
 * To run a mutation, you first call `useRemoveCurrentOwnerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCurrentOwnerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCurrentOwnerMutation, { data, loading, error }] = useRemoveCurrentOwnerMutation({
 *   variables: {
 *   },
 * });
 */
export function useRemoveCurrentOwnerMutation(baseOptions?: Apollo.MutationHookOptions<RemoveCurrentOwnerMutation, RemoveCurrentOwnerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveCurrentOwnerMutation, RemoveCurrentOwnerMutationVariables>(RemoveCurrentOwnerDocument, options);
      }
export type RemoveCurrentOwnerMutationHookResult = ReturnType<typeof useRemoveCurrentOwnerMutation>;
export type RemoveCurrentOwnerMutationResult = Apollo.MutationResult<RemoveCurrentOwnerMutation>;
export type RemoveCurrentOwnerMutationOptions = Apollo.BaseMutationOptions<RemoveCurrentOwnerMutation, RemoveCurrentOwnerMutationVariables>;
export const CancelDeletingCurrentOwnerDocument = gql`
    mutation cancelDeletingCurrentOwner {
  cancelDeletingCurrentOwner
}
    `;
export type CancelDeletingCurrentOwnerMutationFn = Apollo.MutationFunction<CancelDeletingCurrentOwnerMutation, CancelDeletingCurrentOwnerMutationVariables>;

/**
 * __useCancelDeletingCurrentOwnerMutation__
 *
 * To run a mutation, you first call `useCancelDeletingCurrentOwnerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelDeletingCurrentOwnerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelDeletingCurrentOwnerMutation, { data, loading, error }] = useCancelDeletingCurrentOwnerMutation({
 *   variables: {
 *   },
 * });
 */
export function useCancelDeletingCurrentOwnerMutation(baseOptions?: Apollo.MutationHookOptions<CancelDeletingCurrentOwnerMutation, CancelDeletingCurrentOwnerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelDeletingCurrentOwnerMutation, CancelDeletingCurrentOwnerMutationVariables>(CancelDeletingCurrentOwnerDocument, options);
      }
export type CancelDeletingCurrentOwnerMutationHookResult = ReturnType<typeof useCancelDeletingCurrentOwnerMutation>;
export type CancelDeletingCurrentOwnerMutationResult = Apollo.MutationResult<CancelDeletingCurrentOwnerMutation>;
export type CancelDeletingCurrentOwnerMutationOptions = Apollo.BaseMutationOptions<CancelDeletingCurrentOwnerMutation, CancelDeletingCurrentOwnerMutationVariables>;
export const DetachUserFileDocument = gql`
    mutation detachUserFile($input: DetachUserAttachmentInput!) {
  detachUserFile(input: $input)
}
    `;
export type DetachUserFileMutationFn = Apollo.MutationFunction<DetachUserFileMutation, DetachUserFileMutationVariables>;

/**
 * __useDetachUserFileMutation__
 *
 * To run a mutation, you first call `useDetachUserFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDetachUserFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [detachUserFileMutation, { data, loading, error }] = useDetachUserFileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDetachUserFileMutation(baseOptions?: Apollo.MutationHookOptions<DetachUserFileMutation, DetachUserFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DetachUserFileMutation, DetachUserFileMutationVariables>(DetachUserFileDocument, options);
      }
export type DetachUserFileMutationHookResult = ReturnType<typeof useDetachUserFileMutation>;
export type DetachUserFileMutationResult = Apollo.MutationResult<DetachUserFileMutation>;
export type DetachUserFileMutationOptions = Apollo.BaseMutationOptions<DetachUserFileMutation, DetachUserFileMutationVariables>;
export const GetUserContactsDocument = gql`
    query getUserContacts {
  getUserContacts {
    streetAddress
    city
    state
    zipCode
    email
    firstName
    lastName
    phoneNumber
    id
  }
}
    `;

/**
 * __useGetUserContactsQuery__
 *
 * To run a query within a React component, call `useGetUserContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserContactsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserContactsQuery(baseOptions?: Apollo.QueryHookOptions<GetUserContactsQuery, GetUserContactsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserContactsQuery, GetUserContactsQueryVariables>(GetUserContactsDocument, options);
      }
export function useGetUserContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserContactsQuery, GetUserContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserContactsQuery, GetUserContactsQueryVariables>(GetUserContactsDocument, options);
        }
export type GetUserContactsQueryHookResult = ReturnType<typeof useGetUserContactsQuery>;
export type GetUserContactsLazyQueryHookResult = ReturnType<typeof useGetUserContactsLazyQuery>;
export type GetUserContactsQueryResult = Apollo.QueryResult<GetUserContactsQuery, GetUserContactsQueryVariables>;
export const GetOwnerDocument = gql`
    query getOwner($input: GetUserInput!) {
  getOwner(input: $input) {
    ...Owner
    contacts {
      ...Contact
    }
  }
}
    ${OwnerFragmentDoc}
${ContactFragmentDoc}`;

/**
 * __useGetOwnerQuery__
 *
 * To run a query within a React component, call `useGetOwnerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOwnerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOwnerQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetOwnerQuery(baseOptions: Apollo.QueryHookOptions<GetOwnerQuery, GetOwnerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOwnerQuery, GetOwnerQueryVariables>(GetOwnerDocument, options);
      }
export function useGetOwnerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOwnerQuery, GetOwnerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOwnerQuery, GetOwnerQueryVariables>(GetOwnerDocument, options);
        }
export type GetOwnerQueryHookResult = ReturnType<typeof useGetOwnerQuery>;
export type GetOwnerLazyQueryHookResult = ReturnType<typeof useGetOwnerLazyQuery>;
export type GetOwnerQueryResult = Apollo.QueryResult<GetOwnerQuery, GetOwnerQueryVariables>;
export const GetUserDonorsListDocument = gql`
    query getUserDonorsList($input: UserDonorListInput!) {
  getUserDonorsList(input: $input) {
    data {
      ...Donor
      team {
        id
        title
      }
      user {
        ...Owner
        contacts {
          ...Contact
        }
      }
    }
    meta {
      total
    }
  }
}
    ${DonorFragmentDoc}
${OwnerFragmentDoc}
${ContactFragmentDoc}`;

/**
 * __useGetUserDonorsListQuery__
 *
 * To run a query within a React component, call `useGetUserDonorsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserDonorsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserDonorsListQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetUserDonorsListQuery(baseOptions: Apollo.QueryHookOptions<GetUserDonorsListQuery, GetUserDonorsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserDonorsListQuery, GetUserDonorsListQueryVariables>(GetUserDonorsListDocument, options);
      }
export function useGetUserDonorsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserDonorsListQuery, GetUserDonorsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserDonorsListQuery, GetUserDonorsListQueryVariables>(GetUserDonorsListDocument, options);
        }
export type GetUserDonorsListQueryHookResult = ReturnType<typeof useGetUserDonorsListQuery>;
export type GetUserDonorsListLazyQueryHookResult = ReturnType<typeof useGetUserDonorsListLazyQuery>;
export type GetUserDonorsListQueryResult = Apollo.QueryResult<GetUserDonorsListQuery, GetUserDonorsListQueryVariables>;
export const GetUserAttachmentsDocument = gql`
    query getUserAttachments($input: GetUserAttachmentsListInput!) {
  getUserAttachments(input: $input) {
    ...UserAttachment
    file {
      ...File
    }
  }
}
    ${UserAttachmentFragmentDoc}
${FileFragmentDoc}`;

/**
 * __useGetUserAttachmentsQuery__
 *
 * To run a query within a React component, call `useGetUserAttachmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserAttachmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserAttachmentsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetUserAttachmentsQuery(baseOptions: Apollo.QueryHookOptions<GetUserAttachmentsQuery, GetUserAttachmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserAttachmentsQuery, GetUserAttachmentsQueryVariables>(GetUserAttachmentsDocument, options);
      }
export function useGetUserAttachmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserAttachmentsQuery, GetUserAttachmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserAttachmentsQuery, GetUserAttachmentsQueryVariables>(GetUserAttachmentsDocument, options);
        }
export type GetUserAttachmentsQueryHookResult = ReturnType<typeof useGetUserAttachmentsQuery>;
export type GetUserAttachmentsLazyQueryHookResult = ReturnType<typeof useGetUserAttachmentsLazyQuery>;
export type GetUserAttachmentsQueryResult = Apollo.QueryResult<GetUserAttachmentsQuery, GetUserAttachmentsQueryVariables>;
export const CreateProductDocument = gql`
    mutation createProduct($input: CreateProductInput!) {
  createProduct(input: $input) {
    ...Product
    discardedProduct {
      ...DiscardedProductData
      processor {
        ...ProductProcessor
      }
    }
    donation {
      ...Donation
    }
  }
}
    ${ProductFragmentDoc}
${DiscardedProductDataFragmentDoc}
${ProductProcessorFragmentDoc}
${DonationFragmentDoc}`;
export type CreateProductMutationFn = Apollo.MutationFunction<CreateProductMutation, CreateProductMutationVariables>;

/**
 * __useCreateProductMutation__
 *
 * To run a mutation, you first call `useCreateProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProductMutation, { data, loading, error }] = useCreateProductMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProductMutation(baseOptions?: Apollo.MutationHookOptions<CreateProductMutation, CreateProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProductMutation, CreateProductMutationVariables>(CreateProductDocument, options);
      }
export type CreateProductMutationHookResult = ReturnType<typeof useCreateProductMutation>;
export type CreateProductMutationResult = Apollo.MutationResult<CreateProductMutation>;
export type CreateProductMutationOptions = Apollo.BaseMutationOptions<CreateProductMutation, CreateProductMutationVariables>;
export const CreateProductsDocument = gql`
    mutation createProducts($input: CreateProductsInput!) {
  createProducts(input: $input) {
    ...Product
    discardedProduct {
      ...DiscardedProductData
      processor {
        ...ProductProcessor
      }
    }
    donation {
      ...Donation
    }
  }
}
    ${ProductFragmentDoc}
${DiscardedProductDataFragmentDoc}
${ProductProcessorFragmentDoc}
${DonationFragmentDoc}`;
export type CreateProductsMutationFn = Apollo.MutationFunction<CreateProductsMutation, CreateProductsMutationVariables>;

/**
 * __useCreateProductsMutation__
 *
 * To run a mutation, you first call `useCreateProductsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProductsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProductsMutation, { data, loading, error }] = useCreateProductsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProductsMutation(baseOptions?: Apollo.MutationHookOptions<CreateProductsMutation, CreateProductsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProductsMutation, CreateProductsMutationVariables>(CreateProductsDocument, options);
      }
export type CreateProductsMutationHookResult = ReturnType<typeof useCreateProductsMutation>;
export type CreateProductsMutationResult = Apollo.MutationResult<CreateProductsMutation>;
export type CreateProductsMutationOptions = Apollo.BaseMutationOptions<CreateProductsMutation, CreateProductsMutationVariables>;
export const MakeProductAvailableDocument = gql`
    mutation makeProductAvailable($input: MakeProductAvailableInput!) {
  makeProductAvailable(input: $input) {
    ...Product
    donation {
      ...Donation
    }
  }
}
    ${ProductFragmentDoc}
${DonationFragmentDoc}`;
export type MakeProductAvailableMutationFn = Apollo.MutationFunction<MakeProductAvailableMutation, MakeProductAvailableMutationVariables>;

/**
 * __useMakeProductAvailableMutation__
 *
 * To run a mutation, you first call `useMakeProductAvailableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMakeProductAvailableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [makeProductAvailableMutation, { data, loading, error }] = useMakeProductAvailableMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMakeProductAvailableMutation(baseOptions?: Apollo.MutationHookOptions<MakeProductAvailableMutation, MakeProductAvailableMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MakeProductAvailableMutation, MakeProductAvailableMutationVariables>(MakeProductAvailableDocument, options);
      }
export type MakeProductAvailableMutationHookResult = ReturnType<typeof useMakeProductAvailableMutation>;
export type MakeProductAvailableMutationResult = Apollo.MutationResult<MakeProductAvailableMutation>;
export type MakeProductAvailableMutationOptions = Apollo.BaseMutationOptions<MakeProductAvailableMutation, MakeProductAvailableMutationVariables>;
export const UpdateProductStatusDocument = gql`
    mutation updateProductStatus($input: UpdateProductStatusInput!) {
  updateProductStatus(input: $input) {
    ...Product
    discardedProduct {
      ...DiscardedProductData
      processor {
        ...ProductProcessor
      }
    }
    donation {
      ...Donation
    }
  }
}
    ${ProductFragmentDoc}
${DiscardedProductDataFragmentDoc}
${ProductProcessorFragmentDoc}
${DonationFragmentDoc}`;
export type UpdateProductStatusMutationFn = Apollo.MutationFunction<UpdateProductStatusMutation, UpdateProductStatusMutationVariables>;

/**
 * __useUpdateProductStatusMutation__
 *
 * To run a mutation, you first call `useUpdateProductStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductStatusMutation, { data, loading, error }] = useUpdateProductStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProductStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProductStatusMutation, UpdateProductStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProductStatusMutation, UpdateProductStatusMutationVariables>(UpdateProductStatusDocument, options);
      }
export type UpdateProductStatusMutationHookResult = ReturnType<typeof useUpdateProductStatusMutation>;
export type UpdateProductStatusMutationResult = Apollo.MutationResult<UpdateProductStatusMutation>;
export type UpdateProductStatusMutationOptions = Apollo.BaseMutationOptions<UpdateProductStatusMutation, UpdateProductStatusMutationVariables>;
export const UpdateProductDocument = gql`
    mutation updateProduct($input: UpdateProductInput!) {
  updateProduct(input: $input) {
    ...Product
    discardedProduct {
      ...DiscardedProductData
      processor {
        ...ProductProcessor
      }
    }
    donation {
      ...Donation
    }
  }
}
    ${ProductFragmentDoc}
${DiscardedProductDataFragmentDoc}
${ProductProcessorFragmentDoc}
${DonationFragmentDoc}`;
export type UpdateProductMutationFn = Apollo.MutationFunction<UpdateProductMutation, UpdateProductMutationVariables>;

/**
 * __useUpdateProductMutation__
 *
 * To run a mutation, you first call `useUpdateProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductMutation, { data, loading, error }] = useUpdateProductMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProductMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProductMutation, UpdateProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProductMutation, UpdateProductMutationVariables>(UpdateProductDocument, options);
      }
export type UpdateProductMutationHookResult = ReturnType<typeof useUpdateProductMutation>;
export type UpdateProductMutationResult = Apollo.MutationResult<UpdateProductMutation>;
export type UpdateProductMutationOptions = Apollo.BaseMutationOptions<UpdateProductMutation, UpdateProductMutationVariables>;
export const DeleteProductDocument = gql`
    mutation deleteProduct($input: DeleteProductInput!) {
  deleteProduct(input: $input)
}
    `;
export type DeleteProductMutationFn = Apollo.MutationFunction<DeleteProductMutation, DeleteProductMutationVariables>;

/**
 * __useDeleteProductMutation__
 *
 * To run a mutation, you first call `useDeleteProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProductMutation, { data, loading, error }] = useDeleteProductMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteProductMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProductMutation, DeleteProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProductMutation, DeleteProductMutationVariables>(DeleteProductDocument, options);
      }
export type DeleteProductMutationHookResult = ReturnType<typeof useDeleteProductMutation>;
export type DeleteProductMutationResult = Apollo.MutationResult<DeleteProductMutation>;
export type DeleteProductMutationOptions = Apollo.BaseMutationOptions<DeleteProductMutation, DeleteProductMutationVariables>;
export const UntieWoocommerceOrderFromProductDocument = gql`
    mutation untieWoocommerceOrderFromProduct($input: UntieWoocommerceOrderInput!) {
  untieWoocommerceOrderFromProduct(input: $input) {
    id
    woocommerceOrderId
  }
}
    `;
export type UntieWoocommerceOrderFromProductMutationFn = Apollo.MutationFunction<UntieWoocommerceOrderFromProductMutation, UntieWoocommerceOrderFromProductMutationVariables>;

/**
 * __useUntieWoocommerceOrderFromProductMutation__
 *
 * To run a mutation, you first call `useUntieWoocommerceOrderFromProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUntieWoocommerceOrderFromProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [untieWoocommerceOrderFromProductMutation, { data, loading, error }] = useUntieWoocommerceOrderFromProductMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUntieWoocommerceOrderFromProductMutation(baseOptions?: Apollo.MutationHookOptions<UntieWoocommerceOrderFromProductMutation, UntieWoocommerceOrderFromProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UntieWoocommerceOrderFromProductMutation, UntieWoocommerceOrderFromProductMutationVariables>(UntieWoocommerceOrderFromProductDocument, options);
      }
export type UntieWoocommerceOrderFromProductMutationHookResult = ReturnType<typeof useUntieWoocommerceOrderFromProductMutation>;
export type UntieWoocommerceOrderFromProductMutationResult = Apollo.MutationResult<UntieWoocommerceOrderFromProductMutation>;
export type UntieWoocommerceOrderFromProductMutationOptions = Apollo.BaseMutationOptions<UntieWoocommerceOrderFromProductMutation, UntieWoocommerceOrderFromProductMutationVariables>;
export const GetWoocommerceCategoriesDocument = gql`
    query getWoocommerceCategories($input: GetWoocommerceProductCategoriesInput!) {
  getWoocommerceCategories(input: $input) {
    id
    count
    name
    slug
    parent
  }
}
    `;

/**
 * __useGetWoocommerceCategoriesQuery__
 *
 * To run a query within a React component, call `useGetWoocommerceCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWoocommerceCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWoocommerceCategoriesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetWoocommerceCategoriesQuery(baseOptions: Apollo.QueryHookOptions<GetWoocommerceCategoriesQuery, GetWoocommerceCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWoocommerceCategoriesQuery, GetWoocommerceCategoriesQueryVariables>(GetWoocommerceCategoriesDocument, options);
      }
export function useGetWoocommerceCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWoocommerceCategoriesQuery, GetWoocommerceCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWoocommerceCategoriesQuery, GetWoocommerceCategoriesQueryVariables>(GetWoocommerceCategoriesDocument, options);
        }
export type GetWoocommerceCategoriesQueryHookResult = ReturnType<typeof useGetWoocommerceCategoriesQuery>;
export type GetWoocommerceCategoriesLazyQueryHookResult = ReturnType<typeof useGetWoocommerceCategoriesLazyQuery>;
export type GetWoocommerceCategoriesQueryResult = Apollo.QueryResult<GetWoocommerceCategoriesQuery, GetWoocommerceCategoriesQueryVariables>;
export const GetWoocommerceProductsDocument = gql`
    query getWoocommerceProducts($input: GetWoocommerceProductsInput!) {
  getWoocommerceProducts(input: $input) {
    data {
      categories {
        id
        name
        slug
      }
      date_created
      date_modified
      description
      id
      name
      price
      slug
      status
      stock_status
      stock_quantity
      type
    }
    meta {
      total
    }
  }
}
    `;

/**
 * __useGetWoocommerceProductsQuery__
 *
 * To run a query within a React component, call `useGetWoocommerceProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWoocommerceProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWoocommerceProductsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetWoocommerceProductsQuery(baseOptions: Apollo.QueryHookOptions<GetWoocommerceProductsQuery, GetWoocommerceProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWoocommerceProductsQuery, GetWoocommerceProductsQueryVariables>(GetWoocommerceProductsDocument, options);
      }
export function useGetWoocommerceProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWoocommerceProductsQuery, GetWoocommerceProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWoocommerceProductsQuery, GetWoocommerceProductsQueryVariables>(GetWoocommerceProductsDocument, options);
        }
export type GetWoocommerceProductsQueryHookResult = ReturnType<typeof useGetWoocommerceProductsQuery>;
export type GetWoocommerceProductsLazyQueryHookResult = ReturnType<typeof useGetWoocommerceProductsLazyQuery>;
export type GetWoocommerceProductsQueryResult = Apollo.QueryResult<GetWoocommerceProductsQuery, GetWoocommerceProductsQueryVariables>;
export const GetProductsDocument = gql`
    query getProducts($input: ProductListInput!) {
  getProducts(input: $input) {
    data {
      ...Product
      discardedProduct {
        ...DiscardedProductData
        processor {
          ...ProductProcessor
        }
      }
      donation {
        id
        collectionSet
        capillaryRefillTime
        approvedDonationsMl
        jugularVein
        maxLimit
        mucousMembrane
        packedCellVolume
        pulse
        respiration
        shouldDonate
        temperature
        totalSolids
        unit
        failedReason
        actual
        weatherTemperature
        weatherTypes
        weight
        examinationNotes
        preferences
        createdAt
        comment
        shortId
        donationDate
        ineligible
        ineligibleReason
        donor {
          ...DonationDonor
          team {
            id
            title
          }
          user {
            ...Holder
          }
          pictures {
            ...Picture
          }
        }
        additionalInfo {
          ...AdditionalDonationInfo
        }
      }
    }
    meta {
      total
    }
  }
}
    ${ProductFragmentDoc}
${DiscardedProductDataFragmentDoc}
${ProductProcessorFragmentDoc}
${DonationDonorFragmentDoc}
${HolderFragmentDoc}
${PictureFragmentDoc}
${AdditionalDonationInfoFragmentDoc}`;

/**
 * __useGetProductsQuery__
 *
 * To run a query within a React component, call `useGetProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetProductsQuery(baseOptions: Apollo.QueryHookOptions<GetProductsQuery, GetProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductsQuery, GetProductsQueryVariables>(GetProductsDocument, options);
      }
export function useGetProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductsQuery, GetProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductsQuery, GetProductsQueryVariables>(GetProductsDocument, options);
        }
export type GetProductsQueryHookResult = ReturnType<typeof useGetProductsQuery>;
export type GetProductsLazyQueryHookResult = ReturnType<typeof useGetProductsLazyQuery>;
export type GetProductsQueryResult = Apollo.QueryResult<GetProductsQuery, GetProductsQueryVariables>;
export const GetProductDocument = gql`
    query getProduct($input: GetProductInput!) {
  getProduct(input: $input) {
    ...Product
    donation {
      ...Donation
    }
  }
}
    ${ProductFragmentDoc}
${DonationFragmentDoc}`;

/**
 * __useGetProductQuery__
 *
 * To run a query within a React component, call `useGetProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetProductQuery(baseOptions: Apollo.QueryHookOptions<GetProductQuery, GetProductQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductQuery, GetProductQueryVariables>(GetProductDocument, options);
      }
export function useGetProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductQuery, GetProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductQuery, GetProductQueryVariables>(GetProductDocument, options);
        }
export type GetProductQueryHookResult = ReturnType<typeof useGetProductQuery>;
export type GetProductLazyQueryHookResult = ReturnType<typeof useGetProductLazyQuery>;
export type GetProductQueryResult = Apollo.QueryResult<GetProductQuery, GetProductQueryVariables>;
export const GetProductsCountDocument = gql`
    query getProductsCount($input: GetProductsCountInput!) {
  getProductsCount(input: $input)
}
    `;

/**
 * __useGetProductsCountQuery__
 *
 * To run a query within a React component, call `useGetProductsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductsCountQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetProductsCountQuery(baseOptions: Apollo.QueryHookOptions<GetProductsCountQuery, GetProductsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductsCountQuery, GetProductsCountQueryVariables>(GetProductsCountDocument, options);
      }
export function useGetProductsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductsCountQuery, GetProductsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductsCountQuery, GetProductsCountQueryVariables>(GetProductsCountDocument, options);
        }
export type GetProductsCountQueryHookResult = ReturnType<typeof useGetProductsCountQuery>;
export type GetProductsCountLazyQueryHookResult = ReturnType<typeof useGetProductsCountLazyQuery>;
export type GetProductsCountQueryResult = Apollo.QueryResult<GetProductsCountQuery, GetProductsCountQueryVariables>;
export const GetWoocommerceTopSellersDocument = gql`
    query getWoocommerceTopSellers($input: GetWoocommerceTopSellersInput!) {
  getWoocommerceTopSellers(input: $input) {
    name
    product_id
    quantity
  }
}
    `;

/**
 * __useGetWoocommerceTopSellersQuery__
 *
 * To run a query within a React component, call `useGetWoocommerceTopSellersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWoocommerceTopSellersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWoocommerceTopSellersQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetWoocommerceTopSellersQuery(baseOptions: Apollo.QueryHookOptions<GetWoocommerceTopSellersQuery, GetWoocommerceTopSellersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWoocommerceTopSellersQuery, GetWoocommerceTopSellersQueryVariables>(GetWoocommerceTopSellersDocument, options);
      }
export function useGetWoocommerceTopSellersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWoocommerceTopSellersQuery, GetWoocommerceTopSellersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWoocommerceTopSellersQuery, GetWoocommerceTopSellersQueryVariables>(GetWoocommerceTopSellersDocument, options);
        }
export type GetWoocommerceTopSellersQueryHookResult = ReturnType<typeof useGetWoocommerceTopSellersQuery>;
export type GetWoocommerceTopSellersLazyQueryHookResult = ReturnType<typeof useGetWoocommerceTopSellersLazyQuery>;
export type GetWoocommerceTopSellersQueryResult = Apollo.QueryResult<GetWoocommerceTopSellersQuery, GetWoocommerceTopSellersQueryVariables>;
export const GetDonorsReportDocument = gql`
    query getDonorsReport($input: GetDonorsReportInput!) {
  getDonorsReport(input: $input) {
    data {
      ...DonorReport
      user {
        ...DonorOwnerReport
      }
      notes {
        ...DonorNote
      }
      totalCollected
    }
    meta {
      ...CursorPaginationMetaDataFields
    }
  }
}
    ${DonorReportFragmentDoc}
${DonorOwnerReportFragmentDoc}
${DonorNoteFragmentDoc}
${CursorPaginationMetaDataFieldsFragmentDoc}`;

/**
 * __useGetDonorsReportQuery__
 *
 * To run a query within a React component, call `useGetDonorsReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDonorsReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDonorsReportQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetDonorsReportQuery(baseOptions: Apollo.QueryHookOptions<GetDonorsReportQuery, GetDonorsReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDonorsReportQuery, GetDonorsReportQueryVariables>(GetDonorsReportDocument, options);
      }
export function useGetDonorsReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDonorsReportQuery, GetDonorsReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDonorsReportQuery, GetDonorsReportQueryVariables>(GetDonorsReportDocument, options);
        }
export type GetDonorsReportQueryHookResult = ReturnType<typeof useGetDonorsReportQuery>;
export type GetDonorsReportLazyQueryHookResult = ReturnType<typeof useGetDonorsReportLazyQuery>;
export type GetDonorsReportQueryResult = Apollo.QueryResult<GetDonorsReportQuery, GetDonorsReportQueryVariables>;
export const GetDonationReportDocument = gql`
    query getDonationReport($input: GetDonationReportsInput!) {
  getDonationReports(input: $input) {
    data {
      ...DonationReport
      donor {
        ...DonationDonorReport
        user {
          ...DonationOwnerReport
        }
      }
      additionalInfo {
        ...AdditionalDonationInfoReport
        primaryHolder {
          ...HolderReportData
        }
        poker {
          ...HolderReportData
        }
      }
      products {
        ...ProductReport
      }
    }
    meta {
      ...CursorPaginationMetaDataFields
    }
  }
}
    ${DonationReportFragmentDoc}
${DonationDonorReportFragmentDoc}
${DonationOwnerReportFragmentDoc}
${AdditionalDonationInfoReportFragmentDoc}
${HolderReportDataFragmentDoc}
${ProductReportFragmentDoc}
${CursorPaginationMetaDataFieldsFragmentDoc}`;

/**
 * __useGetDonationReportQuery__
 *
 * To run a query within a React component, call `useGetDonationReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDonationReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDonationReportQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetDonationReportQuery(baseOptions: Apollo.QueryHookOptions<GetDonationReportQuery, GetDonationReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDonationReportQuery, GetDonationReportQueryVariables>(GetDonationReportDocument, options);
      }
export function useGetDonationReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDonationReportQuery, GetDonationReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDonationReportQuery, GetDonationReportQueryVariables>(GetDonationReportDocument, options);
        }
export type GetDonationReportQueryHookResult = ReturnType<typeof useGetDonationReportQuery>;
export type GetDonationReportLazyQueryHookResult = ReturnType<typeof useGetDonationReportLazyQuery>;
export type GetDonationReportQueryResult = Apollo.QueryResult<GetDonationReportQuery, GetDonationReportQueryVariables>;
export const GetProductReportsDocument = gql`
    query getProductReports($input: GetProductReportsInput!) {
  getProductReports(input: $input) {
    data {
      ...ProductReport
      donation {
        id
        approvedDonationsMl
        actual
      }
    }
    meta {
      ...CursorPaginationMetaDataFields
    }
  }
}
    ${ProductReportFragmentDoc}
${CursorPaginationMetaDataFieldsFragmentDoc}`;

/**
 * __useGetProductReportsQuery__
 *
 * To run a query within a React component, call `useGetProductReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductReportsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetProductReportsQuery(baseOptions: Apollo.QueryHookOptions<GetProductReportsQuery, GetProductReportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductReportsQuery, GetProductReportsQueryVariables>(GetProductReportsDocument, options);
      }
export function useGetProductReportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductReportsQuery, GetProductReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductReportsQuery, GetProductReportsQueryVariables>(GetProductReportsDocument, options);
        }
export type GetProductReportsQueryHookResult = ReturnType<typeof useGetProductReportsQuery>;
export type GetProductReportsLazyQueryHookResult = ReturnType<typeof useGetProductReportsLazyQuery>;
export type GetProductReportsQueryResult = Apollo.QueryResult<GetProductReportsQuery, GetProductReportsQueryVariables>;
export const GetOwnerReportsDocument = gql`
    query getOwnerReports($input: GetOwnersReportsInput!) {
  getOwnerReports(input: $input) {
    data {
      ...OwnerReport
      donors {
        name
        status
        location
      }
    }
    meta {
      ...CursorPaginationMetaDataFields
    }
  }
}
    ${OwnerReportFragmentDoc}
${CursorPaginationMetaDataFieldsFragmentDoc}`;

/**
 * __useGetOwnerReportsQuery__
 *
 * To run a query within a React component, call `useGetOwnerReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOwnerReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOwnerReportsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetOwnerReportsQuery(baseOptions: Apollo.QueryHookOptions<GetOwnerReportsQuery, GetOwnerReportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOwnerReportsQuery, GetOwnerReportsQueryVariables>(GetOwnerReportsDocument, options);
      }
export function useGetOwnerReportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOwnerReportsQuery, GetOwnerReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOwnerReportsQuery, GetOwnerReportsQueryVariables>(GetOwnerReportsDocument, options);
        }
export type GetOwnerReportsQueryHookResult = ReturnType<typeof useGetOwnerReportsQuery>;
export type GetOwnerReportsLazyQueryHookResult = ReturnType<typeof useGetOwnerReportsLazyQuery>;
export type GetOwnerReportsQueryResult = Apollo.QueryResult<GetOwnerReportsQuery, GetOwnerReportsQueryVariables>;
export const GetIneligibleParticipantsReportsDocument = gql`
    query getIneligibleParticipantsReports($input: GetIneligibleParticipantsReportsInput!) {
  getIneligibleParticipantsReports(input: $input) {
    data {
      ...IneligibleParticipantFields
    }
    meta {
      ...CursorPaginationMetaDataFields
    }
  }
}
    ${IneligibleParticipantFieldsFragmentDoc}
${CursorPaginationMetaDataFieldsFragmentDoc}`;

/**
 * __useGetIneligibleParticipantsReportsQuery__
 *
 * To run a query within a React component, call `useGetIneligibleParticipantsReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIneligibleParticipantsReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIneligibleParticipantsReportsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetIneligibleParticipantsReportsQuery(baseOptions: Apollo.QueryHookOptions<GetIneligibleParticipantsReportsQuery, GetIneligibleParticipantsReportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIneligibleParticipantsReportsQuery, GetIneligibleParticipantsReportsQueryVariables>(GetIneligibleParticipantsReportsDocument, options);
      }
export function useGetIneligibleParticipantsReportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIneligibleParticipantsReportsQuery, GetIneligibleParticipantsReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIneligibleParticipantsReportsQuery, GetIneligibleParticipantsReportsQueryVariables>(GetIneligibleParticipantsReportsDocument, options);
        }
export type GetIneligibleParticipantsReportsQueryHookResult = ReturnType<typeof useGetIneligibleParticipantsReportsQuery>;
export type GetIneligibleParticipantsReportsLazyQueryHookResult = ReturnType<typeof useGetIneligibleParticipantsReportsLazyQuery>;
export type GetIneligibleParticipantsReportsQueryResult = Apollo.QueryResult<GetIneligibleParticipantsReportsQuery, GetIneligibleParticipantsReportsQueryVariables>;
export const ProcessRequestDocument = gql`
    mutation processRequest($input: UpdateRequestInput!) {
  processRequest(input: $input)
}
    `;
export type ProcessRequestMutationFn = Apollo.MutationFunction<ProcessRequestMutation, ProcessRequestMutationVariables>;

/**
 * __useProcessRequestMutation__
 *
 * To run a mutation, you first call `useProcessRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processRequestMutation, { data, loading, error }] = useProcessRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProcessRequestMutation(baseOptions?: Apollo.MutationHookOptions<ProcessRequestMutation, ProcessRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessRequestMutation, ProcessRequestMutationVariables>(ProcessRequestDocument, options);
      }
export type ProcessRequestMutationHookResult = ReturnType<typeof useProcessRequestMutation>;
export type ProcessRequestMutationResult = Apollo.MutationResult<ProcessRequestMutation>;
export type ProcessRequestMutationOptions = Apollo.BaseMutationOptions<ProcessRequestMutation, ProcessRequestMutationVariables>;
export const RemoveRequestDocument = gql`
    mutation removeRequest($input: RemoveRequestInput!) {
  removeRequest(input: $input)
}
    `;
export type RemoveRequestMutationFn = Apollo.MutationFunction<RemoveRequestMutation, RemoveRequestMutationVariables>;

/**
 * __useRemoveRequestMutation__
 *
 * To run a mutation, you first call `useRemoveRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeRequestMutation, { data, loading, error }] = useRemoveRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveRequestMutation(baseOptions?: Apollo.MutationHookOptions<RemoveRequestMutation, RemoveRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveRequestMutation, RemoveRequestMutationVariables>(RemoveRequestDocument, options);
      }
export type RemoveRequestMutationHookResult = ReturnType<typeof useRemoveRequestMutation>;
export type RemoveRequestMutationResult = Apollo.MutationResult<RemoveRequestMutation>;
export type RemoveRequestMutationOptions = Apollo.BaseMutationOptions<RemoveRequestMutation, RemoveRequestMutationVariables>;
export const GetRequestListDocument = gql`
    query getRequestList($input: RequestsListInput!) {
  getRequestList(input: $input) {
    data {
      donor {
        ...Donor
        team {
          id
          title
        }
        user {
          ...Owner
          contacts {
            ...Contact
          }
        }
      }
      id
      number
      updatedAt
    }
    meta {
      total
    }
  }
}
    ${DonorFragmentDoc}
${OwnerFragmentDoc}
${ContactFragmentDoc}`;

/**
 * __useGetRequestListQuery__
 *
 * To run a query within a React component, call `useGetRequestListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRequestListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRequestListQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetRequestListQuery(baseOptions: Apollo.QueryHookOptions<GetRequestListQuery, GetRequestListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRequestListQuery, GetRequestListQueryVariables>(GetRequestListDocument, options);
      }
export function useGetRequestListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRequestListQuery, GetRequestListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRequestListQuery, GetRequestListQueryVariables>(GetRequestListDocument, options);
        }
export type GetRequestListQueryHookResult = ReturnType<typeof useGetRequestListQuery>;
export type GetRequestListLazyQueryHookResult = ReturnType<typeof useGetRequestListLazyQuery>;
export type GetRequestListQueryResult = Apollo.QueryResult<GetRequestListQuery, GetRequestListQueryVariables>;
export const GetRequestDocument = gql`
    query getRequest($input: GetRequestInput!) {
  getRequest(input: $input) {
    donor {
      ...Donor
      team {
        id
        title
      }
      user {
        ...Owner
        contacts {
          ...Contact
        }
      }
    }
    id
    number
    updatedAt
  }
}
    ${DonorFragmentDoc}
${OwnerFragmentDoc}
${ContactFragmentDoc}`;

/**
 * __useGetRequestQuery__
 *
 * To run a query within a React component, call `useGetRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRequestQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetRequestQuery(baseOptions: Apollo.QueryHookOptions<GetRequestQuery, GetRequestQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRequestQuery, GetRequestQueryVariables>(GetRequestDocument, options);
      }
export function useGetRequestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRequestQuery, GetRequestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRequestQuery, GetRequestQueryVariables>(GetRequestDocument, options);
        }
export type GetRequestQueryHookResult = ReturnType<typeof useGetRequestQuery>;
export type GetRequestLazyQueryHookResult = ReturnType<typeof useGetRequestLazyQuery>;
export type GetRequestQueryResult = Apollo.QueryResult<GetRequestQuery, GetRequestQueryVariables>;
export const SaveAppSettingsDocument = gql`
    mutation saveAppSettings($input: SaveAppSettingsInput!) {
  saveAppSettings(input: $input) {
    id
    settingsTab
    settingsJson
    createdAt
    updatedAt
  }
}
    `;
export type SaveAppSettingsMutationFn = Apollo.MutationFunction<SaveAppSettingsMutation, SaveAppSettingsMutationVariables>;

/**
 * __useSaveAppSettingsMutation__
 *
 * To run a mutation, you first call `useSaveAppSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveAppSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveAppSettingsMutation, { data, loading, error }] = useSaveAppSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveAppSettingsMutation(baseOptions?: Apollo.MutationHookOptions<SaveAppSettingsMutation, SaveAppSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveAppSettingsMutation, SaveAppSettingsMutationVariables>(SaveAppSettingsDocument, options);
      }
export type SaveAppSettingsMutationHookResult = ReturnType<typeof useSaveAppSettingsMutation>;
export type SaveAppSettingsMutationResult = Apollo.MutationResult<SaveAppSettingsMutation>;
export type SaveAppSettingsMutationOptions = Apollo.BaseMutationOptions<SaveAppSettingsMutation, SaveAppSettingsMutationVariables>;
export const GetAppSettingsDocument = gql`
    query getAppSettings($input: GetAppSettingsInput!) {
  getAppSettings(input: $input) {
    id
    settingsTab
    settingsJson
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetAppSettingsQuery__
 *
 * To run a query within a React component, call `useGetAppSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppSettingsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAppSettingsQuery(baseOptions: Apollo.QueryHookOptions<GetAppSettingsQuery, GetAppSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppSettingsQuery, GetAppSettingsQueryVariables>(GetAppSettingsDocument, options);
      }
export function useGetAppSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppSettingsQuery, GetAppSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppSettingsQuery, GetAppSettingsQueryVariables>(GetAppSettingsDocument, options);
        }
export type GetAppSettingsQueryHookResult = ReturnType<typeof useGetAppSettingsQuery>;
export type GetAppSettingsLazyQueryHookResult = ReturnType<typeof useGetAppSettingsLazyQuery>;
export type GetAppSettingsQueryResult = Apollo.QueryResult<GetAppSettingsQuery, GetAppSettingsQueryVariables>;
export const SignUpDocument = gql`
    mutation signUp($input: SignUpInput!) {
  signUp(input: $input) {
    ...User
    contacts {
      ...Contact
    }
    role {
      ...Role
    }
  }
}
    ${UserFragmentDoc}
${ContactFragmentDoc}
${RoleFragmentDoc}`;
export type SignUpMutationFn = Apollo.MutationFunction<SignUpMutation, SignUpMutationVariables>;

/**
 * __useSignUpMutation__
 *
 * To run a mutation, you first call `useSignUpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignUpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signUpMutation, { data, loading, error }] = useSignUpMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSignUpMutation(baseOptions?: Apollo.MutationHookOptions<SignUpMutation, SignUpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignUpMutation, SignUpMutationVariables>(SignUpDocument, options);
      }
export type SignUpMutationHookResult = ReturnType<typeof useSignUpMutation>;
export type SignUpMutationResult = Apollo.MutationResult<SignUpMutation>;
export type SignUpMutationOptions = Apollo.BaseMutationOptions<SignUpMutation, SignUpMutationVariables>;
export const ForgotPasswordDocument = gql`
    mutation forgotPassword($input: ForgotPasswordInput!) {
  forgotPassword(input: $input)
}
    `;
export type ForgotPasswordMutationFn = Apollo.MutationFunction<ForgotPasswordMutation, ForgotPasswordMutationVariables>;

/**
 * __useForgotPasswordMutation__
 *
 * To run a mutation, you first call `useForgotPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForgotPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forgotPasswordMutation, { data, loading, error }] = useForgotPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useForgotPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ForgotPasswordMutation, ForgotPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ForgotPasswordMutation, ForgotPasswordMutationVariables>(ForgotPasswordDocument, options);
      }
export type ForgotPasswordMutationHookResult = ReturnType<typeof useForgotPasswordMutation>;
export type ForgotPasswordMutationResult = Apollo.MutationResult<ForgotPasswordMutation>;
export type ForgotPasswordMutationOptions = Apollo.BaseMutationOptions<ForgotPasswordMutation, ForgotPasswordMutationVariables>;
export const ResetPasswordDocument = gql`
    mutation resetPassword($input: ResetPasswordInput!) {
  resetPassword(input: $input)
}
    `;
export type ResetPasswordMutationFn = Apollo.MutationFunction<ResetPasswordMutation, ResetPasswordMutationVariables>;

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordMutation, { data, loading, error }] = useResetPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ResetPasswordMutation, ResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument, options);
      }
export type ResetPasswordMutationHookResult = ReturnType<typeof useResetPasswordMutation>;
export type ResetPasswordMutationResult = Apollo.MutationResult<ResetPasswordMutation>;
export type ResetPasswordMutationOptions = Apollo.BaseMutationOptions<ResetPasswordMutation, ResetPasswordMutationVariables>;
export const ConfirmEmailDocument = gql`
    mutation confirmEmail($input: EmailConfirmationInput!) {
  confirmEmail(input: $input)
}
    `;
export type ConfirmEmailMutationFn = Apollo.MutationFunction<ConfirmEmailMutation, ConfirmEmailMutationVariables>;

/**
 * __useConfirmEmailMutation__
 *
 * To run a mutation, you first call `useConfirmEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmEmailMutation, { data, loading, error }] = useConfirmEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConfirmEmailMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmEmailMutation, ConfirmEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmEmailMutation, ConfirmEmailMutationVariables>(ConfirmEmailDocument, options);
      }
export type ConfirmEmailMutationHookResult = ReturnType<typeof useConfirmEmailMutation>;
export type ConfirmEmailMutationResult = Apollo.MutationResult<ConfirmEmailMutation>;
export type ConfirmEmailMutationOptions = Apollo.BaseMutationOptions<ConfirmEmailMutation, ConfirmEmailMutationVariables>;
export const MakeNotificationsReadDocument = gql`
    mutation makeNotificationsRead {
  makeNotificationsRead
}
    `;
export type MakeNotificationsReadMutationFn = Apollo.MutationFunction<MakeNotificationsReadMutation, MakeNotificationsReadMutationVariables>;

/**
 * __useMakeNotificationsReadMutation__
 *
 * To run a mutation, you first call `useMakeNotificationsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMakeNotificationsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [makeNotificationsReadMutation, { data, loading, error }] = useMakeNotificationsReadMutation({
 *   variables: {
 *   },
 * });
 */
export function useMakeNotificationsReadMutation(baseOptions?: Apollo.MutationHookOptions<MakeNotificationsReadMutation, MakeNotificationsReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MakeNotificationsReadMutation, MakeNotificationsReadMutationVariables>(MakeNotificationsReadDocument, options);
      }
export type MakeNotificationsReadMutationHookResult = ReturnType<typeof useMakeNotificationsReadMutation>;
export type MakeNotificationsReadMutationResult = Apollo.MutationResult<MakeNotificationsReadMutation>;
export type MakeNotificationsReadMutationOptions = Apollo.BaseMutationOptions<MakeNotificationsReadMutation, MakeNotificationsReadMutationVariables>;
export const DeleteNotificationDocument = gql`
    mutation deleteNotification($input: RemoveNotificationInput!) {
  deleteNotification(input: $input)
}
    `;
export type DeleteNotificationMutationFn = Apollo.MutationFunction<DeleteNotificationMutation, DeleteNotificationMutationVariables>;

/**
 * __useDeleteNotificationMutation__
 *
 * To run a mutation, you first call `useDeleteNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteNotificationMutation, { data, loading, error }] = useDeleteNotificationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteNotificationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteNotificationMutation, DeleteNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteNotificationMutation, DeleteNotificationMutationVariables>(DeleteNotificationDocument, options);
      }
export type DeleteNotificationMutationHookResult = ReturnType<typeof useDeleteNotificationMutation>;
export type DeleteNotificationMutationResult = Apollo.MutationResult<DeleteNotificationMutation>;
export type DeleteNotificationMutationOptions = Apollo.BaseMutationOptions<DeleteNotificationMutation, DeleteNotificationMutationVariables>;
export const ArchiveUserDocument = gql`
    mutation archiveUser($input: ArchiveUserInput!) {
  archiveUser(input: $input)
}
    `;
export type ArchiveUserMutationFn = Apollo.MutationFunction<ArchiveUserMutation, ArchiveUserMutationVariables>;

/**
 * __useArchiveUserMutation__
 *
 * To run a mutation, you first call `useArchiveUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveUserMutation, { data, loading, error }] = useArchiveUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useArchiveUserMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveUserMutation, ArchiveUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveUserMutation, ArchiveUserMutationVariables>(ArchiveUserDocument, options);
      }
export type ArchiveUserMutationHookResult = ReturnType<typeof useArchiveUserMutation>;
export type ArchiveUserMutationResult = Apollo.MutationResult<ArchiveUserMutation>;
export type ArchiveUserMutationOptions = Apollo.BaseMutationOptions<ArchiveUserMutation, ArchiveUserMutationVariables>;
export const UnArchiveUserDocument = gql`
    mutation unArchiveUser($input: ArchiveUserInput!) {
  unArchiveUser(input: $input)
}
    `;
export type UnArchiveUserMutationFn = Apollo.MutationFunction<UnArchiveUserMutation, UnArchiveUserMutationVariables>;

/**
 * __useUnArchiveUserMutation__
 *
 * To run a mutation, you first call `useUnArchiveUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnArchiveUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unArchiveUserMutation, { data, loading, error }] = useUnArchiveUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnArchiveUserMutation(baseOptions?: Apollo.MutationHookOptions<UnArchiveUserMutation, UnArchiveUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnArchiveUserMutation, UnArchiveUserMutationVariables>(UnArchiveUserDocument, options);
      }
export type UnArchiveUserMutationHookResult = ReturnType<typeof useUnArchiveUserMutation>;
export type UnArchiveUserMutationResult = Apollo.MutationResult<UnArchiveUserMutation>;
export type UnArchiveUserMutationOptions = Apollo.BaseMutationOptions<UnArchiveUserMutation, UnArchiveUserMutationVariables>;
export const SignUpWithDonorsDocument = gql`
    mutation signUpWithDonors($input: SignUpWithDonorsInput!) {
  signUpWithDonors(input: $input)
}
    `;
export type SignUpWithDonorsMutationFn = Apollo.MutationFunction<SignUpWithDonorsMutation, SignUpWithDonorsMutationVariables>;

/**
 * __useSignUpWithDonorsMutation__
 *
 * To run a mutation, you first call `useSignUpWithDonorsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignUpWithDonorsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signUpWithDonorsMutation, { data, loading, error }] = useSignUpWithDonorsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSignUpWithDonorsMutation(baseOptions?: Apollo.MutationHookOptions<SignUpWithDonorsMutation, SignUpWithDonorsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignUpWithDonorsMutation, SignUpWithDonorsMutationVariables>(SignUpWithDonorsDocument, options);
      }
export type SignUpWithDonorsMutationHookResult = ReturnType<typeof useSignUpWithDonorsMutation>;
export type SignUpWithDonorsMutationResult = Apollo.MutationResult<SignUpWithDonorsMutation>;
export type SignUpWithDonorsMutationOptions = Apollo.BaseMutationOptions<SignUpWithDonorsMutation, SignUpWithDonorsMutationVariables>;
export const GetAllIneligibleDocument = gql`
    query getAllIneligible {
  getAllIneligibleParticipants {
    ineligible {
      id
      createdAt
      ownerData
      donorData
    }
  }
}
    `;

/**
 * __useGetAllIneligibleQuery__
 *
 * To run a query within a React component, call `useGetAllIneligibleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllIneligibleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllIneligibleQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllIneligibleQuery(baseOptions?: Apollo.QueryHookOptions<GetAllIneligibleQuery, GetAllIneligibleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllIneligibleQuery, GetAllIneligibleQueryVariables>(GetAllIneligibleDocument, options);
      }
export function useGetAllIneligibleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllIneligibleQuery, GetAllIneligibleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllIneligibleQuery, GetAllIneligibleQueryVariables>(GetAllIneligibleDocument, options);
        }
export type GetAllIneligibleQueryHookResult = ReturnType<typeof useGetAllIneligibleQuery>;
export type GetAllIneligibleLazyQueryHookResult = ReturnType<typeof useGetAllIneligibleLazyQuery>;
export type GetAllIneligibleQueryResult = Apollo.QueryResult<GetAllIneligibleQuery, GetAllIneligibleQueryVariables>;
export const GetCurrentUserDocument = gql`
    query GetCurrentUser {
  currentUser {
    ...User
    contacts {
      ...Contact
    }
    role {
      ...Role
    }
  }
}
    ${UserFragmentDoc}
${ContactFragmentDoc}
${RoleFragmentDoc}`;

/**
 * __useGetCurrentUserQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrentUserQuery, GetCurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentUserQuery, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
      }
export function useGetCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentUserQuery, GetCurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentUserQuery, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
        }
export type GetCurrentUserQueryHookResult = ReturnType<typeof useGetCurrentUserQuery>;
export type GetCurrentUserLazyQueryHookResult = ReturnType<typeof useGetCurrentUserLazyQuery>;
export type GetCurrentUserQueryResult = Apollo.QueryResult<GetCurrentUserQuery, GetCurrentUserQueryVariables>;
export const GetMyPermissionsDocument = gql`
    query getMyPermissions {
  getMyPermissions {
    ...Permission
    role {
      ...Role
    }
  }
}
    ${PermissionFragmentDoc}
${RoleFragmentDoc}`;

/**
 * __useGetMyPermissionsQuery__
 *
 * To run a query within a React component, call `useGetMyPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyPermissionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyPermissionsQuery(baseOptions?: Apollo.QueryHookOptions<GetMyPermissionsQuery, GetMyPermissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyPermissionsQuery, GetMyPermissionsQueryVariables>(GetMyPermissionsDocument, options);
      }
export function useGetMyPermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyPermissionsQuery, GetMyPermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyPermissionsQuery, GetMyPermissionsQueryVariables>(GetMyPermissionsDocument, options);
        }
export type GetMyPermissionsQueryHookResult = ReturnType<typeof useGetMyPermissionsQuery>;
export type GetMyPermissionsLazyQueryHookResult = ReturnType<typeof useGetMyPermissionsLazyQuery>;
export type GetMyPermissionsQueryResult = Apollo.QueryResult<GetMyPermissionsQuery, GetMyPermissionsQueryVariables>;
export const GetUsersListDocument = gql`
    query getUsersList($input: GetUserListInput!) {
  getUsersList(input: $input) {
    data {
      ...User
      contacts {
        ...Contact
      }
      role {
        ...Role
      }
    }
    meta {
      total
    }
  }
}
    ${UserFragmentDoc}
${ContactFragmentDoc}
${RoleFragmentDoc}`;

/**
 * __useGetUsersListQuery__
 *
 * To run a query within a React component, call `useGetUsersListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersListQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetUsersListQuery(baseOptions: Apollo.QueryHookOptions<GetUsersListQuery, GetUsersListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsersListQuery, GetUsersListQueryVariables>(GetUsersListDocument, options);
      }
export function useGetUsersListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersListQuery, GetUsersListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsersListQuery, GetUsersListQueryVariables>(GetUsersListDocument, options);
        }
export type GetUsersListQueryHookResult = ReturnType<typeof useGetUsersListQuery>;
export type GetUsersListLazyQueryHookResult = ReturnType<typeof useGetUsersListLazyQuery>;
export type GetUsersListQueryResult = Apollo.QueryResult<GetUsersListQuery, GetUsersListQueryVariables>;
export const GetOwnersListDocument = gql`
    query getOwnersList($input: GetOwnerListInput!) {
  getOwnersList(input: $input) {
    data {
      ...User
      contacts {
        ...Contact
      }
      role {
        ...Role
      }
    }
    meta {
      total
    }
  }
}
    ${UserFragmentDoc}
${ContactFragmentDoc}
${RoleFragmentDoc}`;

/**
 * __useGetOwnersListQuery__
 *
 * To run a query within a React component, call `useGetOwnersListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOwnersListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOwnersListQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetOwnersListQuery(baseOptions: Apollo.QueryHookOptions<GetOwnersListQuery, GetOwnersListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOwnersListQuery, GetOwnersListQueryVariables>(GetOwnersListDocument, options);
      }
export function useGetOwnersListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOwnersListQuery, GetOwnersListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOwnersListQuery, GetOwnersListQueryVariables>(GetOwnersListDocument, options);
        }
export type GetOwnersListQueryHookResult = ReturnType<typeof useGetOwnersListQuery>;
export type GetOwnersListLazyQueryHookResult = ReturnType<typeof useGetOwnersListLazyQuery>;
export type GetOwnersListQueryResult = Apollo.QueryResult<GetOwnersListQuery, GetOwnersListQueryVariables>;
export const CheckUserConnectionDocument = gql`
    query checkUserConnection {
  checkUserConnection
}
    `;

/**
 * __useCheckUserConnectionQuery__
 *
 * To run a query within a React component, call `useCheckUserConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckUserConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckUserConnectionQuery({
 *   variables: {
 *   },
 * });
 */
export function useCheckUserConnectionQuery(baseOptions?: Apollo.QueryHookOptions<CheckUserConnectionQuery, CheckUserConnectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckUserConnectionQuery, CheckUserConnectionQueryVariables>(CheckUserConnectionDocument, options);
      }
export function useCheckUserConnectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckUserConnectionQuery, CheckUserConnectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckUserConnectionQuery, CheckUserConnectionQueryVariables>(CheckUserConnectionDocument, options);
        }
export type CheckUserConnectionQueryHookResult = ReturnType<typeof useCheckUserConnectionQuery>;
export type CheckUserConnectionLazyQueryHookResult = ReturnType<typeof useCheckUserConnectionLazyQuery>;
export type CheckUserConnectionQueryResult = Apollo.QueryResult<CheckUserConnectionQuery, CheckUserConnectionQueryVariables>;